import React__default, { createElement, isValidElement, cloneElement, PureComponent, Component, useState, useRef, useEffect, useMemo, useCallback, createRef } from 'react';
import PropTypes__default, { string, oneOf, PropTypes, number } from 'prop-types';
import ReactDOM, { createPortal } from 'react-dom';
import uniqueId from 'lodash/uniqueId';
import isEqual$2 from 'lodash/isEqual';
import moment$1__default, { isMoment } from 'moment';
import memoize from 'lodash/memoize';
import { cloneDeep, isArray, isBoolean } from 'lodash';
import kebabCase from 'lodash/kebabCase';
import isFunction$1 from 'lodash/isFunction';
import { Tooltip as Tooltip$1 } from 'factor';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var styleToObject = function (input) {
    var attributes = input.split(/ ?; ?/);
    return attributes.reduce(function (acc, d) {
        var _a = __read(d.split(/ ?: ?/), 2), key = _a[0], value = _a[1];
        if (key && value) {
            acc[key.replace(/-(\w)/g, function (_$0, $1) { return $1.toUpperCase(); })] = Number.isNaN(Number(value))
                ? value
                : Number(value);
        }
        return acc;
    }, {});
};
var noTextChildNodes = [
    'br',
    'col',
    'colgroup',
    'dl',
    'hr',
    'iframe',
    'img',
    'input',
    'link',
    'menuitem',
    'meta',
    'ol',
    'param',
    'select',
    'table',
    'tbody',
    'tfoot',
    'thead',
    'tr',
    'ul',
    'wbr',
];
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Taken from https://raw.githubusercontent.com/facebook/react/baff5cc2f69d30589a5dc65b089e47765437294b/packages/react-dom/src/shared/possibleStandardNames.js
// tslint:disable:object-literal-sort-keys
var possibleStandardNames = {
    // HTML
    'accept-charset': 'acceptCharset',
    acceptcharset: 'acceptCharset',
    accesskey: 'accessKey',
    allowfullscreen: 'allowFullScreen',
    autocapitalize: 'autoCapitalize',
    autocomplete: 'autoComplete',
    autocorrect: 'autoCorrect',
    autofocus: 'autoFocus',
    autoplay: 'autoPlay',
    autosave: 'autoSave',
    cellpadding: 'cellPadding',
    cellspacing: 'cellSpacing',
    charset: 'charSet',
    class: 'className',
    classid: 'classID',
    classname: 'className',
    colspan: 'colSpan',
    contenteditable: 'contentEditable',
    contextmenu: 'contextMenu',
    controlslist: 'controlsList',
    crossorigin: 'crossOrigin',
    dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
    datetime: 'dateTime',
    defaultchecked: 'defaultChecked',
    defaultvalue: 'defaultValue',
    enctype: 'encType',
    for: 'htmlFor',
    formmethod: 'formMethod',
    formaction: 'formAction',
    formenctype: 'formEncType',
    formnovalidate: 'formNoValidate',
    formtarget: 'formTarget',
    frameborder: 'frameBorder',
    hreflang: 'hrefLang',
    htmlfor: 'htmlFor',
    httpequiv: 'httpEquiv',
    'http-equiv': 'httpEquiv',
    icon: 'icon',
    innerhtml: 'innerHTML',
    inputmode: 'inputMode',
    itemid: 'itemID',
    itemprop: 'itemProp',
    itemref: 'itemRef',
    itemscope: 'itemScope',
    itemtype: 'itemType',
    keyparams: 'keyParams',
    keytype: 'keyType',
    marginwidth: 'marginWidth',
    marginheight: 'marginHeight',
    maxlength: 'maxLength',
    mediagroup: 'mediaGroup',
    minlength: 'minLength',
    nomodule: 'noModule',
    novalidate: 'noValidate',
    playsinline: 'playsInline',
    radiogroup: 'radioGroup',
    readonly: 'readOnly',
    referrerpolicy: 'referrerPolicy',
    rowspan: 'rowSpan',
    spellcheck: 'spellCheck',
    srcdoc: 'srcDoc',
    srclang: 'srcLang',
    srcset: 'srcSet',
    tabindex: 'tabIndex',
    typemustmatch: 'typeMustMatch',
    usemap: 'useMap',
    // SVG
    accentheight: 'accentHeight',
    'accent-height': 'accentHeight',
    alignmentbaseline: 'alignmentBaseline',
    'alignment-baseline': 'alignmentBaseline',
    allowreorder: 'allowReorder',
    arabicform: 'arabicForm',
    'arabic-form': 'arabicForm',
    attributename: 'attributeName',
    attributetype: 'attributeType',
    autoreverse: 'autoReverse',
    basefrequency: 'baseFrequency',
    baselineshift: 'baselineShift',
    'baseline-shift': 'baselineShift',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    capheight: 'capHeight',
    'cap-height': 'capHeight',
    clippath: 'clipPath',
    'clip-path': 'clipPath',
    clippathunits: 'clipPathUnits',
    cliprule: 'clipRule',
    'clip-rule': 'clipRule',
    colorinterpolation: 'colorInterpolation',
    'color-interpolation': 'colorInterpolation',
    colorinterpolationfilters: 'colorInterpolationFilters',
    'color-interpolation-filters': 'colorInterpolationFilters',
    colorprofile: 'colorProfile',
    'color-profile': 'colorProfile',
    colorrendering: 'colorRendering',
    'color-rendering': 'colorRendering',
    contentscripttype: 'contentScriptType',
    contentstyletype: 'contentStyleType',
    diffuseconstant: 'diffuseConstant',
    dominantbaseline: 'dominantBaseline',
    'dominant-baseline': 'dominantBaseline',
    edgemode: 'edgeMode',
    enablebackground: 'enableBackground',
    'enable-background': 'enableBackground',
    externalresourcesrequired: 'externalResourcesRequired',
    fillopacity: 'fillOpacity',
    'fill-opacity': 'fillOpacity',
    fillrule: 'fillRule',
    'fill-rule': 'fillRule',
    filterres: 'filterRes',
    filterunits: 'filterUnits',
    floodopacity: 'floodOpacity',
    'flood-opacity': 'floodOpacity',
    floodcolor: 'floodColor',
    'flood-color': 'floodColor',
    fontfamily: 'fontFamily',
    'font-family': 'fontFamily',
    fontsize: 'fontSize',
    'font-size': 'fontSize',
    fontsizeadjust: 'fontSizeAdjust',
    'font-size-adjust': 'fontSizeAdjust',
    fontstretch: 'fontStretch',
    'font-stretch': 'fontStretch',
    fontstyle: 'fontStyle',
    'font-style': 'fontStyle',
    fontvariant: 'fontVariant',
    'font-variant': 'fontVariant',
    fontweight: 'fontWeight',
    'font-weight': 'fontWeight',
    glyphname: 'glyphName',
    'glyph-name': 'glyphName',
    glyphorientationhorizontal: 'glyphOrientationHorizontal',
    'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
    glyphorientationvertical: 'glyphOrientationVertical',
    'glyph-orientation-vertical': 'glyphOrientationVertical',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    horizadvx: 'horizAdvX',
    'horiz-adv-x': 'horizAdvX',
    horizoriginx: 'horizOriginX',
    'horiz-origin-x': 'horizOriginX',
    imagerendering: 'imageRendering',
    'image-rendering': 'imageRendering',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    letterspacing: 'letterSpacing',
    'letter-spacing': 'letterSpacing',
    lightingcolor: 'lightingColor',
    'lighting-color': 'lightingColor',
    limitingconeangle: 'limitingConeAngle',
    markerend: 'markerEnd',
    'marker-end': 'markerEnd',
    markerheight: 'markerHeight',
    markermid: 'markerMid',
    'marker-mid': 'markerMid',
    markerstart: 'markerStart',
    'marker-start': 'markerStart',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    overlineposition: 'overlinePosition',
    'overline-position': 'overlinePosition',
    overlinethickness: 'overlineThickness',
    'overline-thickness': 'overlineThickness',
    paintorder: 'paintOrder',
    'paint-order': 'paintOrder',
    'panose-1': 'panose1',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointerevents: 'pointerEvents',
    'pointer-events': 'pointerEvents',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    refx: 'refX',
    refy: 'refY',
    renderingintent: 'renderingIntent',
    'rendering-intent': 'renderingIntent',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    shaperendering: 'shapeRendering',
    'shape-rendering': 'shapeRendering',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    stopcolor: 'stopColor',
    'stop-color': 'stopColor',
    stopopacity: 'stopOpacity',
    'stop-opacity': 'stopOpacity',
    strikethroughposition: 'strikethroughPosition',
    'strikethrough-position': 'strikethroughPosition',
    strikethroughthickness: 'strikethroughThickness',
    'strikethrough-thickness': 'strikethroughThickness',
    strokedasharray: 'strokeDasharray',
    'stroke-dasharray': 'strokeDasharray',
    strokedashoffset: 'strokeDashoffset',
    'stroke-dashoffset': 'strokeDashoffset',
    strokelinecap: 'strokeLinecap',
    'stroke-linecap': 'strokeLinecap',
    strokelinejoin: 'strokeLinejoin',
    'stroke-linejoin': 'strokeLinejoin',
    strokemiterlimit: 'strokeMiterlimit',
    'stroke-miterlimit': 'strokeMiterlimit',
    strokewidth: 'strokeWidth',
    'stroke-width': 'strokeWidth',
    strokeopacity: 'strokeOpacity',
    'stroke-opacity': 'strokeOpacity',
    suppresscontenteditablewarning: 'suppressContentEditableWarning',
    suppresshydrationwarning: 'suppressHydrationWarning',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textanchor: 'textAnchor',
    'text-anchor': 'textAnchor',
    textdecoration: 'textDecoration',
    'text-decoration': 'textDecoration',
    textlength: 'textLength',
    textrendering: 'textRendering',
    'text-rendering': 'textRendering',
    underlineposition: 'underlinePosition',
    'underline-position': 'underlinePosition',
    underlinethickness: 'underlineThickness',
    'underline-thickness': 'underlineThickness',
    unicodebidi: 'unicodeBidi',
    'unicode-bidi': 'unicodeBidi',
    unicoderange: 'unicodeRange',
    'unicode-range': 'unicodeRange',
    unitsperem: 'unitsPerEm',
    'units-per-em': 'unitsPerEm',
    unselectable: 'unselectable',
    valphabetic: 'vAlphabetic',
    'v-alphabetic': 'vAlphabetic',
    vectoreffect: 'vectorEffect',
    'vector-effect': 'vectorEffect',
    vertadvy: 'vertAdvY',
    'vert-adv-y': 'vertAdvY',
    vertoriginx: 'vertOriginX',
    'vert-origin-x': 'vertOriginX',
    vertoriginy: 'vertOriginY',
    'vert-origin-y': 'vertOriginY',
    vhanging: 'vHanging',
    'v-hanging': 'vHanging',
    videographic: 'vIdeographic',
    'v-ideographic': 'vIdeographic',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    vmathematical: 'vMathematical',
    'v-mathematical': 'vMathematical',
    wordspacing: 'wordSpacing',
    'word-spacing': 'wordSpacing',
    writingmode: 'writingMode',
    'writing-mode': 'writingMode',
    xchannelselector: 'xChannelSelector',
    xheight: 'xHeight',
    'x-height': 'xHeight',
    xlinkactuate: 'xlinkActuate',
    'xlink:actuate': 'xlinkActuate',
    xlinkarcrole: 'xlinkArcrole',
    'xlink:arcrole': 'xlinkArcrole',
    xlinkhref: 'xlinkHref',
    'xlink:href': 'xlinkHref',
    xlinkrole: 'xlinkRole',
    'xlink:role': 'xlinkRole',
    xlinkshow: 'xlinkShow',
    'xlink:show': 'xlinkShow',
    xlinktitle: 'xlinkTitle',
    'xlink:title': 'xlinkTitle',
    xlinktype: 'xlinkType',
    'xlink:type': 'xlinkType',
    xmlbase: 'xmlBase',
    'xml:base': 'xmlBase',
    xmllang: 'xmlLang',
    'xml:lang': 'xmlLang',
    'xml:space': 'xmlSpace',
    xmlnsxlink: 'xmlnsXlink',
    'xmlns:xlink': 'xmlnsXlink',
    xmlspace: 'xmlSpace',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan',
    // event handlers
    onblur: 'onBlur',
    onchange: 'onChange',
    onclick: 'onClick',
    oncontextmenu: 'onContextMenu',
    ondoubleclick: 'onDoubleClick',
    ondrag: 'onDrag',
    ondragend: 'onDragEnd',
    ondragenter: 'onDragEnter',
    ondragexit: 'onDragExit',
    ondragleave: 'onDragLeave',
    ondragover: 'onDragOver',
    ondragstart: 'onDragStart',
    ondrop: 'onDrop',
    onerror: 'onError',
    onfocus: 'onFocus',
    oninput: 'onInput',
    oninvalid: 'onInvalid',
    onkeydown: 'onKeyDown',
    onkeypress: 'onKeyPress',
    onkeyup: 'onKeyUp',
    onload: 'onLoad',
    onmousedown: 'onMouseDown',
    onmouseenter: 'onMouseEnter',
    onmouseleave: 'onMouseLeave',
    onmousemove: 'onMouseMove',
    onmouseout: 'onMouseOut',
    onmouseover: 'onMouseOver',
    onmouseup: 'onMouseUp',
    onscroll: 'onScroll',
    onsubmit: 'onSubmit',
    ontouchcancel: 'onTouchCancel',
    ontouchend: 'onTouchEnd',
    ontouchmove: 'onTouchMove',
    ontouchstart: 'onTouchStart',
    onwheel: 'onWheel',
};

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (undefined && undefined.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read$1(arguments[i]));
    return ar;
};
function parseAttributes(node, reactKey) {
    var attributes = {
        key: reactKey,
    };
    /* istanbul ignore else */
    if (node instanceof Element) {
        var nodeClassNames = node.getAttribute('class');
        if (nodeClassNames) {
            attributes.className = nodeClassNames;
        }
        __spread(node.attributes).forEach(function (d) {
            switch (d.name) {
                // this is manually handled above, so break;
                case 'class':
                    break;
                case 'style':
                    attributes[d.name] = styleToObject(d.value);
                    break;
                case 'allowfullscreen':
                case 'allowpaymentrequest':
                case 'async':
                case 'autofocus':
                case 'autoplay':
                case 'checked':
                case 'controls':
                case 'default':
                case 'defer':
                case 'disabled':
                case 'formnovalidate':
                case 'hidden':
                case 'ismap':
                case 'itemscope':
                case 'loop':
                case 'multiple':
                case 'muted':
                case 'nomodule':
                case 'novalidate':
                case 'open':
                case 'readonly':
                case 'required':
                case 'reversed':
                case 'selected':
                case 'typemustmatch':
                    attributes[possibleStandardNames[d.name] || d.name] = true;
                    break;
                default:
                    attributes[possibleStandardNames[d.name] || d.name] = d.value;
            }
        });
    }
    return attributes;
}
function parseChildren(childNodeList, level, options) {
    var children = __spread(childNodeList).map(function (node, index) {
        return convertFromNode(node, __assign(__assign({}, options), { index: index, level: level + 1 }));
    })
        .filter(Boolean);
    if (!children.length) {
        return null;
    }
    return children;
}
function parseName(nodeName) {
    if (/[a-z]+[A-Z]+[a-z]+/.test(nodeName)) {
        return nodeName;
    }
    return nodeName.toLowerCase();
}
function convertFromNode(input, options) {
    var _a;
    if (options === void 0) { options = {}; }
    if (!input || !(input instanceof Node)) {
        return null;
    }
    var _b = options.actions, actions = _b === void 0 ? [] : _b, _c = options.index, index = _c === void 0 ? 0 : _c, _d = options.level, level = _d === void 0 ? 0 : _d;
    var node = input;
    var key = level + "-" + index;
    var result = [];
    /* istanbul ignore else */
    if (Array.isArray(actions)) {
        actions.forEach(function (action) {
            if (action.condition(node, key, level)) {
                if (typeof action.pre === 'function') {
                    node = action.pre(node, key, level);
                    if (!(node instanceof Node)) {
                        node = input;
                        /* istanbul ignore else */
                        if (process.env.NODE_ENV !== 'production') {
                            // eslint-disable-next-line no-console
                            console.warn('The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)');
                        }
                    }
                }
                if (typeof action.post === 'function') {
                    result.push(action.post(node, key, level));
                }
            }
        });
    }
    if (result.length) {
        return result;
    }
    switch (node.nodeType) {
        case 1: {
            // regular dom-node
            return createElement(parseName(node.nodeName), parseAttributes(node, key), parseChildren(node.childNodes, level, options));
        }
        case 3: {
            // textnode
            var nodeText = ((_a = node.nodeValue) === null || _a === void 0 ? void 0 : _a.toString()) || '';
            /* istanbul ignore else */
            if (/^\s+$/.test(nodeText) && !/[\u202F\u00A0]/.test(nodeText)) {
                return null;
            }
            /* istanbul ignore next */
            if (!node.parentNode) {
                return nodeText;
            }
            var parentNodeName = node.parentNode.nodeName.toLowerCase();
            if (noTextChildNodes.indexOf(parentNodeName) !== -1) {
                /* istanbul ignore else */
                if (/\S/.test(nodeText)) {
                    // eslint-disable-next-line no-console
                    console.warn("A textNode is not allowed inside '" + parentNodeName + "'. Your text \"" + nodeText + "\" will be ignored");
                }
                return null;
            }
            return nodeText;
        }
        case 8: {
            // html-comment
            return null;
        }
        /* istanbul ignore next */
        default: {
            return null;
        }
    }
}
function convertFromString(input, options) {
    if (options === void 0) { options = {}; }
    if (!input || typeof input !== 'string') {
        return null;
    }
    var _a = options.nodeOnly, nodeOnly = _a === void 0 ? false : _a, _b = options.selector, selector = _b === void 0 ? 'body > *' : _b, _c = options.type, type = _c === void 0 ? 'text/html' : _c;
    try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(input, type);
        var node = doc.querySelector(selector);
        if (!(node instanceof Node)) {
            throw new Error('Error parsing input');
        }
        if (nodeOnly) {
            return node;
        }
        return convertFromNode(node, options);
    }
    catch (error) {
        /* istanbul ignore else */
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }
    return null;
}
function convert(input, options) {
    if (options === void 0) { options = {}; }
    if (typeof input === 'string') {
        return convertFromString(input, options);
    }
    if (input instanceof Node) {
        return convertFromNode(input, options);
    }
    return null;
}

var exenv = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if ( module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});
var exenv_1 = exenv.canUseDOM;

var STATUS = {
    FAILED: 'failed',
    LOADED: 'loaded',
    LOADING: 'loading',
    PENDING: 'pending',
    READY: 'ready',
    UNSUPPORTED: 'unsupported',
};
function canUseDOM() {
    return exenv_1;
}
function supportsInlineSVG() {
    /* istanbul ignore next */
    if (!document) {
        return false;
    }
    var div = document.createElement('div');
    div.innerHTML = '<svg />';
    return !!div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
}
function isSupportedEnvironment() {
    return supportsInlineSVG() && typeof window !== 'undefined' && window !== null;
}
function randomString(length) {
    var letters = 'abcdefghijklmnopqrstuvwxyz';
    var numbers = '1234567890';
    var charset = "" + letters + letters.toUpperCase() + numbers;
    var randomCharacter = function (character) {
        return character[Math.floor(Math.random() * character.length)];
    };
    var R = '';
    for (var i = 0; i < length; i++) {
        R += randomCharacter(charset);
    }
    return R;
}

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read$2 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread$1 = (undefined && undefined.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read$2(arguments[i]));
    return ar;
};
var cacheStore = Object.create(null);
var InlineSVG = /** @class */ (function (_super) {
    __extends(InlineSVG, _super);
    function InlineSVG(props) {
        var _this = _super.call(this, props) || this;
        _this.isActive = false;
        _this.handleCacheQueue = function (content) {
            /* istanbul ignore else */
            if (typeof content === 'string') {
                _this.handleLoad(content);
                return;
            }
            _this.handleError(content);
        };
        _this.handleLoad = function (content) {
            /* istanbul ignore else */
            if (_this.isActive) {
                _this.setState({
                    content: content,
                    status: STATUS.LOADED,
                }, _this.getElement);
            }
        };
        _this.handleError = function (error) {
            var onError = _this.props.onError;
            var status = error.message === 'Browser does not support SVG' ? STATUS.UNSUPPORTED : STATUS.FAILED;
            /* istanbul ignore else */
            if (_this.isActive) {
                _this.setState({ status: status }, function () {
                    /* istanbul ignore else */
                    if (typeof onError === 'function') {
                        onError(error);
                    }
                });
            }
        };
        _this.request = function () {
            var _a = _this.props, cacheRequests = _a.cacheRequests, src = _a.src;
            try {
                if (cacheRequests) {
                    cacheStore[src] = { content: '', status: STATUS.LOADING, queue: [] };
                }
                return fetch(src)
                    .then(function (response) {
                    var contentType = response.headers.get('content-type');
                    var _a = __read$2((contentType || '').split(/ ?; ?/), 1), fileType = _a[0];
                    if (response.status > 299) {
                        throw new Error('Not found');
                    }
                    if (!['image/svg+xml', 'text/plain'].some(function (d) { return fileType.indexOf(d) >= 0; })) {
                        throw new Error("Content type isn't valid: " + fileType);
                    }
                    return response.text();
                })
                    .then(function (content) {
                    _this.handleLoad(content);
                    /* istanbul ignore else */
                    if (cacheRequests) {
                        var cache = cacheStore[src];
                        /* istanbul ignore else */
                        if (cache) {
                            cache.content = content;
                            cache.status = STATUS.LOADED;
                            cache.queue = cache.queue.filter(function (cb) {
                                cb(content);
                                return false;
                            });
                        }
                    }
                })
                    .catch(function (error) {
                    _this.handleError(error);
                    /* istanbul ignore else */
                    if (cacheRequests) {
                        var cache = cacheStore[src];
                        /* istanbul ignore else */
                        if (cache) {
                            cache.queue.forEach(function (cb) {
                                cb(error);
                            });
                            delete cacheStore[src];
                        }
                    }
                });
            }
            catch (error) {
                return _this.handleError(new Error(error.message));
            }
        };
        _this.state = {
            content: '',
            element: null,
            hasCache: !!props.cacheRequests && !!cacheStore[props.src],
            status: STATUS.PENDING,
        };
        _this.hash = props.uniqueHash || randomString(8);
        return _this;
    }
    InlineSVG.prototype.componentDidMount = function () {
        this.isActive = true;
        if (!canUseDOM()) {
            return;
        }
        var status = this.state.status;
        var src = this.props.src;
        try {
            /* istanbul ignore else */
            if (status === STATUS.PENDING) {
                /* istanbul ignore else */
                if (!isSupportedEnvironment()) {
                    throw new Error('Browser does not support SVG');
                }
                /* istanbul ignore else */
                if (!src) {
                    throw new Error('Missing src');
                }
                this.load();
            }
        }
        catch (error) {
            this.handleError(error);
        }
    };
    InlineSVG.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!canUseDOM()) {
            return;
        }
        var _a = this.state, hasCache = _a.hasCache, status = _a.status;
        var _b = this.props, onLoad = _b.onLoad, src = _b.src;
        if (prevState.status !== STATUS.READY && status === STATUS.READY) {
            /* istanbul ignore else */
            if (onLoad) {
                onLoad(src, hasCache);
            }
        }
        if (prevProps.src !== src) {
            if (!src) {
                this.handleError(new Error('Missing src'));
                return;
            }
            this.load();
        }
    };
    InlineSVG.prototype.componentWillUnmount = function () {
        this.isActive = false;
    };
    InlineSVG.prototype.processSVG = function () {
        var content = this.state.content;
        var preProcessor = this.props.preProcessor;
        if (preProcessor) {
            return preProcessor(content);
        }
        return content;
    };
    InlineSVG.prototype.updateSVGAttributes = function (node) {
        var _this = this;
        var _a = this.props, _b = _a.baseURL, baseURL = _b === void 0 ? '' : _b, uniquifyIDs = _a.uniquifyIDs;
        var replaceableAttributes = ['id', 'href', 'xlink:href', 'xlink:role', 'xlink:arcrole'];
        var linkAttributes = ['href', 'xlink:href'];
        var isDataValue = function (name, value) {
            return linkAttributes.indexOf(name) >= 0 && (value ? value.indexOf('#') < 0 : false);
        };
        if (!uniquifyIDs) {
            return node;
        }
        __spread$1(node.children).map(function (d) {
            if (d.attributes && d.attributes.length) {
                var attributes_1 = Object.values(d.attributes).map(function (a) {
                    var attr = a;
                    var match = a.value.match(/url\((.*?)\)/);
                    if (match && match[1]) {
                        attr.value = a.value.replace(match[0], "url(" + baseURL + match[1] + "__" + _this.hash + ")");
                    }
                    return attr;
                });
                replaceableAttributes.forEach(function (r) {
                    var attribute = attributes_1.find(function (a) { return a.name === r; });
                    if (attribute && !isDataValue(r, attribute.value)) {
                        attribute.value = attribute.value + "__" + _this.hash;
                    }
                });
            }
            if (d.children.length) {
                return _this.updateSVGAttributes(d);
            }
            return d;
        });
        return node;
    };
    InlineSVG.prototype.getNode = function () {
        var _a = this.props, description = _a.description, title = _a.title;
        try {
            var svgText = this.processSVG();
            var node = convert(svgText, { nodeOnly: true });
            if (!node || !(node instanceof SVGSVGElement)) {
                throw new Error('Could not convert the src to a DOM Node');
            }
            var svg = this.updateSVGAttributes(node);
            if (description) {
                var originalDesc = svg.querySelector('desc');
                if (originalDesc && originalDesc.parentNode) {
                    originalDesc.parentNode.removeChild(originalDesc);
                }
                var descElement = document.createElement('desc');
                descElement.innerHTML = description;
                svg.prepend(descElement);
            }
            if (title) {
                var originalTitle = svg.querySelector('title');
                if (originalTitle && originalTitle.parentNode) {
                    originalTitle.parentNode.removeChild(originalTitle);
                }
                var titleElement = document.createElement('title');
                titleElement.innerHTML = title;
                svg.prepend(titleElement);
            }
            return svg;
        }
        catch (error) {
            return this.handleError(error);
        }
    };
    InlineSVG.prototype.getElement = function () {
        try {
            var node = this.getNode();
            var element = convert(node);
            if (!element || !isValidElement(element)) {
                throw new Error('Could not convert the src to a React element');
            }
            this.setState({
                element: element,
                status: STATUS.READY,
            });
        }
        catch (error) {
            this.handleError(new Error(error.message));
        }
    };
    InlineSVG.prototype.load = function () {
        var _this = this;
        /* istanbul ignore else */
        if (this.isActive) {
            this.setState({
                content: '',
                element: null,
                status: STATUS.LOADING,
            }, function () {
                var _a = _this.props, cacheRequests = _a.cacheRequests, src = _a.src;
                var cache = cacheRequests && cacheStore[src];
                if (cache) {
                    /* istanbul ignore else */
                    if (cache.status === STATUS.LOADING) {
                        cache.queue.push(_this.handleCacheQueue);
                    }
                    else if (cache.status === STATUS.LOADED) {
                        _this.handleLoad(cache.content);
                    }
                    return;
                }
                var dataURI = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);
                var inlineSrc;
                if (dataURI) {
                    inlineSrc = dataURI[1] ? atob(dataURI[2]) : decodeURIComponent(dataURI[2]);
                }
                else if (src.indexOf('<svg') >= 0) {
                    inlineSrc = src;
                }
                if (inlineSrc) {
                    _this.handleLoad(inlineSrc);
                    return;
                }
                _this.request();
            });
        }
    };
    InlineSVG.prototype.render = function () {
        var _a = this.state, element = _a.element, status = _a.status;
        var _b = this.props, baseURL = _b.baseURL, cacheRequests = _b.cacheRequests, _c = _b.children, children = _c === void 0 ? null : _c, description = _b.description, innerRef = _b.innerRef, _d = _b.loader, loader = _d === void 0 ? null : _d, onError = _b.onError, onLoad = _b.onLoad, preProcessor = _b.preProcessor, src = _b.src, title = _b.title, uniqueHash = _b.uniqueHash, uniquifyIDs = _b.uniquifyIDs, rest = __rest(_b, ["baseURL", "cacheRequests", "children", "description", "innerRef", "loader", "onError", "onLoad", "preProcessor", "src", "title", "uniqueHash", "uniquifyIDs"]);
        if (!canUseDOM()) {
            return loader;
        }
        if (element) {
            return cloneElement(element, __assign$1({ ref: innerRef }, rest));
        }
        if ([STATUS.UNSUPPORTED, STATUS.FAILED].indexOf(status) > -1) {
            return children;
        }
        return loader;
    };
    InlineSVG.defaultProps = {
        cacheRequests: true,
        uniquifyIDs: false,
    };
    return InlineSVG;
}(PureComponent));

var PROD_URL = 'https://d64is2qkxbhv3.cloudfront.net/assets/dist';
var STAGE_URL = 'https://d2v0lj9tfbnmhu.cloudfront.net/assets/dist';
var isProd = process.env.REACT_APP_ENVIRONMENT === 'production';
var SVG_HOST_URL = isProd ? PROD_URL : STAGE_URL;
var RUM_ACTION_ATTRIBUTE = 'data-dd-action-name';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var fileTypeIcons = {
  FileTypeXLSX: 'file-types/xlsx.svg',
  FileTypeCSV: 'file-types/csv.svg',
  FileTypeGIF: 'file-types/gif.svg',
  FileTypeJPEG: 'file-types/jpeg.svg',
  FileTypePNG: 'file-types/png.svg',
  FileTypeMP3: 'file-types/mp3.svg',
  FileTypeWAV: 'file-types/wav.svg',
  FileTypeOGG: 'file-types/ogg.svg',
  FileTypeMP4: 'file-types/mp4.svg',
  FileTypeMOV: 'file-types/mov.svg',
  FileTypeMPEG: 'file-types/mpeg.svg'
};
var creativesIcons = {
  CreativeImage: 'creative/image.svg',
  CreativeHtml: 'creative/html.svg',
  CreativeGotv: 'creative/gotv.svg',
  CreativeTicker: 'creative/ticker.svg',
  CreativeVideo: 'creative/video.svg',
  CreativeAudio: 'creative/audio.svg',
  CreativeImageEmptyListPlaceholder: 'creatives/empty-list-placeholder/image.svg',
  CreativeHTMLEmptyListPlaceholder: 'creatives/empty-list-placeholder/html.svg',
  CreativeVideoEmptyListPlaceholder: 'creatives/empty-list-placeholder/video.svg',
  CreativeAudioEmptyListPlaceholder: 'creatives/empty-list-placeholder/audio.svg',
  CreativeImageDescription: 'creatives/creative-description/image.svg',
  CreativeHTMLDescription: 'creatives/creative-description/html.svg',
  CreativeVideoDescription: 'creatives/creative-description/video.svg',
  CreativeAudioDescription: 'creatives/creative-description/audio.svg'
};
var audienceIcons = {
  AudienceAll: 'audience/audiences-all.svg',
  AudienceAdvanced: 'audience/advanced.svg',
  AudienceCampaign: 'audience/campaign.svg',
  AudienceCustom: 'audience/custom.svg',
  AudienceGeo: 'audience/geo.svg',
  AudienceMatched: 'audience/matched.svg',
  AudienceRetargeted: 'audience/retargeted.svg',
  AudienceSegmented: 'audience/segmented.svg',
  AudienceLookalike: 'audience/lookalike.svg',
  AudienceContextual: 'audience/contextual.svg',
  AudienceEmptyTimeline: 'audience/emptyTimeline.svg'
};
var InventoryIcons = {
  InventoryTypeIOS: 'inventory/type-ios.svg',
  InventoryTypeSite: 'inventory/type-site.svg',
  InventoryTypeAndroid: 'inventory/type-android.svg',
  InventoryTypeOther: 'inventory/type-other.svg',
  InventoryExchange: 'inventory/exchange.svg',
  InventoryDeals: 'inventory/deals.svg',
  InventoryContextual: 'inventory/contextual.svg',
  InventoryEmptySearchResult: 'inventory/empty-search-result.svg',
  InventoryEmptyExchangeGroup: 'inventory/empty-exchange-group.svg',
  InventoryEmptyDealsGroup: 'inventory/empty-deals-group.svg',
  InventoryEmptyContextualGroup: 'inventory/empty-contextual-group.svg',
  InventoryEmptyBlacklist: 'inventory/empty-blacklist.svg',
  InventoryEmptyBlocklist: 'inventory/empty-blocklist.svg',
  InventoryEmptyGroup: 'inventory/empty-group.svg',
  InventoryEmptyGroupList: 'inventory/empty-group-list.svg'
};
var bidModelIcons = {
  BidModelCreative: 'bid-model/creative.svg',
  BidModelDemographics: 'bid-model/demographics.svg',
  BidModelExchange: 'bid-model/exchange.svg',
  BidModelInventory: 'bid-model/inventory.svg',
  BidModelLocation: 'bid-model/location.svg',
  BidModelTechnology: 'bid-model/technology.svg'
};
var eventsIcons = {
  EventsAppEvent: 'events/app_event.svg',
  EventsCalculated: 'events/calculated.svg',
  EventsConversion: 'events/conversion.svg',
  EventsLocation: 'events/location.svg',
  EventsPixel: 'events/pixel.svg',
  EventsPostBack: 'events/post_back.svg',
  EventsFunnel: 'events/funnel.svg'
};
var miscIcons = {
  EmptySectionBlue: 'misc/empty-section-blue.svg'
};
var statusIcons = {
  StatusRunning: 'status/status_running.svg',
  StatusRunningColor: 'status/status_running_color.svg',
  StatusPaused: 'status/status_paused.svg',
  StatusPausedColor: 'status/status_paused_color.svg',
  StatusBudgetPaused: 'status/status_budget_pasued.svg',
  StatusBudgetPausedColor: 'status/status_budget_pasued_color.svg',
  StatusPending: 'status/status_pending.svg',
  StatusPendingColor: 'status/status_pending_color.svg',
  StatusDraft: 'status/status_draft.svg',
  StatusDraftColor: 'status/status_draft_color.svg',
  StatusExpired: 'status/status_expired.svg',
  StatusExpiredColor: 'status/status_expired_color.svg',
  StatusDeleted: 'status/status_deleted.svg',
  StatusDeletedColor: 'status/status_deleted_color.svg',
  StatusRejected: 'status/status_rejected.svg',
  StatusRejectedColor: 'status/status_rejected_color.svg',
  StatusApproved: 'status/status_approved.svg',
  StatusApprovedColor: 'status/status_approved_color.svg',
  StatusAll: 'status/status_all.svg',
  StatusAllColor: 'status/status_all_color.svg',
  StatusFailed: 'status/status_failed.svg',
  StatusFailedColor: 'status/status_failed_color.svg',
  StatusReadyColor: 'status/status_ready_color.svg',
  StatusUnusedColor: 'status/status_unused_color.svg',
  StatusProcessingColor: 'status/status_processing_color.svg',
  StatusInvitedColor: 'status/status_invited_color.svg'
};
var osIcons = {
  OsAmazon: 'os/amazon.svg',
  OsAndroid: 'os/android.svg',
  OsApple: 'os/apple.svg',
  OsChrome: 'os/chrome.svg',
  OsLinux: 'os/linux.svg',
  OsWindows: 'os/windows.svg'
};
var filterIcons = {
  FilterDma: 'filter/dma.svg',
  FilterRadius: 'filter/radius.svg',
  FilterPolygon: 'filter/polygon.svg',
  FilterZip: 'filter/zip.svg',
  FilterCongress: 'filter/congress.svg',
  FilterSenate: 'filter/senate.svg',
  FilterHouse: 'filter/house.svg',
  FilterCounty: 'filter/county.svg',
  FilterCity: 'filter/city.svg',
  FilterState: 'filter/state.svg'
};
var campaignsIcons = {
  CampaignsCreative: 'campaigns/creative.svg',
  CampaignsLocation: 'campaigns/location.svg',
  CampaignsDemographic: 'campaigns/demographic.svg',
  CampaignsInventory: 'campaigns/inventory.svg',
  CampaignsTime: 'campaigns/time.svg',
  CampaignsInfo: 'campaigns/info.svg',
  CampaignsBid: 'campaigns/bid.svg',
  CampaignsAudience: 'campaigns/audience.svg',
  CampaignsBudget: 'campaigns/budget.svg',
  CampaignsStatistic: 'campaigns/statistic.svg',
  CampaignsTechnology: 'campaigns/technology.svg',
  CampaignsStateLaw: 'campaigns/state_law.svg',
  CampaignsKeyWords: 'campaigns/key_words.svg',
  CampaignsEmptyLocations: 'campaigns/empty-locations.svg'
};
var applicationsIcons = {
  'Manage Users': 'applications/app-1.svg',
  'Manage Customers': 'applications/app-2.svg',
  Finance: 'applications/finances.svg',
  Dashboard: 'applications/dashboard.svg',
  'Campaign Builder': 'applications/campaigns.svg',
  'Creative Builder': 'applications/creatives.svg',
  'Audience Builder': 'applications/audiences.svg',
  'Manage Publishers': 'applications/app-8.svg',
  'Manage Exchanges': 'applications/app-9.svg',
  'Report Builder': 'applications/reports.svg',
  'Voter Intelligence': 'applications/app-11.svg',
  'Campaign Manager': 'applications/app-12.svg',
  'My Profile': 'applications/my-profile.svg',
  Accounts: 'applications/accounts.svg',
  Customers: 'applications/customers.svg',
  'Bid Model': 'applications/bid-model.svg',
  Inventory: 'applications/inventory.svg',
  'Inventory Managment': 'applications/inventory-management.svg',
  Framework: 'applications/framework.svg',
  Segments: 'applications/segments.svg',
  Conversions: 'applications/conversions.svg',
  Organization: 'applications/organization.svg',
  Supertweak: 'applications/supertweak.svg'
};
var creativeIcons = {
  BannerXS: 'banner_xs.svg',
  HtmlXS: 'html_xs.svg',
  gotvXS: 'gotv_xs.svg',
  scrollXS: 'scroll_xs.svg',
  VideoXS: 'video_xs.svg',
  VoiceXS: 'voice_xs.svg',
  NativeAdXs: 'native-ad_xs.svg'
};
var reportIcons = {
  customizeReport: 'report/ic-customize-report.svg',
  dataReport: 'report/ic-data-report.svg',
  omniChannel: 'report/ic-omni-channel.svg',
  supplyPath: 'report/ic-supply-path.svg',
  emptyCreateCampaign: 'report/img-empty-create-campaign.svg',
  emptyCreateReport: 'report/img-empty-create-report.svg',
  emptyReportingAnalytics: 'report/img-empty-reporting-analytics.svg'
};
var deviceIcons = {
  Phone: 'phone.svg',
  Tablet: 'tablet.svg',
  Desktop: 'desktop.svg',
  SmartTV: 'smart_tv.svg',
  OtherEmbedded: 'other_embedded.svg',
  EmptyClipboard: 'empty-clipboard.svg'
};
var commonIcons = {
  CSV: 'csv.svg',
  XLS: 'xls.svg',
  Delete: 'delete.svg',
  DeleteAlt: 'delete-alt.svg',
  Copy: 'copy.svg',
  CopyRounded: 'copy-rounded.svg',
  Spending: 'spending.svg',
  Reorder: 'reorder.svg',
  Checkbox: 'check-box-24px.svg',
  CheckboxBlank: 'check-box-blank-24px.svg',
  AlertCircle: 'alert_circle.svg',
  CheckCircle: 'check_circle.svg',
  CheckCircleBW: 'check_circle-bw.svg',
  ErrorTriangle: 'error_triangle.svg',
  WarningTriangle: 'warning_triangle.svg',
  DateRange: 'date_range.svg',
  DragIndicator: 'drag-indicator.svg',
  Apps: 'apps.svg',
  Notification: 'notifications.svg',
  Created: 'created.svg',
  Print: 'print.svg',
  Refresh: 'refresh.svg',
  Updated: 'updated.svg',
  Impressions: 'impressions.svg',
  Close: 'close.svg',
  Add: 'add.svg',
  Plus: 'plus.svg',
  Left: 'left.svg',
  Collapse: 'collapse.svg',
  Right: 'right.svg',
  Expand: 'expand.svg',
  UnfoldMore: 'unfold_more.svg',
  ArrowLeft: 'arrow_left.svg',
  ArrowUp: 'arrow_up.svg',
  ArrowRight: 'arrow_right.svg',
  ArrowDown: 'arrow_down.svg',
  ArrowMaximize: 'arrow_maximize.svg',
  ArrowMinimize: 'arrow_minimize.svg',
  DropDown: 'drop_down.svg',
  DropUp: 'drop_up.svg',
  Report: 'report.svg',
  NoData: 'no_data.svg',
  Search: 'search.svg',
  Marketplace: 'marketplace.svg',
  Edit: 'edit.svg',
  EditAlt: 'edit-alt.svg',
  Eye: 'eye.svg',
  EyeOff: 'eye-off.svg',
  Menu: 'menu.svg',
  MessageDots: 'message_dots.svg',
  Filter: 'filter.svg',
  FilterItems: 'filter_items.svg',
  More: 'more.svg',
  Agenda: 'agenda.svg',
  Done: 'done.svg',
  Sort: 'sort.svg',
  Star: 'star.svg',
  Tap: 'tap.svg',
  Info: 'info.svg',
  List: 'list.svg',
  Table: 'table.svg',
  OneDate: 'one_date.svg',
  AddEmail: 'envelope-add.svg',
  Question: 'question.svg',
  Upload: 'upload.svg',
  People: 'people.svg',
  NoImage: 'no_image.svg',
  Activity: 'activity.svg',
  Advanced: 'advanced.svg',
  Audio: 'audio.svg',
  Circle: 'circle.svg',
  CloseCircle: 'close_circle.svg',
  Conditional: 'conditioanal.svg',
  Customer: 'customer.svg',
  Dollar: 'dollar.svg',
  Dot: 'dot.svg',
  DotLarge: 'dot_large.svg',
  Download: 'download.svg',
  ViewColumn: 'view_column.svg',
  ExpandSide: 'expand_side.svg',
  Group: 'group.svg',
  Link: 'link.svg',
  Location: 'location.svg',
  Lock: 'lock.svg',
  MinusCircle: 'minus_circle.svg',
  OpenLink: 'open_link.svg',
  Pause: 'pause.svg',
  Person: 'person.svg',
  Play: 'play.svg',
  Plugin: 'plugin.svg',
  PlusCircle: 'plus_circle.svg',
  Polygon: 'polygon.svg',
  Radius: 'radius.svg',
  Square: 'square.svg',
  PrivateDeals: 'private_deals.svg',
  Globe: 'globe.svg',
  Internet: 'internet.svg',
  Mail: 'mail.svg',
  Briefcase: 'briefcase.svg',
  Sharp: 'sharp.svg',
  Address: 'address.svg',
  App: 'app.svg',
  Web: 'web.svg',
  Percentage: 'percentage.svg',
  RadioChecked: 'radio_button_checked.svg',
  RadioUnchecked: 'radio_button_unchecked.svg',
  DollarInSquare: 'dollar-in-square.svg',
  PictureInPicture: 'picture-in-picture.svg',
  HelpCircle: 'help-circle.svg',
  Home: 'home.svg',
  Fingerprint: 'fingerprint.svg',
  Users: 'users.svg',
  ArrowSort: 'arrows-sort.svg',
  Photo: 'photo.svg',
  Crown: 'crown.svg',
  Settings: 'settings.svg',
  Tool: 'tool.svg',
  Invoice: 'invoice.svg',
  Payments: 'payments.svg',
  FileDownload: 'file_download.svg',
  Credit: 'credit.svg',
  SubscriptionPlan: 'add_email.svg',
  EditSquare: 'edit-square.svg',
  Save: 'save.svg',
  Reset: 'reset.svg',
  ShieldLock: 'shield-lock.svg',
  Building: 'building.svg',
  Palette: 'palette.svg',
  UserCheck: 'user_check.svg',
  FileInvoice: 'file_invoice.svg',
  PDF: 'pdf.svg',
  PaymentCard: 'payment-card.svg',
  PaymentPaypal: 'payment-paypal.svg',
  PaymentCheck: 'payment-check.svg',
  Timezone: 'timezone.svg',
  SquarePlus: 'square_plus.svg',
  SquareMinus: 'square_minus.svg',
  DownloadRounded: 'download-rounded.svg',
  BookmarkFlag: 'bookmark-flag.svg',
  ActivityLogVine: 'activity-log-vine.svg',
  ActivityAlt: 'activity-alt.svg',
  AppsAlt: 'apps-alt.svg',
  Bookmarks: 'bookmarks.svg',
  CurrencyDollar: 'currency-dollar.svg',
  ListCheck: 'list-check.svg',
  Send: 'send.svg',
  UsersAlt: 'users-alt.svg',
  AdminActivity: 'admin-activity.svg',
  CTV: 'ctv.svg',
  OTT: 'ott.svg',
  Folder: 'folder.svg',
  responsiveMessage: 'img-responsive-msg.svg',
  Ads: 'ads.svg',
  CalendarEvent: 'calendar-events.svg',
  Code: 'code.svg',
  Equilizer: 'equilizer.svg',
  FileUpload: 'file-upload.svg',
  GeofenceUser: 'geofence-user.svg',
  MapPin: 'map-pin.svg',
  MultiPeople: 'multi-people.svg',
  PickUsers: 'pick-users.svg',
  Segment: 'segment.svg',
  TableCell: "table-cell.svg",
  UserList: 'user-list.svg',
  UserTag: 'user-tag.svg',
  UserTarget: 'user-target.svg',
  WebsiteClick: 'website-click.svg',
  Website: 'website.svg',
  FolderShare: 'folder_share.svg',
  Scan: 'scan.svg',
  Analytics: 'analytics.svg'
};
var iconNameURLMap = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, commonIcons), creativesIcons), fileTypeIcons), audienceIcons), InventoryIcons), bidModelIcons), eventsIcons), statusIcons), osIcons), filterIcons), campaignsIcons), applicationsIcons), reportIcons), creativeIcons), deviceIcons), miscIcons), {}, {
  GenerateProgress: 'gen_report.svg',
  EnabledAdBlockImage: 'EnabledAdBlockImage.svg'
});
var strokeIcons = ['ViewColumn', 'Download', 'Percentage', 'DollarInSquare', 'PictureInPicture', 'Mail', 'Tool', 'Internet', 'Briefcase', 'Eye', 'EyeOff', 'Home', 'Fingerprint', 'Users', 'ArrowSort', 'Photo', 'Crown', 'Settings', 'Invoice', 'Payments', 'FileDownload', 'Credit', 'ShieldLock', 'Building', 'UserCheck', 'FileInvoice', 'Palette', 'Globe', 'SquarePlus', 'DownloadRounded', 'BookmarkFlag', 'ActivityAlt', 'Bookmarks', 'CurrencyDollar', 'ListCheck', 'Send', 'EmptyClipboard', 'CopyRounded', 'Ads', 'CalendarEvent', 'Code', 'Equilizer', 'FileUpload', 'GeofenceUser', 'MapPin', 'MultiPeople', 'PickUsers', 'Segment', 'TableCell', 'UserList', 'UserTag', 'UserTarget', 'WebsiteClick', 'Website', 'MessageDots'];
var noColorChangeIcons = ['App', 'Web', 'SmartTV', 'Phone', 'Desktop', 'Tablet', 'Address', 'FilterDma', 'FilterZip', 'FilterCongress', 'FilterSenate', 'InventoryEmptyGroup', 'FolderShare', 'Scan', 'Analytics', 'FilterHouse'];
var fillPathIcons = ['Search', 'EditAlt', 'AddEmail', 'HelpCircle', 'AppsAlt', 'UsersAlt', 'AdminActivity'];
var Icon = /*#__PURE__*/function (_Component) {
  inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;
      var fileName = iconNameURLMap[name] || 'no_image.svg';
      var classNameToSet = [className || ''];

      if (strokeIcons.includes(name)) {
        classNameToSet.push('stroke-icon');
      } else if (noColorChangeIcons.includes(name)) {
        classNameToSet.push('no-color-change-icon');
      } else if (fillPathIcons.includes(name)) {
        classNameToSet.push('fill-path-icon');
      }

      return /*#__PURE__*/React__default.createElement(InlineSVG, {
        preProcessor: function preProcessor(svg) {
          if (!svg.includes('viewBox=')) {
            var res = "".concat(svg.substring(0, 4), " viewBox=\"\" ").concat(svg.substring(5, svg.length));
            var widthStart = res.substring(res.indexOf('width="') + 7);
            var heightStart = res.substring(res.indexOf('height="') + 8);
            var width = widthStart.substring(0, widthStart.indexOf('"'));
            var height = heightStart.substring(0, heightStart.indexOf('"'));
            return res.replace(/\swidth="\S+"\s/, ' ').replace(/\sheight="\S+"\s/, ' ').replace('viewBox=""', "viewBox=\"0 0 ".concat(width, " ").concat(height, "\""));
          }

          return svg;
        },
        uniqueHash: name.toLowerCase().replace(/\s/, ''),
        uniquifyIDs: true,
        className: "svg-icon ".concat(classNameToSet.join(' ')),
        src: "".concat(SVG_HOST_URL, "/").concat(fileName),
        loader: /*#__PURE__*/React__default.createElement("svg", {
          className: "svg-icon loader ".concat(className),
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/React__default.createElement("rect", {
          width: "24",
          height: "24"
        }))
      });
    }
  }]);

  return Icon;
}(Component);
Icon.propTypes = {
  name: PropTypes__default.string.isRequired,
  className: PropTypes__default.string
};

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Ripple = /*#__PURE__*/function (_React$Component) {
  inherits(Ripple, _React$Component);

  var _super = _createSuper$1(Ripple);

  function Ripple() {
    var _this;

    classCallCheck(this, Ripple);

    _this = _super.call(this);
    _this.ripple = /*#__PURE__*/React__default.createRef();
    _this.state = {
      animate: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
    return _this;
  }

  createClass(Ripple, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "ripple ".concat(this.state.animate ? 'is-reppling' : ''),
        ref: this.ripple,
        style: {
          top: this.state.top + 'px',
          left: this.state.left + 'px',
          width: this.state.width + 'px',
          height: this.state.height + 'px'
        }
      });
    }
  }, {
    key: "reppling",
    value: function reppling(cursorPos) {
      var ripple = this.ripple.current;
      var parent = ripple.parentElement;
      var buttonPos = parent.getBoundingClientRect();
      var buttonWidth = parent.offsetWidth;
      var buttonHeight = parent.offsetHeight; // Make a Square Ripple

      var rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth); // Make Ripple Position to be center

      var centerize = rippleWidthShouldBe / 2;
      this.setState({
        animate: true,
        width: rippleWidthShouldBe,
        height: rippleWidthShouldBe,
        top: cursorPos.top - buttonPos.top - centerize,
        left: cursorPos.left - buttonPos.left - centerize
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var cursorPos = nextProps.cursorPos; // Prevent Component duplicates do ripple effect at the same time

      if (cursorPos.time !== this.props.cursorPos.time) {
        if (this.state.animate) {
          this.setState({
            animate: false
          }, function () {
            _this2.reppling(cursorPos);
          });
        } else {
          this.reppling(cursorPos);
        }
      }
    }
  }]);

  return Ripple;
}(React__default.Component);

var Button = function Button(props) {
  var innerRefProps = props.innerRef,
      children = props.children,
      className = props.className,
      size = props.size,
      ripple = props.ripple,
      variant = props.variant,
      iconName = props.iconName,
      iconPosition = props.iconPosition,
      underline = props.underline,
      rest = objectWithoutProperties(props, ["innerRef", "children", "className", "size", "ripple", "variant", "iconName", "iconPosition", "underline"]);

  var _useState = useState({}),
      _useState2 = slicedToArray(_useState, 2),
      cursorPos = _useState2[0],
      setCursorPos = _useState2[1];

  var rippleOnMouseDown = function rippleOnMouseDown(e) {
    var cursorPos = {
      top: e.clientY,
      left: e.clientX,
      time: Date.now()
    };
    setCursorPos(cursorPos);
  };

  var innerRef = function innerRef(el) {
    if (innerRefProps) {
      innerRefProps(el);
    }
  };

  return /*#__PURE__*/React__default.createElement("button", _extends_1({
    className: "btn-v2 ".concat(className, " _").concat(size, " _").concat(variant, " ").concat(iconName ? 'with-icon' : '', " ").concat(underline ? '' : '_no-underline'),
    onMouseDown: rippleOnMouseDown,
    ref: innerRef
  }, rest), /*#__PURE__*/React__default.createElement("span", {
    className: "btn-content"
  }, iconName && iconPosition === 'left' ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconName,
    className: "icon-left"
  }) : null, children, iconName && iconPosition === 'right' ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconName,
    className: "icon-right"
  }) : null), ripple && /*#__PURE__*/React__default.createElement("div", {
    className: "ripple-parent_button"
  }, /*#__PURE__*/React__default.createElement(Ripple, {
    cursorPos: cursorPos
  })));
};
var ButtonCircle = function ButtonCircle(_ref) {
  var iconName = _ref.iconName,
      iconClass = _ref.iconClass,
      className = _ref.className,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["iconName", "iconClass", "className", "children"]);

  return /*#__PURE__*/React__default.createElement(Button, _extends_1({
    variant: "tertiary"
  }, rest, {
    className: "btn-circle ".concat(className || '')
  }), /*#__PURE__*/React__default.createElement(Icon, {
    className: iconClass,
    name: iconName
  }), children);
};
Button.defaultProps = {
  size: 'large',
  variant: 'primary',
  ripple: true,
  className: '',
  iconPosition: 'left',
  underline: true
};
Button.propTypes = {
  className: PropTypes__default.string,
  size: PropTypes__default.oneOf(['small', 'large']),
  variant: PropTypes__default.oneOf(['primary', 'secondary', 'tertiary', 'tertiary2', 'danger', 'bold-link', 'link', 'danger-link', 'danger-bold-link']),
  ripple: PropTypes__default.bool,
  innerRef: PropTypes__default.func,
  iconName: PropTypes__default.string,
  iconPosition: PropTypes__default.oneOf(['left', 'right']),
  underline: PropTypes__default.bool
};

var defaultClass = 'btn-1 _persimmon';
var ButtonLink = function ButtonLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultClass : _ref$className,
      rest = objectWithoutProperties(_ref, ["children", "href", "className"]);

  return /*#__PURE__*/React__default.createElement("a", _extends_1({
    className: className,
    href: href
  }, rest), children);
};

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React__default.createElement("g", {
  fill: "#ff5859",
  className: "logo__i"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M.2 11c.4.3.7.6 1.1.9C6.7 17.3 12 22.7 17.4 28c.7.7 1 1.4 1 2.4v40.3c0 1.6-.1 1.7-1.7 1.7H.2V11z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M18.4.2v16.5c0 .4.2 1-.3 1.2-.5.2-.7-.4-1-.7C11.9 12 6.7 6.8 1.4 1.6L.2.4c.2-.5.6-.2 1-.2h17.2z"
}));

var _ref2 = /*#__PURE__*/React__default.createElement("g", {
  className: "logo__q"
}, /*#__PURE__*/React__default.createElement("path", {
  fill: "#ffa300",
  d: "M103.2.2v64.7c0 .6.3 1.5-.3 1.7-.5.2-.9-.6-1.3-1-5.3-5.2-10.5-10.4-15.7-15.6-.7-.7-1-1.4-1-2.4V19.9c0-1.6 0-1.6-1.6-1.6H50.5c-1.6 0-1.6 0-1.6 1.6v32.6c0 1.7 0 1.7 1.7 1.7H78c1.1 0 1.9.3 2.6 1.1 8.3 8.3 16.6 16.6 24.9 25 .3.3.8.5.7.9-.2.5-.8.3-1.2.3H82.6c-1 0-1.7-.3-2.3-1-2.3-2.3-4.6-4.6-6.8-6.9-.8-.8-1.5-1.1-2.6-1.1H32.7c-1.9 0-1.9 0-1.9-1.9V.3C54.8.2 79 .2 103.2.2z"
}));

var _ref3 = /*#__PURE__*/React__default.createElement("g", {
  fill: "#3fd4ad",
  className: "logo__m"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M202.3.2v70.4c0 1.7-.1 1.8-1.9 1.8h-14.9c-1.2 0-1.5-.4-1.5-1.6V18.7c-.7.1-.9.5-1.2.8L160 42.3c-1.1 1.1-1.1 1.1-2.2 0-13.8-13.6-27.5-27.4-41.3-41.1-.3-.3-.6-.7-.9-1H141c5.8 5.8 11.5 11.6 17.3 17.4.5.5.8.3 1.2-.1C165.2 11.7 171 5.9 176.8.2h25.5z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M115.6 41.7v-29c0-.4-.2-1 .2-1.2.5-.2.7.4 1 .7 5.3 5.3 10.6 10.6 15.9 15.8.7.7 1 1.4 1 2.4v40.4c0 1.6 0 1.7-1.7 1.7h-14.9c-1.2 0-1.5-.4-1.5-1.5V41.7z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 202.1 81.1"
  }, props), _ref, _ref2, _ref3);
};

var Logo = function Logo(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      type = _ref.type;
  var classes = ['logo', className];

  if (type) {
    classes.push("_".concat(type));
  }

  return /*#__PURE__*/React__default.createElement("span", {
    className: classes.join(' ')
  }, /*#__PURE__*/React__default.createElement(SvgComponent, null));
};
Logo.defaultProps = {};
Logo.propTypes = {
  className: string,
  type: oneOf(['white', 'black'])
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes layout-module_hover-ripples__3oMeb {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.layout-module_btn-transparent__3omAi {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none; }\n  .layout-module_btn-transparent__3omAi:focus {\n    outline: 0; }\n\n.layout-module_container__2FTRa {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 3.75rem 0 0;\n  min-height: 100vh;\n  transition: all 0.3s linear; }\n  @media (max-width: 1279px) {\n    .layout-module_container__2FTRa {\n      min-width: 80rem; } }\n  .layout-module_container__2FTRa.layout-module__sidebarPadding__Ysywi {\n    padding-left: 20rem; }\n  @media (min-width: 1280px) {\n    .layout-module_container__2FTRa.layout-module__sidebarOpened__lAUeP {\n      padding-left: 20rem; }\n    .layout-module_container__2FTRa.layout-module__rightbarOpened__sXM7r {\n      padding-right: 3.125rem; } }\n\n.layout-module_main__2L7DT {\n  position: relative;\n  flex-grow: 1;\n  transition: padding linear 0.3s; }\n";
var styles = {"btn-transparent":"layout-module_btn-transparent__3omAi","container":"layout-module_container__2FTRa","_sidebarPadding":"layout-module__sidebarPadding__Ysywi","_sidebarOpened":"layout-module__sidebarOpened__lAUeP","_rightbarOpened":"layout-module__rightbarOpened__sXM7r","main":"layout-module_main__2L7DT","hover-ripples":"layout-module_hover-ripples__3oMeb"};
styleInject(css_248z);

var css_248z$1 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes sidebar-module_hover-ripples__36bCk {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.sidebar-module_btn-transparent__2I46I {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none; }\n  .sidebar-module_btn-transparent__2I46I:focus {\n    outline: 0; }\n\n.sidebar-module_sidebar__mrw-A {\n  position: fixed;\n  z-index: 20;\n  top: 4rem;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  align-items: stretch;\n  width: 20rem;\n  border-right: 0.0625rem solid #f4f4f4;\n  background: #ffffff;\n  transition: transform linear 0.3s, width linear 0.3s; }\n  .sidebar-module_sidebar__mrw-A:not(._is-open) {\n    transform: translateX(-100%); }\n  .sidebar-module_sidebar__mrw-A._is-expanded {\n    width: 59.375rem; }\n    .sidebar-module_sidebar__mrw-A._is-expanded._is-open::after {\n      content: '';\n      background-color: #000000;\n      opacity: .25;\n      width: calc(100vw - 100%);\n      height: 100%;\n      position: absolute;\n      margin-left: 100%; }\n\n.sidebar-module_wrapper__2BKsB {\n  pointer-events: none;\n  position: absolute;\n  z-index: 20;\n  right: 0;\n  bottom: 0.75rem;\n  height: 2rem; }\n\n.sidebar-module_sidebar__mrw-A._is-open .sidebar-module_wrapper__2BKsB {\n  width: 20rem;\n  overflow: hidden; }\n\n.sidebar-module_arrow__2zILC {\n  pointer-events: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  align-items: center;\n  transform: translateX(2rem);\n  height: 2rem;\n  border-radius: 0 .25rem .25rem 0;\n  background-color: var(--primary2);\n  opacity: .5;\n  cursor: pointer;\n  transition: background-color .3s, transform .3s, opacity .3s; }\n  .sidebar-module_arrow__2zILC:hover {\n    transform: translateX(100%);\n    opacity: 1; }\n  .sidebar-module_arrow__2zILC:active {\n    outline: none;\n    opacity: 1; }\n\n.sidebar-module_sidebar__mrw-A._is-open .sidebar-module_arrow__2zILC {\n  flex-direction: row;\n  transform: translateX(calc(100% - 32rem / 16));\n  border-radius: .25rem 0 0 .25rem;\n  transition: border-radius .3s .3s, flex-direction .3s .3s, transform .3s, background-color .3s; }\n  .sidebar-module_sidebar__mrw-A._is-open .sidebar-module_arrow__2zILC:hover {\n    transform: translateX(0); }\n\n@keyframes sidebar-module_sidebar-arrow-pointer-events__T8xbc {\n  from {\n    pointer-events: none; }\n  to {\n    pointer-events: none; } }\n\n.sidebar-module_sidebar__mrw-A._is-closed .sidebar-module_arrow__2zILC {\n  animation: sidebar-module_sidebar-arrow-pointer-events__T8xbc .1s; }\n\n.sidebar-module_icon__4dDPT {\n  flex: 0 0 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 2rem;\n  min-height: 2rem; }\n  .sidebar-module_icon__4dDPT svg {\n    transform: rotate(180deg); }\n  .sidebar-module_icon__4dDPT path:nth-child(1) {\n    fill: #ffffff; }\n\n.sidebar-module_sidebar__mrw-A._is-open .sidebar-module_icon__4dDPT svg {\n  transform: none; }\n\n.sidebar-module_title__3N09d {\n  flex: 1 1 auto;\n  padding: 0 0 0 .625rem;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #ffffff; }\n\n.sidebar-module_sidebar__mrw-A._is-open .sidebar-module_title__3N09d {\n  padding: 0 .625rem 0 0; }\n";
var styles$1 = {"btn-transparent":"sidebar-module_btn-transparent__2I46I","sidebar":"sidebar-module_sidebar__mrw-A","wrapper":"sidebar-module_wrapper__2BKsB","arrow":"sidebar-module_arrow__2zILC","sidebar-arrow-pointer-events":"sidebar-module_sidebar-arrow-pointer-events__T8xbc","icon":"sidebar-module_icon__4dDPT","title":"sidebar-module_title__3N09d","hover-ripples":"sidebar-module_hover-ripples__36bCk"};
styleInject(css_248z$1);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Sidebar = /*#__PURE__*/function (_Component) {
  inherits(Sidebar, _Component);

  var _super = _createSuper$2(Sidebar);

  function Sidebar() {
    var _this;

    classCallCheck(this, Sidebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.timer = null;
    _this.zoom = 100;

    _this.changeZoom = function (width) {
      if (!_this.timer) {
        clearTimeout(_this.timer);
      }

      if (width > 1280) {
        if (_this.zoom !== 100) {
          _this.zoom = 100;
          document.body.style.zoom = '100%';
        }

        return;
      }

      var rawZoom = width / 1280 * 100;
      var zoom = Math.min(parseInt(rawZoom) || 100, 100);
      _this.timer = setTimeout(function () {
        _this.zoom = zoom;
        document.body.style.zoom = "".concat(parseInt(zoom) || 100, "%");
      }, 800);
    };

    _this.toggleSidebarOnResize = function () {
      var _this$props = _this.props,
          toggleSidebar = _this$props.toggleSidebar,
          zoomOnResize = _this$props.zoomOnResize;
      var width = window.innerWidth;

      if (zoomOnResize && width > 959 && width < 1281) {
        _this.changeZoom(window.innerWidth);
      } else {
        if (_this.windowWidth === undefined) {
          _this.windowWidth = window.innerWidth;

          if (_this.windowWidth < 1280) {
            toggleSidebar(false);
          }
        } else {
          if (_this.windowWidth < 1280) {
            _this.windowWidth = window.innerWidth;
          } else {
            if (window.innerWidth < 1280) {
              _this.windowWidth = window.innerWidth;
              _this.props.isOpen && toggleSidebar(false);
            }
          }
        }
      }
    };

    return _this;
  }

  createClass(Sidebar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.toggleSidebarOnResize);
      this.toggleSidebarOnResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.toggleSidebarOnResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          _this$props2$arrowCla = _this$props2.arrowClassName,
          arrowClassName = _this$props2$arrowCla === void 0 ? '' : _this$props2$arrowCla,
          _this$props2$isOpen = _this$props2.isOpen,
          isOpen = _this$props2$isOpen === void 0 ? true : _this$props2$isOpen,
          _this$props2$isExpand = _this$props2.isExpanded,
          isExpanded = _this$props2$isExpand === void 0 ? false : _this$props2$isExpand,
          toggleSidebar = _this$props2.toggleSidebar,
          children = _this$props2.children,
          getRef = _this$props2.getRef;
      return /*#__PURE__*/React__default.createElement("aside", {
        ref: getRef,
        className: "".concat(styles$1.sidebar, " ").concat(isOpen ? '_is-open' : '_is-closed', " ").concat(isExpanded ? '_is-expanded' : '_is-collapsed', " ").concat(className)
      }, children, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$1.wrapper, " ").concat(arrowClassName),
        onClick: toggleSidebar
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1.arrow
      }, /*#__PURE__*/React__default.createElement("i", {
        className: styles$1.icon
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Left"
      })), /*#__PURE__*/React__default.createElement("span", {
        className: styles$1.title
      }, isOpen ? 'Hide' : 'Show'))));
    }
  }]);

  return Sidebar;
}(Component);
Sidebar.propTypes = {
  className: PropTypes__default.string,
  arrowClassName: PropTypes__default.string,
  isOpen: PropTypes__default.bool,
  isExpanded: PropTypes__default.bool,
  toggleSidebar: PropTypes__default.func,
  getRef: PropTypes__default.func,
  zoomOnResize: PropTypes__default.bool
};

var css_248z$2 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes rightbar-module_hover-ripples__1jTVt {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.rightbar-module_btn-transparent__zAORe {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none; }\n  .rightbar-module_btn-transparent__zAORe:focus {\n    outline: 0; }\n\n.rightbar-module_rightbar__WuDvr {\n  position: fixed;\n  z-index: 20;\n  top: 4rem;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: stretch;\n  width: 3.125rem;\n  background: #ffffff;\n  transition: transform linear 0.3s; }\n  .rightbar-module_rightbar__WuDvr:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 0.0625rem;\n    background-color: #f4f4f4; }\n  .rightbar-module_rightbar__WuDvr:not(._is-open) {\n    transform: translateX(100%); }\n\n.rightbar-module_wrapper__3SUb4 {\n  display: flex;\n  align-items: stretch;\n  width: 100%; }\n\n.rightbar-module_arrowWrapper__1lpgt {\n  pointer-events: none;\n  position: absolute;\n  z-index: 20;\n  left: 0;\n  bottom: 0.75rem;\n  height: 1.625rem; }\n\n.rightbar-module_rightbar__WuDvr._is-open .rightbar-module_arrowWrapper__1lpgt {\n  width: 3.125rem;\n  overflow: hidden; }\n\n.rightbar-module_rightbar__WuDvr._is-open._is-expanded .rightbar-module_arrowWrapper__1lpgt {\n  left: -20rem;\n  width: 23.75rem; }\n\n.rightbar-module_arrow__2INqg {\n  pointer-events: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  transform: translateX(-1.125rem);\n  height: 1.625rem;\n  border-radius: .25rem 0 0 .25rem;\n  background-color: rgba(var(--primary2), 0.5);\n  cursor: pointer;\n  transition: background-color .3s, transform .3s; }\n  .rightbar-module_arrow__2INqg:hover {\n    transform: translateX(-100%);\n    background-color: var(--primary2); }\n  .rightbar-module_arrow__2INqg:active {\n    outline: none;\n    background-color: var(--primary2); }\n\n.rightbar-module_rightbar__WuDvr._is-open .rightbar-module_arrow__2INqg {\n  flex-direction: row-reverse;\n  transform: translateX(calc(-100% + 18rem / 16));\n  border-radius: 0 .25rem .25rem 0;\n  transition: border-radius .3s .3s, flex-direction .3s .3s, transform .3s, background-color .3s; }\n  .rightbar-module_rightbar__WuDvr._is-open .rightbar-module_arrow__2INqg:hover {\n    transform: translateX(0); }\n\n@keyframes rightbar-module_rightbar-arrow-pointer-events__XXPQq {\n  from {\n    pointer-events: none; }\n  to {\n    pointer-events: none; } }\n\n.rightbar-module_rightbar__WuDvr._is-closed .rightbar-module_arrow__2INqg {\n  animation: rightbar-module_rightbar-arrow-pointer-events__XXPQq .1s; }\n\n.rightbar-module_icon__H2Wim {\n  flex: 0 0 1.125rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 1.125rem;\n  max-width: 1.125rem;\n  min-height: 1.625rem;\n  overflow: hidden; }\n  .rightbar-module_icon__H2Wim svg {\n    width: 1.5rem;\n    min-width: 1.5rem;\n    height: auto; }\n  .rightbar-module_icon__H2Wim path:nth-child(1) {\n    fill: #ffffff; }\n\n.rightbar-module_rightbar__WuDvr._is-open .rightbar-module_icon__H2Wim svg {\n  transform: rotate(180deg); }\n\n.rightbar-module_title__1jTAk {\n  flex: 0 0 auto;\n  padding: 0 .25rem 0 0;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #ffffff; }\n\n.rightbar-module_rightbar__WuDvr._is-open .rightbar-module_title__1jTAk {\n  padding: 0 0 0 .25rem; }\n";
var styles$2 = {"btn-transparent":"rightbar-module_btn-transparent__zAORe","rightbar":"rightbar-module_rightbar__WuDvr","wrapper":"rightbar-module_wrapper__3SUb4","arrowWrapper":"rightbar-module_arrowWrapper__1lpgt","arrow":"rightbar-module_arrow__2INqg","rightbar-arrow-pointer-events":"rightbar-module_rightbar-arrow-pointer-events__XXPQq","icon":"rightbar-module_icon__H2Wim","title":"rightbar-module_title__1jTAk","hover-ripples":"rightbar-module_hover-ripples__1jTVt"};
styleInject(css_248z$2);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Rightbar = /*#__PURE__*/function (_Component) {
  inherits(Rightbar, _Component);

  var _super = _createSuper$3(Rightbar);

  function Rightbar() {
    var _this;

    classCallCheck(this, Rightbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.toggleRightbarOnResize = function () {
      var toggleRightbar = _this.props.toggleRightbar;

      if (_this.windowWidth === undefined) {
        _this.windowWidth = window.innerWidth;

        if (_this.windowWidth < 1280) {
          toggleRightbar(false);
        }
      } else {
        if (_this.windowWidth < 1280) {
          _this.windowWidth = window.innerWidth;
        } else {
          if (window.innerWidth < 1280) {
            _this.windowWidth = window.innerWidth;
            _this.props.isOpen && toggleRightbar(false);
          }
        }
      }
    };

    return _this;
  }

  createClass(Rightbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.toggleRightbarOnResize);
      this.toggleRightbarOnResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.toggleRightbarOnResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$arrowClas = _this$props.arrowClassName,
          arrowClassName = _this$props$arrowClas === void 0 ? '' : _this$props$arrowClas,
          _this$props$isOpen = _this$props.isOpen,
          isOpen = _this$props$isOpen === void 0 ? true : _this$props$isOpen,
          children = _this$props.children,
          isExpanded = _this$props.isExpanded,
          toggleRightbar = _this$props.toggleRightbar;
      var rightBarClassNames = [styles$2.rightbar];

      if (isOpen) {
        rightBarClassNames.push('_is-open');
      } else {
        rightBarClassNames.push('_is-closed');
      }

      if (className) {
        rightBarClassNames.push(className);
      }

      if (isExpanded) {
        rightBarClassNames.push('_is-expanded');
      }

      return /*#__PURE__*/React__default.createElement("aside", {
        className: rightBarClassNames.join(' ')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$2.wrapper
      }, children, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$2.arrowWrapper, " ").concat(arrowClassName),
        onClick: toggleRightbar
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$2.arrow
      }, /*#__PURE__*/React__default.createElement("i", {
        className: styles$2.icon
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Left"
      })), /*#__PURE__*/React__default.createElement("span", {
        className: styles$2.title
      }, isOpen ? 'Hide' : 'Show')))));
    }
  }]);

  return Rightbar;
}(Component);
Rightbar.propTypes = {
  className: PropTypes__default.string,
  arrowClassName: PropTypes__default.string,
  isOpen: PropTypes__default.bool,
  toggleRightbar: PropTypes__default.func,
  isExpanded: PropTypes__default.bool
};

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Layout = /*#__PURE__*/function (_Component) {
  inherits(Layout, _Component);

  var _super = _createSuper$4(Layout);

  function Layout() {
    classCallCheck(this, Layout);

    return _super.apply(this, arguments);
  }

  createClass(Layout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          sidebarClassName = _this$props.sidebarClassName,
          rightbarClassName = _this$props.rightbarClassName,
          _this$props$mainClass = _this$props.mainClassName,
          mainClassName = _this$props$mainClass === void 0 ? '' : _this$props$mainClass,
          _this$props$opened = _this$props.opened,
          opened = _this$props$opened === void 0 ? true : _this$props$opened,
          toggleSidebar = _this$props.toggleSidebar,
          expanded = _this$props.expanded,
          sidebar = _this$props.sidebar,
          children = _this$props.children,
          _this$props$zoomOnRes = _this$props.zoomOnResize,
          zoomOnResize = _this$props$zoomOnRes === void 0 ? false : _this$props$zoomOnRes,
          _this$props$isRightba = _this$props.isRightbarOpen,
          isRightbarOpen = _this$props$isRightba === void 0 ? true : _this$props$isRightba,
          _this$props$isRightba2 = _this$props.isRightbarExpanded,
          isRightbarExpanded = _this$props$isRightba2 === void 0 ? false : _this$props$isRightba2,
          toggleRightbar = _this$props.toggleRightbar,
          rightbarChildren = _this$props.rightbarChildren;
      var containerClassNames = [styles.container, 'layout-container'];

      if (opened) {
        containerClassNames.push(styles._sidebarOpened);

        if (zoomOnResize) {
          var width = window.innerWidth;

          if (width > 959 && width < 1281) {
            containerClassNames.push(styles._sidebarPadding);
          }
        }
      }

      if (rightbarChildren && isRightbarOpen) {
        containerClassNames.push(styles._rightbarOpened);
      }

      if (className) {
        containerClassNames.push(className);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: containerClassNames.join(' ')
      }, /*#__PURE__*/React__default.createElement(Sidebar, {
        className: sidebarClassName,
        isOpen: opened,
        zoomOnResize: zoomOnResize,
        toggleSidebar: toggleSidebar,
        isExpanded: expanded
      }, sidebar), /*#__PURE__*/React__default.createElement("main", {
        className: "".concat(styles.main, " ").concat(mainClassName)
      }, children), rightbarChildren && /*#__PURE__*/React__default.createElement(Rightbar, {
        className: rightbarClassName,
        isOpen: isRightbarOpen,
        isExpanded: isRightbarExpanded,
        toggleRightbar: toggleRightbar
      }, rightbarChildren));
    }
  }]);

  return Layout;
}(Component);
Layout.propTypes = {
  className: PropTypes__default.string,
  sidebarClassName: PropTypes__default.string,
  rightbarClassName: PropTypes__default.string,
  mainClassName: PropTypes__default.string,
  opened: PropTypes__default.bool,
  expanded: PropTypes__default.bool,
  toggleSidebar: PropTypes__default.func,
  sidebar: PropTypes__default.element,
  isRightbarOpen: PropTypes__default.bool,
  isRightbarExpanded: PropTypes__default.bool,
  toggleRightbar: PropTypes__default.func,
  rightbarChildren: PropTypes__default.element
};

var css_248z$3 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes sidebarHeader-module_hover-ripples__2nlbl {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.sidebarHeader-module_header__2J8Yn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n  min-height: 3rem; }\n  .sidebarHeader-module_header__2J8Yn:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 0.0625rem;\n    background-color: #f4f4f4; }\n\n.sidebarHeader-module_title__1OAzK {\n  flex: 1 1 auto;\n  font-family: 'Avenir Next Bold', sans-serif;\n  font-weight: normal;\n  font-size: 1.25rem;\n  line-height: 1.2em;\n  color: #000000; }\n\n.sidebarHeader-module_close__3oSof {\n  width: .75rem;\n  height: .75rem; }\n  .sidebarHeader-module_close__3oSof:before, .sidebarHeader-module_close__3oSof:after {\n    width: 1rem;\n    height: .125rem; }\n";
var styles$3 = {"header":"sidebarHeader-module_header__2J8Yn","title":"sidebarHeader-module_title__1OAzK","close":"sidebarHeader-module_close__3oSof","hover-ripples":"sidebarHeader-module_hover-ripples__2nlbl"};
styleInject(css_248z$3);

var SidebarHeader = function SidebarHeader(_ref) {
  var title = _ref.title,
      _ref$onCloseClick = _ref.onCloseClick,
      onCloseClick = _ref$onCloseClick === void 0 ? function () {} : _ref$onCloseClick;
  return /*#__PURE__*/React__default.createElement("header", {
    className: styles$3.header
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: styles$3.title
  }, title), /*#__PURE__*/React__default.createElement(ButtonCircle, {
    iconName: "Close",
    className: "".concat(styles$3.close),
    onClick: onCloseClick
  }));
};
SidebarHeader.propTypes = {
  className: PropTypes__default.string,
  onCloseClick: PropTypes__default.func
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

var Snackbar = function Snackbar(props) {
  var messages = props.messages,
      autoHideDuration = props.autoHideDuration,
      updateToasts = props.updateToasts,
      className = props.className,
      containerClassName = props.containerClassName;
  var localToasts = useRef([]);
  var timerMap = {};

  var handleClose = function handleClose(id) {
    delete timerMap[id];

    var remainingToasts = toConsumableArray(localToasts.current).filter(function (toast) {
      return toast.id !== id;
    });

    updateToasts(remainingToasts);
  };

  useEffect(function () {
    if (!isEqual$2(messages, localToasts.current)) {
      localToasts.current = messages;

      var _loop = function _loop(i) {
        var element = messages[i];

        if (!timerMap[element.id]) {
          timerMap[element.id] = setTimeout(function () {
            handleClose(element.id);
          }, autoHideDuration);
        }
      };

      for (var i = 0; i < messages.length; i += 1) {
        _loop(i);
      }
    }
  }, [messages]);

  if (!messages.length) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "snackbar__container ".concat(containerClassName)
  }, messages.map(function (toast) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: toast.id,
      className: "snackbar _".concat(toast.type, " ").concat(className)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "snackbar__inner-wrapper"
    }, toast.iconName ? /*#__PURE__*/React__default.createElement(Icon, {
      name: toast.iconName,
      className: "snackbar__icon"
    }) : null, /*#__PURE__*/React__default.createElement("div", {
      className: "snackbar__message ".concat(toast.iconName ? 'with_icon' : '')
    }, toast.message, toast.action && /*#__PURE__*/React__default.createElement("div", {
      className: "snackbar__action"
    }, toast.action)), /*#__PURE__*/React__default.createElement(ButtonCircle, {
      iconName: "Close",
      onClick: function onClick() {
        return handleClose(toast.id);
      },
      className: "snackbar__close"
    })));
  }));
};
Snackbar.defaultProps = {
  autoHideDuration: 10000,
  className: '',
  containerClassName: '',
  updateToasts: function updateToasts() {},
  messages: []
};
Snackbar.propTypes = {
  autoHideDuration: PropTypes__default.number,
  messages: PropTypes__default.arrayOf(PropTypes__default.shape({
    id: PropTypes__default.string.isRequired,
    message: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]).isRequired,
    type: PropTypes__default.oneOf(['warning', 'info', 'success', 'error']).isRequired,
    iconName: PropTypes__default.string,
    action: PropTypes__default.node
  })),
  className: PropTypes__default.string,
  containerClassName: PropTypes__default.string,
  updateToasts: PropTypes__default.func
};

var css_248z$4 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes CopyToClipboardButton-module_hover-ripples__W5lgU {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.CopyToClipboardButton-module_close__mZyS- {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  cursor: pointer;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.15;\n  color: #FFA300;\n  text-transform: uppercase; }\n  .CopyToClipboardButton-module_close__mZyS-:focus {\n    outline: 0; }\n";
var styles$4 = {"close":"CopyToClipboardButton-module_close__mZyS-","hover-ripples":"CopyToClipboardButton-module_hover-ripples__W5lgU"};
styleInject(css_248z$4);

var CopyToClipboardButton = function CopyToClipboardButton(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children,
      codeFromProps = props.code;

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      toastMessages = _useState2[0],
      setToastMessages = _useState2[1];

  var updateToasts = function updateToasts(msgs) {
    setToastMessages(msgs);
  };

  var onCopy = function onCopy(code) {
    var input = document.createElement('textarea');
    input.value = code;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    setToastMessages([{
      message: 'Copied!',
      type: 'success',
      id: uniqueId('copied-')
    }]);
  };

  var handleButtonClick = function handleButtonClick() {
    return onCopy(codeFromProps);
  };

  var button = children ? children(handleButtonClick) : /*#__PURE__*/React__default.createElement(ButtonCircle, {
    className: "".concat(styles$4.btn, " ").concat(className),
    onClick: handleButtonClick,
    iconName: "Copy",
    outline: true
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, button, /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement(Snackbar, {
    updateToasts: updateToasts,
    messages: toastMessages
  }), document.body));
};
CopyToClipboardButton.propTypes = {
  className: PropTypes__default.string,
  code: PropTypes__default.string
};

var fontfaceobserver_standalone = createCommonjsModule(function (module) {
/* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b);}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a();}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a();});}function t(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c);}
function u(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";";}function z(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function A(a,b){function c(){var a=k;z(a)&&a.a.parentNode&&b(a.g);}var k=a;l(a.b,c);l(a.c,c);z(a);}function B(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal";}var C=null,D=null,E=null,F=null;function G(){if(null===D)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);D=!!a&&603>parseInt(a[1],10);}else D=!1;return D}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif";}catch(b){}E=""!==a.style.font;}return E}function L(a,b){return [a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
B.prototype.load=function(a,b){var c=this,k=a||"BESbswy",r=0,n=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=n?b(Error(""+n+"ms timeout exceeded")):document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25);},b);}e();}),N=new Promise(function(a,c){r=setTimeout(function(){c(Error(""+n+"ms timeout exceeded"));},n);});Promise.race([N,M]).then(function(){clearTimeout(r);a(c);},
b);}else m(function(){function v(){var b;if(b=-1!=f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===C&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),C=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=C&&(f==w&&g==w&&h==w||f==x&&g==x&&h==x||f==y&&g==y&&h==y)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(r),a(c));}function I(){if((new Date).getTime()-H>=n)d.parentNode&&d.parentNode.removeChild(d),b(Error(""+
n+"ms timeout exceeded"));else {var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,g=p.a.offsetWidth,h=q.a.offsetWidth,v();r=setTimeout(I,50);}}var e=new t(k),p=new t(k),q=new t(k),f=-1,g=-1,h=-1,w=-1,x=-1,y=-1,d=document.createElement("div");d.dir="ltr";u(e,L(c,"sans-serif"));u(p,L(c,"serif"));u(q,L(c,"monospace"));d.appendChild(e.a);d.appendChild(p.a);d.appendChild(q.a);document.body.appendChild(d);w=e.a.offsetWidth;x=p.a.offsetWidth;y=q.a.offsetWidth;I();A(e,function(a){f=a;v();});u(e,
L(c,'"'+c.family+'",sans-serif'));A(p,function(a){g=a;v();});u(p,L(c,'"'+c.family+'",serif'));A(q,function(a){h=a;v();});u(q,L(c,'"'+c.family+'",monospace'));});})};module.exports=B;}());
});

var isEqual = function isEqual(props, first, second) {
  var equal = true;

  for (var ii = 0; ii < props.length; ii++) {
    var property = props[ii];

    if (first[property] !== second[property]) {
      equal = false;
      return equal;
    }
  }

  return equal;
};

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Switch = /*#__PURE__*/function (_Component) {
  inherits(Switch, _Component);

  var _super = _createSuper$5(Switch);

  function Switch(props) {
    var _this;

    classCallCheck(this, Switch);

    _this = _super.call(this, props);

    _this.onFontLoaded = function () {
      var font = new fontfaceobserver_standalone('Avenir Next Regular');
      font.load().then(function () {
        _this.setState({
          itemsMaxWidth: null
        });
      });
    };

    _this.makeItemsWidthsEqual = function () {
      var max = _this.getMax();

      if (max) {
        _this.setState({
          itemsMaxWidth: max
        });
      }
    };

    _this.getMax = function () {
      return _this.switchItems.length && Math.max.apply(Math, toConsumableArray(_this.switchItems.map(function (item) {
        return item.offsetWidth;
      })));
    };

    _this.handleClick = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      var isClickedOnce = _this.state.isClickedOnce;

      if (!disabled) {
        if (!isClickedOnce) {
          _this.setState({
            isClickedOnce: true
          });
        }

        onChange(!value);
      }
    };

    _this.switchItems = [];
    _this.size = props.size;
    _this.state = {
      itemsMaxWidth: null,
      isClickedOnce: false
    };
    return _this;
  }

  createClass(Switch, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['list', 'className', 'value', 'name', 'size'], this.props, nextProps) && isEqual(['itemsMaxWidth'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.makeItemsWidthsEqual();
      this.forceUpdate();
      this.onFontLoaded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var itemsMaxWidth = this.state.itemsMaxWidth;

      if (this.size !== this.props.size) {
        this.size = this.props.size;
        this.setState({
          itemsMaxWidth: null
        }, this.makeItemsWidthsEqual());
      }

      if (!itemsMaxWidth) {
        this.makeItemsWidthsEqual();
      }
    }
  }, {
    key: "_pushSwitchItemRef",
    value: function _pushSwitchItemRef(item) {
      if (item && this.switchItems.indexOf(item) === -1) {
        this.switchItems.push(item);
      }
    }
  }, {
    key: "_setIndicatorRef",
    value: function _setIndicatorRef(item) {
      if (!this.indicator) {
        this.indicator = item;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          size = _this$props2.size,
          className = _this$props2.className,
          list = _this$props2.list,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? false : _this$props2$value,
          disabled = _this$props2.disabled;
      var _this$state = this.state,
          itemsMaxWidth = _this$state.itemsMaxWidth,
          isClickedOnce = _this$state.isClickedOnce;
      var indicatorStyle = {
        left: "".concat(value ? itemsMaxWidth - 1 : -1, "px"),
        width: "".concat(itemsMaxWidth + 2, "px")
      };
      var classNames = ['switch'];

      if (className) {
        classNames.push(className);
      }

      if (size) {
        classNames.push("_".concat(size));
      }

      if (disabled) {
        classNames.push('_disabled');
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames.join(' '),
        ref: function ref(el) {
          _this2["switch"] = el;
        },
        onClick: this.handleClick
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "switch__label"
      }, list.map(function (item, i) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: i,
          className: "switch__item ".concat(value === Boolean(i) ? '_active' : ''),
          ref: function ref(item) {
            return _this2._pushSwitchItemRef(item);
          },
          style: {
            minWidth: itemsMaxWidth || ''
          }
        }, item);
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "switch__indicator ".concat(isClickedOnce ? '_transition' : ''),
        ref: function ref(item) {
          return _this2._setIndicatorRef(item);
        },
        style: indicatorStyle
      })));
    }
  }]);

  return Switch;
}(Component);
Switch.propTypes = {
  onChange: PropTypes__default.func.isRequired,
  list: PropTypes__default.array.isRequired,
  value: PropTypes__default.bool.isRequired,
  className: PropTypes__default.string,
  size: PropTypes__default.string,
  disabled: PropTypes__default.bool
};

var Tumbler = function Tumbler(props) {
  var className = props.className,
      on = props.on,
      onChange = props.onChange,
      disabled = props.disabled,
      title = props.title,
      titleSide = props.titleSide; // provide height and width in classname to center tumbler both horizontally(add justify-content: center) and vertically

  var classNames = useMemo(function () {
    var cls = ['tumbler'];

    if (disabled) {
      cls.push('_disabled');
    }

    if (on) {
      cls.push('_on');
    }

    cls.push(className);
    return cls;
  }, [on, disabled, className]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames.join(' '),
    onClick: onChange
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "tumbler__label"
  }, title && titleSide === 'left' && /*#__PURE__*/React__default.createElement("span", {
    className: "tumbler__title _left"
  }, title), /*#__PURE__*/React__default.createElement("span", {
    className: "tumbler__btn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "tumbler__btn-switch-bg"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "tumbler__btn-switch-thumb",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        onChange();
        e.stopPropagation();
      }
    }
  })), title && titleSide === 'right' && /*#__PURE__*/React__default.createElement("span", {
    className: "tumbler__title _right"
  }, title)));
};
Tumbler.defaultProps = {
  className: '',
  on: false,
  titleSide: 'right'
};
Tumbler.propTypes = {
  className: PropTypes__default.string,
  on: PropTypes__default.bool,
  onChange: PropTypes__default.func.isRequired,
  disabled: PropTypes__default.bool,
  titleSide: PropTypes__default.oneOf(['left', 'right']),
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element])
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var emptyObject = {};

if (process.env.NODE_ENV !== 'production') {
  Object.freeze(emptyObject);
}

var emptyObject_1 = emptyObject;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

if (process.env.NODE_ENV !== 'production') {
  var warning$1 = warning_1;
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (process.env.NODE_ENV !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = objectAssign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = objectAssign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = objectAssign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (process.env.NODE_ENV !== 'production') {
          warning$1(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      invariant_1(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      invariant_1(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (process.env.NODE_ENV !== 'production') {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning$1(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    invariant_1(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    invariant_1(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            invariant_1(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (process.env.NODE_ENV !== 'production') {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      invariant_1(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        invariant_1(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    invariant_1(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        invariant_1(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (process.env.NODE_ENV !== 'production') {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning$1(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning$1(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (process.env.NODE_ENV !== 'production') {
        warning$1(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  objectAssign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (process.env.NODE_ENV !== 'production') {
        warning$1(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject_1;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (process.env.NODE_ENV !== 'production') {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      invariant_1(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (process.env.NODE_ENV !== 'production') {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    invariant_1(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (process.env.NODE_ENV !== 'production') {
      warning$1(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning$1(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning$1(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

var factory_1 = factory;

if (typeof React__default === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React__default.Component().updater;

var createReactClass = factory_1(
  React__default.Component,
  React__default.isValidElement,
  ReactNoopUpdateQueue
);

var momentRange = createCommonjsModule(function (module, exports) {
!function(t,e){module.exports=e(moment$1__default);}(commonjsGlobal,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r});},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=3)}([function(t,e,n){var r=n(5)();t.exports=function(t){return t!==r&&null!==t};},function(t,e,n){t.exports=n(18)()?Symbol:n(20);},function(e,n){e.exports=t;},function(t,e,n){function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t){return t.range=function(e,n){var r=this;return "string"==typeof e&&y.hasOwnProperty(e)?new h(t(r).startOf(e),t(r).endOf(e)):new h(e,n)},t.rangeFromInterval=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t();if(t.isMoment(r)||(r=t(r)),!r.isValid())throw new Error("Invalid date.");var o=r.clone().add(n,e),i=[];return i.push(t.min(r,o)),i.push(t.max(r,o)),new h(i)},t.rangeFromISOString=function(e){var n=a(e),r=t.parseZone(n[0]),o=t.parseZone(n[1]);return new h(r,o)},t.parseZoneRange=t.rangeFromISOString,t.fn.range=t.range,t.range.constructor=h,t.isRange=function(t){return t instanceof h},t.fn.within=function(t){return t.contains(this.toDate())},t}function a(t){return t.split("/")}Object.defineProperty(e,"__esModule",{value:!0}),e.DateRange=void 0;var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,a=t[Symbol.iterator]();!(r=(u=a.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t;}finally{try{!r&&a.return&&a.return();}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},f=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r);}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();e.extendMoment=u;var l=n(2),v=r(l),d=n(1),p=r(d),y={year:!0,quarter:!0,month:!0,week:!0,day:!0,hour:!0,minute:!0,second:!0},h=e.DateRange=function(){function t(e,n){i(this,t);var r=e,o=n;if(1===arguments.length||void 0===n)if("object"===(void 0===e?"undefined":c(e))&&2===e.length){var u=s(e,2);r=u[0],o=u[1];}else if("string"==typeof e){var f=a(e),l=s(f,2);r=l[0],o=l[1];}this.start=r||0===r?(0, v.default)(r):(0, v.default)(-864e13),this.end=o||0===o?(0, v.default)(o):(0, v.default)(864e13);}return f(t,[{key:"adjacent",value:function(t){var e=this.start.isSame(t.end),n=this.end.isSame(t.start);return e&&t.start.valueOf()<=this.start.valueOf()||n&&t.end.valueOf()>=this.end.valueOf()}},{key:"add",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1};return this.overlaps(t,e)?new this.constructor(v.default.min(this.start,t.start),v.default.max(this.end,t.end)):null}},{key:"by",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeEnd||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.start.clone().add(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"byRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeEnd:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeEnd||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0, v.default)(n.start.valueOf()+t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"center",value:function(){var t=this.start.valueOf()+this.diff()/2;return (0, v.default)(t)}},{key:"clone",value:function(){return new this.constructor(this.start.clone(),this.end.clone())}},{key:"contains",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,excludeEnd:!1},r=this.start.valueOf(),o=this.end.valueOf(),i=e.valueOf(),u=e.valueOf(),a=n.excludeStart||!1,s=n.excludeEnd||!1;n.hasOwnProperty("exclusive")&&(a=s=n.exclusive),e instanceof t&&(i=e.start.valueOf(),u=e.end.valueOf());var c=r<i||r<=i&&!a,f=o>u||o>=u&&!s;return c&&f}},{key:"diff",value:function(t,e){return this.end.diff(this.start,t,e)}},{key:"duration",value:function(t,e){return this.diff(t,e)}},{key:"intersect",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf(),i=e==n,u=r==o;if(i){var a=e;if(a==r||a==o)return null;if(a>r&&a<o)return this.clone()}else if(u){var s=r;if(s==e||s==n)return null;if(s>e&&s<n)return new this.constructor(s,s)}return e<=r&&r<n&&n<o?new this.constructor(r,n):r<e&&e<o&&o<=n?new this.constructor(e,o):r<e&&e<=n&&n<o?this.clone():e<=r&&r<=o&&o<=n?new this.constructor(r,o):null}},{key:"isEqual",value:function(t){return this.start.isSame(t.start)&&this.end.isSame(t.end)}},{key:"isSame",value:function(t){return this.isEqual(t)}},{key:"overlaps",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{adjacent:!1},n=null!==this.intersect(t);return e.adjacent&&!n?this.adjacent(t):n}},{key:"reverseBy",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this;return o({},p.default.iterator,function(){var r=e.step||1,o=Math.abs(n.start.diff(n.end,t))/r,i=e.excludeStart||!1,u=0;return e.hasOwnProperty("exclusive")&&(i=e.exclusive),{next:function(){var e=n.end.clone().subtract(u*r,t),a=i?!(u<o):!(u<=o);return u++,{done:a,value:a?void 0:e}}}})}},{key:"reverseByRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{excludeStart:!1,step:1},n=this,r=e.step||1,i=this.valueOf()/t.valueOf()/r,u=Math.floor(i),a=e.excludeStart||!1,s=0;return e.hasOwnProperty("exclusive")&&(a=e.exclusive),o({},p.default.iterator,function(){return u===1/0?{done:!0}:{next:function(){var e=(0, v.default)(n.end.valueOf()-t.valueOf()*s*r),o=u===i&&a?!(s<u):!(s<=u);return s++,{done:o,value:o?void 0:e}}}})}},{key:"snapTo",value:function(t){var e=this.clone();return e.start.isSame((0, v.default)(-864e13))||(e.start=e.start.startOf(t)),e.end.isSame((0, v.default)(864e13))||(e.end=e.end.endOf(t)),e}},{key:"subtract",value:function(t){var e=this.start.valueOf(),n=this.end.valueOf(),r=t.start.valueOf(),o=t.end.valueOf();return null===this.intersect(t)?[this]:r<=e&&e<n&&n<=o?[]:r<=e&&e<o&&o<n?[new this.constructor(o,n)]:e<r&&r<n&&n<=o?[new this.constructor(e,r)]:e<r&&r<o&&o<n?[new this.constructor(e,r),new this.constructor(o,n)]:e<r&&r<n&&o<n?[new this.constructor(e,r),new this.constructor(r,n)]:[]}},{key:"toDate",value:function(){return [this.start.toDate(),this.end.toDate()]}},{key:"toString",value:function(){return this.start.format()+"/"+this.end.format()}},{key:"valueOf",value:function(){return this.end.valueOf()-this.start.valueOf()}}]),t}();},function(t,e,n){var r,o=n(6),i=n(13),u=n(9),a=n(15);r=t.exports=function(t,e){var n,r,u,s,c;return arguments.length<2||"string"!=typeof t?(s=e,e=t,t=null):s=arguments[2],null==t?(n=u=!0,r=!1):(n=a.call(t,"c"),r=a.call(t,"e"),u=a.call(t,"w")),c={value:e,configurable:n,enumerable:r,writable:u},s?o(i(s),c):c},r.gs=function(t,e,n){var r,s,c,f;return "string"!=typeof t?(c=n,n=e,e=t,t=null):c=arguments[3],null==e?e=void 0:u(e)?null==n?n=void 0:u(n)||(c=n,n=void 0):(c=e,e=n=void 0),null==t?(r=!0,s=!1):(r=a.call(t,"c"),s=a.call(t,"e")),f={get:e,set:n,configurable:r,enumerable:s},c?o(i(c),f):f};},function(t,e,n){t.exports=function(){};},function(t,e,n){t.exports=n(7)()?Object.assign:n(8);},function(t,e,n){t.exports=function(){var t,e=Object.assign;return "function"==typeof e&&(t={foo:"raz"},e(t,{bar:"dwa"},{trzy:"trzy"}),t.foo+t.bar+t.trzy==="razdwatrzy")};},function(t,e,n){var r=n(10),o=n(14),i=Math.max;t.exports=function(t,e){var n,u,a,s=i(arguments.length,2);for(t=Object(o(t)),a=function(r){try{t[r]=e[r];}catch(t){n||(n=t);}},u=1;u<s;++u)e=arguments[u],r(e).forEach(a);if(void 0!==n)throw n;return t};},function(t,e,n){t.exports=function(t){return "function"==typeof t};},function(t,e,n){t.exports=n(11)()?Object.keys:n(12);},function(t,e,n){t.exports=function(){try{return Object.keys("primitive"),!0}catch(t){return !1}};},function(t,e,n){var r=n(0),o=Object.keys;t.exports=function(t){return o(r(t)?Object(t):t)};},function(t,e,n){var r=n(0),o=Array.prototype.forEach,i=Object.create,u=function(t,e){var n;for(n in t)e[n]=t[n];};t.exports=function(t){var e=i(null);return o.call(arguments,function(t){r(t)&&u(Object(t),e);}),e};},function(t,e,n){var r=n(0);t.exports=function(t){if(!r(t))throw new TypeError("Cannot use null or undefined");return t};},function(t,e,n){t.exports=n(16)()?String.prototype.contains:n(17);},function(t,e,n){var r="razdwatrzy";t.exports=function(){return "function"==typeof r.contains&&(!0===r.contains("dwa")&&!1===r.contains("foo"))};},function(t,e,n){var r=String.prototype.indexOf;t.exports=function(t){return r.call(this,t,arguments[1])>-1};},function(t,e,n){var r={object:!0,symbol:!0};t.exports=function(){var t;if("function"!=typeof Symbol)return !1;t=Symbol("test symbol");try{String(t);}catch(t){return !1}return !!r[typeof Symbol.iterator]&&(!!r[typeof Symbol.toPrimitive]&&!!r[typeof Symbol.toStringTag])};},function(t,e,n){t.exports=function(t){return !!t&&("symbol"==typeof t||!!t.constructor&&("Symbol"===t.constructor.name&&"Symbol"===t[t.constructor.toStringTag]))};},function(t,e,n){var r,o,i,u,a=n(4),s=n(21),c=Object.create,f=Object.defineProperties,l=Object.defineProperty,v=Object.prototype,d=c(null);if("function"==typeof Symbol){r=Symbol;try{String(r()),u=!0;}catch(t){}}var p=function(){var t=c(null);return function(e){for(var n,r,o=0;t[e+(o||"")];)++o;return e+=o||"",t[e]=!0,n="@@"+e,l(v,n,a.gs(null,function(t){r||(r=!0,l(this,n,a(t)),r=!1);})),n}}();i=function(t){if(this instanceof i)throw new TypeError("Symbol is not a constructor");return o(t)},t.exports=o=function t(e){var n;if(this instanceof t)throw new TypeError("Symbol is not a constructor");return u?r(e):(n=c(i.prototype),e=void 0===e?"":String(e),f(n,{__description__:a("",e),__name__:a("",p(e))}))},f(o,{for:a(function(t){return d[t]?d[t]:d[t]=o(String(t))}),keyFor:a(function(t){var e;s(t);for(e in d)if(d[e]===t)return e}),hasInstance:a("",r&&r.hasInstance||o("hasInstance")),isConcatSpreadable:a("",r&&r.isConcatSpreadable||o("isConcatSpreadable")),iterator:a("",r&&r.iterator||o("iterator")),match:a("",r&&r.match||o("match")),replace:a("",r&&r.replace||o("replace")),search:a("",r&&r.search||o("search")),species:a("",r&&r.species||o("species")),split:a("",r&&r.split||o("split")),toPrimitive:a("",r&&r.toPrimitive||o("toPrimitive")),toStringTag:a("",r&&r.toStringTag||o("toStringTag")),unscopables:a("",r&&r.unscopables||o("unscopables"))}),f(i.prototype,{constructor:a(o),toString:a("",function(){return this.__name__})}),f(o.prototype,{toString:a(function(){return "Symbol ("+s(this).__description__+")"}),valueOf:a(function(){return s(this)})}),l(o.prototype,o.toPrimitive,a("",function(){var t=s(this);return "symbol"==typeof t?t:t.toString()})),l(o.prototype,o.toStringTag,a("c","Symbol")),l(i.prototype,o.toStringTag,a("c",o.prototype[o.toStringTag])),l(i.prototype,o.toPrimitive,a("c",o.prototype[o.toPrimitive]));},function(t,e,n){var r=n(19);t.exports=function(t){if(!r(t))throw new TypeError(t+" is not a symbol");return t};}])});

});

var range = unwrapExports(momentRange);

var momentRange$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _moment2 = _interopRequireDefault(moment$1__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = (0, momentRange.extendMoment)(_moment2.default);

exports.default = moment;
});

unwrapExports(momentRange$1);

var immutable = createCommonjsModule(function (module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   module.exports = factory() ;
}(commonjsGlobal, function () {var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); };
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  };

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        };
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level :  this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value);
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    };
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    };
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    };
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    };
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      };
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    };

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    };
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));
});

/*!
 * calendar.js: inspired by the calendar module from Python
 * Copyright(c) 2011 Luciano Ramalho <luciano@ramalho.org>
 * MIT Licensed
 */

var version = '0.1.0';

var CalendarException = function CalendarException(message) {
   this.message = message;
   this.toString = function() {
      return this.constructor.name + ": " + this.message
   };
};

var Calendar = function Calendar(firstWeekDay) {
    //properties
    this.firstWeekDay = firstWeekDay || 0; // 0 = Sunday
};

Calendar.prototype = {
    constructor : Calendar,
    weekStartDate : function weekStartDate(date) {
        var startDate = new Date(date.getTime());
        while (startDate.getDay() !== this.firstWeekDay) {
            startDate.setDate(startDate.getDate() - 1);
        }
        return startDate;
    },
    monthDates : function monthDates(year, month, dayFormatter, weekFormatter) {
        if ((typeof year !== "number") || (year < 1970)) {
            throw new CalendarException('year must be a number >= 1970');
        }        if ((typeof month !== "number") || (month < 0) || (month > 11)) {
            throw new CalendarException('month must be a number (Jan is 0)');
        }        var weeks = [],
            week = [],
            i = 0,
            date = this.weekStartDate(new Date(year, month, 1));
        do {
            for (i=0; i<7; i++) {
                week.push(dayFormatter ? dayFormatter(date) : date);
                date = new Date(date.getTime());
                date.setDate(date.getDate() + 1);
            }
            weeks.push(weekFormatter ? weekFormatter(week) : week);
            week = [];
        } while ((date.getMonth()<=month) && (date.getFullYear()===year));
        return weeks;
    },
    monthDays : function monthDays(year, month) {
        var getDayOrZero = function getDayOrZero(date) {
            return date.getMonth() === month ? date.getDate() : 0;
        };
        return this.monthDates(year, month, getDayOrZero);
    },
    monthText : function monthText(year, month) {
        if (typeof year === "undefined") {
            var now = new Date();
            year = now.getFullYear();
            month = now.getMonth();
        }        var getDayOrBlank = function getDayOrBlank(date) {
            var s = date.getMonth() === month ? date.getDate().toString() : "  ";
            while (s.length < 2) s = " "+s;
            return s;
        };
        var weeks = this.monthDates(year, month, getDayOrBlank,
            function (week) { return week.join(" ") });
        return weeks.join("\n");
    }
};
var months = "JAN FEB MAR APR MAY JUN JUL AUG SEP OCT NOV DEC".split(" ");
for (var i=0; i<months.length; i++)
    Calendar[months[i]] = i;

var Calendar_1 = Calendar;

var calendar = {
	version: version,
	Calendar: Calendar_1
};

var bemCx_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = bemCx;
function bemCx() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var block = options.block,
      element = options.element,
      namespace = options.namespace,
      modifiers = options.modifiers,
      states = options.states;

  var bemClasses = [];
  var baseClassName = void 0;

  if (element) {
    if (namespace) {
      baseClassName = namespace + '-' + block + '__' + element;
    } else {
      baseClassName = block + '__' + element;
    }
  } else {
    if (namespace) {
      baseClassName = namespace + '-' + block;
    } else {
      baseClassName = block;
    }
  }

  bemClasses.push(baseClassName);

  if (states) {
    if ((typeof states === 'undefined' ? 'undefined' : _typeof(states)) === 'object') {
      states = Object.keys(states).filter(function (s) {
        return states[s];
      });
    }

    states.forEach(function (state) {
      bemClasses.push(baseClassName + '--is-' + state);
    });
  }

  if (modifiers) {
    if ((typeof modifiers === 'undefined' ? 'undefined' : _typeof(modifiers)) === 'object') {
      modifiers = Object.keys(modifiers).filter(function (m) {
        return modifiers[m];
      });
    }

    modifiers.forEach(function (modifier) {
      bemClasses.push(baseClassName + '--' + modifier);

      if (states) {
        states.forEach(function (state) {
          bemClasses.push(baseClassName + '--' + modifier + '--is-' + state);
        });
      }
    });
  }

  return bemClasses.join(' ');
}
});

unwrapExports(bemCx_1);

var BemMixin_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _bemCx2 = _interopRequireDefault(bemCx_1);



var _propTypes2 = _interopRequireDefault(PropTypes__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BemMixin = {
  propTypes: {
    bemNamespace: _propTypes2.default.string,
    bemBlock: _propTypes2.default.string
  },

  contextTypes: {
    bemNamespace: _propTypes2.default.string,
    bemBlock: _propTypes2.default.string
  },

  childContextTypes: {
    bemNamespace: _propTypes2.default.string,
    bemBlock: _propTypes2.default.string
  },

  getChildContext: function getChildContext() {
    return {
      bemNamespace: this.getBemNamespace(),
      bemBlock: this.getBemBlock()
    };
  },
  getBemNamespace: function getBemNamespace() {
    if (this.props.bemNamespace) {
      return this.props.bemNamespace;
    }
    if (this.context.bemNamespace) {
      return this.context.bemNamespace;
    }
    return null;
  },
  getBemBlock: function getBemBlock() {
    if (this.props.bemBlock) {
      return this.props.bemBlock;
    }
    if (this.context.bemBlock) {
      return this.context.bemBlock;
    }
    return null;
  },
  cx: function cx() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var opts = {
      namespace: this.getBemNamespace(),
      element: this.constructor.displayName,
      block: this.getBemBlock()
    };

    Object.assign(opts, options);
    return (0, _bemCx2.default)(opts);
  }
};

exports.default = BemMixin;
});

unwrapExports(BemMixin_1);

var isMomentRange_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMomentRange;



var _momentRange2 = _interopRequireDefault(momentRange$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMomentRange(val) {
  return val && val.start && val.end && _momentRange2.default.isMoment(val.start) && _momentRange2.default.isMoment(val.end);
}
});

unwrapExports(isMomentRange_1);

var CustomPropTypes = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _momentRange2 = _interopRequireDefault(momentRange$1);



var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  momentOrMomentRange: function momentOrMomentRange(props, propName) {
    var val = props[propName];

    if (!val) {
      return null;
    } else if (_momentRange2.default.isMoment(val)) {
      return null;
    } else if ((0, _isMomentRange2.default)(val)) {
      return null;
    }
    return new Error('\'' + propName + '\' must be a moment or a moment range');
  },
  moment: function moment(props, propName) {
    var val = props[propName];

    if (!val) {
      return null;
    } else if (_momentRange2.default.isMoment(val)) {
      return null;
    }
    return new Error('\'' + propName + '\' must be a moment');
  },
  momentRange: function momentRange(props, propName) {
    var val = props[propName];

    if (!val) {
      return null;
    } else if ((0, _isMomentRange2.default)(val)) {
      return null;
    }
    return new Error('\'' + propName + '\' must be a moment range');
  }
};
});

unwrapExports(CustomPropTypes);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$1.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

var shallowEqual_1 = shallowEqual;

var reactAddonsPureRenderMixin = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return (
      !shallowEqual_1(this.props, nextProps) ||
      !shallowEqual_1(this.state, nextState)
    );
  }
};

var Legend_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _reactAddonsPureRenderMixin2 = _interopRequireDefault(reactAddonsPureRenderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legend = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _reactAddonsPureRenderMixin2.default],
  displayName: "Legend",

  propTypes: {
    selectedLabel: _propTypes2.default.string.isRequired,
    stateDefinitions: _propTypes2.default.object.isRequired
  },

  render: function render() {
    var _props = this.props,
        selectedLabel = _props.selectedLabel,
        stateDefinitions = _props.stateDefinitions;

    var items = [];
    var name = void 0;
    var def = void 0;
    var style = void 0;

    for (name in stateDefinitions) {
      def = stateDefinitions[name];
      if (def.label && def.color) {
        style = {
          backgroundColor: def.color
        };
        items.push(_react2.default.createElement(
          'li',
          { className: this.cx({ element: 'LegendItem' }), key: name },
          _react2.default.createElement('span', { className: this.cx({ element: 'LegendItemColor' }), style: style }),
          _react2.default.createElement(
            'span',
            { className: this.cx({ element: 'LegendItemLabel' }) },
            def.label
          )
        ));
      }
    }

    return _react2.default.createElement(
      'ul',
      { className: this.cx() },
      _react2.default.createElement(
        'li',
        { className: this.cx({ element: 'LegendItem' }) },
        _react2.default.createElement('span', { className: this.cx({ element: 'LegendItemColor', modifiers: { 'selection': true } }) }),
        _react2.default.createElement(
          'span',
          { className: this.cx({ element: 'LegendItemLabel' }) },
          selectedLabel
        )
      ),
      items
    );
  }
});

exports.default = Legend;
});

unwrapExports(Legend_1);

var areMomentRangesEqual_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = areMomentRangesEqual;



var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areMomentRangesEqual(r1, r2) {
  if (!(0, _isMomentRange2.default)(r1) || !(0, _isMomentRange2.default)(r2)) {
    return false;
  }

  return r1.start.isSame(r2.start, 'day') && r1.end.isSame(r2.end, 'day');
}
});

unwrapExports(areMomentRangesEqual_1);

var shallowEqual_1$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _momentRange2 = _interopRequireDefault(momentRange$1);



var _areMomentRangesEqual2 = _interopRequireDefault(areMomentRangesEqual_1);



var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }
  var key;

  // Test for A's keys different from B.
  for (key in objA) {
    if (objA.hasOwnProperty(key)) {
      if (!objB.hasOwnProperty(key)) {
        return false;
      } else if (_momentRange2.default.isMoment(objA[key]) && _momentRange2.default.isMoment(objB[key])) {
        if (!objA[key].isSame(objB[key], 'day')) {
          return false;
        }
      } else if ((0, _isMomentRange2.default)(objA[key]) && (0, _isMomentRange2.default)(objB[key])) {
        if (!(0, _areMomentRangesEqual2.default)(objA[key], objB[key])) {
          return false;
        }
      } else if (objA[key] !== objB[key]) {
        return false;
      }
    }
  }

  // Test for B's keys missing from A.
  for (key in objB) {
    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

exports.default = shallowEqual;
});

unwrapExports(shallowEqual_1$1);

var PureRenderMixin_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _shallowEqual2 = _interopRequireDefault(shallowEqual_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
  }
};

exports.default = PureRenderMixin;
});

unwrapExports(PureRenderMixin_1);

var CalendarMonth_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _momentRange2 = _interopRequireDefault(momentRange$1);



var _calendar2 = _interopRequireDefault(calendar);



var _immutable2 = _interopRequireDefault(immutable);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _CustomPropTypes2 = _interopRequireDefault(CustomPropTypes);



var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);



var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CalendarMonth = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _PureRenderMixin2.default],
  displayName: "CalendarMonth",

  propTypes: {
    dateComponent: _propTypes2.default.func,
    disableNavigation: _propTypes2.default.bool,
    enabledRange: _CustomPropTypes2.default.momentRange,
    firstOfMonth: _CustomPropTypes2.default.moment,
    firstOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
    hideSelection: _propTypes2.default.bool,
    highlightedDate: _propTypes2.default.object,
    highlightedRange: _propTypes2.default.object,
    onMonthChange: _propTypes2.default.func,
    onYearChange: _propTypes2.default.func,
    value: _CustomPropTypes2.default.momentOrMomentRange,
    locale: _propTypes2.default.string,
    focusedElement: _propTypes2.default.oneOf(['start', 'end'])
  },

  setLocale: function setLocale(locale) {
    _momentRange2.default.locale(locale);
    this.WEEKDAYS = _immutable2.default.List(_momentRange2.default.weekdays()).zip(_immutable2.default.List(_momentRange2.default.weekdaysShort()));
    this.MONTHS = _immutable2.default.List(_momentRange2.default.months());
  },
  componentWillMount: function componentWillMount() {
    var locale = this.props.locale;

    this.setLocale(locale);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var locale = nextProps.locale;

    if (locale !== this.props.locale) {
      this.setLocale(locale);
    }
  },
  renderDay: function renderDay(date, i) {
    var _props = this.props,
        CalendarDate = _props.dateComponent,
        value = _props.value,
        highlightedDate = _props.highlightedDate,
        highlightedRange = _props.highlightedRange,
        hideSelection = _props.hideSelection,
        enabledRange = _props.enabledRange,
        focusedElement = _props.focusedElement,
        props = _objectWithoutProperties(_props, ['dateComponent', 'value', 'highlightedDate', 'highlightedRange', 'hideSelection', 'enabledRange', 'focusedElement']);

    var d = (0, _momentRange2.default)(date).locale(this.props.locale);

    var isInSelectedRange = void 0;
    var isSelectedDate = void 0;
    var isSelectedRangeStart = void 0;
    var isSelectedRangeEnd = void 0;

    if (!hideSelection && value && _momentRange2.default.isMoment(value) && value.isSame(d, 'day')) {
      isSelectedDate = true;
    } else if (!hideSelection && value && (0, _isMomentRange2.default)(value) && value.contains(d)) {
      isInSelectedRange = true;

      isSelectedRangeStart = value.start.isSame(d, 'day');
      isSelectedRangeEnd = value.end.isSame(d, 'day');
    }

    return _react2.default.createElement(CalendarDate, _extends({
      key: i,
      isToday: d.isSame((0, _momentRange2.default)(), 'day'),
      isDisabled: !enabledRange.contains(d),
      isHighlightedDate: !!(highlightedDate && highlightedDate.isSame(d, 'day')),
      isHighlightedRangeStart: !!(highlightedRange && highlightedRange.start.isSame(d, 'day')),
      isHighlightedRangeEnd: !!(highlightedRange && highlightedRange.end.isSame(d, 'day')),
      isInHighlightedRange: !!(highlightedRange && highlightedRange.contains(d)),
      isSelectedDate: isSelectedDate,
      isSelectedRangeStart: isSelectedRangeStart,
      isSelectedRangeEnd: isSelectedRangeEnd,
      isInSelectedRange: isInSelectedRange,
      date: d,
      focusedElement: focusedElement
    }, props));
  },
  renderWeek: function renderWeek(dates, i) {
    var days = dates.map(this.renderDay);
    return _react2.default.createElement(
      'tr',
      { className: this.cx({ element: 'Week' }), key: i },
      days.toJS()
    );
  },
  renderDayHeaders: function renderDayHeaders() {
    var firstOfWeek = this.props.firstOfWeek;

    var indices = _immutable2.default.Range(firstOfWeek, 7).concat(_immutable2.default.Range(0, firstOfWeek));

    var headers = indices.map(function (index) {
      var weekday = this.WEEKDAYS.get(index);
      return _react2.default.createElement(
        'th',
        { className: this.cx({ element: 'WeekdayHeading' }), key: weekday, scope: 'col' },
        _react2.default.createElement(
          'abbr',
          { title: weekday[0] },
          weekday[1]
        )
      );
    }.bind(this));

    return _react2.default.createElement(
      'tr',
      { className: this.cx({ element: 'Weekdays' }) },
      headers.toJS()
    );
  },
  handleYearChange: function handleYearChange(event) {
    this.props.onYearChange(parseInt(event.target.value, 10));
  },
  renderYearChoice: function renderYearChoice(year) {
    var enabledRange = this.props.enabledRange;


    if (year < enabledRange.start.year()) {
      return null;
    }

    if (year > enabledRange.end.year()) {
      return null;
    }

    return _react2.default.createElement(
      'option',
      { key: year, value: year },
      (0, _momentRange2.default)(year, 'YYYY').locale(this.props.locale).format('YYYY')
    );
  },
  renderHeaderYear: function renderHeaderYear() {
    var firstOfMonth = this.props.firstOfMonth;

    var y = firstOfMonth.year();
    var years = _immutable2.default.Range(y - 5, y).concat(_immutable2.default.Range(y, y + 10));
    var choices = years.map(this.renderYearChoice);
    var modifiers = { year: true };
    return _react2.default.createElement(
      'span',
      { className: this.cx({ element: 'MonthHeaderLabel', modifiers: modifiers }) },
      firstOfMonth.locale(this.props.locale).format('YYYY'),
      this.props.disableNavigation ? null : _react2.default.createElement(
        'select',
        { className: this.cx({ element: 'MonthHeaderSelect' }), value: y, onChange: this.handleYearChange },
        choices.toJS()
      )
    );
  },
  handleMonthChange: function handleMonthChange(event) {
    this.props.onMonthChange(parseInt(event.target.value, 10));
  },
  renderMonthChoice: function renderMonthChoice(month, i) {
    var _props2 = this.props,
        firstOfMonth = _props2.firstOfMonth,
        enabledRange = _props2.enabledRange;

    var disabled = false;
    var year = firstOfMonth.year();

    if ((0, _momentRange2.default)({ years: year, months: i + 1, date: 1 }).unix() < enabledRange.start.unix()) {
      disabled = true;
    }

    if ((0, _momentRange2.default)({ years: year, months: i, date: 1 }).unix() > enabledRange.end.unix()) {
      disabled = true;
    }

    return _react2.default.createElement(
      'option',
      { key: month, value: i, disabled: disabled ? 'disabled' : null },
      month
    );
  },
  renderHeaderMonth: function renderHeaderMonth() {
    var firstOfMonth = this.props.firstOfMonth;

    var choices = this.MONTHS.map(this.renderMonthChoice);
    var modifiers = { month: true };

    return _react2.default.createElement(
      'span',
      { className: this.cx({ element: 'MonthHeaderLabel', modifiers: modifiers }) },
      firstOfMonth.locale(this.props.locale).format('MMMM'),
      this.props.disableNavigation ? null : _react2.default.createElement(
        'select',
        { className: this.cx({ element: 'MonthHeaderSelect' }), value: firstOfMonth.month(), onChange: this.handleMonthChange },
        choices.toJS()
      )
    );
  },
  renderHeader: function renderHeader() {
    return _react2.default.createElement(
      'div',
      { className: this.cx({ element: 'MonthHeader' }) },
      this.renderHeaderMonth(),
      ' ',
      this.renderHeaderYear()
    );
  },
  render: function render() {
    var _props3 = this.props,
        firstOfWeek = _props3.firstOfWeek,
        firstOfMonth = _props3.firstOfMonth;


    var cal = new _calendar2.default.Calendar(firstOfWeek);
    var monthDates = _immutable2.default.fromJS(cal.monthDates(firstOfMonth.year(), firstOfMonth.month()));
    var weeks = monthDates.map(this.renderWeek);

    return _react2.default.createElement(
      'div',
      { className: this.cx({ element: 'Month' }) },
      this.renderHeader(),
      _react2.default.createElement(
        'table',
        { className: this.cx({ element: 'MonthDates' }) },
        _react2.default.createElement(
          'thead',
          null,
          this.renderDayHeaders()
        ),
        _react2.default.createElement(
          'tbody',
          null,
          weeks.toJS()
        )
      )
    );
  }
});

exports.default = CalendarMonth;
});

unwrapExports(CalendarMonth_1);

var lightenDarkenColor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lightenDarkenColor;
function lightenDarkenColor(col, amt) {
  var usePound = false;
  var num = void 0;
  var r = void 0;
  var b = void 0;
  var g = void 0;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  num = parseInt(col, 16);

  r = (num >> 16) + amt;

  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }

  b = (num >> 8 & 0x00FF) + amt;

  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }

  g = (num & 0x0000FF) + amt;

  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }

  return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
}
});

unwrapExports(lightenDarkenColor_1);

var CalendarDatePeriod_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CalendarDatePeriod = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _PureRenderMixin2.default],
  displayName: "CalendarDatePeriod",

  propTypes: {
    color: _propTypes2.default.string,
    period: _propTypes2.default.string
  },

  render: function render() {
    var _props = this.props,
        color = _props.color,
        period = _props.period;

    var modifiers = _defineProperty({}, period, true);
    var style = void 0;

    if (color) {
      style = { backgroundColor: color };
    }

    return _react2.default.createElement('div', { style: style, className: this.cx({ modifiers: modifiers }) });
  }
});

exports.default = CalendarDatePeriod;
});

unwrapExports(CalendarDatePeriod_1);

var CalendarHighlight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CalendarHighlight = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _PureRenderMixin2.default],
  displayName: "CalendarHighlight",

  propTypes: {
    modifier: _propTypes2.default.string
  },

  render: function render() {
    var modifier = this.props.modifier;

    var modifiers = _defineProperty({}, modifier, true);
    var states = {};

    return _react2.default.createElement('div', { className: this.cx({ states: states, modifiers: modifiers }) });
  }
});

exports.default = CalendarHighlight;
});

unwrapExports(CalendarHighlight_1);

var CalendarSelection_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CalendarSelection = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _PureRenderMixin2.default],
  displayName: "CalendarSelection",

  propTypes: {
    modifier: _propTypes2.default.string,
    pending: _propTypes2.default.bool.isRequired,
    focused: _propTypes2.default.bool
  },

  render: function render() {
    var _props = this.props,
        modifier = _props.modifier,
        pending = _props.pending,
        focused = _props.focused;

    var modifiers = _defineProperty({}, modifier, true);
    modifiers.focused = focused;
    var states = {
      pending: pending
    };

    return _react2.default.createElement('div', { className: this.cx({ states: states, modifiers: modifiers }) });
  }
});

exports.default = CalendarSelection;
});

unwrapExports(CalendarSelection_1);

var CalendarDate_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _immutable2 = _interopRequireDefault(immutable);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _CustomPropTypes2 = _interopRequireDefault(CustomPropTypes);



var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);



var _lightenDarkenColor2 = _interopRequireDefault(lightenDarkenColor_1);



var _CalendarDatePeriod2 = _interopRequireDefault(CalendarDatePeriod_1);



var _CalendarHighlight2 = _interopRequireDefault(CalendarHighlight_1);



var _CalendarSelection2 = _interopRequireDefault(CalendarSelection_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarDate = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _PureRenderMixin2.default],
  displayName: "CalendarDate",

  propTypes: {
    date: _CustomPropTypes2.default.moment,

    firstOfMonth: _propTypes2.default.object.isRequired,

    isSelectedDate: _propTypes2.default.bool,
    isSelectedRangeStart: _propTypes2.default.bool,
    isSelectedRangeEnd: _propTypes2.default.bool,
    isInSelectedRange: _propTypes2.default.bool,

    isHighlightedDate: _propTypes2.default.bool,
    isHighlightedRangeStart: _propTypes2.default.bool,
    isHighlightedRangeEnd: _propTypes2.default.bool,
    isInHighlightedRange: _propTypes2.default.bool,

    highlightedDate: _propTypes2.default.object,
    dateStates: _propTypes2.default.instanceOf(_immutable2.default.List),
    isDisabled: _propTypes2.default.bool,
    isToday: _propTypes2.default.bool,

    dateRangesForDate: _propTypes2.default.func,
    onHighlightDate: _propTypes2.default.func,
    onUnHighlightDate: _propTypes2.default.func,
    onSelectDate: _propTypes2.default.func,
    focusedElement: _propTypes2.default.oneOf(['start', 'end'])
  },

  getInitialState: function getInitialState() {
    return {
      mouseDown: false
    };
  },
  componentWillUnmount: function componentWillUnmount() {
    this.isUnmounted = true;
    document.removeEventListener('mouseup', this.mouseUp);
    document.removeEventListener('touchend', this.touchEnd);
  },
  mouseUp: function mouseUp() {
    this.props.onSelectDate(this.props.date);

    if (this.isUnmounted) {
      return;
    }

    if (this.state.mouseDown) {
      this.setState({
        mouseDown: false
      });
    }

    document.removeEventListener('mouseup', this.mouseUp);
  },
  mouseDown: function mouseDown() {
    this.setState({
      mouseDown: true
    });

    document.addEventListener('mouseup', this.mouseUp);
  },
  touchEnd: function touchEnd() {
    event.preventDefault();
    this.props.onHighlightDate(this.props.date);
    this.props.onSelectDate(this.props.date);

    if (this.isUnmounted) {
      return;
    }

    if (this.state.mouseDown) {
      this.setState({
        mouseDown: false
      });
    }
    document.removeEventListener('touchend', this.touchEnd);
  },
  touchStart: function touchStart(event) {
    event.preventDefault();
    this.setState({
      mouseDown: true
    });
    document.addEventListener('touchend', this.touchEnd);
  },
  mouseEnter: function mouseEnter() {
    this.props.onHighlightDate(this.props.date);
  },
  mouseLeave: function mouseLeave() {
    if (this.state.mouseDown) {
      this.props.onSelectDate(this.props.date);

      this.setState({
        mouseDown: false
      });
    }
    this.props.onUnHighlightDate(this.props.date);
  },
  getBemModifiers: function getBemModifiers() {
    var _props = this.props,
        date = _props.date,
        firstOfMonth = _props.firstOfMonth,
        today = _props.isToday;


    var otherMonth = false;
    var weekend = false;

    if (date.month() !== firstOfMonth.month()) {
      otherMonth = true;
    }

    if (date.day() === 0 || date.day() === 6) {
      weekend = true;
    }

    return { today: today, weekend: weekend, otherMonth: otherMonth };
  },
  getBemStates: function getBemStates() {
    var _props2 = this.props,
        isSelectedDate = _props2.isSelectedDate,
        isInSelectedRange = _props2.isInSelectedRange,
        isInHighlightedRange = _props2.isInHighlightedRange,
        highlighted = _props2.isHighlightedDate,
        disabled = _props2.isDisabled;


    var selected = isSelectedDate || isInSelectedRange || isInHighlightedRange;

    return { disabled: disabled, highlighted: highlighted, selected: selected };
  },
  render: function render() {
    var _props3 = this.props,
        date = _props3.date,
        dateRangesForDate = _props3.dateRangesForDate,
        isSelectedDate = _props3.isSelectedDate,
        isSelectedRangeStart = _props3.isSelectedRangeStart,
        isSelectedRangeEnd = _props3.isSelectedRangeEnd,
        isInSelectedRange = _props3.isInSelectedRange,
        isHighlightedDate = _props3.isHighlightedDate,
        isHighlightedRangeStart = _props3.isHighlightedRangeStart,
        isHighlightedRangeEnd = _props3.isHighlightedRangeEnd,
        isInHighlightedRange = _props3.isInHighlightedRange,
        focusedElement = _props3.focusedElement;


    var bemModifiers = this.getBemModifiers();
    var bemStates = this.getBemStates();
    var pending = isInHighlightedRange;

    var color = void 0;
    var amColor = void 0;
    var pmColor = void 0;
    var states = dateRangesForDate(date);
    var numStates = states.count();
    var cellStyle = {};
    var style = {};

    var highlightModifier = void 0;
    var selectionModifier = void 0;
    var focused = void 0;

    if (isSelectedDate || isSelectedRangeStart && isSelectedRangeEnd || isHighlightedRangeStart && isHighlightedRangeEnd) {
      selectionModifier = 'single';
    } else if (isSelectedRangeStart || isHighlightedRangeStart) {
      selectionModifier = 'start';
      focused = focusedElement === 'start';
    } else if (isSelectedRangeEnd || isHighlightedRangeEnd) {
      selectionModifier = 'end';
      focused = focusedElement === 'end';
    } else if (isInSelectedRange || isInHighlightedRange) {
      selectionModifier = 'segment';
    }

    if (isHighlightedDate) {
      highlightModifier = 'single';
    }

    if (numStates === 1) {
      // If there's only one state, it means we're not at a boundary
      color = states.getIn([0, 'color']);

      if (color) {

        style = {
          backgroundColor: color
        };
        cellStyle = {
          borderLeftColor: (0, _lightenDarkenColor2.default)(color, -10),
          borderRightColor: (0, _lightenDarkenColor2.default)(color, -10)
        };
      }
    } else {
      amColor = states.getIn([0, 'color']);
      pmColor = states.getIn([1, 'color']);

      if (amColor) {
        cellStyle.borderLeftColor = (0, _lightenDarkenColor2.default)(amColor, -10);
      }

      if (pmColor) {
        cellStyle.borderRightColor = (0, _lightenDarkenColor2.default)(pmColor, -10);
      }
    }

    return _react2.default.createElement(
      'td',
      { className: this.cx({ element: 'Date', modifiers: bemModifiers, states: bemStates }),
        style: cellStyle,
        onTouchStart: this.touchStart,
        onMouseEnter: this.mouseEnter,
        onMouseLeave: this.mouseLeave,
        onMouseDown: this.mouseDown },
      numStates > 1 && _react2.default.createElement(
        'div',
        { className: this.cx({ element: "HalfDateStates" }) },
        _react2.default.createElement(_CalendarDatePeriod2.default, { period: 'am', color: amColor }),
        _react2.default.createElement(_CalendarDatePeriod2.default, { period: 'pm', color: pmColor })
      ),
      numStates === 1 && _react2.default.createElement('div', { className: this.cx({ element: "FullDateStates" }), style: style }),
      selectionModifier ? _react2.default.createElement(_CalendarSelection2.default, { modifier: selectionModifier, focused: focused, pending: pending }) : null,
      _react2.default.createElement(
        'span',
        { className: this.cx({ element: "DateLabel" }) },
        date.format('D')
      ),
      highlightModifier ? _react2.default.createElement(_CalendarHighlight2.default, { modifier: highlightModifier }) : null
    );
  }
});

exports.default = CalendarDate;
});

unwrapExports(CalendarDate_1);

var PaginationArrow_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _reactAddonsPureRenderMixin2 = _interopRequireDefault(reactAddonsPureRenderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PaginationArrow = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _reactAddonsPureRenderMixin2.default],
  displayName: "PaginationArrow",

  propTypes: {
    disabled: _propTypes2.default.bool,
    onTrigger: _propTypes2.default.func,
    direction: _propTypes2.default.oneOf(['next', 'previous'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false
    };
  },
  render: function render() {
    var _props = this.props,
        disabled = _props.disabled,
        direction = _props.direction,
        onTrigger = _props.onTrigger,
        props = _objectWithoutProperties(_props, ['disabled', 'direction', 'onTrigger']);

    var modifiers = _defineProperty({}, direction, true);
    var states = { disabled: disabled };

    var elementOpts = {
      modifiers: modifiers,
      states: states
    };

    var iconOpts = {
      element: 'PaginationArrowIcon',
      modifiers: modifiers,
      states: states
    };

    return _react2.default.createElement(
      'div',
      _extends({ className: this.cx(elementOpts) }, props, { onClick: onTrigger }),
      _react2.default.createElement('div', { className: this.cx(iconOpts) })
    );
  }
});

exports.default = PaginationArrow;
});

unwrapExports(PaginationArrow_1);

var areMomentValuesEqual = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (previousValue, nextValue) {
  var areBothMoment = _momentRange2.default.isMoment(previousValue) && _momentRange2.default.isMoment(nextValue);
  if (!areBothMoment) {
    return false;
  }

  return previousValue.isSame(nextValue);
};



var _momentRange2 = _interopRequireDefault(momentRange$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
});

unwrapExports(areMomentValuesEqual);

var hasUpdatedValue = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (previousProps, nextProps) {
  var previousValue = previousProps.value;
  var nextValue = nextProps.value;

  return !(previousValue === nextValue || (0, _areMomentValuesEqual2.default)(previousValue, nextValue) || (0, _areMomentRangesEqual2.default)(previousValue, nextValue));
};



var _areMomentRangesEqual2 = _interopRequireDefault(areMomentRangesEqual_1);



var _areMomentValuesEqual2 = _interopRequireDefault(areMomentValuesEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
});

unwrapExports(hasUpdatedValue);

var getYearMonth_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYearMonthProps = undefined;
exports.getYearMonth = getYearMonth;



var _momentRange2 = _interopRequireDefault(momentRange$1);



var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getYearMonth(date) {
  if (!_momentRange2.default.isMoment(date)) {
    return undefined;
  }

  return { year: date.year(), month: date.month() };
}

var getYearMonthProps = exports.getYearMonthProps = function getYearMonthProps(props) {
  var selectionType = props.selectionType,
      value = props.value,
      initialYear = props.initialYear,
      initialMonth = props.initialMonth;

  if (!(_momentRange2.default.isMoment(value) || (0, _isMomentRange2.default)(value))) {
    return { year: initialYear, month: initialMonth };
  }

  if (selectionType === 'single') {
    return getYearMonth(value);
  }

  return getYearMonth(value.start);
};
});

unwrapExports(getYearMonth_1);
var getYearMonth_2 = getYearMonth_1.getYearMonthProps;
var getYearMonth_3 = getYearMonth_1.getYearMonth;

var DateRangePicker_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _createReactClass2 = _interopRequireDefault(createReactClass);



var _momentRange2 = _interopRequireDefault(momentRange$1);



var _immutable2 = _interopRequireDefault(immutable);



var _calendar2 = _interopRequireDefault(calendar);



var _BemMixin2 = _interopRequireDefault(BemMixin_1);



var _CustomPropTypes2 = _interopRequireDefault(CustomPropTypes);



var _Legend2 = _interopRequireDefault(Legend_1);



var _CalendarMonth2 = _interopRequireDefault(CalendarMonth_1);



var _CalendarDate2 = _interopRequireDefault(CalendarDate_1);



var _PaginationArrow2 = _interopRequireDefault(PaginationArrow_1);



var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);



var _hasUpdatedValue2 = _interopRequireDefault(hasUpdatedValue);





var _reactAddonsPureRenderMixin2 = _interopRequireDefault(reactAddonsPureRenderMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var absoluteMinimum = (0, _momentRange2.default)(new Date(-8640000000000000 / 2)).startOf('day');
var absoluteMaximum = (0, _momentRange2.default)(new Date(8640000000000000 / 2)).startOf('day');

function noop() {}

var DIRECTIONS = {
  next: 'next',
  previous: 'previous'
};

var DateRangePicker = (0, _createReactClass2.default)({
  mixins: [_BemMixin2.default, _reactAddonsPureRenderMixin2.default],
  displayName: "DateRangePicker",

  propTypes: {
    bemBlock: _propTypes2.default.string,
    bemNamespace: _propTypes2.default.string,
    className: _propTypes2.default.string,
    dateStates: _propTypes2.default.array, // an array of date ranges and their states
    defaultState: _propTypes2.default.string,
    disableNavigation: _propTypes2.default.bool,
    firstOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
    helpMessage: _propTypes2.default.string,
    initialDate: _propTypes2.default.instanceOf(Date),
    initialFromValue: _propTypes2.default.bool,
    initialMonth: _propTypes2.default.number, // Overrides values derived from initialDate/initialRange
    initialRange: _propTypes2.default.object,
    initialYear: _propTypes2.default.number, // Overrides values derived from initialDate/initialRange
    locale: _propTypes2.default.string,
    maximumDate: _propTypes2.default.instanceOf(Date),
    minimumDate: _propTypes2.default.instanceOf(Date),
    numberOfCalendars: _propTypes2.default.number,
    onHighlightDate: _propTypes2.default.func, // triggered when a date is highlighted (hovered)
    onHighlightRange: _propTypes2.default.func, // triggered when a range is highlighted (hovered)
    onSelect: _propTypes2.default.func, // triggered when a date or range is selectec
    onSelectStart: _propTypes2.default.func, // triggered when the first date in a range is selected
    paginationArrowComponent: _propTypes2.default.func,
    selectedLabel: _propTypes2.default.string,
    selectionType: _propTypes2.default.oneOf(['single', 'range']),
    singleDateRange: _propTypes2.default.bool,
    showLegend: _propTypes2.default.bool,
    stateDefinitions: _propTypes2.default.object,
    value: _CustomPropTypes2.default.momentOrMomentRange,
    animate: _propTypes2.default.bool,
    animationAxis: _propTypes2.default.oneOf(['X', 'Y']),
    duration: _propTypes2.default.number,
    focusedElement: _propTypes2.default.oneOf(['start', 'end'])
  },

  getDefaultProps: function getDefaultProps() {
    var date = new Date();
    var initialDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    return {
      bemNamespace: null,
      bemBlock: 'DateRangePicker',
      className: '',
      numberOfCalendars: 1,
      firstOfWeek: 0,
      disableNavigation: false,
      nextLabel: '',
      previousLabel: '',
      initialDate: initialDate,
      initialFromValue: true,
      locale: (0, _momentRange2.default)().locale(),
      selectionType: 'range',
      singleDateRange: false,
      stateDefinitions: {
        '__default': {
          color: null,
          selectable: true,
          label: null
        }
      },
      selectedLabel: "Your selected dates",
      defaultState: '__default',
      dateStates: [],
      showLegend: false,
      onSelect: noop,
      paginationArrowComponent: _PaginationArrow2.default,
      animate: true,
      animationAxis: 'X',
      duration: 500
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this = this;

    var _props = this.props,
        numberOfCalendars = _props.numberOfCalendars,
        maximumDate = _props.maximumDate;

    var maxDate = new Date(maximumDate);
    var nextDateStates = this.getDateStates(nextProps);
    var nextEnabledRange = this.getEnabledRange(nextProps);
    var value = nextProps.value;

    value = (0, _isMomentRange2.default)(value) ? value.start : value;

    var updatedState = {
      selectedStartDate: this.state.selectedStartDate,
      hideSelection: !!this.state.selectedStartDate,
      dateStates: this.state.dateStates && _immutable2.default.is(this.state.dateStates, nextDateStates) ? this.state.dateStates : nextDateStates,
      enabledRange: this.state.enabledRange && this.state.enabledRange.isSame(nextEnabledRange) ? this.state.enabledRange : nextEnabledRange,
      highlightedRange: !this.state.selectedStartDate
    };

    if ((0, _hasUpdatedValue2.default)(this.props, nextProps)) {
      if (this.state.selectedStartDate) {
        updatedState.hideSelection = false;
        updatedState.selectedStartDate = null;
        this.setState({
          highlightedRange: nextProps.value
        }, function () {
          return _this.completeSelection();
        });
      }

      if (!nextProps.value || !this.isStartOrEndVisible(nextProps)) {
        var yearMonth = (0, getYearMonth_1.getYearMonthProps)(nextProps);

        updatedState.year = yearMonth.year;
        updatedState.month = yearMonth.month;
      }

      if (numberOfCalendars > 1 && maxDate && maxDate.getFullYear() === +value.format('YYYY') && maxDate.getMonth() === +value.format('M') - 1) {
        var momentDate = (0, _momentRange2.default)(maxDate).subtract(numberOfCalendars, 'month');
        updatedState.year = +momentDate.format('YYYY');
        updatedState.month = +momentDate.format('M');
      }
    }

    this.setState(updatedState);
  },
  getInitialState: function getInitialState() {
    var now = new Date();
    var _props2 = this.props,
        initialYear = _props2.initialYear,
        initialMonth = _props2.initialMonth,
        initialFromValue = _props2.initialFromValue,
        value = _props2.value;

    var year = now.getFullYear();
    var month = now.getMonth();

    if (Number.isInteger(initialYear) && Number.isInteger(initialMonth)) {
      year = initialYear;
      month = initialMonth;
    }

    if (initialFromValue && (_momentRange2.default.isMoment(value) || (0, _isMomentRange2.default)(value))) {
      var yearMonth = (0, getYearMonth_1.getYearMonthProps)(this.props);
      month = yearMonth.month;
      year = yearMonth.year;
    }

    return {
      year: year,
      month: month,
      selectedStartDate: null,
      highlightedDate: null,
      highlightRange: null,
      hideSelection: false,
      enabledRange: this.getEnabledRange(this.props),
      dateStates: this.getDateStates(this.props),
      direction: ''
    };
  },
  getEnabledRange: function getEnabledRange(props) {
    var min = props.minimumDate ? (0, _momentRange2.default)(props.minimumDate).startOf('day') : absoluteMinimum;
    var max = props.maximumDate ? (0, _momentRange2.default)(props.maximumDate).startOf('day') : absoluteMaximum;

    return _momentRange2.default.range(min, max);
  },
  getDateStates: function getDateStates(props) {
    var dateStates = props.dateStates,
        defaultState = props.defaultState,
        stateDefinitions = props.stateDefinitions;

    var actualStates = [];
    var minDate = absoluteMinimum;
    var maxDate = absoluteMaximum;
    var dateCursor = (0, _momentRange2.default)(minDate).startOf('day');

    var defs = _immutable2.default.fromJS(stateDefinitions);

    dateStates.forEach(function (s) {
      var r = s.range;
      var start = r.start.startOf('day');
      var end = r.end.startOf('day');

      if (!dateCursor.isSame(start, 'day')) {
        actualStates.push({
          state: defaultState,
          range: _momentRange2.default.range(dateCursor, start)
        });
      }
      actualStates.push(s);
      dateCursor = end;
    });

    actualStates.push({
      state: defaultState,
      range: _momentRange2.default.range(dateCursor, maxDate)
    });

    // sanitize date states
    return _immutable2.default.List(actualStates).map(function (s) {
      var def = defs.get(s.state);
      return _immutable2.default.Map({
        range: s.range,
        state: s.state,
        selectable: def.get('selectable', true),
        color: def.get('color')
      });
    });
  },
  isDateDisabled: function isDateDisabled(date) {
    return !this.state.enabledRange.contains(date);
  },
  isDateSelectable: function isDateSelectable(date) {
    return this.dateRangesForDate(date).some(function (r) {
      return r.get('selectable');
    });
  },
  nonSelectableStateRanges: function nonSelectableStateRanges() {
    return this.state.dateStates.filter(function (d) {
      return !d.get('selectable');
    });
  },
  dateRangesForDate: function dateRangesForDate(date) {
    return this.state.dateStates.filter(function (d) {
      return d.get('range').contains(date);
    });
  },
  sanitizeRange: function sanitizeRange(range, forwards) {
    /* Truncates the provided range at the first intersection
     * with a non-selectable state. Using forwards to determine
     * which direction to work
     */
    var blockedRanges = this.nonSelectableStateRanges().map(function (r) {
      return r.get('range');
    });
    var intersect = void 0;

    if (forwards) {
      intersect = blockedRanges.find(function (r) {
        return range.intersect(r);
      });
      if (intersect) {
        return _momentRange2.default.range(range.start, intersect.start);
      }
    } else {
      intersect = blockedRanges.findLast(function (r) {
        return range.intersect(r);
      });

      if (intersect) {
        return _momentRange2.default.range(intersect.end, range.end);
      }
    }

    if (range.start.isBefore(this.state.enabledRange.start)) {
      return _momentRange2.default.range(this.state.enabledRange.start, range.end);
    }

    if (range.end.isAfter(this.state.enabledRange.end)) {
      return _momentRange2.default.range(range.start, this.state.enabledRange.end);
    }

    return range;
  },
  highlightRange: function highlightRange(range) {
    this.setState({
      highlightedRange: range,
      highlightedDate: null
    });
    if (typeof this.props.onHighlightRange === 'function') {
      this.props.onHighlightRange(range, this.statesForRange(range));
    }
  },
  onUnHighlightDate: function onUnHighlightDate() {
    this.setState({
      highlightedDate: null
    });
  },
  onSelectDate: function onSelectDate(date) {
    var selectionType = this.props.selectionType;
    var selectedStartDate = this.state.selectedStartDate;


    if (selectionType === 'range') {
      if (selectedStartDate) {
        this.completeRangeSelection();
      } else if (date && !this.isDateDisabled(date) && this.isDateSelectable(date)) {
        this.startRangeSelection(date);
        if (this.props.singleDateRange) {
          this.highlightRange(_momentRange2.default.range(date, date));
        }
      }
    } else {
      if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
        this.completeSelection();
      }
    }
  },
  onHighlightDate: function onHighlightDate(date) {
    var selectionType = this.props.selectionType;
    var selectedStartDate = this.state.selectedStartDate;


    var datePair = void 0;
    var range = void 0;
    var forwards = void 0;

    if (selectionType === 'range') {
      if (selectedStartDate) {
        datePair = _immutable2.default.List.of(selectedStartDate, date).sortBy(function (d) {
          return d.unix();
        });
        range = _momentRange2.default.range(datePair.get(0), datePair.get(1));
        forwards = range.start.unix() === selectedStartDate.unix();
        range = this.sanitizeRange(range, forwards);
        this.highlightRange(range);
      } else if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
        this.highlightDate(date);
      }
    } else {
      if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
        this.highlightDate(date);
      }
    }
  },
  startRangeSelection: function startRangeSelection(date) {
    this.setState({
      hideSelection: true,
      selectedStartDate: date
    });
    if (typeof this.props.onSelectStart === 'function') {
      this.props.onSelectStart((0, _momentRange2.default)(date));
    }
  },
  statesForDate: function statesForDate(date) {
    return this.state.dateStates.filter(function (d) {
      return date.within(d.get('range'));
    }).map(function (d) {
      return d.get('state');
    });
  },
  statesForRange: function statesForRange(range) {
    if (range.start.isSame(range.end, 'day')) {
      return this.statesForDate(range.start);
    }
    return this.state.dateStates.filter(function (d) {
      return d.get('range').intersect(range);
    }).map(function (d) {
      return d.get('state');
    });
  },
  completeSelection: function completeSelection() {
    var highlightedDate = this.state.highlightedDate;
    if (highlightedDate) {
      this.setState({
        hideSelection: false,
        highlightedDate: null
      });
      this.props.onSelect(highlightedDate, this.statesForDate(highlightedDate));
    }
  },
  completeRangeSelection: function completeRangeSelection() {
    var range = this.state.highlightedRange;

    if (range && (!range.start.isSame(range.end, 'day') || this.props.singleDateRange)) {
      this.setState({
        selectedStartDate: null,
        highlightedRange: null,
        highlightedDate: null,
        hideSelection: false
      });
      this.props.onSelect(range, this.statesForRange(range));
    }
  },
  highlightDate: function highlightDate(date) {
    this.setState({
      highlightedDate: date
    });
    if (typeof this.props.onHighlightDate === 'function') {
      this.props.onHighlightDate(date, this.statesForDate(date));
    }
  },
  getMonthDate: function getMonthDate() {
    return (0, _momentRange2.default)(new Date(this.state.year, this.state.month, 1));
  },
  isStartOrEndVisible: function isStartOrEndVisible(props) {
    var _this2 = this;

    var value = props.value,
        selectionType = props.selectionType,
        numberOfCalendars = props.numberOfCalendars;


    var isVisible = function isVisible(date) {
      var yearMonth = (0, getYearMonth_1.getYearMonth)(date);
      var isSameYear = yearMonth.year === _this2.state.year;
      var isMonthVisible = yearMonth.month === _this2.state.month || numberOfCalendars === 2 && yearMonth.month - 1 === _this2.state.month;

      return isSameYear && isMonthVisible;
    };

    if (selectionType === 'single') {
      return isVisible(value);
    }

    return isVisible(value.start) || isVisible(value.end);
  },
  canMoveBack: function canMoveBack() {
    if (this.getMonthDate().subtract(1, 'days').isBefore(this.state.enabledRange.start)) {
      return false;
    }
    return true;
  },
  moveBack: function moveBack() {
    var monthDate = void 0;

    if (this.canMoveBack()) {
      monthDate = this.getMonthDate();
      monthDate.subtract(1, 'months');

      this.animate(DIRECTIONS.previous, monthDate);
    }
  },
  canMoveForward: function canMoveForward() {
    if (this.getMonthDate().add(this.props.numberOfCalendars, 'months').isAfter(this.state.enabledRange.end)) {
      return false;
    }
    return true;
  },
  moveForward: function moveForward() {
    var monthDate = void 0;

    if (this.canMoveForward()) {
      monthDate = this.getMonthDate();
      monthDate.add(1, 'months');

      this.animate(DIRECTIONS.next, monthDate);
    }
  },
  animate: function animate(direction, monthDate) {
    var _this3 = this;

    var _props3 = this.props,
        animate = _props3.animate,
        duration = _props3.duration;


    if (animate) {
      this.setState({
        direction: direction
      });

      setTimeout(function () {
        _this3.setState(_extends({}, (0, getYearMonth_1.getYearMonth)(monthDate), {
          direction: ''
        }));
      }, duration);
    } else {
      this.setState((0, getYearMonth_1.getYearMonth)(monthDate));
    }
  },
  changeYear: function changeYear(year) {
    var _state = this.state,
        enabledRange = _state.enabledRange,
        month = _state.month;


    if ((0, _momentRange2.default)({ years: year, months: month, date: 1 }).unix() < enabledRange.start.unix()) {
      month = enabledRange.start.month();
    }

    if ((0, _momentRange2.default)({ years: year, months: month + 1, date: 1 }).unix() > enabledRange.end.unix()) {
      month = enabledRange.end.month();
    }

    this.setState({
      year: year,
      month: month
    });
  },
  changeMonth: function changeMonth(date) {
    var _state2 = this.state,
        enabledRange = _state2.enabledRange,
        year = _state2.year;


    if ((0, _momentRange2.default)({ years: year, months: date, date: 1 }).unix() < enabledRange.start.unix()) {
      year += 1;
    }

    this.setState({
      month: date,
      year: year
    });
  },
  rangesOverlap: function rangesOverlap(rangeA, rangeB) {
    if (rangeA.overlaps(rangeB) || rangeA.contains(rangeB.start) || rangeA.contains(rangeB.end)) {
      return true;
    }
    return false;
  },
  renderCalendar: function renderCalendar(index) {
    var _props4 = this.props,
        bemBlock = _props4.bemBlock,
        bemNamespace = _props4.bemNamespace,
        firstOfWeek = _props4.firstOfWeek,
        numberOfCalendars = _props4.numberOfCalendars,
        selectionType = _props4.selectionType,
        value = _props4.value;
    var _state3 = this.state,
        dateStates = _state3.dateStates,
        enabledRange = _state3.enabledRange,
        hideSelection = _state3.hideSelection,
        highlightedDate = _state3.highlightedDate,
        highlightedRange = _state3.highlightedRange;

    var monthDate = this.getMonthDate();
    var year = monthDate.year();
    var month = monthDate.month();
    var key = index + '-' + year + '-' + month;
    var props = void 0;

    monthDate.add(index, 'months');

    var cal = new _calendar2.default.Calendar(firstOfWeek);
    var monthDates = _immutable2.default.fromJS(cal.monthDates(monthDate.year(), monthDate.month()));
    var monthStart = monthDates.first().first();
    var monthEnd = monthDates.last().last();
    var monthRange = _momentRange2.default.range(monthStart, monthEnd);

    if (_momentRange2.default.isMoment(value) && !monthRange.contains(value)) {
      value = null;
    } else if ((0, _isMomentRange2.default)(value) && !this.rangesOverlap(monthRange, value)) {
      value = null;
    }

    if (!_momentRange2.default.isMoment(highlightedDate) || !monthRange.contains(highlightedDate)) {
      highlightedDate = null;
    }

    if (!(0, _isMomentRange2.default)(highlightedRange) || !this.rangesOverlap(monthRange, highlightedRange)) {
      highlightedRange = null;
    }

    props = {
      bemBlock: bemBlock,
      bemNamespace: bemNamespace,
      dateStates: dateStates,
      enabledRange: enabledRange,
      firstOfWeek: firstOfWeek,
      hideSelection: hideSelection,
      highlightedDate: highlightedDate,
      highlightedRange: highlightedRange,
      index: index,
      key: key,
      selectionType: selectionType,
      value: value,
      maxIndex: numberOfCalendars - 1,
      firstOfMonth: monthDate,
      onMonthChange: this.changeMonth,
      onYearChange: this.changeYear,
      onSelectDate: this.onSelectDate,
      onHighlightDate: this.onHighlightDate,
      onUnHighlightDate: this.onUnHighlightDate,
      dateRangesForDate: this.dateRangesForDate,
      dateComponent: _CalendarDate2.default,
      locale: this.props.locale,
      focusedElement: this.props.focusedElement
    };

    return _react2.default.createElement(_CalendarMonth2.default, props);
  },
  getStyle: function getStyle() {
    var direction = this.state.direction;
    var animate = this.props.animate;


    if (!direction || !animate) {
      return null;
    }

    var _props5 = this.props,
        numberOfCalendars = _props5.numberOfCalendars,
        duration = _props5.duration,
        animationAxis = _props5.animationAxis;


    var style = void 0;

    switch (direction) {
      case DIRECTIONS.next:
        {
          style = {
            transition: 'transform ' + duration + 'ms',
            transform: 'translate' + animationAxis + '(-' + 100 / numberOfCalendars + '%)'
          };
          break;
        }
      case DIRECTIONS.previous:
        {
          style = {
            transition: 'transform ' + duration + 'ms',
            transform: 'translate' + animationAxis + '(' + 100 / numberOfCalendars + '%)'
          };
          break;
        }
    }

    return style;
  },


  render: function render() {
    var _props6 = this.props,
        PaginationArrowComponent = _props6.paginationArrowComponent,
        className = _props6.className,
        numberOfCalendars = _props6.numberOfCalendars,
        stateDefinitions = _props6.stateDefinitions,
        selectedLabel = _props6.selectedLabel,
        showLegend = _props6.showLegend,
        helpMessage = _props6.helpMessage;


    var wrapperStyle = this.getStyle();

    var calendars = _immutable2.default.Range(-1, numberOfCalendars + 1).map(this.renderCalendar);
    className = this.cx({ element: null }) + ' ' + className;

    return _react2.default.createElement(
      'div',
      { className: className.trim() },
      _react2.default.createElement(PaginationArrowComponent, { direction: 'previous', onTrigger: this.moveBack, disabled: !this.canMoveBack() }),
      _react2.default.createElement(
        'div',
        { className: this.cx({ element: 'MonthWrapper' }) },
        _react2.default.createElement(
          'div',
          { className: this.cx({ element: 'MonthInnerWrapper' }), style: wrapperStyle },
          calendars.toJS()
        )
      ),
      _react2.default.createElement(PaginationArrowComponent, { direction: 'next', onTrigger: this.moveForward, disabled: !this.canMoveForward() }),
      helpMessage ? _react2.default.createElement(
        'span',
        { className: this.cx({ element: 'HelpMessage' }) },
        helpMessage
      ) : null,
      showLegend ? _react2.default.createElement(_Legend2.default, { stateDefinitions: stateDefinitions, selectedLabel: selectedLabel }) : null
    );
  }
});

exports.default = DateRangePicker;
});

var DateRangePicker = unwrapExports(DateRangePicker_1);

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.shape({
  enter: PropTypes__default.number,
  exit: PropTypes__default.number,
  appear: PropTypes__default.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.shape({
  enter: PropTypes__default.string,
  exit: PropTypes__default.string,
  active: PropTypes__default.string
}), PropTypes__default.shape({
  enter: PropTypes__default.string,
  enterDone: PropTypes__default.string,
  enterActive: PropTypes__default.string,
  exit: PropTypes__default.string,
  exitDone: PropTypes__default.string,
  exitActive: PropTypes__default.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes__default.shape({
    current: typeof Element === 'undefined' ? PropTypes__default.any : PropTypes__default.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes__default.oneOfType([PropTypes__default.func.isRequired, PropTypes__default.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes__default.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes__default.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes__default.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes__default.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes__default.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes__default.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes__default.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes__default.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes__default.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes__default.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes__default.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes__default.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes__default.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});
var reactIs_1 = reactIs.isValidElementType;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function withClickOutside(WrappedComponent) {
  var EnhancedComponent = /*#__PURE__*/function (_React$Component) {
    inherits(EnhancedComponent, _React$Component);

    var _super = _createSuper$6(EnhancedComponent);

    function EnhancedComponent(props) {
      var _this;

      classCallCheck(this, EnhancedComponent);

      _this = _super.call(this, props);
      _this.__domNode = void 0;
      _this.__wrappedInstance = void 0;
      _this.handleClickOutside = void 0;

      _this.handleClickOutside = function (e) {
        var domNode = _this.__domNode;

        if ((!domNode || !domNode.contains(e.target)) && _this.__wrappedInstance && typeof _this.__wrappedInstance.handleClickOutside === 'function') {
          _this.__wrappedInstance.handleClickOutside(e);
        }
      };

      _this.handleClickOutside = _this.handleClickOutside.bind(assertThisInitialized(_this));
      return _this;
    }

    createClass(EnhancedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            wrappedRef = _this$props.wrappedRef,
            rest = objectWithoutProperties(_this$props, ["wrappedRef"]);

        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends_1({}, rest, {
          ref: function ref(c) {
            _this2.__wrappedInstance = c;
            _this2.__domNode = ReactDOM.findDOMNode(c);
            wrappedRef && wrappedRef(c);
          }
        }));
      }
    }]);

    return EnhancedComponent;
  }(React__default.Component);

  EnhancedComponent.displayName = "withClickOutside(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return typeof WrappedComponent === 'function' ? EnhancedComponent : hoistNonReactStatics_cjs(EnhancedComponent, WrappedComponent);
}

var Tabs = function Tabs(props) {
  var className = props.className,
      value = props.value,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      variant = props.variant;
  var tabClasses = useCallback(function (variant, active) {
    if (variant === 'capsule') {
      return "tabs__item _capsule ".concat(active ? '_active' : '');
    } else if (variant === 'text') {
      return "tabs__item _text ".concat(active ? '_active' : '');
    } else {
      return "tabs__item _btn ".concat(active ? '_active' : '');
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "tabs ".concat(className, " ").concat(variant === 'normal' ? '_underline' : '')
  }, items.map(function (item, index) {
    var active = item.value === value;
    return /*#__PURE__*/React__default.createElement("button", {
      key: index,
      onClick: function onClick() {
        return onChange(item);
      },
      className: tabClasses(variant, active),
      "data-placeholder": item.title
    }, item.title, item.subTitle ? /*#__PURE__*/React__default.createElement("span", {
      className: "subtitle"
    }, item.subTitle) : null);
  }));
};
Tabs.defaultProps = {
  variant: 'normal',
  className: ''
};
Tabs.propTypes = {
  className: PropTypes__default.string,
  value: PropTypes__default.any,
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
    subTitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
    value: PropTypes__default.any
  })),
  onChange: PropTypes__default.func,
  variant: PropTypes__default.oneOf(['text', 'capsule', 'normal'])
};

function momentOrDatePropCheck(props, propName) {
  var val = props[propName];

  if (!val) {
    return null;
  } else if (isMoment(val)) {
    return null;
  } else if (val instanceof Date) {
    return null;
  }

  return new Error("'".concat(propName, "' must be a moment or Date"));
}

var css_248z$5 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.TimePicker-module_container__1Szpk {\n  display: flex;\n  flex-direction: column;\n  position: relative; }\n  .TimePicker-module_container__1Szpk.TimePicker-module_withTabs__nHUlT {\n    font-size: 12px;\n    line-height: 18px; }\n    .TimePicker-module_container__1Szpk.TimePicker-module_withTabs__nHUlT .TimePicker-module_mode__32WtN {\n      left: auto;\n      right: 0; }\n    .TimePicker-module_container__1Szpk.TimePicker-module_withTabs__nHUlT .TimePicker-module_time__1Gy-1 {\n      left: 0;\n      right: auto; }\n\n.TimePicker-module_button__3OKj9 {\n  position: absolute;\n  top: 0;\n  color: var(--primary2);\n  text-transform: capitalize;\n  cursor: pointer;\n  display: inline-block;\n  padding: 0;\n  z-index: 2;\n  user-select: none; }\n  .TimePicker-module_buttonMeridiem__3oT5x {\n    left: 0;\n    padding-left: 0;\n    text-transform: uppercase; }\n  .TimePicker-module_buttonView__3xTKu {\n    right: 0;\n    padding-right: 0; }\n\n.TimePicker-module_mode__32WtN {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0;\n  z-index: 2; }\n\n.TimePicker-module_time__1Gy-1 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0;\n  font-family: \"Avenir Next Regular\", sans-serif;\n  font-weight: 400; }\n";
var styles$5 = {"container":"TimePicker-module_container__1Szpk","withTabs":"TimePicker-module_withTabs__nHUlT","mode":"TimePicker-module_mode__32WtN","time":"TimePicker-module_time__1Gy-1","button":"TimePicker-module_button__3OKj9","buttonMeridiem":"TimePicker-module_buttonMeridiem__3oT5x","buttonView":"TimePicker-module_buttonView__3xTKu"};
styleInject(css_248z$5);

var css_248z$6 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.ClockNumber-module_clockNumber__2YJoK {\n  width: 32px;\n  height: 32px;\n  user-select: none;\n  position: absolute;\n  left: calc(50% - (32px / 2));\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%; }\n  .ClockNumber-module_clockNumberSelected__1k-Og {\n    color: #ffffff; }\n  .ClockNumber-module_clockNumber-sm__3SO73 {\n    font-size: 20px;\n    font-family: \"Avenir Next Regular\", sans-serif;\n    font-weight: 400; }\n";
var styles$6 = {"clockNumber":"ClockNumber-module_clockNumber__2YJoK","clockNumberSelected":"ClockNumber-module_clockNumberSelected__1k-Og","clockNumber-sm":"ClockNumber-module_clockNumber-sm__3SO73"};
styleInject(css_248z$6);

var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var memoizeTransform = memoize(function (index) {
  var position = positions[index];
  return {
    transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
  };
});
var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      size = _ref.size;
  var transformStyle = memoizeTransform(index);
  return /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(styles$6.clockNumber, " ").concat(size ? styles$6["clockNumber-".concat(size)] : '', " ").concat(selected ? styles$6.clockNumberSelected : ''),
    style: transformStyle
  }, label);
};
ClockNumber.propTypes = {
  selected: PropTypes__default.bool,
  label: PropTypes__default.string,
  index: PropTypes__default.number,
  size: PropTypes__default.oneOf(['sm', ''])
};

var ClockTypes = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds'
};
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}

var getMoment = function getMoment(date) {
  if (moment$1__default.isMoment(date)) {
    return date;
  }

  return moment$1__default(date);
};

var getHoursValue = function getHoursValue(d) {
  var date = getMoment(d);
  return date.hour();
};
var getMinutesValue = function getMinutesValue(d) {
  var date = getMoment(d);
  return date.minute();
};
var getSecondsValue = function getSecondsValue(d) {
  var date = getMoment(d);
  return date.second();
};
var setHoursValue = function setHoursValue(t, hours) {
  var time = getMoment(t);
  return time.set('h', hours);
};
var setMinutesValue = function setMinutesValue(t, minutes) {
  var time = getMoment(t);
  return time.set('m', minutes);
};
var setSecondsValue = function setSecondsValue(t, seconds) {
  var time = getMoment(t);
  return time.set('s', seconds);
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      date = _ref.date,
      size = _ref.size;
  var currentHours = getHoursValue(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: label,
      selected: isSelected(hour),
      size: size
    };
    hourNumbers.push( /*#__PURE__*/React__default.createElement(ClockNumber, _extends_1({
      key: hour
    }, props)));
  }

  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      size = _ref2.size;
  return [/*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '00',
    selected: value === 0,
    index: 12,
    key: 12
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '05',
    selected: value === 5,
    index: 1,
    key: 1
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '10',
    selected: value === 10,
    index: 2,
    key: 2
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '15',
    selected: value === 15,
    index: 3,
    key: 3
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '20',
    selected: value === 20,
    index: 4,
    key: 4
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '25',
    selected: value === 25,
    index: 5,
    key: 5
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '30',
    selected: value === 30,
    index: 6,
    key: 6
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '35',
    selected: value === 35,
    index: 7,
    key: 7
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '40',
    selected: value === 40,
    index: 8,
    key: 8
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '45',
    selected: value === 45,
    index: 9,
    key: 9
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '50',
    selected: value === 50,
    index: 10,
    key: 10
  }), /*#__PURE__*/React__default.createElement(ClockNumber, {
    size: size,
    label: '55',
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue.value,
      distance = _getAngleValue.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue2.value;

  value = value * step % 60;
  return value;
};
var getMeridiem = function getMeridiem(date) {
  return getHoursValue(date) >= 12 ? 'pm' : 'am';
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm) {
  if (ampm) {
    var currentMeridiem = getHoursValue(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? getHoursValue(time) - 12 : getHoursValue(time) + 12;
      return setHoursValue(time, hours);
    }
  }

  return time;
};

var css_248z$7 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.Clock-module_container__u9bjC {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  margin: 16px 0; }\n\n.Clock-module_clock__3pf-q {\n  background-color: rgba(0, 0, 0, 0.07);\n  border-radius: 50%;\n  height: 260px;\n  width: 260px;\n  position: relative;\n  pointer-events: none;\n  z-index: 1; }\n\n.Clock-module_squareMask__367fB {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  pointer-events: auto;\n  outline: none;\n  touch-action: none;\n  user-select: none; }\n  .Clock-module_squareMask__367fB:active {\n    cursor: move; }\n\n.Clock-module_pin__3GogJ {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: var(--primary2);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.Clock-module_containersm__37oAn {\n  height: 130px;\n  align-items: center; }\n\n.Clock-module_clocksm__3ocgE {\n  transform: scale(0.6); }\n";
var styles$7 = {"container":"Clock-module_container__u9bjC","clock":"Clock-module_clock__3pf-q","squareMask":"Clock-module_squareMask__367fB","pin":"Clock-module_pin__3GogJ","containersm":"Clock-module_containersm__37oAn","clocksm":"Clock-module_clocksm__3ocgE"};
styleInject(css_248z$7);

var css_248z$8 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.ClockPointer-module_pointer__28siQ {\n  width: 2px;\n  background-color: var(--primary2);\n  position: absolute;\n  left: calc(50% - 1px);\n  bottom: 50%;\n  transform-origin: center bottom 0px; }\n\n.ClockPointer-module_animateTransform__2kcFs {\n  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms; }\n\n.ClockPointer-module_thumb__11aUL {\n  width: 4px;\n  height: 4px;\n  background-color: #ffffff;\n  border-radius: 100%;\n  position: absolute;\n  top: -21px;\n  left: -15px;\n  border: 14px solid var(--primary2);\n  box-sizing: content-box; }\n\n.ClockPointer-module_noPoint__zRXBt {\n  background-color: var(--primary2); }\n";
var classes = {"pointer":"ClockPointer-module_pointer__28siQ","animateTransform":"ClockPointer-module_animateTransform__2kcFs","thumb":"ClockPointer-module_thumb__11aUL","noPoint":"ClockPointer-module_noPoint__zRXBt"};
styleInject(css_248z$8);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ClockPointer = /*#__PURE__*/function (_React$Component) {
  inherits(ClockPointer, _React$Component);

  var _super = _createSuper$7(ClockPointer);

  function ClockPointer() {
    var _this;

    classCallCheck(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          type = _this$props.type,
          isInner = _this$props.isInner;
      var max = type === ClockTypes.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockTypes.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    };

    return _this;
  }

  createClass(ClockPointer, [{
    key: "render",
    value: function render() {
      var hasSelected = this.props.hasSelected;
      var toAnimateTransform = this.state.toAnimateTransform;
      return /*#__PURE__*/React__default.createElement("div", {
        style: this.getAngleStyle(),
        className: "".concat(classes.pointer, " ").concat(toAnimateTransform ? classes.animateTransform : '')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(classes.thumb, " ").concat(hasSelected ? classes.noPoint : '')
      }));
    }
  }]);

  return ClockPointer;
}(React__default.Component);
ClockPointer.propTypes = {
  value: PropTypes__default.number.isRequired,
  hasSelected: PropTypes__default.bool,
  type: PropTypes__default.oneOf(['hours', 'minutes', 'seconds']),
  isInner: PropTypes__default.bool
};

ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Clock = /*#__PURE__*/function (_React$Component) {
  inherits(Clock, _React$Component);

  var _super = _createSuper$8(Clock);

  function Clock() {
    var _this;

    classCallCheck(this, Clock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.isMoving = false;

    _this.handleTouchMove = function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    };

    _this.handleTouchEnd = function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    };

    _this.handleMove = function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    };

    _this.handleMouseUp = function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    };

    _this.hasSelected = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          value = _this$props.value;

      if (type === ClockTypes.HOURS) {
        return true;
      }

      return value % 5 === 0;
    };

    return _this;
  }

  createClass(Clock, [{
    key: "setTime",
    value: function setTime(e) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (typeof offsetX === 'undefined') {
        var rect = e.target.getBoundingClientRect();
        offsetX = e.changedTouches[0].clientX - rect.left;
        offsetY = e.changedTouches[0].clientY - rect.top;
      }

      var value = this.props.type === ClockTypes.SECONDS || this.props.type === ClockTypes.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
      this.props.onChange(value, isFinish);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          children = _this$props2.children,
          type = _this$props2.type,
          ampm = _this$props2.ampm,
          size = _this$props2.size;
      var isPointerInner = !ampm && type === ClockTypes.HOURS && (value < 1 || value > 12);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$7.container, " ").concat(size ? styles$7["container".concat(size)] : '', " clock__container")
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$7.clock, " ").concat(size ? styles$7["clock".concat(size)] : '', " clock")
      }, /*#__PURE__*/React__default.createElement("div", {
        role: "menu",
        tabIndex: -1,
        className: styles$7.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.pin
      }), /*#__PURE__*/React__default.createElement(ClockPointer, {
        value: value,
        type: type,
        hasSelected: this.hasSelected(),
        isInner: isPointerInner
      }), children));
    }
  }]);

  return Clock;
}(React__default.Component);
Clock.propTypes = {
  type: PropTypes__default.oneOf(Object.keys(ClockTypes).map(function (key) {
    return ClockTypes[key];
  })).isRequired,
  value: PropTypes__default.number.isRequired,
  onChange: PropTypes__default.func.isRequired,
  children: PropTypes__default.arrayOf(PropTypes__default.node).isRequired,
  ampm: PropTypes__default.bool,
  minutesStep: PropTypes__default.number,
  size: PropTypes__default.oneOf(['sm', '']) // innerRef: PropTypes.any,

};
Clock.defaultProps = {
  ampm: false,
  minutesStep: 1
};

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ClockView = /*#__PURE__*/function (_React$Component) {
  inherits(ClockView, _React$Component);

  var _super = _createSuper$9(ClockView);

  function ClockView() {
    classCallCheck(this, ClockView);

    return _super.apply(this, arguments);
  }

  createClass(ClockView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          ampm = _this$props.ampm,
          date = _this$props.date,
          onHourChange = _this$props.onHourChange,
          onMinutesChange = _this$props.onMinutesChange,
          onSecondsChange = _this$props.onSecondsChange,
          minutesStep = _this$props.minutesStep,
          size = _this$props.size;
      var viewProps = memoize(function () {
        switch (type) {
          case ClockTypes.HOURS:
            {
              return {
                value: getHoursValue(date),
                children: getHourNumbers({
                  ampm: ampm,
                  date: date,
                  size: size
                }),
                onChange: function onChange(value, isFinish) {
                  var currentMeridiem = getMeridiem(date);
                  var updatedTimeWithMeridiem = convertToMeridiem(setHoursValue(date, value), currentMeridiem, Boolean(ampm));
                  onHourChange(updatedTimeWithMeridiem, isFinish);
                }
              };
            }

          case ClockTypes.MINUTES:
            {
              var minutesValue = getMinutesValue(date);
              return {
                value: minutesValue,
                children: getMinutesNumbers({
                  value: minutesValue,
                  size: size
                }),
                onChange: function onChange(value, isFinish) {
                  var updatedTime = setMinutesValue(date, value);
                  onMinutesChange(updatedTime, isFinish);
                }
              };
            }

          case ClockTypes.SECONDS:
            {
              var secondsValue = getSecondsValue(date);
              return {
                value: secondsValue,
                children: getMinutesNumbers({
                  value: secondsValue,
                  size: size
                }),
                onChange: function onChange(value, isFinish) {
                  var updatedTime = setSecondsValue(date, value);
                  onSecondsChange(updatedTime, isFinish);
                }
              };
            }

          default:
            {
              throw new Error("You must provide the type for TimePicker: ".concat(Object.values(ClockTypes).join(', ')));
            }
        }
      }, function () {
        return [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type];
      });
      return /*#__PURE__*/React__default.createElement(Clock, _extends_1({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep,
        size: size
      }, viewProps()));
    }
  }]);

  return ClockView;
}(React__default.Component);
ClockView.propTypes = {
  type: PropTypes__default.oneOf(['hours', 'minutes', 'seconds']).isRequired,
  date: PropTypes__default.number.isRequired,
  ampm: PropTypes__default.bool,
  onHourChange: PropTypes__default.func,
  onMinutesChange: PropTypes__default.func,
  onSecondsChange: PropTypes__default.func,
  minutesStep: PropTypes__default.number,
  size: PropTypes__default.oneOf(['sm', ''])
};

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TimePicker = /*#__PURE__*/function (_React$Component) {
  inherits(TimePicker, _React$Component);

  var _super = _createSuper$a(TimePicker);

  function TimePicker(props) {
    var _this;

    classCallCheck(this, TimePicker);

    _this = _super.call(this, props);

    _this.handleChange = function (value, isFinish) {
      var _this$props = _this.props,
          views = _this$props.views,
          onChange = _this$props.onChange;
      var openTo = _this.state.openTo;
      var nextViewToOpen = views[views.indexOf(openTo) + 1];

      _this.setState({
        time: value
      });

      if (isFinish && nextViewToOpen) {
        // do not close picker if needs to show next view
        onChange(value, false);

        _this.setState({
          openTo: nextViewToOpen
        });

        return;
      }

      onChange(value, Boolean(isFinish));
    };

    _this.handleMeridiemChange = function () {
      var oldMode = _this.state.mode;
      var mode = oldMode === 'am' ? 'pm' : 'am';
      var _this$props2 = _this.props,
          value = _this$props2.value,
          ampm = _this$props2.ampm;

      _this.setState({
        mode: mode
      });

      var timeWithMeridiem = convertToMeridiem(value, mode, Boolean(ampm));

      _this.handleChange(timeWithMeridiem, false);
    };

    _this.handleChangeTimeView = function (view) {
      var views = _this.props.views;
      var openTo = _this.state.openTo;
      var nextViewToOpen = views[views.indexOf(openTo) + 1] || views[0];

      _this.setState({
        openTo: nextViewToOpen
      });
    };

    _this.state = {
      openTo: props.openTo && arrayIncludes(props.views, props.openTo) ? props.openTo : props.views[0],
      mode: getMeridiem(props.value),
      time: moment$1__default(props.value)
    };
    return _this;
  }

  createClass(TimePicker, [{
    key: "timeOptions",
    get: function get() {
      return this.props.views.map(function (v) {
        return {
          title: v,
          value: v
        };
      });
    }
  }, {
    key: "openTo",
    get: function get() {
      return this.props.openTo || this.state.openTo;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          ampm = _this$props3.ampm,
          minutesStep = _this$props3.minutesStep,
          size = _this$props3.size,
          useViewsAsTabs = _this$props3.useViewsAsTabs;
      var _this$state = this.state,
          mode = _this$state.mode,
          time = _this$state.time;
      var modeValue = !!(mode === 'pm');
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$5.container, " ").concat(useViewsAsTabs ? styles$5.withTabs : '', " timepicker")
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$5.mode
      }, /*#__PURE__*/React__default.createElement(Switch, {
        size: useViewsAsTabs ? 'sm' : '',
        list: ['AM', 'PM'],
        name: "time-mode-swithcer",
        onChange: this.handleMeridiemChange,
        value: modeValue
      })), !useViewsAsTabs ? /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$5.button, " ").concat(styles$5.buttonView),
        onClick: this.handleChangeTimeView
      }, /*#__PURE__*/React__default.createElement("span", null, this.openTo)) : /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$5.time),
        onClick: this.handleChangeTimeView
      }, /*#__PURE__*/React__default.createElement("span", null, time.format('hh:mm A'))), /*#__PURE__*/React__default.createElement(ClockView, {
        type: this.openTo,
        date: value,
        ampm: ampm,
        minutesStep: minutesStep,
        onHourChange: this.handleChange,
        onMinutesChange: this.handleChange,
        onSecondsChange: this.handleChange,
        size: size
      }));
    }
  }]);

  return TimePicker;
}(React__default.Component);
TimePicker.propTypes = {
  value: PropTypes__default.number.isRequired,
  ampm: PropTypes__default.bool,
  minutesStep: PropTypes__default.number,
  openTo: PropTypes__default.oneOf(Object.values(ClockTypes)),
  views: PropTypes__default.arrayOf(PropTypes__default.oneOf(Object.values(ClockTypes))),
  onChange: PropTypes__default.func.isRequired,
  size: PropTypes__default.oneOf(['sm', '']),
  useViewsAsTabs: PropTypes__default.bool
};
TimePicker.defaultProps = {
  ampm: true,
  views: ['hours', 'minutes'],
  size: '',
  useViewsAsTabs: false
};

var css_248z$9 = ".DatesPickerWithTimePicker-module_tabs__2JVyl {\n  margin-bottom: 1rem; }\n\n.DatesPickerWithTimePicker-module_pickerWrapper__3YuUW {\n  font-size: 16px; }\n";
var styles$8 = {"tabs":"DatesPickerWithTimePicker-module_tabs__2JVyl","pickerWrapper":"DatesPickerWithTimePicker-module_pickerWrapper__3YuUW"};
styleInject(css_248z$9);

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var tabs = [{
  title: 'Date',
  value: 'date'
}];
var DatesPickerWithTimePicker = /*#__PURE__*/function (_React$Component) {
  inherits(DatesPickerWithTimePicker, _React$Component);

  var _super = _createSuper$b(DatesPickerWithTimePicker);

  function DatesPickerWithTimePicker() {
    var _this;

    classCallCheck(this, DatesPickerWithTimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      tab: 'date'
    };
    _this.tabs = tabs.concat(['hours', 'minutes'].map(function (view) {
      return {
        title: view.replace(view.charAt(0), view.charAt(0).toLocaleUpperCase()),
        value: view
      };
    }));

    _this.handleChangeTab = function (tab) {
      _this.setState({
        tab: tab.value
      });

      _this.props.clearAfterSelection();
    };

    _this.handleChange = function (value) {
      _this.props.onChange(value);
    };

    _this.renderTimePicker = function () {
      var value = _this.props.value;
      var tab = _this.state.tab;
      var time = value ? value.valueOf() : moment$1__default().startOf('day').valueOf();
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$8.pickerWrapper
      }, /*#__PURE__*/React__default.createElement(TimePicker, {
        openTo: tab,
        value: time,
        onChange: _this.handleChange,
        size: 'sm',
        useViewsAsTabs: true
      }));
    };

    _this.renderBar = function () {
      var tab = _this.state.tab;
      var children = _this.props.children;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Tabs, {
        items: _this.tabs,
        className: "tabs_small tabs_capitalized ".concat(styles$8.tabs),
        value: tab,
        onChange: _this.handleChangeTab
      }), tab === 'date' ? children : _this.renderTimePicker());
    };

    return _this;
  }

  createClass(DatesPickerWithTimePicker, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps, prevState) {
      if (this.props.toggleToTime && !prevProps.toggleToTime && this.state.tab === 'date') {
        return true;
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (snapshot) {
        this.handleChangeTab(this.tabs[1]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withTimePicker = _this$props.withTimePicker,
          children = _this$props.children;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, withTimePicker ? this.renderBar() : children);
    }
  }]);

  return DatesPickerWithTimePicker;
}(React__default.Component);
DatesPickerWithTimePicker.propTypes = {
  value: PropTypes__default.oneOfType([PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]), PropTypes__default.shape({
    start: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]),
    end: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck])
  })]),
  withTimePicker: PropTypes__default.bool.isRequired,
  onChange: PropTypes__default.func.isRequired,
  clearAfterSelection: PropTypes__default.func,
  toggleToTime: PropTypes__default.bool
};

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DatesPickerOnDoneWrapperComponent = /*#__PURE__*/function (_React$PureComponent) {
  inherits(DatesPickerOnDoneWrapperComponent, _React$PureComponent);

  var _super = _createSuper$c(DatesPickerOnDoneWrapperComponent);

  function DatesPickerOnDoneWrapperComponent() {
    var _this;

    classCallCheck(this, DatesPickerOnDoneWrapperComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      value: null
    };

    _this.findPreselectedRangeId = function (dateRange) {
      var preselectedRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var start = moment$1__default(dateRange.start);
      var end = moment$1__default(dateRange.end);

      for (var ii = 0; ii < preselectedRange.length; ii++) {
        var current = preselectedRange[ii];
        var rangeStart = moment$1__default(current.start);
        var rangeEnd = moment$1__default(current.end);

        if (start.isSame(rangeStart, 'day') && end.isSame(rangeEnd, 'day')) {
          return current.key;
        }
      }

      return null;
    };

    _this.onSelect = function (value, states, preselectedRangeKey) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          preselectedRangeValues = _this$props.preselectedRangeValues,
          updateByDone = _this$props.updateByDone,
          resetInputValue = _this$props.resetInputValue;

      var formatedPreselectedKey = preselectedRangeKey || _this.findPreselectedRangeId(value, preselectedRangeValues);

      _this.setState({
        value: value,
        states: states,
        preselectedRange: formatedPreselectedKey
      });

      if (!updateByDone) {
        resetInputValue();
        onSelect(value, states, formatedPreselectedKey);
      }
    };

    _this.handleClickOutside = function () {
      return _this.props.resetInputValue();
    };

    return _this;
  }

  createClass(DatesPickerOnDoneWrapperComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        value: this.props.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var resetInputValue = this.props.resetInputValue;
      var _this$state = this.state,
          value = _this$state.value,
          preselectedRange = _this$state.preselectedRange;
      return this.props.children(value, this.onSelect, preselectedRange, resetInputValue);
    }
  }]);

  return DatesPickerOnDoneWrapperComponent;
}(React__default.PureComponent);

DatesPickerOnDoneWrapperComponent.propTypes = {
  onSelect: PropTypes__default.func,
  value: PropTypes__default.any,
  resetInputValue: PropTypes__default.func,
  updateByDone: PropTypes__default.bool,
  preselectedRangeValues: PropTypes__default.array
};
var DatesPickerOnDoneWrapper = withClickOutside(DatesPickerOnDoneWrapperComponent);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Positions = {
  LEFT: 'tooltipV2_left',
  TOP: 'tooltipV2_top',
  RIGHT: 'tooltipV2_right',
  BOTTOM: 'tooltipV2_bottom',
  'BOTTOM-LEFT': 'tooltipV2_bottom-left',
  'BOTTOM-RIGHT': 'tooltipV2_bottom-right',
  'TOP-LEFT': 'tooltipV2_top-left',
  'TOP-RIGHT': 'tooltipV2_top-right'
};
var Tooltip = /*#__PURE__*/function (_PureComponent) {
  inherits(Tooltip, _PureComponent);

  var _super = _createSuper$d(Tooltip);

  function Tooltip(props) {
    var _this;

    classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.tooltipLabel = /*#__PURE__*/createRef();
    _this.tooltipWrapperRef = /*#__PURE__*/createRef();

    _this.onFontLoaded = function () {
      var font = new fontfaceobserver_standalone('Avenir Next Regular');
      font.load().then(function () {
        _this.setStyleToInitial();
      });
    };

    _this.setStyleToInitial = function () {
      _this.setState({
        labelInnerMaxWidth: _this.labelInnerWidth,
        isLabelMaxWidthSet: false
      });
    };

    _this.setLabelMaxWidth = function () {
      if (_this.tooltipLabelInner) {
        var contentWidth = Math.ceil(_this.tooltipLabelInner.getBoundingClientRect().width);
        contentWidth = contentWidth <= _this.labelInnerWidth ? contentWidth : _this.labelInnerWidth;

        _this.setState({
          labelInnerMaxWidth: contentWidth,
          isLabelMaxWidthSet: true
        });
      }
    };

    _this.handleMouseEnter = function () {
      if (_this.props.disable) {
        return;
      }

      _this.setStyleToInitial();

      var position = _this.getPosition();

      var xycoords = _this.getXYCoords();

      _this.timer = setTimeout(function () {
        _this.setState({
          isVisible: true,
          isShowing: true,
          position: position,
          xycoords: xycoords
        });
      }, _this.props.delayTime);
    };

    _this.handleMouseLeave = function () {
      clearTimeout(_this.timer);

      _this.setState({
        isVisible: false
      }, function () {
        _this.process = setTimeout(function () {
          _this.setState({
            position: _this.props.auto ? Positions['TOP-LEFT'] : Positions[_this.props.position.toUpperCase()],
            isShowing: false
          });
        }, _this.props.disableAnimation ? 0 : 200); // Animation duration
      });
    };

    _this.labelInnerWidth = props.labelMaxWidth ? props.labelMaxWidth - 20 : 480; // 2x 10px horizontal paddings

    _this.state = {
      isVisible: false,
      isShowing: false,
      // visible with animation duration
      position: Positions[props.position.toUpperCase()],
      labelInnerMaxWidth: _this.labelInnerWidth
    };
    _this.timer = null;
    return _this;
  }

  createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onFontLoaded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.state.isLabelMaxWidthSet) {
        this.setLabelMaxWidth();
      }

      if (this.props.disable && !prevProps.disable) {
        this.handleMouseLeave();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      if (this.props.auto) {
        clearTimeout(this.process);
        var _this$state = this.state,
            isShowing = _this$state.isShowing,
            current = _this$state.position;

        if (isShowing) {
          return current;
        }

        var position = Positions['TOP-LEFT'];
        var coord = this.props.portal ? this.tooltipWrapperRef.current.getBoundingClientRect() : this.tooltipLabel.current.getBoundingClientRect();
        var x = coord.x,
            y = coord.y,
            right = coord.right;

        if (y < 0) {
          position = Positions['BOTTOM-LEFT'];
        }

        if (x < 0) {
          position = Positions.RIGHT;
        }

        if (right > window.innerWidth) {
          position = Positions.LEFT;
        }

        return position;
      } else {
        return this.state.position;
      }
    }
  }, {
    key: "getXYCoords",
    value: function getXYCoords() {
      var _this$tooltipWrapperR, _this$tooltipWrapperR2, _this$tooltipWrapperR3, _this$tooltipWrapperR4;

      var coord = (_this$tooltipWrapperR = (_this$tooltipWrapperR2 = this.tooltipWrapperRef) === null || _this$tooltipWrapperR2 === void 0 ? void 0 : (_this$tooltipWrapperR3 = _this$tooltipWrapperR2.current) === null || _this$tooltipWrapperR3 === void 0 ? void 0 : (_this$tooltipWrapperR4 = _this$tooltipWrapperR3.getBoundingClientRect) === null || _this$tooltipWrapperR4 === void 0 ? void 0 : _this$tooltipWrapperR4.call(_this$tooltipWrapperR3)) !== null && _this$tooltipWrapperR !== void 0 ? _this$tooltipWrapperR : {
        x: 0,
        y: 0
      };
      var x = coord.x,
          y = coord.y;
      return {
        top: y,
        left: x
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          style = _this$props.style,
          handleClick = _this$props.handleClick,
          portal = _this$props.portal,
          showOnFocus = _this$props.showOnFocus,
          disableAnimation = _this$props.disableAnimation;
      var _this$state2 = this.state,
          isVisible = _this$state2.isVisible,
          position = _this$state2.position,
          labelInnerMaxWidth = _this$state2.labelInnerMaxWidth,
          xycoords = _this$state2.xycoords;
      var visible = isVisible ? 'tooltipV2_visible' : 'tooltipV2_hidden';
      var tooltipClassName = "tooltipV2 ".concat(position, " ").concat(visible, " ").concat(className);
      var content = this.props.label ? /*#__PURE__*/React__default.createElement("span", {
        ref: this.tooltipLabel,
        className: "tooltipV2__label ".concat(disableAnimation ? 'no-animation' : '')
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "tooltipV2__label-outer",
        style: {
          width: "".concat(this.labelInnerWidth, "px"),
          maxWidth: "".concat(labelInnerMaxWidth, "px")
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        ref: function ref(el) {
          _this2.tooltipLabelInner = el;
        },
        className: "tooltipV2__label-inner"
      }, this.props.label))) : null;

      if (portal) {
        content = /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", {
          className: tooltipClassName,
          style: _objectSpread$1(_objectSpread$1({}, style), {}, {
            position: 'fixed',
            zIndex: 9999
          }, xycoords)
        }, content), document.body);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: tooltipClassName,
        onMouseEnter: showOnFocus ? null : this.handleMouseEnter,
        onMouseLeave: showOnFocus ? null : this.handleMouseLeave,
        onFocus: showOnFocus ? this.handleMouseEnter : null,
        onBlur: showOnFocus ? this.handleMouseLeave : null,
        style: style,
        onClick: handleClick,
        ref: this.tooltipWrapperRef
      }, content, this.props.children);
    }
  }]);

  return Tooltip;
}(PureComponent);
Tooltip.defaultProps = {
  delayTime: 500,
  position: 'top',
  auto: true,
  portal: false,
  showOnFocus: false,
  disable: false,
  disableAnimation: false
};
Tooltip.propTypes = {
  label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]).isRequired,
  delayTime: PropTypes__default.number,
  position: PropTypes__default.oneOf(['top', 'right', 'bottom', 'bottom-left', 'bottom-right', 'left', 'top-left', 'top-right']),
  auto: PropTypes__default.bool,
  labelMaxWidth: PropTypes__default.number,
  className: PropTypes__default.string,
  style: PropTypes__default.object,
  handleClick: PropTypes__default.func,
  showOnFocus: PropTypes__default.bool,
  portal: PropTypes__default.bool,
  disable: PropTypes__default.bool,
  disableAnimation: PropTypes__default.bool
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var moment = range.extendMoment(moment$1__default);

var noop$1 = function noop() {
  console.log('noop');
};

var DATE_FORMAT = 'MM/DD/YYYY';
var DEFAULT_PRESELECTED_VALUES = function () {
  var end = moment().endOf('day');
  return [{
    key: 'week',
    title: 'Week',
    start: moment().add(-1, 'week').startOf('day').add(1, 'day'),
    end: end
  }, {
    key: 'month',
    title: 'Month',
    start: moment().add(-1, 'month').startOf('day').add(1, 'day'),
    end: end
  }, {
    key: '3months',
    title: '3 Months',
    start: moment().add(-3, 'month').startOf('day').add(1, 'day'),
    end: end
  }];
}();

var getMomentDate = function getMomentDate(date) {
  if (date instanceof moment) {
    return date;
  }

  return moment(date, DATE_FORMAT);
};

var DatesPickerWrapper = function DatesPickerWrapper(_ref) {
  var children = _ref.children,
      tooltipParams = _ref.tooltipParams;
  return tooltipParams ? /*#__PURE__*/React__default.createElement(Tooltip, tooltipParams, children) : children;
};

var DatesPickerComponent = /*#__PURE__*/function (_Component) {
  inherits(DatesPickerComponent, _Component);

  var _super = _createSuper$e(DatesPickerComponent);

  function DatesPickerComponent(props) {
    var _this;

    classCallCheck(this, DatesPickerComponent);

    _this = _super.call(this, props);
    _this.startInputRef = null;

    _this.onSelect = function (value, states, preselectedRange) {
      var _this$props = _this.props,
          singleDateMode = _this$props.singleDateMode,
          updateDateRange = _this$props.updateDateRange;

      if (!value) {
        return;
      }

      var start = value.start,
          end = value.end;

      if (end) {
        end = moment(end).endOf('day');
      }

      _this.setState({
        value: value,
        states: states,
        preselectedRange: preselectedRange,
        inputValue: null,
        afterSelection: true,
        isButtonDisabled: false
      });

      singleDateMode ? updateDateRange(value, preselectedRange) : updateDateRange(start, end, preselectedRange);
    };

    _this.revertAfterSelection = function () {
      _this.setState({
        afterSelection: false
      });
    };

    _this.onOpen = function () {
      _this.setState({
        isOpen: true
      });
    };

    _this.onClose = function () {
      _this.setState({
        isOpen: false
      });
    };

    _this.onInputFocus = function (e, field) {
      var target = e.target;
      var value = target.value;
      !_this.state.isOpen && target.blur();
      target.setSelectionRange(0, value.length);

      _this.setState({
        focusedElement: field === 'singleDate' ? null : field
      });
    };

    _this.onInputBlur = function (e, field) {
      var isOpen = _this.state.isOpen;

      _this.setState({
        focusedElement: null
      });

      isOpen && _this.onInputEntered(e, field);
    };

    _this.onInputKeyEnter = function (e, field) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        _this.onInputEntered(e, field, true);

        e.target.blur();

        _this.onClose();
      }
    };

    _this.onInputEntered = function (e, field, fromEnterKey) {
      var _this$props2 = _this.props,
          dateRange = _this$props2.dateRange,
          singleDate = _this$props2.singleDate,
          singleDateMode = _this$props2.singleDateMode,
          dateFormat = _this$props2.dateFormat;
      var target = e.target;
      var momentValue = moment$1__default(target.value, dateFormat);
      var prevValue = singleDateMode ? singleDate : dateRange; // Checking if value is valid and could be selected

      if (!momentValue.isValid() || _this.pickerComponent && _this.pickerComponent.isDateDisabled(momentValue) && !_this.pickerComponent.isDateSelectable(momentValue)) {
        var value = singleDateMode ? prevValue : _objectSpread$2({}, prevValue);
        return _this.onSelect(value);
      }

      var newValue;

      switch (field) {
        case 'start':
          {
            if (momentValue.isAfter(moment$1__default(prevValue.end))) {
              newValue = prevValue.start;
            } else {
              newValue = momentValue.startOf('day').toDate();
            }

            break;
          }

        case 'end':
          {
            if (momentValue.isBefore(moment$1__default(prevValue.start))) {
              newValue = prevValue.end;
            } else {
              newValue = momentValue.endOf('day').toDate();
            }

            break;
          }

        case 'singleDate':
          {
            newValue = _this.props.withTimePicker ? momentValue.toDate() : momentValue.endOf('day').toDate();
            break;
          }

        default:
          {
            newValue = prevValue[field];
          }
      }

      field === 'singleDate' ? _this.setState({
        inputValue: newValue
      }, function () {
        return fromEnterKey && _this.onSelect(newValue);
      }) : _this.setState({
        inputValue: _objectSpread$2(_objectSpread$2({}, prevValue), {}, defineProperty({}, field, newValue))
      }, function () {
        return fromEnterKey && _this.onSelect(_objectSpread$2(_objectSpread$2({}, prevValue), {}, defineProperty({}, field, newValue)));
      });
    };

    _this.handleClear = function (e) {
      _this.setState({
        inputValue: null,
        value: null,
        singleDate: ''
      });

      _this.props.updateDateRange(null);

      e.stopPropagation();
    };

    _this.renderSelectionValue = function () {
      var _this$props3 = _this.props,
          singleDateProps = _this$props3.singleDate,
          dateRange = _this$props3.dateRange,
          singleDateMode = _this$props3.singleDateMode,
          dateFormat = _this$props3.dateFormat,
          label = _this$props3.label,
          noLabel = _this$props3.noLabel,
          singleDatePlaceholder = _this$props3.singleDatePlaceholder,
          tooltipParams = _this$props3.tooltipParams,
          _this$props3$classNam = _this$props3.className,
          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
          isClearable = _this$props3.isClearable,
          variant = _this$props3.variant,
          disabled = _this$props3.disabled,
          underline = _this$props3.underline;

      var _ref2 = dateRange || {},
          start = _ref2.start,
          end = _ref2.end;

      var singleDate = singleDateMode && singleDateProps;
      var inputValue = _this.state.inputValue;

      if (start) {
        start = moment(inputValue ? inputValue.start : start).format(dateFormat);
      }

      if (end) {
        end = moment(inputValue ? inputValue.end : end).format(dateFormat);
      }

      if (singleDate) {
        singleDate = moment(inputValue || singleDate).format(dateFormat);
      }

      return /*#__PURE__*/React__default.createElement(DatesPickerWrapper, {
        tooltipParams: tooltipParams
      }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker ".concat(_this.state.isOpen ? '_opened' : '', " ").concat(className, " _").concat(variant),
        onClick: !disabled ? _this.onOpen : null,
        tabIndex: disabled ? -1 : 0,
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 13 || e.keyCode === 32 && !disabled) {
            _this.onOpen();

            e.stopPropagation();
          }
        }
      }, !noLabel && /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker__label ".concat(underline ? '_underline' : '')
      }, label || "Date ".concat(singleDateMode ? '' : 'Range')), /*#__PURE__*/React__default.createElement("i", {
        className: "icon date-picker__icon"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "DateRange"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker__wrapper ".concat(underline ? '' : '_removeUnderline')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker__item ".concat(singleDateMode ? '_single' : '')
      }, /*#__PURE__*/React__default.createElement("label", {
        className: "date-picker__item-label",
        onClick: function onClick(e) {
          return !_this.state.isOpen && e.preventDefault();
        }
      }, /*#__PURE__*/React__default.createElement("input", {
        ref: function ref(el) {
          if (el) {
            el.value = singleDateMode ? singleDate : start;
            _this.startInputRef = el;
          }
        },
        onFocus: function onFocus(e) {
          return _this.onInputFocus(e, singleDateMode ? 'singleDate' : 'start');
        },
        onBlur: function onBlur(e) {
          return _this.onInputBlur(e, singleDateMode ? 'singleDate' : 'start');
        },
        type: "text",
        size: "5",
        placeholder: singleDatePlaceholder,
        className: "form-control",
        onKeyDown: function onKeyDown(e) {
          return _this.onInputKeyEnter(e, singleDateMode ? 'singleDate' : 'start');
        },
        tabIndex: -1
      }))), !singleDateMode && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker__item-divider"
      }, " \u2013 "), /*#__PURE__*/React__default.createElement("div", {
        className: "date-picker__item"
      }, /*#__PURE__*/React__default.createElement("label", {
        className: "date-picker__item-label"
      }, /*#__PURE__*/React__default.createElement("input", {
        type: "text",
        size: "5",
        className: "form-control",
        ref: function ref(el) {
          if (el) {
            el.value = end;
          }
        },
        onFocus: function onFocus(e) {
          return _this.onInputFocus(e, 'end');
        },
        onBlur: function onBlur(e) {
          return _this.onInputBlur(e, 'end');
        },
        onKeyDown: function onKeyDown(e) {
          return _this.onInputKeyEnter(e, 'end');
        },
        tabIndex: -1
      })))))), singleDateMode && isClearable && singleDate ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        iconName: "Close",
        className: "date-picker__item-clear",
        onClick: _this.handleClear
      }) : null));
    };

    _this.selectPreselectedRange = function (onSelectCallback) {
      return function (event) {
        var rangeID = event.target.getAttribute('data-range-id');
        if (!rangeID) return;

        var range = _this.state.preselectedRangeValues.reduce(function (acc, item) {
          acc[item.key] = item;
          return acc;
        }, {});

        var _range$rangeID = range[rangeID],
            start = _range$rangeID.start,
            end = _range$rangeID.end;
        var r = _this.props.singleDateMode ? range[rangeID].date : moment.range(start, end);

        _this.setState({
          isButtonDisabled: false
        });

        if (onSelectCallback) {
          onSelectCallback(r, null, rangeID);
        } else {
          _this.onSelect(r, null, rangeID);
        }
      };
    };

    _this.handleClickOutside = function (event) {
      if (_this.state.isOpen) {
        event.stopPropagation();
      }

      _this.onClose();
    };

    _this.innerWrapperHandler = function (el) {
      if (el) {
        try {
          var elLeft = Number.parseFloat(window.getComputedStyle(el).left);
          var parentLeft = el.parentElement.getBoundingClientRect().left;
          var diff = Math.abs(parentLeft) - Math.abs(elLeft);

          if (diff < 0) {
            el.style.right = "".concat(-(Math.abs(diff) + 10), "px");
          }
        } catch (e) {
          el.style.right = 0;
        }
      }
    };

    _this.state = {
      isOpen: false,
      preselectedRange: false,
      // props.dateRange && props.dateRange.range,
      preselectedRangeValues: _this.getPreselectedList(),
      focusedElement: null,
      inputValue: null,
      afterSelection: false,
      isButtonDisabled: false
    };
    return _this;
  }

  createClass(DatesPickerComponent, [{
    key: "withTimePicker",
    get: function get() {
      var _this$props4 = this.props,
          singleDateMode = _this$props4.singleDateMode,
          withTimePicker = _this$props4.withTimePicker;
      return singleDateMode && withTimePicker;
    }
  }, {
    key: "getPreselectedList",
    value: function getPreselectedList() {
      var preselected = this.props.preselected;
      var preselectedRangeValues;

      if (preselected) {
        if (preselected === true) {
          preselectedRangeValues = DEFAULT_PRESELECTED_VALUES;
        } else if (preselected instanceof Array) {
          preselectedRangeValues = preselected;
        } else {
          throw Error('The preselected property must be a boolean or an Array types');
        }
      }

      return preselectedRangeValues;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.singleDateMode && this.props.preselected && this.props.dateRange) {
        this.checkPreselectedValues(this.props.dateRange, this.state.preselectedRangeValues);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var preselectedRangeValues;

      if (this.props.preselected !== prevProps.preselected) {
        preselectedRangeValues = this.getPreselectedList();
        this.setState(function () {
          return {
            preselectedRangeValues: preselectedRangeValues
          };
        });
      }

      if (!this.props.singleDateMode && this.props.preselected && prevProps.dateRange !== this.props.dateRange) {
        this.checkPreselectedValues(this.props.dateRange, preselectedRangeValues || this.state.preselectedRangeValues);
      }

      if (this.props.singleDateMode && this.props.preselected && prevProps.singleDate !== this.props.singleDate) {
        this.checkPreselectedValue(this.props.singleDate, preselectedRangeValues || this.state.preselectedRangeValues);
      }
    }
  }, {
    key: "checkPreselectedValue",
    value: function checkPreselectedValue(singleDate, preselectedRange, returnResult) {
      var preselectedRangeKey = null;

      for (var i = 0; i < preselectedRange.length; i++) {
        var current = preselectedRange[i];
        var preselectedDate = getMomentDate(current.date);

        if (preselectedDate.isSame(getMomentDate(singleDate), 'day')) {
          preselectedRangeKey = current.key;
        }
      }

      if (returnResult) {
        return preselectedRangeKey;
      }

      if (this.state.preselectedRange) {
        this.setState({
          preselectedRange: preselectedRangeKey
        });
      }
    }
  }, {
    key: "checkPreselectedValues",
    value: function checkPreselectedValues(dateRange, preselectedRange) {
      var start = getMomentDate(dateRange.start);
      var end = getMomentDate(dateRange.end);

      for (var ii = 0; ii < preselectedRange.length; ii++) {
        var current = preselectedRange[ii];
        var rangeStart = getMomentDate(current.start);
        var rangeEnd = getMomentDate(current.end);

        if (start.isSame(rangeStart, 'day') && end.isSame(rangeEnd, 'day')) {
          this.setState({
            preselectedRange: current.key
          });
          return;
        }
      }

      if (this.state.preselectedRange) {
        this.setState({
          preselectedRange: null
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      if (this.state.isOpen !== newState.isOpen || this.state.focusedElement !== newState.focusedElement) {
        return true;
      }

      return !(newProps.dateRange === this.props.dateRange && newState.preselectedRange === this.state.preselectedRange && newState.preselectedRangeValues === this.state.preselectedRangeValues && newProps.singleDate === this.props.singleDate && newProps.preselected === this.props.preselected && newProps.afterSelection === this.state.afterSelection);
    }
  }, {
    key: "renderPreselectedRange",
    value: function renderPreselectedRange(onSelectCallback, selectedRangeId) {
      var _this2 = this;

      if (!this.props.preselected) {
        return null;
      }

      var preselectedRangeValues = this.state.preselectedRangeValues;
      return /*#__PURE__*/React__default.createElement("div", {
        "data-active-range": this.state.preselectedRange,
        className: "date-range-picker__btns",
        onClick: this.selectPreselectedRange(onSelectCallback)
      }, preselectedRangeValues.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("button", {
          key: index,
          className: "date-range-picker__btn ".concat((selectedRangeId === undefined ? _this2.state.preselectedRange === item.key : selectedRangeId === item.key) ? '_active' : ''),
          "data-range-id": item.key
        }, item.title);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          singleDate = _this$props5.singleDate,
          singleDateMode = _this$props5.singleDateMode,
          insidePreselectors = _this$props5.insidePreselectors,
          dateRangePickerClassName = _this$props5.dateRangePickerClassName,
          applyBtnClassName = _this$props5.applyBtnClassName,
          variant = _this$props5.variant,
          confirmButtonClicked = _this$props5.confirmButtonClicked,
          underline = _this$props5.underline,
          dataDogApplyButtonLabel = _this$props5.dataDogApplyButtonLabel,
          onClickApply = _this$props5.onClickApply;
      var _this$props6 = this.props,
          datePickerProps = _this$props6.datePickerProps,
          removeSafariSelectionIssue = _this$props6.removeSafariSelectionIssue;
      var _this$state = this.state,
          isButtonDisabled = _this$state.isButtonDisabled,
          isOpen = _this$state.isOpen;

      var _ref3 = this.props.dateRange || {},
          start = _ref3.start,
          end = _ref3.end;

      var value1 = null;

      if (start && end) {
        value1 = moment.range(moment(start).startOf('day'), moment(end));
      } else if (singleDateMode) {
        value1 = singleDate ? moment(singleDate) : null;
      }

      var animateYAxisClassName = this.props.datePickerProps.animationAxis === 'Y' ? '_animate-y-axis' : '';
      var dateRangePickerClassNames = ['date-range-picker'];

      if (isOpen) {
        dateRangePickerClassNames.push('_opened');
      }

      if (this.withTimePicker) {
        dateRangePickerClassNames.push('date-range-picker_with-time');
      }

      if (dateRangePickerClassName) {
        dateRangePickerClassNames.push(dateRangePickerClassName);
      }

      var applyBtnClassNames = ['btn-square _xs _filled _conflower-blue date-range-picker__btn-done'];

      if (applyBtnClassName) {
        applyBtnClassNames.push(applyBtnClassName);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: dateRangePickerClassNames.join(' ')
      }, !singleDateMode && !insidePreselectors && this.renderPreselectedRange(), /*#__PURE__*/React__default.createElement("div", {
        className: "date-range-picker__wrapper ".concat(underline ? '_underline' : '')
      }, this.renderSelectionValue(), singleDateMode && variant === 'withTickbox' && this.state.isOpen ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: function onClick(event) {
          _this3.onClose();

          confirmButtonClicked(event);
        },
        variant: "primary",
        iconName: "CheckCircleBW",
        className: "date-confirmBtn",
        tabIndex: 0
      }) : null, /*#__PURE__*/React__default.createElement(Transition, {
        "in": this.state.isOpen,
        timeout: {
          enter: 1,
          exit: 250
        },
        unmountOnExit: true
      }, function (state) {
        return /*#__PURE__*/React__default.createElement(DatesPickerOnDoneWrapper, {
          value: value1,
          inputValue: _this3.state.inputValue || value1,
          resetInputValue: function resetInputValue() {
            return _this3.setState({
              inputValue: null
            });
          },
          onSelect: _this3.onSelect,
          updateByDone: _this3.props.updateByDone,
          preselectedRangeValues: _this3.getPreselectedList()
        }, function (value, _onSelect, preselectedRangeKey, resetInputValue) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "date-range-picker__wrapper-inner _".concat(state, " ").concat(animateYAxisClassName),
            ref: _this3.innerWrapperHandler
          }, /*#__PURE__*/React__default.createElement(DatesPickerWithTimePicker, {
            toggleToTime: _this3.state.afterSelection,
            clearAfterSelection: _this3.revertAfterSelection,
            value: value,
            withTimePicker: _this3.withTimePicker,
            onChange: _onSelect
          }, /*#__PURE__*/React__default.createElement(DateRangePicker, _extends_1({
            ref: function ref(comp) {
              _this3.pickerComponent = comp;
            },
            value: value,
            onSelect: function onSelect(v) {
              _onSelect(v);

              resetInputValue();

              _this3.setState({
                afterSelection: true,
                isButtonDisabled: false
              });
            },
            focusedElement: _this3.state.focusedElement,
            selectionType: singleDateMode ? 'single' : 'range',
            onSelectStart: function onSelectStart() {
              return _this3.setState({
                isButtonDisabled: true
              });
            }
          }, datePickerProps))), /*#__PURE__*/React__default.createElement("div", {
            className: "date-range-picker__controls"
          }, _this3.props.insidePreselectors && _this3.renderPreselectedRange(_onSelect, singleDateMode ? _this3.checkPreselectedValue(value, _this3.state.preselectedRangeValues, true) : preselectedRangeKey), /*#__PURE__*/React__default.createElement(Button, _extends_1({
            size: "small",
            className: applyBtnClassNames.join(' '),
            onClick: function onClick(event) {
              var datesValue = removeSafariSelectionIssue ? value || _this3.state.inputValue : _this3.state.inputValue || value;

              if (onClickApply) {
                onClickApply(datesValue);
              }

              _this3.onSelect(datesValue);

              _this3.handleClickOutside(event);
            },
            disabled: isButtonDisabled
          }, dataDogApplyButtonLabel ? {
            'data-dd-action-name': dataDogApplyButtonLabel
          } : {}), "Apply")));
        });
      })));
    }
  }]);

  return DatesPickerComponent;
}(Component);
DatesPickerComponent.defaultProps = {
  updateDateRange: noop$1,
  dateRange: {
    start: '',
    end: ''
  },
  preselected: false,
  insidePreselectors: false,
  singleDate: '',
  singleDateMode: false,
  labels: [],
  dateFormat: DATE_FORMAT,
  withTimePicker: false,
  updateByDone: true,
  label: '',
  noLabel: false,
  variant: 'withoutTickbox',
  confirmButtonClicked: function confirmButtonClicked() {},
  underline: false
};
DatesPickerWrapper.propTypes = {
  tooltipParams: PropTypes__default.object
};
var propTypes = {
  datePickerProps: PropTypes__default.object,
  dateRange: PropTypes__default.shape({
    start: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]),
    end: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck])
  }),
  singleDate: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]),
  preselected: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.arrayOf(PropTypes__default.shape({
    start: momentOrDatePropCheck,
    end: momentOrDatePropCheck,
    title: PropTypes__default.string,
    key: PropTypes__default.string
  }))]),
  insidePreselectors: PropTypes__default.bool,
  updateDateRange: PropTypes__default.func,
  dateFormat: PropTypes__default.string,
  singleDateMode: PropTypes__default.bool,
  labels: PropTypes__default.arrayOf(PropTypes__default.string),
  withTimePicker: PropTypes__default.bool,
  updateByDone: PropTypes__default.bool,
  label: PropTypes__default.string,
  noLabel: PropTypes__default.bool,
  singleDatePlaceholder: PropTypes__default.string,
  tooltipParams: PropTypes__default.object,
  className: PropTypes__default.string,
  dateRangePickerClassName: PropTypes__default.string,
  applyBtnClassName: PropTypes__default.string,
  isClearable: PropTypes__default.bool,
  disabled: PropTypes__default.bool,
  variant: PropTypes__default.oneOf(['withTickbox', 'withoutTickbox']),
  confirmButtonClicked: PropTypes__default.func,
  underline: PropTypes__default.bool,
  removeSafariSelectionIssue: PropTypes__default.bool,
  dataDogApplyButtonLabel: PropTypes__default.string,
  onClickApply: PropTypes__default.func
};
DatesPickerComponent.propTypes = propTypes;
var DatesPicker = withClickOutside(DatesPickerComponent);
DatesPicker.propTypes = propTypes;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual$1(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual$1(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

if (process.env.NODE_ENV !== 'production') ;

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection = /*#__PURE__*/new WeakSet();
    devWarningsTagName$1 = /*#__PURE__*/new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized$1(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized$1(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var itemCount = this.props.itemCount;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          initialScrollOffset = _this$props2.initialScrollOffset,
          layout = _this$props2.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          layout = _this$props3.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemCount = _this$props4.itemCount,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey$1 : _this$props4$itemKey,
          layout = _this$props4.layout,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: _extends$1({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, createElement(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props5 = this.props,
          itemCount = _this$props5.itemCount,
          overscanCount = _this$props5.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (process.env.NODE_ENV !== 'production') {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;

var getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
  var _ref = props,
      itemSize = _ref.itemSize;
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;

  if (index > lastMeasuredIndex) {
    var offset = 0;

    if (lastMeasuredIndex >= 0) {
      var itemMetadata = itemMetadataMap[lastMeasuredIndex];
      offset = itemMetadata.offset + itemMetadata.size;
    }

    for (var i = lastMeasuredIndex + 1; i <= index; i++) {
      var size = itemSize(i);
      itemMetadataMap[i] = {
        offset: offset,
        size: size
      };
      offset += size;
    }

    instanceProps.lastMeasuredIndex = index;
  }

  return itemMetadataMap[index];
};

var findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
  var itemMetadataMap = instanceProps.itemMetadataMap,
      lastMeasuredIndex = instanceProps.lastMeasuredIndex;
  var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;

  if (lastMeasuredItemOffset >= offset) {
    // If we've already measured items within this range just use a binary search as it's faster.
    return findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
  } else {
    // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
  }
};

var findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
  while (low <= high) {
    var middle = low + Math.floor((high - low) / 2);
    var currentOffset = getItemMetadata$1(props, middle, instanceProps).offset;

    if (currentOffset === offset) {
      return middle;
    } else if (currentOffset < offset) {
      low = middle + 1;
    } else if (currentOffset > offset) {
      high = middle - 1;
    }
  }

  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};

var findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
  var itemCount = props.itemCount;
  var interval = 1;

  while (index < itemCount && getItemMetadata$1(props, index, instanceProps).offset < offset) {
    index += interval;
    interval *= 2;
  }

  return findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};

var getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
  var itemCount = _ref2.itemCount;
  var itemMetadataMap = _ref3.itemMetadataMap,
      estimatedItemSize = _ref3.estimatedItemSize,
      lastMeasuredIndex = _ref3.lastMeasuredIndex;
  var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
  // https://github.com/bvaughn/react-window/pull/138

  if (lastMeasuredIndex >= itemCount) {
    lastMeasuredIndex = itemCount - 1;
  }

  if (lastMeasuredIndex >= 0) {
    var itemMetadata = itemMetadataMap[lastMeasuredIndex];
    totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
  }

  var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
  var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
  return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};

var VariableSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(props, index, instanceProps) {
    return getItemMetadata$1(props, index, instanceProps).offset;
  },
  getItemSize: function getItemSize(props, index, instanceProps) {
    return instanceProps.itemMetadataMap[index].size;
  },
  getEstimatedTotalSize: getEstimatedTotalSize,
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.

    var estimatedTotalSize = getEstimatedTotalSize(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        return Math.round(minOffset + (maxOffset - minOffset) / 2);

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
    return findNearestItem$1(props, instanceProps, offset);
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
    var direction = props.direction,
        height = props.height,
        itemCount = props.itemCount,
        layout = props.layout,
        width = props.width; // TODO Deprecate direction "horizontal"

    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var itemMetadata = getItemMetadata$1(props, startIndex, instanceProps);
    var maxOffset = scrollOffset + size;
    var offset = itemMetadata.offset + itemMetadata.size;
    var stopIndex = startIndex;

    while (stopIndex < itemCount - 1 && offset < maxOffset) {
      stopIndex++;
      offset += getItemMetadata$1(props, stopIndex, instanceProps).size;
    }

    return stopIndex;
  },
  initInstanceProps: function initInstanceProps(props, instance) {
    var _ref4 = props,
        estimatedItemSize = _ref4.estimatedItemSize;
    var instanceProps = {
      itemMetadataMap: {},
      estimatedItemSize: estimatedItemSize || DEFAULT_ESTIMATED_ITEM_SIZE$1,
      lastMeasuredIndex: -1
    };

    instance.resetAfterIndex = function (index, shouldForceUpdate) {
      if (shouldForceUpdate === void 0) {
        shouldForceUpdate = true;
      }

      instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
      // But since styles are only cached while scrolling is in progress-
      // It seems an unnecessary optimization.
      // It's unlikely that resetAfterIndex() will be called while a user is scrolling.

      instance._getItemStyleCache(-1);

      if (shouldForceUpdate) {
        instance.forceUpdate();
      }
    };

    return instanceProps;
  },
  shouldResetStyleCacheOnItemSizeChange: false,
  validateProps: function validateProps(_ref5) {
    var itemSize = _ref5.itemSize;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof itemSize !== 'function') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a function. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var FixedSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var InfiniteScroll_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return call && (typeof call === 'object' || typeof call === 'function')
    ? call
    : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError(
      'Super expression must either be null or a function, not ' +
        typeof superClass
    );
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
}

var InfiniteScroll = (function(_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(
      this,
      (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(
        this,
        props
      )
    );

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [
    {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.pageLoaded = this.props.pageStart;
        this.options = this.eventListenerOptions();
        this.attachScrollListener();
      }
    },
    {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (this.props.isReverse && this.loadMore) {
          var parentElement = this.getParentElement(this.scrollComponent);
          parentElement.scrollTop =
            parentElement.scrollHeight -
            this.beforeScrollHeight +
            this.beforeScrollTop;
          this.loadMore = false;
        }
        this.attachScrollListener();
      }
    },
    {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.detachScrollListener();
        this.detachMousewheelListener();
      }
    },
    {
      key: 'isPassiveSupported',
      value: function isPassiveSupported() {
        var passive = false;

        var testOptions = {
          get passive() {
            passive = true;
          }
        };

        try {
          document.addEventListener('test', null, testOptions);
          document.removeEventListener('test', null, testOptions);
        } catch (e) {
          // ignore
        }
        return passive;
      }
    },
    {
      key: 'eventListenerOptions',
      value: function eventListenerOptions() {
        var options = this.props.useCapture;

        if (this.isPassiveSupported()) {
          options = {
            useCapture: this.props.useCapture,
            passive: true
          };
        }
        return options;
      }

      // Set a defaut loader for all your `InfiniteScroll` components
    },
    {
      key: 'setDefaultLoader',
      value: function setDefaultLoader(loader) {
        this.defaultLoader = loader;
      }
    },
    {
      key: 'detachMousewheelListener',
      value: function detachMousewheelListener() {
        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }

        scrollEl.removeEventListener(
          'mousewheel',
          this.mousewheelListener,
          this.options ? this.options : this.props.useCapture
        );
      }
    },
    {
      key: 'detachScrollListener',
      value: function detachScrollListener() {
        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = this.getParentElement(this.scrollComponent);
        }

        scrollEl.removeEventListener(
          'scroll',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );
        scrollEl.removeEventListener(
          'resize',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );
      }
    },
    {
      key: 'getParentElement',
      value: function getParentElement(el) {
        var scrollParent =
          this.props.getScrollParent && this.props.getScrollParent(el);
        if (scrollParent != null) {
          return scrollParent;
        }
        return el && el.parentNode;
      }
    },
    {
      key: 'filterProps',
      value: function filterProps(props) {
        return props;
      }
    },
    {
      key: 'attachScrollListener',
      value: function attachScrollListener() {
        var parentElement = this.getParentElement(this.scrollComponent);

        if (!this.props.hasMore || !parentElement) {
          return;
        }

        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = parentElement;
        }

        scrollEl.addEventListener(
          'mousewheel',
          this.mousewheelListener,
          this.options ? this.options : this.props.useCapture
        );
        scrollEl.addEventListener(
          'scroll',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );
        scrollEl.addEventListener(
          'resize',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );

        if (this.props.initialLoad) {
          this.scrollListener();
        }
      }
    },
    {
      key: 'mousewheelListener',
      value: function mousewheelListener(e) {
        // Prevents Chrome hangups
        // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
        if (e.deltaY === 1 && !this.isPassiveSupported()) {
          e.preventDefault();
        }
      }
    },
    {
      key: 'scrollListener',
      value: function scrollListener() {
        var el = this.scrollComponent;
        var scrollEl = window;
        var parentNode = this.getParentElement(el);

        var offset = void 0;
        if (this.props.useWindow) {
          var doc =
            document.documentElement ||
            document.body.parentNode ||
            document.body;
          var scrollTop =
            scrollEl.pageYOffset !== undefined
              ? scrollEl.pageYOffset
              : doc.scrollTop;
          if (this.props.isReverse) {
            offset = scrollTop;
          } else {
            offset = this.calculateOffset(el, scrollTop);
          }
        } else if (this.props.isReverse) {
          offset = parentNode.scrollTop;
        } else {
          offset =
            el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
        }

        // Here we make sure the element is visible as well as checking the offset
        if (
          offset < Number(this.props.threshold) &&
          el &&
          el.offsetParent !== null
        ) {
          this.detachScrollListener();
          this.beforeScrollHeight = parentNode.scrollHeight;
          this.beforeScrollTop = parentNode.scrollTop;
          // Call loadMore after detachScrollListener to allow for non-async loadMore functions
          if (typeof this.props.loadMore === 'function') {
            this.props.loadMore((this.pageLoaded += 1));
            this.loadMore = true;
          }
        }
      }
    },
    {
      key: 'calculateOffset',
      value: function calculateOffset(el, scrollTop) {
        if (!el) {
          return 0;
        }

        return (
          this.calculateTopPosition(el) +
          (el.offsetHeight - scrollTop - window.innerHeight)
        );
      }
    },
    {
      key: 'calculateTopPosition',
      value: function calculateTopPosition(el) {
        if (!el) {
          return 0;
        }
        return el.offsetTop + this.calculateTopPosition(el.offsetParent);
      }
    },
    {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var renderProps = this.filterProps(this.props);

        var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, [
            'children',
            'element',
            'hasMore',
            'initialLoad',
            'isReverse',
            'loader',
            'loadMore',
            'pageStart',
            'ref',
            'threshold',
            'useCapture',
            'useWindow',
            'getScrollParent'
          ]);

        props.ref = function(node) {
          _this2.scrollComponent = node;
          if (ref) {
            ref(node);
          }
        };

        var childrenArray = [children];
        if (hasMore) {
          if (loader) {
            isReverse
              ? childrenArray.unshift(loader)
              : childrenArray.push(loader);
          } else if (this.defaultLoader) {
            isReverse
              ? childrenArray.unshift(this.defaultLoader)
              : childrenArray.push(this.defaultLoader);
          }
        }
        return _react2.default.createElement(element, props, childrenArray);
      }
    }
  ]);

  return InfiniteScroll;
})(React__default.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];
});

unwrapExports(InfiniteScroll_1);

var reactInfiniteScroller = InfiniteScroll_1;

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OpenerContentComponent = /*#__PURE__*/function (_Component) {
  inherits(OpenerContentComponent, _Component);

  var _super = _createSuper$f(OpenerContentComponent);

  function OpenerContentComponent() {
    var _this;

    classCallCheck(this, OpenerContentComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleClickOutside = function (_ref) {
      var target = _ref.target;
      var _this$props = _this.props,
          btn = _this$props.btn,
          handleClickOutside = _this$props.handleClickOutside;

      if (!handleClickOutside || !btn || btn.contains(target) || btn === target) {
        return;
      }

      handleClickOutside();
    };

    return _this;
  }

  createClass(OpenerContentComponent, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          isOpen = _this$props2.isOpen,
          children = _this$props2.children,
          close = _this$props2.close,
          style = _this$props2.style,
          portal = _this$props2.portal;
      var container = /*#__PURE__*/React__default.createElement("div", {
        className: "opener ".concat(isOpen ? '_opened' : '', "  ").concat(Boolean(style) ? '' : className),
        style: style
      }, children && /*#__PURE__*/React__default.cloneElement(children, {
        close: close
      }));
      return portal ? /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'fixed',
          inset: 0,
          display: isOpen ? 'block' : 'none',
          zIndex: 9999 // We want it higher - refactor in future to have each popup component i.e tooltip to have a priority z-index.

        }
      }, container) : container;
    }
  }]);

  return OpenerContentComponent;
}(Component);

var OpenerContent = withClickOutside(OpenerContentComponent);
OpenerContentComponent.propTypes = {
  className: PropTypes__default.string,
  isOpen: PropTypes__default.bool,
  btn: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),
  handleClickOutside: PropTypes__default.func,
  close: PropTypes__default.func
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Opener = function Opener(props) {
  var defaultOpen = props.isOpen,
      onToggle = props.onToggle,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$btnClassName = props.btnClassName,
      btnClassName = _props$btnClassName === void 0 ? '' : _props$btnClassName,
      _props$contentClassNa = props.contentClassName,
      contentClassName = _props$contentClassNa === void 0 ? '' : _props$contentClassNa,
      btn = props.btn,
      content = props.content,
      _props$contentClose = props.contentClose,
      contentClose = _props$contentClose === void 0 ? true : _props$contentClose,
      _props$isAlwaysOpen = props.isAlwaysOpen,
      isAlwaysOpen = _props$isAlwaysOpen === void 0 ? false : _props$isAlwaysOpen,
      _props$getToggleConte = props.getToggleContent,
      getToggleContent = _props$getToggleConte === void 0 ? function () {} : _props$getToggleConte,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$portal = props.portal,
      portal = _props$portal === void 0 ? false : _props$portal;

  var _useState = useState(defaultOpen),
      _useState2 = slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var containerRef = useRef(null);
  var btnRef = useRef();

  var toggleContent = function toggleContent(isOpenValue) {
    setIsOpen(typeof isOpenValue === 'boolean' ? isOpenValue : !isOpen);
  };

  useEffect(function () {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);
  useEffect(function () {
    getToggleContent(toggleContent);
  }, []);
  useEffect(function () {
    if (onToggle) {
      onToggle(isOpen);
    }
  }, [isOpen]);

  var closeContent = function closeContent() {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  var xyCoords = useMemo(function () {
    if (isOpen && containerRef.current) {
      var _containerRef$current, _containerRef$current2, _containerRef$current3;

      var coords = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : (_containerRef$current3 = _containerRef$current2.getBoundingClientRect) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.call(_containerRef$current2)) !== null && _containerRef$current !== void 0 ? _containerRef$current : {};
      return {
        top: coords === null || coords === void 0 ? void 0 : coords.bottom,
        left: coords === null || coords === void 0 ? void 0 : coords.left,
        width: coords === null || coords === void 0 ? void 0 : coords.width
      };
    }
  }, [isOpen]);
  var openerContent = /*#__PURE__*/React__default.createElement(OpenerContent, {
    className: "".concat(contentClassName),
    isOpen: isOpen || isAlwaysOpen,
    btn: btnRef.current,
    handleClickOutside: closeContent,
    close: contentClose ? closeContent : '',
    style: portal ? _objectSpread$3({
      position: 'absolute'
    }, xyCoords) : undefined,
    portal: portal
  }, content);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(className, " ").concat(isOpen ? '_opened' : ''),
    ref: containerRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: btnClassName,
    ref: btnRef,
    onClick: function onClick(e) {
      e.stopPropagation();

      if (disabled) {
        return;
      }

      toggleContent();
    }
  }, btn), Boolean(portal) ? /*#__PURE__*/createPortal(openerContent, document.body) : openerContent);
};
Opener.propTypes = {
  className: PropTypes__default.string,
  onToggle: PropTypes__default.func,
  btnClassName: PropTypes__default.string,
  contentClassName: PropTypes__default.string,
  btn: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),
  content: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object, PropTypes__default.oneOf([null])]),
  isOpen: PropTypes__default.bool,
  getToggleContent: PropTypes__default.func,
  contentClose: PropTypes__default.bool,
  isAlwaysOpen: PropTypes__default.bool,
  disabled: PropTypes__default.bool,
  portal: PropTypes__default.bool
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var isIncludeSubstr = function isIncludeSubstr() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return a.toLowerCase().includes(b.toLowerCase());
};

var itemIsSelected = function itemIsSelected(item, selectedValue) {
  if (selectedValue === null || selectedValue === undefined || Array.isArray(selectedValue) && !selectedValue.length) {
    return false;
  }

  if (Array.isArray(selectedValue)) {
    return selectedValue.some(function (v) {
      return v.value === item.value;
    });
  }

  return item.value === selectedValue.value;
};

var moveItem = function moveItem(a, from, to) {
  if (from === to || to === null) return a;

  var clone = toConsumableArray(a);

  clone.splice(to, 0, clone.splice(from, 1)[0]);
  return clone;
};

var escape = function escape(str) {
  return str.replace(/\(/g, '\\(').replace(/\)/g, '\\)').replace(/\{/g, '\\{').replace(/\}/g, '\\}').replace(/\./g, '\\.');
};

var filterItems = function filterItems(list, search, searchByValue, wildcardSearch) {
  var recurse = function recurse(arr) {
    return arr.map(function (item) {
      if (Array.isArray(item.options)) {
        var options = recurse(item.options);

        if (options && options.filter(function (o) {
          return o;
        }).length) {
          return _objectSpread$4(_objectSpread$4({}, item), {}, {
            options: options
          });
        }
      }

      if (isIncludeSubstr(item.label, search)) {
        return item;
      }

      if (search && wildcardSearch) {
        var lookaheads = search.split(/[%*]+/g).map(function (str) {
          return "(?=.*".concat(escape(str), ")");
        }).join('');
        var regex = RegExp("^".concat(lookaheads, ".*$"), 'gi');

        if (regex.test(item.label)) {
          return item;
        }
      }

      if (searchByValue && item.value.toString().includes(search)) {
        return item;
      }

      return false;
    }).filter(function (o) {
      return o;
    });
  };

  return recurse(list);
};
var getItemClasses = function getItemClasses(item, _ref) {
  var isActive = _ref.isActive,
      indexItem = _ref.indexItem,
      startDragIndex = _ref.startDragIndex,
      targetDropIndex = _ref.targetDropIndex,
      isDisable = _ref.isDisable,
      isReadOnly = _ref.isReadOnly,
      tabsModeIsInclude = _ref.tabsModeIsInclude;
  var className = 'select__option';
  if (isActive) className += ' _active';
  if (item.isGroupHeader) className += ' _header';
  if (item.alwaysEnabled) className += ' _enabled';
  if (item.lastFirstGroup) className += ' _last-enabled';
  if (isDisable) className += ' _disabled';
  if (isReadOnly) className += ' _readonly';

  if (tabsModeIsInclude !== undefined) {
    className += tabsModeIsInclude ? ' _include-tab' : ' _exclude-tab';
  }

  if (indexItem !== undefined) {
    if (targetDropIndex === indexItem) className += ' _separator';
    if (startDragIndex === indexItem) className += ' _hide';
    className += startDragIndex < targetDropIndex ? ' _bottom' : ' _top';
  }

  return className;
};
var updateStateOfOptions = function updateStateOfOptions(state, item, isMulti) {
  var traverseMulti = function traverseMulti(list, parentSelected) {
    if (!list) return;
    var selectedValuesFromItem = [item.value];

    if (item.options && item.options.length) {
      item.options.forEach(function (option) {
        selectedValuesFromItem.push(option.value);
      });
    }

    list.forEach(function (node) {
      var isActive, included, excluded;

      if (node.value === item.value) {
        isActive = !node.isActive;

        if (node.isActive) {
          delete node.included;
          delete node.excluded;
        } else {
          included = !!item.included;
          excluded = !!item.excluded;
        }
      } else if (selectedValuesFromItem.includes(node.value)) {
        isActive = !item.isActive;
      } else if (parentSelected !== undefined) {
        isActive = parentSelected;
      }

      if (isActive !== undefined) {
        node.isActive = isActive;

        if (included) {
          node.included = included;
        }

        if (excluded) {
          node.excluded = excluded;
        }
      }

      if (!(node.options && node.options.length)) return;
      traverseMulti(node.options, isActive);
      node.isActive = node.options.every(function (o) {
        return o.isActive;
      });
    });
  };

  var traverseSingle = function traverseSingle(list) {
    if (!list) return;
    list.forEach(function (node) {
      node.isActive = item.value === node.value;
      traverseSingle(node.options);
    });
  };

  var traverse = function traverse(list) {
    if (!list) return;
    isMulti ? traverseMulti(list) : traverseSingle(list);
  };

  var clonedState = cloneOptions(state);
  traverse(clonedState);
  return clonedState;
};
var cloneOptions = function cloneOptions(state) {
  var clonedState = [];

  if (Array.isArray(state)) {
    clonedState = state.map(function (value) {
      return Object.keys(value).reduce(function (result, key) {
        result[key] = key === 'reactLabel' ? value[key] : cloneDeep(value[key]);
        return result;
      }, {});
    });
  } else {
    clonedState = cloneDeep(state);
  }

  return clonedState;
};
var makeStateOfOptions = function makeStateOfOptions(options, selectedValue) {
  var recurse = function recurse(list) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return list.map(function (item) {
      var res = _objectSpread$4(_objectSpread$4({}, item), {}, {
        deep: deep,
        isActive: item.alwaysEnabled || itemIsSelected(item, selectedValue)
      });

      if (item.options && item.options.length) {
        res.options = recurse(item.options, deep + 1);
      }

      if (item.alwaysEnabled) {
        res.alwaysEnabled = item.alwaysEnabled;
      }

      if (Array.isArray(selectedValue) && selectedValue.length) {
        var foundedItem = selectedValue.find(function (v) {
          return v.value === item.value;
        });

        if (foundedItem) {
          if (foundedItem.included) {
            res.included = true;
          }

          if (foundedItem.excluded) {
            res.excluded = true;
          }
        }
      }

      return res;
    });
  };

  var state = recurse(options);
  return state;
};
var traverseState = function traverseState(list, cb) {
  list.forEach(function (item) {
    cb(item);
    if (item.options && item.options.length) traverseState(item.options, cb);
  });
};
var normalizeValue = function normalizeValue(value) {
  if (!value) return value;

  var getProps = function getProps(_ref2) {
    var deep = _ref2.deep,
        options = _ref2.options,
        isActive = _ref2.isActive,
        rest = objectWithoutProperties(_ref2, ["deep", "options", "isActive"]);

    return rest;
  };

  if (!Array.isArray(value)) {
    return getProps(value);
  } else {
    var list = value.map(function (v) {
      return getProps(v);
    });
    return list;
  }
};

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var WithErrorPlaceholderImage = /*#__PURE__*/function (_React$Component) {
  inherits(WithErrorPlaceholderImage, _React$Component);

  var _super = _createSuper$g(WithErrorPlaceholderImage);

  function WithErrorPlaceholderImage() {
    var _this;

    classCallCheck(this, WithErrorPlaceholderImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hasLoadingError: false
    };

    _this.onError = function () {
      return _this.setState({
        hasLoadingError: true
      });
    };

    return _this;
  }

  createClass(WithErrorPlaceholderImage, [{
    key: "render",
    value: function render() {
      if (this.state.hasLoadingError) {
        return /*#__PURE__*/React__default.createElement(Icon, {
          name: "NoData"
        });
      }

      return /*#__PURE__*/React__default.createElement("img", {
        src: this.props.src,
        onError: this.onError
      });
    }
  }]);

  return WithErrorPlaceholderImage;
}(React__default.Component);
WithErrorPlaceholderImage.propTypes = {
  src: PropTypes__default.string
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PADDING_STEP = 20;

var BtnWrapper = function BtnWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      tooltipParams = _ref.tooltipParams,
      handleClick = _ref.handleClick;
  return tooltipParams ? /*#__PURE__*/React__default.createElement(Tooltip, _extends_1({
    className: className,
    handleClick: handleClick
  }, tooltipParams), children) : /*#__PURE__*/React__default.createElement("div", {
    className: className,
    onClick: handleClick
  }, children);
};

var Select = /*#__PURE__*/function (_Component) {
  inherits(Select, _Component);

  var _super = _createSuper$h(Select);

  function Select(props) {
    var _this;

    classCallCheck(this, Select);

    _this = _super.call(this, props);
    _this._selectList = null;

    _this.setOpenStateThroughProp = function (prevProps) {
      // if isOpen prop is set and not equal to isOpen state
      if (typeof _this.props.isOpen === 'boolean' && _this.props.isOpen !== _this.state.isOpen) {
        _this.setState({
          isOpen: _this.props.isOpen
        }); // prevents closing through windowClickHandler when clicking on external el that changes isOpen prop


        _this.ignoredCloseClickElement = _this.props.ignoredCloseClickElement;
      }
    };

    _this.windowClickHandler = function (_ref2) {
      var target = _ref2.target;

      if (!_this.state.isOpen || target.closest('.select-simple') === _this.select || // prevent closing if el added as ignored
      _this.ignoredCloseClickElement && target === _this.ignoredCloseClickElement || _this.state.isSearchCleared && !_this.props.portal) {
        return;
      }

      if (_this.state.isSearchCleared && _this.props.portal) {
        _this.setState({
          isSearchCleared: false
        });

        return;
      }

      _this.setState({
        isOpen: false
      }); // changes isOpen prop when isOpen state is changed


      _this.props.toggleOpenProp && _this.props.toggleOpenProp(false);
    };

    _this.clearSearch = function () {
      if (_this.props.lazyLoad && _this.props.changeSearchHandler) {
        _this.props.changeSearchHandler({
          target: {
            value: ''
          }
        });
      }

      _this.setState({
        isSearchCleared: true,
        search: '',
        isOpen: true
      });
    };

    _this.toggleSelect = function () {
      var btnOnClick = _this.props.btnOnClick;

      if (btnOnClick) {
        btnOnClick();
      } else {
        var isOpen = _this.state.isOpen;

        _this.setState({
          isOpen: !isOpen
        }); // changes isOpen prop when isOpen state is changed


        _this.props.toggleOpenProp && _this.props.toggleOpenProp(!_this.state.isOpen);
      }
    };

    _this.handleChangeSearch = function (_ref3) {
      var target = _ref3.target;

      _this.props.onSearchChange(target.value);

      _this.setState({
        search: target.value
      });
    };

    _this.toggleTumbler = function () {
      _this.props.onTumblerChange();
    };

    _this.handleSelectedOption = function (item) {
      return function (e) {
        var _this$props = _this.props,
            isMulti = _this$props.isMulti,
            withTabs = _this$props.withTabs,
            maxSelectedLimit = _this$props.maxSelectedLimit,
            value = _this$props.value,
            onExceededMaxLimit = _this$props.onExceededMaxLimit,
            variant = _this$props.variant,
            lazyLoad = _this$props.lazyLoad,
            virtualizationProps = _this$props.virtualizationProps;
        var _this$state = _this.state,
            stateOfOptions = _this$state.stateOfOptions,
            tabsModeIsInclude = _this$state.tabsModeIsInclude;

        if (virtualizationProps) {
          e.stopPropagation();
        }

        if (value && maxSelectedLimit && !item.isActive && value.length >= maxSelectedLimit) {
          onExceededMaxLimit && onExceededMaxLimit();
          return;
        }

        if (withTabs) {
          if (!item.isActive) {
            item = Object.assign(item, tabsModeIsInclude ? {
              included: true
            } : {
              excluded: true
            });
          }
        }

        var newState = updateStateOfOptions(stateOfOptions, item, isMulti);

        _this.setStateOptions(newState, item);

        if (lazyLoad) {
          _this.ignoredCloseClickElement = e.target;
        }

        if (!isMulti && variant !== 'withTickbox') {
          _this.toggleSelect();
        }
      };
    };

    _this.allSelected = function () {
      var _this$props2 = _this.props,
          totalRecords = _this$props2.totalRecords,
          searchByValue = _this$props2.searchByValue,
          wildcardSearch = _this$props2.wildcardSearch;
      var _this$state2 = _this.state,
          stateOfOptions = _this$state2.stateOfOptions,
          search = _this$state2.search;

      if (!stateOfOptions.length) {
        return false;
      }

      var allSelected = true;

      var callback = function callback(item) {
        if (!item.isActive) {
          allSelected = false;
        }
      };

      traverseState(filterItems(stateOfOptions, search, searchByValue, wildcardSearch, _this.props.onSearchChange), callback);
      return totalRecords ? allSelected && stateOfOptions.length === totalRecords : allSelected;
    };

    _this.allVisibleItemsSelected = function () {
      var _this$props3 = _this.props,
          searchByValue = _this$props3.searchByValue,
          wildcardSearch = _this$props3.wildcardSearch;
      var _this$state3 = _this.state,
          stateOfOptions = _this$state3.stateOfOptions,
          search = _this$state3.search;

      if (!stateOfOptions.length) {
        return false;
      }

      var allSelected = true;

      var callback = function callback(item) {
        if (!item.isActive) {
          allSelected = false;
        }
      };

      traverseState(filterItems(stateOfOptions, search, searchByValue, wildcardSearch), callback);
      return allSelected;
    };

    _this.deselectAll = function () {
      var stateOfOptions = _this.state.stateOfOptions;
      var cloneState = cloneOptions(stateOfOptions);

      var callback = function callback(item) {
        if (!item.alwaysEnabled) {
          item.isActive = false;
        }
      };

      traverseState(cloneState, callback);

      _this.setStateOptions(cloneState, null, true);
    };

    _this.selectAll = function () {
      var _this$props4 = _this.props,
          searchByValue = _this$props4.searchByValue,
          wildcardSearch = _this$props4.wildcardSearch,
          onSelectAll = _this$props4.onSelectAll,
          withTabs = _this$props4.withTabs;
      var _this$state4 = _this.state,
          stateOfOptions = _this$state4.stateOfOptions,
          search = _this$state4.search,
          tabsModeIsInclude = _this$state4.tabsModeIsInclude;
      var clonedState = cloneOptions(stateOfOptions);
      var cloneState = filterItems(clonedState, search, searchByValue, wildcardSearch);

      var callback = function callback(item) {
        item.isActive = true;

        if (withTabs) {
          Object.assign(item, tabsModeIsInclude ? {
            included: true
          } : {
            excluded: true
          });
        }
      };

      traverseState(cloneState, callback);

      _this.setStateOptions(cloneState);

      if (onSelectAll) {
        onSelectAll();
      }
    };

    _this.onSortStart = function () {
      _this.setState({
        isSorting: true
      });
    };

    _this.onSortEnd = function (_ref4) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;
      var newValues = moveItem(_this.state.stateOfOptions, oldIndex, newIndex);

      _this.setStateOptions(newValues);

      _this.setState({
        targetDropIndex: null,
        startDragIndex: null,
        isSorting: false
      });
    };

    _this.handleClearValue = function (e) {
      e.stopPropagation();

      _this.deselectAll();
    };

    _this.renderItem = function (item, i) {
      var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$props5 = _this.props,
          levelPadding = _this$props5.levelPadding,
          withTabs = _this$props5.withTabs,
          _this$props5$isReadOn = _this$props5.isReadOnly,
          isReadOnly = _this$props5$isReadOn === void 0 ? false : _this$props5$isReadOn,
          virtualizationProps = _this$props5.virtualizationProps;
      var tabsModeIsInclude = _this.state.tabsModeIsInclude;
      var additionalProps = {
        style: {}
      };
      var padd = (item.deep || 0) * (levelPadding || PADDING_STEP);

      if (padd !== 0) {
        additionalProps.style.paddingLeft = padd;
      }

      if (virtualizationProps) {
        var itemHeight = typeof virtualizationProps.itemSize === 'number' ? virtualizationProps.itemSize : virtualizationProps.itemSize(item);

        var virtualizationStyles = _objectSpread$5(_objectSpread$5({}, style), {}, {
          height: "".concat(itemHeight, "px"),
          maxHeight: "".concat(itemHeight, "px")
        });

        additionalProps.style = _objectSpread$5(_objectSpread$5({}, additionalProps.style), virtualizationStyles);
      }

      if (!item.isGroupHeader && !item.alwaysEnabled) {
        additionalProps.onClick = _this.handleSelectedOption(item);
      } // to make clickable group header bold the checking is needed:
      // - if option is not a child of other option and have its own children
      // - and also if no reactLabel is used since it has its own markup


      var isClickableGroupHeader = !item.reactLabel && item.deep === 0 && item.options && item.options.length;
      var isActive = item.isActive,
          included = item.included,
          excluded = item.excluded;
      var _item$isDisable = item.isDisable,
          isDisable = _item$isDisable === void 0 ? false : _item$isDisable;

      if (withTabs) {
        isDisable = tabsModeIsInclude ? !!excluded : !!included;
      }

      var className = getItemClasses(item, {
        isActive: isActive,
        isDisable: isDisable,
        tabsModeIsInclude: tabsModeIsInclude,
        isReadOnly: isReadOnly
      });

      if (isClickableGroupHeader) {
        className += ' _clickable-header';
      }

      if (item.deep === 0) {
        className += ' _header-option';
      }

      var key = "".concat(i, "_").concat(padd, "_").concat(item.value || uniqueId());
      additionalProps = isReadOnly ? _objectSpread$5(_objectSpread$5({}, additionalProps), {}, {
        onClick: function onClick() {}
      }) : additionalProps;
      return /*#__PURE__*/React__default.createElement("div", _extends_1({
        key: key,
        className: className
      }, additionalProps), /*#__PURE__*/React__default.createElement("div", {
        className: "select__option-label"
      }, item.labelImageSrc && /*#__PURE__*/React__default.createElement("div", {
        className: "select__option-image"
      }, /*#__PURE__*/React__default.createElement(WithErrorPlaceholderImage, {
        src: item.labelImageSrc
      })), item.reactLabel || item.label));
    };

    _this.getRenderVirtualizedItem = function (items) {
      return function (_ref5) {
        var index = _ref5.index,
            style = _ref5.style;
        return _this.renderItem(items[index], index, style);
      };
    };

    _this.renderList = function () {
      var _this$props6 = _this.props,
          isSearchable = _this$props6.isSearchable,
          searchByValue = _this$props6.searchByValue,
          wildcardSearch = _this$props6.wildcardSearch,
          lazyLoad = _this$props6.lazyLoad,
          _this$props6$infinite = _this$props6.infiniteScrollProps,
          infiniteScrollProps = _this$props6$infinite === void 0 ? {} : _this$props6$infinite,
          virtualizationProps = _this$props6.virtualizationProps,
          emptyDropdownLabel = _this$props6.emptyDropdownLabel;
      var _this$state5 = _this.state,
          search = _this$state5.search,
          stateOfOptions = _this$state5.stateOfOptions;

      if (!stateOfOptions) {
        return null;
      }

      var resultOptions = stateOfOptions;

      if (isSearchable) {
        resultOptions = filterItems(stateOfOptions, search, searchByValue, wildcardSearch);
      }

      var res = [];

      var cb = function cb(item) {
        return res.push(item);
      };

      traverseState(resultOptions, cb);

      if ((!res || !res.length) && emptyDropdownLabel) {
        var _virtualizationProps$;

        return /*#__PURE__*/React__default.createElement("div", {
          className: "select__list",
          style: {
            width: (_virtualizationProps$ = virtualizationProps === null || virtualizationProps === void 0 ? void 0 : virtualizationProps.width) !== null && _virtualizationProps$ !== void 0 ? _virtualizationProps$ : 'auto'
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "select__option-label"
        }, emptyDropdownLabel));
      }

      if (virtualizationProps) {
        var selectListStyles = virtualizationProps ? {
          height: "".concat(virtualizationProps.height, "px"),
          maxHeight: "".concat(virtualizationProps.height, "px"),
          width: "".concat(virtualizationProps.width, "px"),
          maxWidth: "".concat(virtualizationProps.width, "px")
        } : {};
        var isFixedSize = typeof virtualizationProps.itemSize === 'number';
        return /*#__PURE__*/React__default.createElement("div", {
          className: "select__list",
          style: selectListStyles
        }, isFixedSize ? /*#__PURE__*/React__default.createElement(FixedSizeList, _extends_1({
          itemCount: res.length
        }, virtualizationProps), _this.getRenderVirtualizedItem(res, virtualizationProps.itemSize)) : /*#__PURE__*/React__default.createElement(VariableSizeList, _extends_1({
          ref: _this.virtualizedVariableSizeListRef,
          itemCount: res.length
        }, virtualizationProps, {
          itemSize: function itemSize(index) {
            return virtualizationProps.itemSize(res[index]);
          }
        }), _this.getRenderVirtualizedItem(res, virtualizationProps.itemSize)));
      }

      var listItems = res.map(function (item, i) {
        return _this.renderItem(item, i);
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: "select__list",
        ref: function ref(el) {
          _this._selectList = el;
        }
      }, lazyLoad ? /*#__PURE__*/React__default.createElement(reactInfiniteScroller, _extends_1({}, infiniteScrollProps, {
        useWindow: false
      }), listItems) : listItems);
    };

    _this.renderButton = function () {
      var shouldRenderBeforeSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var buttonProps = _this.props.buttonProps;

      if (buttonProps && shouldRenderBeforeSearch === buttonProps.shouldRenderBeforeSearch) {
        var onClick = buttonProps.shouldCloseOnClick ? function () {
          _this.toggleSelect();

          buttonProps.onClick();
        } : buttonProps.onClick;
        return /*#__PURE__*/React__default.createElement("div", {
          className: "w-100 d-flex justify-content-center"
        }, /*#__PURE__*/React__default.createElement(Button, {
          className: buttonProps.className || 'btn-round _conflower-blue mt-3 mb-3',
          onClick: onClick
        }, !!buttonProps.symbolBeforeLabel && /*#__PURE__*/React__default.createElement("span", {
          className: "btn-round__prefix"
        }, buttonProps.symbolBeforeLabel), buttonProps.label || 'New'));
      }

      return null;
    };

    _this.renderSelectedValue = function () {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          showValueOnOpen = _this$props7.showValueOnOpen,
          multiPlaceholder = _this$props7.multiPlaceholder,
          allSelectedText = _this$props7.allSelectedText,
          v = _this$props7.value,
          options = _this$props7.options;
      var isOpen = _this.state.isOpen;

      if (isMulti) {
        if (v && !!v.length) {
          if ((!isOpen || showValueOnOpen) && _this.allVisibleItemsSelected() && !multiPlaceholder) {
            return allSelectedText || 'All Selected';
          }

          var selectionMap = {};
          var selectedCount = v.reduce(function (selectedCount, item) {
            if (!item.uncountable && !(options !== null && options !== void 0 && options.find(function (opt) {
              return opt.options && opt.value === item.value;
            }))) {
              selectedCount = selectionMap[item.value] ? selectedCount : selectedCount + 1;
              selectionMap[item.value] = item.value;
            }

            return selectedCount;
          }, 0);

          if (multiPlaceholder) {
            return multiPlaceholder(selectedCount);
          }

          return "".concat(selectedCount, " Selected");
        }
      } else {
        // return value if value is array and when isMulti is false
        if (isArray(v)) {
          return v.length ? v[0].label : '';
        }

        return v && (v.reactLabel || v.label);
      }
    };

    _this.renderTabs = function () {
      var value = _this.props.value;
      var tabsModeIsInclude = _this.state.tabsModeIsInclude;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "select__tabs d-flex mb-3"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "tab flex-grow-1 text-center ".concat(tabsModeIsInclude ? '_active' : ''),
        onClick: function onClick() {
          return _this.setState({
            tabsModeIsInclude: true
          });
        }
      }, "Allowlist (".concat(Array.isArray(value) ? _this.props.value.filter(function (i) {
        return i.included;
      }).length : 0, ")")), /*#__PURE__*/React__default.createElement("div", {
        className: "tab flex-grow-1 text-center ".concat(tabsModeIsInclude ? '' : '_active'),
        onClick: function onClick() {
          return _this.setState({
            tabsModeIsInclude: false
          });
        }
      }, "Blocklist (".concat(Array.isArray(value) ? _this.props.value.filter(function (i) {
        return i.excluded;
      }).length : 0, ")")));
    };

    _this.handleKeyUp = function (event) {
      if (_this.props.onSubmitted && event.key === 'Enter') {
        _this.props.onSubmitted(_this.state.search, _this.toggleSelect);
      }
    };

    _this.state = {
      isOpen: false,
      search: '',
      isSearchCleared: false,
      tumblerIsActive: props.tumblerIsActive,
      withGroups: props.options.some(function (item) {
        return item.isGroupHeader;
      }),
      stateOfOptions: makeStateOfOptions(props.options, props.value),
      isSorting: false,
      tabsModeIsInclude: true,
      noOptionValue: ''
    };
    _this.virtualizedVariableSizeListRef = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  createClass(Select, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['value', 'options', 'isMulti', 'multiPlaceholder', 'noOptionValue', 'allSelectable', 'isSearchable', 'onChange', 'showControlLabel', 'tumbler', 'onTumblerChange', 'label', 'labelImageSrc', 'reactLabel', 'placeholder', 'className', 'isOpen', // sets isOpen state through prop
      'toggleOpenProp', // changes isOpen prop value
      'ignoredCloseClickElement', // prevents select from closing when clicking on outer element that changes isOpen prop
      'isAlwaysOpen', 'btnOnClick'], this.props, nextProps) && isEqual(['isOpen', 'search', 'stateOfOptions', 'tumblerIsActive', 'targetDropIndex', 'startDragIndex', 'isSorting', 'tabsModeIsInclude'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.windowClickHandler);
      this.setOpenStateThroughProp();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!isEqual(['value', 'options', 'isMulti'], this.props, prevProps) || !isEqual(['isSorting'], this.state, prevState)) {
        var _this$props$virtualiz;

        this.setState({
          withGroups: this.props.options.some(function (item) {
            return item.isGroupHeader;
          }),
          stateOfOptions: makeStateOfOptions(this.props.options, this.props.value)
        });

        if (this.props.options !== prevProps.options && typeof ((_this$props$virtualiz = this.props.virtualizationProps) === null || _this$props$virtualiz === void 0 ? void 0 : _this$props$virtualiz.itemSize) !== 'number' && this.virtualizedVariableSizeListRef.current) {
          this.virtualizedVariableSizeListRef.current.resetAfterIndex(0);
        }
      }

      if (prevProps.tumblerIsActive !== this.props.tumblerIsActive) {
        this.setState({
          tumblerIsActive: this.props.tumblerIsActive
        });
      }

      if (this.state.isOpen && this.state.isOpen !== prevState.isOpen) {
        if (this._selectList) {
          this._selectList.classList.add(this.props.scrollableClassName || '_scrollable');
        }

        this.searchInput && this.searchInput.focus(); // has isOpen state changed to true, then focus search input
      } // If state.isOpen was changed, then props.isOpen is not yet updated here.
      // This function should be fired by props.isOpen change.


      if (prevState.isOpen === this.state.isOpen) {
        this.setOpenStateThroughProp(prevProps);
      } // clear filter after drop-down was closed


      if (!this.state.isOpen && prevState.isOpen) {
        this.setState({
          search: ''
        }); // pass '' to custom search handler

        if (this.props.changeSearchHandler) {
          this.props.changeSearchHandler('');
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.windowClickHandler);
    } // opens/closes select clicking on external element

  }, {
    key: "setStateOptions",
    value: function setStateOptions(state, item, fromDeselectedAll) {
      var _this$props8 = this.props,
          withConfirmation = _this$props8.withConfirmation,
          onChange = _this$props8.onChange;

      if (onChange) {
        var values = [];

        var callback = function callback(item) {
          if (item.isActive) values.push(item);
        };

        traverseState(state, callback);

        if (!this.props.isMulti) {
          values = values.length ? values[0] : null;
        } // add fromDeselectedAll for lazyLoad select


        onChange(normalizeValue(values), item, fromDeselectedAll);
      }

      if (!withConfirmation) {
        this.setState({
          stateOfOptions: state
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props9 = this.props,
          className = _this$props9.className,
          label = _this$props9.label,
          reactLabel = _this$props9.reactLabel,
          allSelectable = _this$props9.allSelectable,
          isMulti = _this$props9.isMulti,
          isClearable = _this$props9.isClearable,
          hideCrossIfClosed = _this$props9.hideCrossIfClosed,
          showValueOnOpen = _this$props9.showValueOnOpen,
          selectAllLabel = _this$props9.selectAllLabel,
          tumbler = _this$props9.tumbler,
          tumblerLabel = _this$props9.tumblerLabel,
          noOptionValue = _this$props9.noOptionValue,
          value = _this$props9.value,
          isSearchable = _this$props9.isSearchable,
          changeSearchHandler = _this$props9.changeSearchHandler,
          placeholder = _this$props9.placeholder,
          tooltipParams = _this$props9.tooltipParams,
          withTabs = _this$props9.withTabs,
          isAlwaysOpen = _this$props9.isAlwaysOpen,
          renderMenuTarget = _this$props9.renderMenuTarget,
          isMenu = _this$props9.isMenu,
          isReadOnly = _this$props9.isReadOnly,
          isNaked = _this$props9.isNaked,
          rightDrop = _this$props9.rightDrop,
          menuClassName = _this$props9.menuClassName,
          fitContainer = _this$props9.fitContainer,
          toggleOpenProp = _this$props9.toggleOpenProp,
          showLabelAlways = _this$props9.showLabelAlways,
          variant = _this$props9.variant,
          confirmButtonClicked = _this$props9.confirmButtonClicked,
          underline = _this$props9.underline,
          isSearchClearable = _this$props9.isSearchClearable,
          portal = _this$props9.portal,
          customSelectRenderValue = _this$props9.customSelectRenderValue,
          allSelectedText = _this$props9.allSelectedText,
          multiPlaceholder = _this$props9.multiPlaceholder,
          virtualizationProps = _this$props9.virtualizationProps;
      var _this$state6 = this.state,
          isOpen = _this$state6.isOpen,
          search = _this$state6.search,
          tumblerIsActive = _this$state6.tumblerIsActive,
          withGroups = _this$state6.withGroups,
          isSorting = _this$state6.isSorting;
      var isSelected = value && (value.reactLabel || value.label || value.length);
      var showSelectAll = isMulti && (isOpen || isMenu) && allSelectable && !this.allVisibleItemsSelected();
      var showClearIcon = (isClearable || allSelectable) && (!hideCrossIfClosed || isOpen || isMenu) && !isReadOnly && value && (!Array.isArray(value) || !!value.length);
      var labelClassName = 'select__label';

      if (isSelected) {
        labelClassName += ' _up';
      }

      var showLabel = true;

      if (!reactLabel && !label && !isOpen && isSelected) {
        showLabel = false;
      }

      var classNames = isMenu ? [] : ['select-simple']; // :['select', 'js-select'];

      if (isSorting) {
        classNames.push('_sorting');
      }

      if (isAlwaysOpen || isOpen) {
        classNames.push('_opened');
      }

      if (withGroups) {
        classNames.push('_with-groups');
      }

      if (className) {
        classNames.push(className);
      }

      if (virtualizationProps) {
        classNames.push('_virtualized');
      }

      var renderTriggerButton = function renderTriggerButton() {
        var isInsideMenu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var selectBtnClasses = ['select__btn', isInsideMenu ? '_inside-menu' : 'opener__btn', isNaked ? 'select__btn-naked' : '', fitContainer || isInsideMenu ? 'select__btn-fit' : 'select__btn-fixed', variant === 'withTickbox' || underline ? '_with-tickbox' : '', underline ? '_underline' : ''].join(' ');
        var style = virtualizationProps ? {
          maxWidth: "calc(".concat(virtualizationProps.width, "px + 2px)")
        } : {};
        return /*#__PURE__*/React__default.createElement("div", {
          style: style
        }, /*#__PURE__*/React__default.createElement(BtnWrapper, {
          className: selectBtnClasses,
          tooltipParams: isInsideMenu ? {} : tooltipParams,
          tabIndex: 0,
          onKeyDown: function onKeyDown(e) {
            if ((e.key === 'Enter' || !isSearchable && e.key === ' ') && !isInsideMenu) {
              _this2.toggleSelect();

              e.stopPropagation();
            }
          }
        }, showLabel && !showLabelAlways && /*#__PURE__*/React__default.createElement("div", {
          className: labelClassName
        }, isOpen ? label || placeholder : isSelected ? label : placeholder), showLabelAlways && !isSelected && /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(labelClassName, " _placeholder")
        }, placeholder), /*#__PURE__*/React__default.createElement("div", {
          className: "select__value ".concat(isSelected && !showValueOnOpen ? '_selected' : '')
        }, typeof customSelectRenderValue === 'function' ? customSelectRenderValue({
          isMulti: isMulti,
          showValueOnOpen: showValueOnOpen,
          multiPlaceholder: multiPlaceholder,
          allSelectedText: allSelectedText,
          value: value,
          isOpen: _this2.state.isOpen
        }) : _this2.renderSelectedValue()), showClearIcon && !allSelectable && /*#__PURE__*/React__default.createElement("div", {
          className: "select__clear",
          onClick: _this2.handleClearValue
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "Close"
        })), !isReadOnly && !showValueOnOpen && /*#__PURE__*/React__default.createElement("div", {
          className: "select__indicator"
        })), variant === 'withTickbox' && isOpen ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
          onClick: confirmButtonClicked,
          variant: "primary",
          iconName: "CheckCircleBW",
          className: "select__confirmBtn",
          tabIndex: 0
        }) : null);
      };

      var renderSecondRow = function renderSecondRow() {
        var _this2$props$options;

        if (!showSelectAll && !(showClearIcon && allSelectable)) {
          return null;
        }

        return /*#__PURE__*/React__default.createElement("div", {
          className: "select__second-row"
        }, showSelectAll && (_this2$props$options = _this2.props.options) !== null && _this2$props$options !== void 0 && _this2$props$options.length ? /*#__PURE__*/React__default.createElement("div", {
          className: "select__btn-secondary",
          onClick: function onClick(e) {
            e.stopPropagation();

            _this2.selectAll();
          }
        }, selectAllLabel || 'Select All') : null, showClearIcon && allSelectable && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !showSelectAll && /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", {
          className: "select__btn-secondary",
          onClick: function onClick(e) {
            e.stopPropagation();

            _this2.deselectAll();
          }
        }, "Clear All")));
      };

      var virtualizationStyles = virtualizationProps ? {
        width: virtualizationProps.width,
        maxWidth: virtualizationProps.width
      } : {};
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: classNames.join(' '),
        ref: function ref(el) {
          _this2.select = el;
        },
        style: virtualizationStyles
      }, showLabelAlways && /*#__PURE__*/React__default.createElement("div", {
        className: "select__top-label"
      }, label), /*#__PURE__*/React__default.createElement(Opener, {
        className: "opener__container ".concat(fitContainer ? 'full_width' : '', " "),
        isAlwaysOpen: isAlwaysOpen,
        isOpen: isOpen,
        onToggle: function onToggle(newIsOpen) {
          toggleOpenProp(newIsOpen);

          _this2.setState({
            isOpen: newIsOpen
          });
        },
        portal: portal,
        btn: isMenu ? renderMenuTarget(this.toggleSelect, isOpen) : renderTriggerButton(),
        content: /*#__PURE__*/React__default.createElement("div", {
          className: "select__list-menu"
        }, isMenu && showValueOnOpen && renderTriggerButton(true), isOpen && renderSecondRow(), withTabs && isMulti && this.renderTabs(), this.renderButton(true), isSearchable && /*#__PURE__*/React__default.createElement("div", {
          className: "select__list-input-wrapper"
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "Search"
        }), /*#__PURE__*/React__default.createElement("input", {
          ref: function ref(el) {
            _this2.searchInput = el;
          },
          placeholder: this.props.searchPlaceholder,
          className: "select__list-input",
          value: changeSearchHandler ? undefined : search,
          onChange: changeSearchHandler || this.handleChangeSearch,
          onKeyUp: this.handleKeyUp
        }), isSearchClearable && (search || this.props.lazyLoad && this.props.lazySelectSearchString) ? /*#__PURE__*/React__default.createElement("div", {
          onClick: this.clearSearch,
          className: "select__search-clear"
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "Close"
        })) : null), this.renderButton(), tumbler && /*#__PURE__*/React__default.createElement(Tumbler, {
          className: "select__tumbler",
          onChange: this.toggleTumbler,
          on: tumblerIsActive,
          title: tumblerLabel || 'Show groups'
        }), this.state.withGroups || this.state.stateOfOptions.length || this.props.lazyLoad ? this.renderList() : noOptionValue),
        contentClassName: "opener__content ".concat(menuClassName, " ").concat(rightDrop ? 'opener__content_right-drop' : '')
      })));
    }
  }]);

  return Select;
}(Component);
BtnWrapper.propTypes = {
  className: PropTypes__default.string,
  tooltipParams: PropTypes__default.object,
  handleClick: PropTypes__default.func
};
Select.defaultProps = {
  placeholder: '',
  renderMenuTarget: function renderMenuTarget() {},
  isReadOnly: false,
  isNaked: true,
  rightDrop: false,
  menuClassName: 'full_width',
  fitContainer: false,
  toggleOpenProp: function toggleOpenProp() {},
  showLabelAlways: false,
  variant: 'withoutTickbox',
  confirmButtonClicked: function confirmButtonClicked() {},
  onSearchChange: function onSearchChange() {},
  isMulti: false,
  isClearable: false,
  allSelectable: false,
  underline: false,
  isSearchClearable: false,
  searchPlaceholder: 'Search'
};
Select.propTypes = {
  options: PropTypes__default.array,
  noOptionValue: PropTypes__default.node,
  value: PropTypes__default.any,
  onChange: PropTypes__default.func,
  onSubmitted: PropTypes__default.func,
  isMulti: PropTypes__default.bool,
  tumblerIsActive: PropTypes__default.bool,
  multiPlaceholder: PropTypes__default.func,
  allSelectable: PropTypes__default.bool,
  isClearable: PropTypes__default.bool,
  hideCrossIfClosed: PropTypes__default.bool,
  showValueOnOpen: PropTypes__default.bool,
  tumbler: PropTypes__default.bool,
  onTumblerChange: PropTypes__default.func,
  label: PropTypes__default.string,
  reactLabel: PropTypes__default.elementType,
  labelImageSrc: PropTypes__default.string,
  placeholder: PropTypes__default.string,
  selectAllLabel: PropTypes__default.string,
  tumblerLabel: PropTypes__default.string,
  onSearchChange: PropTypes__default.func,
  isSearchable: PropTypes__default.bool,
  searchByValue: PropTypes__default.bool,
  wildcardSearch: PropTypes__default.bool,
  className: PropTypes__default.string,
  levelPadding: PropTypes__default.number,
  totalRecords: PropTypes__default.number,
  changeSearchHandler: PropTypes__default.func,
  allSelectedText: PropTypes__default.string,
  scrollableClassName: PropTypes__default.string,
  tooltipParams: PropTypes__default.object,
  isOpen: PropTypes__default.bool,
  toggleOpenProp: PropTypes__default.func,
  ignoredCloseClickElement: PropTypes__default.object,
  buttonProps: PropTypes__default.exact({
    label: PropTypes__default.string,
    className: PropTypes__default.string,
    onClick: PropTypes__default.func,
    shouldCloseOnClick: PropTypes__default.bool,
    symbolBeforeLabel: PropTypes__default.string,
    shouldRenderBeforeSearch: PropTypes__default.bool
  }),
  onSelectAll: PropTypes__default.func,
  withTabs: PropTypes__default.bool,
  maxSelectedLimit: PropTypes__default.number,
  onExceededMaxLimit: PropTypes__default.func,
  withConfirmation: PropTypes__default.bool,
  isAlwaysOpen: PropTypes__default.bool,
  btnOnClick: PropTypes__default.func,
  isMenu: PropTypes__default.bool,
  renderMenuTarget: PropTypes__default.func,
  isReadOnly: PropTypes__default.bool,
  isNaked: PropTypes__default.bool,
  rightDrop: PropTypes__default.bool,
  menuClassName: PropTypes__default.string,
  fitContainer: PropTypes__default.bool,
  lazyLoad: PropTypes__default.bool,
  infiniteScrollProps: PropTypes__default.exact({
    loadMore: PropTypes__default.func,
    hasMore: PropTypes__default.bool,
    pageStart: PropTypes__default.number
  }),
  showLabelAlways: PropTypes__default.bool,
  confirmButtonClicked: PropTypes__default.func,
  variant: PropTypes__default.oneOf(['withTickbox', 'withoutTickbox']),
  underline: PropTypes__default.bool,
  isSearchClearable: PropTypes__default.bool,
  emptyDropdownLabel: PropTypes__default.elementType,
  portal: PropTypes__default.bool,
  customSelectRenderValue: PropTypes__default.func,
  virtualizationProps: PropTypes__default.shape({
    height: PropTypes__default.number.isRequired,
    width: PropTypes__default.number.isRequired,
    itemSize: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.func]),
    overscanCount: PropTypes__default.number
  }),
  searchPlaceholder: PropTypes__default.string,
  lazySelectSearchString: PropTypes__default.string
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TextFieldComponent = /*#__PURE__*/function (_Component) {
  inherits(TextFieldComponent, _Component);

  var _super = _createSuper$i(TextFieldComponent);

  function TextFieldComponent(props) {
    var _this;

    classCallCheck(this, TextFieldComponent);

    _this = _super.call(this);

    _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }

      _this.setState({
        focused: true
      });

      _this.inputRef && _this.inputRef.select();

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleKeyUp = function (event) {
      if (_this.props.onSubmitted && event.key === 'Enter') {
        _this.props.onSubmitted(_this.props.value);
      }
    };

    _this.pushClassName = function (arrays) {
      return function (className) {
        arrays.forEach(function (array) {
          return array.push(className);
        });
      };
    };

    _this.handleResetClick = function () {
      _this.props.onChange('');

      _this.setState({
        isFilled: false
      }, function () {
        if (_this.props.onResetClick) {
          _this.props.onResetClick();
        }
      });
    };

    _this.handleAutoFilledInput = function () {
      return _this.setState({
        isFilled: true
      });
    };

    _this.getText = function (value) {
      if (['amount', 'percentage'].includes(_this.props.type) && _this.props.useFixedValue) {
        return Number(value).toFixed(2);
      }

      if (_this.props.type === 'password') {
        return value.replace(/[\S\s]/g, '•');
      }

      return value;
    };

    _this.onClickConfirmButton = function () {
      var isValid = _this.state.isValid;
      var _this$props = _this.props,
          confirmButtonClicked = _this$props.confirmButtonClicked,
          value = _this$props.value;

      if (isValid) {
        confirmButtonClicked(value);

        _this.setState({
          focused: false
        });
      }
    };

    _this.onResetButtonClicked = function () {
      var isValid = _this.state.isValid;
      var _this$props2 = _this.props,
          resetButtonClicked = _this$props2.resetButtonClicked,
          value = _this$props2.value;

      if (isValid) {
        resetButtonClicked(value);

        _this.setState({
          focused: false
        });
      }
    };

    _this.state = {
      isValid: true,
      error: null,
      isFilled: !!props.value
    };
    _this.isControlled = props.value !== undefined;
    return _this;
  }

  createClass(TextFieldComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }

      if (this.props.validateOnInit) {
        this.validateControl();
      }

      if (this.props.getValidationTrigger) {
        this.props.getValidationTrigger(function () {
          return _this2.validateControl();
        });
      }

      this.props.inputRef && this.props.inputRef(this.inputRef);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.props.variant === 'withTickbox' && this.props.fixWithTickbox === true) {
        return;
      }

      this.setState({
        focused: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: "validateControl",
    value: function validateControl() {
      var target = this.inputRef;
      return this.validate(target.value, target);
    }
  }, {
    key: "checkDirty",
    value: function checkDirty(_ref) {
      var value = _ref.value;

      if (value) {
        this.setState({
          isFilled: true
        });
      } else {
        this.setState({
          isFilled: false
        });
      }
    }
  }, {
    key: "handleOnBlur",
    value: function handleOnBlur(value, target) {
      if (!(value !== null && value !== void 0 && value.trim().length)) {
        this.inputRef.value = '';
        this.handleValueChange('', target);
      }
    }
  }, {
    key: "handleValueChange",
    value: function handleValueChange(value, target) {
      var _this$props3 = this.props,
          type = _this$props3.type,
          onChange = _this$props3.onChange,
          validationRules = _this$props3.validationRules,
          label = _this$props3.label,
          doNotAllowDecimals = _this$props3.doNotAllowDecimals;

      if (type === 'amount' || type === 'percentage') {
        var i = 0;
        value = value.replace(/[^0-9.]+/g, '').replace(/\./g, function (match) {
          i += 1;
          return i === 2 ? '' : match;
        });
      }

      if (type === 'percentage' && doNotAllowDecimals) {
        var isValid = value ? /^\d{1,2}$/.test(value) : /^$/.test(value);

        if (!isValid) {
          value = null;
        } else {
          value = +value;
        }
      }

      if (onChange) {
        var errors;

        if (validationRules && validationRules.length) {
          errors = validationRules.reduce(function (errors, rule) {
            if (!rule.func(value, target, rule)) {
              if (!errors) {
                errors = [];
              }

              errors.push({
                name: target.name,
                message: rule.error(label, rule)
              });
            }

            return errors;
          }, null);
        }

        onChange(value, errors);
      }

      if (!this.isControlled) {
        this.checkDirty({
          value: value
        });
      }

      this.validate(value, target);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (this.props.value !== oldProps.value || !isEqual$2(this.props.validationKeys, oldProps.validationKeys)) {
        if (this.isControlled) {
          this.checkDirty({
            value: this.props.value
          });
        }

        this.validate(this.props.value, this.inputRef);
      }
    }
  }, {
    key: "validate",
    value: function validate(value, target) {
      var _this$props$validatio = this.props.validationRules,
          validationRules = _this$props$validatio === void 0 ? [] : _this$props$validatio;
      var rules = validationRules.slice();
      var rule = rules.pop();

      while (rule) {
        var isValid = rule.func(value, target, rule);

        if (!isValid) {
          this.setValidationState(false, rule, target.name);
          return false;
        }

        rule = rules.pop();
      }

      this.setValidationState(true);
      return true;
    }
  }, {
    key: "setValidationState",
    value: function setValidationState(isValid, rule, name) {
      var _this$props4 = this.props,
          onValidate = _this$props4.onValidate,
          label = _this$props4.label;

      if (isValid) {
        this.setState({
          isValid: true,
          error: null
        });
        onValidate(true);
      } else {
        this.setState({
          isValid: false,
          error: rule.error(label, rule)
        });
        onValidate(false);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual$2(['label', 'type', 'name', 'value', 'helpText', 'placeholder', 'disabled', 'validationKeys', 'isTextarea', 'iconName', 'hasTextareaCopy'], this.props, nextProps) && isEqual$2(['focused', 'isValid', 'error', 'isFilled'], this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          className = _this$props5.className,
          label = _this$props5.label,
          type = _this$props5.type,
          name = _this$props5.name,
          value = _this$props5.value,
          helpText = _this$props5.helpText,
          placeholder = _this$props5.placeholder,
          disabled = _this$props5.disabled,
          isTextarea = _this$props5.isTextarea,
          iconName = _this$props5.iconName,
          hasTextareaCopy = _this$props5.hasTextareaCopy,
          inputAttributes = _this$props5.inputAttributes,
          variant = _this$props5.variant,
          underline = _this$props5.underline,
          helpActions = _this$props5.helpActions,
          hasAlwaysResetButton = _this$props5.hasAlwaysResetButton,
          _this$props5$disableL = _this$props5.disableLogging,
          disableLogging = _this$props5$disableL === void 0 ? false : _this$props5$disableL,
          showResetBtn = _this$props5.showResetBtn,
          _this$props5$tooltip = _this$props5.tooltip,
          tooltip = _this$props5$tooltip === void 0 ? false : _this$props5$tooltip,
          _this$props5$tooltipP = _this$props5.tooltipProps,
          tooltipProps = _this$props5$tooltipP === void 0 ? {} : _this$props5$tooltipP,
          resetButtonRUMLabel = _this$props5.resetButtonRUMLabel,
          confirmButtonRUMLabel = _this$props5.confirmButtonRUMLabel;
      var _this$state = this.state,
          focused = _this$state.focused,
          isValid = _this$state.isValid,
          error = _this$state.error,
          isFilled = _this$state.isFilled;
      var hasResetBtn = iconName === 'Search';
      var textFieldClassName = ['text-field', className];
      var labelClassName = ['text-field__label'];
      var baseClassName = ['text-field__base'];
      var inputClassName = ['text-field__input'];
      var placeholderClassName = ['text-field__placeholder'];
      var pushClassName = this.pushClassName([textFieldClassName, labelClassName, baseClassName, inputClassName, placeholderClassName]);

      var variantClassName = function variantClassName() {
        if (variant === 'withTickbox') {
          return '_with-tickbox';
        }

        if (variant === 'withConfirmAndReset') {
          return '_with-confirm-reset';
        }

        return '_without-tickbox';
      };

      pushClassName(variantClassName());
      underline && pushClassName('_underline');

      if (focused) {
        pushClassName('_focused');
      }

      if (isFilled) {
        pushClassName('_filled');
      }

      if (iconName) {
        pushClassName('_icon');
      }

      if (!isValid) {
        pushClassName('_error');
      }

      if (disabled) {
        pushClassName('_disabled');
      }

      if (isTextarea) {
        pushClassName('_textarea');
      }

      if (tooltip) {
        pushClassName('_with-tooltip');
      }

      var placeholderContainer = isFilled ? this.getText(value) : placeholder;

      if (!focused && underline) {
        inputClassName.push('_hide');
      } // now is only to use with bordered textarea without clear 'cross'-button


      var hasCopyToClipboardButton = hasTextareaCopy && isTextarea && !hasResetBtn && value;
      var inputElement = /*#__PURE__*/React__default.createElement(!isTextarea ? 'input' : 'textarea', _objectSpread$6(_objectSpread$6(_objectSpread$6({
        ref: function ref(el) {
          _this3.inputRef = el;
        },
        className: inputClassName.join(' '),
        type: type,
        name: name,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onFocus: this.handleFocus,
        onChange: function onChange(e) {
          return _this3.handleValueChange(e.target.value, e.target);
        },
        onKeyUp: this.handleKeyUp,
        onAnimationStart: this.handleAutoFilledInput,
        onBlur: function onBlur(e) {
          return _this3.handleOnBlur(e.target.value, e.target);
        },
        autoComplete: 'off'
      }, disabled ? {
        tabIndex: -1
      } : {}), inputAttributes), disableLogging ? {
        'data-dd-privacy': 'hidden',
        'data-dd-action-name': '******'
      } : {}));
      return tooltip ? /*#__PURE__*/React__default.createElement("div", _extends_1({
        className: textFieldClassName.join(' '),
        "data-automation": kebabCase(name || placeholder || label)
      }, disableLogging ? {
        'data-dd-privacy': 'hidden',
        'data-dd-action-name': '******'
      } : {}), label && /*#__PURE__*/React__default.createElement("label", {
        className: labelClassName.join(' ')
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: baseClassName.join(' ')
      }, hasCopyToClipboardButton && /*#__PURE__*/React__default.createElement(CopyToClipboardButton, {
        className: "text-field__copy",
        code: value
      }), iconName && /*#__PURE__*/React__default.createElement("i", {
        className: "text-field__icon"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: iconName
      })), /*#__PURE__*/React__default.createElement(Tooltip, _extends_1({
        auto: true,
        label: placeholderContainer
      }, tooltipProps, {
        className: "text-field__tooltip"
      }), inputElement, placeholderContainer && !focused && underline ? /*#__PURE__*/React__default.createElement("span", {
        onClick: this.handleFocus,
        className: placeholderClassName.join(' ')
      }, placeholderContainer) : null), focused && variant === 'withTickbox' ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: this.onClickConfirmButton,
        variant: "primary",
        iconName: "CheckCircleBW",
        className: "text-field__confirmBtn ".concat(!isValid ? '_error' : ''),
        tabIndex: 0
      }) : null, focused && variant === 'withConfirmAndReset' ? /*#__PURE__*/React__default.createElement("div", {
        className: "text-field__confirmResetBtnContainer"
      }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: this.onClickConfirmButton,
        variant: "link",
        iconName: "CheckCircleBW",
        className: "text-field__confirmResetBtn _confirm ".concat(!isValid ? '_error' : ''),
        tabIndex: 0,
        underline: false
      }), /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: this.onResetButtonClicked,
        variant: "link",
        iconName: "CloseCircle",
        className: "text-field__confirmResetBtn _reset ".concat(!isValid ? '_error' : ''),
        tabIndex: 0,
        underline: false
      })) : null, helpActions ? /*#__PURE__*/React__default.createElement("div", {
        className: "text-field__help-actions"
      }, helpActions) : null, (hasAlwaysResetButton || hasResetBtn && value || showResetBtn && value) && /*#__PURE__*/React__default.createElement("button", {
        className: "text-field__reset",
        onClick: this.handleResetClick
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Close"
      })), focused && type === 'percentage' && !(showResetBtn || hasAlwaysResetButton) ? /*#__PURE__*/React__default.createElement("span", {
        className: "text-field__percentage"
      }, "%") : null), (error || helpText) && /*#__PURE__*/React__default.createElement("p", {
        className: "text-field__help-text"
      }, error || helpText)) : /*#__PURE__*/React__default.createElement("div", _extends_1({
        className: textFieldClassName.join(' '),
        "data-automation": kebabCase(name || placeholder || label)
      }, disableLogging ? {
        'data-dd-privacy': 'hidden',
        'data-dd-action-name': '******'
      } : {}), label && /*#__PURE__*/React__default.createElement("label", {
        className: labelClassName.join(' ')
      }, label), /*#__PURE__*/React__default.createElement("div", {
        className: baseClassName.join(' ')
      }, hasCopyToClipboardButton && /*#__PURE__*/React__default.createElement(CopyToClipboardButton, {
        className: "text-field__copy",
        code: value
      }), iconName && /*#__PURE__*/React__default.createElement("i", {
        className: "text-field__icon"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: iconName
      })), inputElement, focused && variant === 'withTickbox' ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: this.onClickConfirmButton,
        variant: "primary",
        iconName: "CheckCircleBW",
        className: "text-field__confirmBtn ".concat(!isValid ? '_error' : ''),
        tabIndex: 0
      }) : null, focused && variant === 'withConfirmAndReset' ? /*#__PURE__*/React__default.createElement("div", {
        className: "text-field__confirmResetBtnContainer"
      }, /*#__PURE__*/React__default.createElement(ButtonCircle, _extends_1({
        onClick: this.onClickConfirmButton,
        variant: "link",
        iconName: "CheckCircleBW",
        className: "text-field__confirmResetBtn _confirm ".concat(!isValid ? '_error' : ''),
        tabIndex: 0,
        underline: false
      }, defineProperty({}, RUM_ACTION_ATTRIBUTE, confirmButtonRUMLabel || 'Confirm'))), /*#__PURE__*/React__default.createElement(ButtonCircle, _extends_1({
        onClick: this.onResetButtonClicked,
        variant: "link",
        iconName: "CloseCircle",
        className: "text-field__confirmResetBtn _reset ".concat(!isValid ? '_error' : ''),
        tabIndex: 0,
        underline: false
      }, defineProperty({}, RUM_ACTION_ATTRIBUTE, resetButtonRUMLabel || 'Reset')))) : null, placeholderContainer && !focused && underline ? /*#__PURE__*/React__default.createElement("span", {
        onClick: this.handleFocus,
        className: placeholderClassName.join(' ')
      }, "".concat(placeholderContainer).concat(type === 'percentage' ? '%' : '')) : null, helpActions ? /*#__PURE__*/React__default.createElement("div", {
        className: "text-field__help-actions"
      }, helpActions) : null, (hasAlwaysResetButton || hasResetBtn && value || showResetBtn && value) && /*#__PURE__*/React__default.createElement("button", {
        className: "text-field__reset",
        onClick: this.handleResetClick
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Close"
      })), focused && type === 'percentage' && !(showResetBtn || hasAlwaysResetButton) ? /*#__PURE__*/React__default.createElement("span", {
        className: "text-field__percentage"
      }, "%") : null), (error || helpText) && /*#__PURE__*/React__default.createElement("p", {
        className: "text-field__help-text"
      }, error || helpText));
    }
  }]);

  return TextFieldComponent;
}(Component);

TextFieldComponent.defaultProps = {
  type: 'text',
  className: '',
  inputAttributes: {},
  confirmButtonClicked: function confirmButtonClicked() {},
  onValidate: function onValidate() {},
  validateOnInit: false,
  variant: 'withTickbox',
  underline: true,
  fixWithTickbox: false,
  showResetBtn: false,
  useFixedValue: true,
  doNotAllowDecimals: false
};
TextFieldComponent.propTypes = {
  className: PropTypes__default.string,
  label: PropTypes__default.string,
  type: PropTypes__default.string,
  name: PropTypes__default.string,
  value: PropTypes__default.string,
  helpText: PropTypes__default.string,
  validationRules: PropTypes__default.array,
  validateOnInit: PropTypes__default.bool,
  validationKeys: PropTypes__default.array,
  placeholder: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  inputRef: PropTypes__default.func,
  onSubmitted: PropTypes__default.func,
  onFocus: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  onChange: PropTypes__default.func,
  onValidate: PropTypes__default.func,
  isTextarea: PropTypes__default.bool,
  iconName: PropTypes__default.string,
  hasTextareaCopy: PropTypes__default.bool,
  inputAttributes: PropTypes__default.object,
  getValidationTrigger: PropTypes__default.func,
  confirmButtonClicked: PropTypes__default.func,
  resetButtonClicked: PropTypes__default.func,
  variant: PropTypes__default.oneOf(['withTickbox', 'withoutTickbox', 'withConfirmAndReset']),
  underline: PropTypes__default.bool,
  helpActions: PropTypes__default.node,
  onResetClick: PropTypes__default.func,
  hasAlwaysResetButton: PropTypes__default.bool,
  showResetBtn: PropTypes__default.bool,
  fixWithTickbox: PropTypes__default.bool,
  disableLogging: PropTypes__default.bool,
  tooltip: PropTypes__default.bool,
  tooltipProps: PropTypes__default.object,
  useFixedValue: PropTypes__default.bool,
  doNotAllowDecimals: PropTypes__default.bool,
  resetButtonRUMLabel: PropTypes__default.string,
  confirmButtonRUMLabel: PropTypes__default.string
};
var TextField = withClickOutside(TextFieldComponent);

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TextFieldWithIcon = /*#__PURE__*/function (_Component) {
  inherits(TextFieldWithIcon, _Component);

  var _super = _createSuper$j(TextFieldWithIcon);

  function TextFieldWithIcon() {
    var _this;

    classCallCheck(this, TextFieldWithIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      focused: false,
      isFilled: !!_this.props.value
    };
    _this.inputRef = null;

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(e);

      _this.checkDirty(e.target);
    };

    _this.handleFocus = function () {
      if (_this.inputRef) {
        _this.inputRef.select();
      }

      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.handleReset = function (e) {
      var onChange = _this.props.onChange;
      onChange({
        target: {
          value: ''
        }
      }, true);

      _this.checkDirty(e.target);
    };

    return _this;
  }

  createClass(TextFieldWithIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['name', 'placeholder', 'type', 'iconName', 'value', 'svgParams', 'reset', 'isMultipleIcons', 'multipleIconsInfo'], this.props, nextProps) && isEqual(['focused', 'isFilled'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.inputRef && this.props.inputRef(this.inputRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value !== prevProps.value) {
        this.setState({
          isFilled: !!this.props.value
        });
      }
    }
  }, {
    key: "checkDirty",
    value: function checkDirty(_ref) {
      var value = _ref.value;
      var isFilled = this.state.isFilled;

      if (isFilled !== !!value) {
        this.setState({
          isFilled: !!value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          iconName = _this$props.iconName,
          onChange = _this$props.onChange,
          value = _this$props.value,
          svgParams = _this$props.svgParams,
          multipleIconsInfo = _this$props.multipleIconsInfo,
          _this$props$disableLo = _this$props.disableLogging,
          disableLogging = _this$props$disableLo === void 0 ? false : _this$props$disableLo,
          rest = objectWithoutProperties(_this$props, ["name", "placeholder", "type", "iconName", "onChange", "value", "svgParams", "multipleIconsInfo", "disableLogging"]);

      var _this$state = this.state,
          focused = _this$state.focused,
          isFilled = _this$state.isFilled;
      var isSearchIcon;
      var isMultipleIcons = multipleIconsInfo && !!multipleIconsInfo.length;

      if (isMultipleIcons) {
        isSearchIcon = multipleIconsInfo.some(function (icon) {
          return icon.iconName === 'Search';
        });
      } else {
        isSearchIcon = iconName === 'Search';
      }

      var containerClassName = ['text-field-icon'];

      if (focused) {
        containerClassName.push('_focused');
      }

      if (isSearchIcon) {
        containerClassName.push('_reset-icon');
      }

      if (iconName || isMultipleIcons) {
        containerClassName.push('_icon');
      }

      var labelClassName = ['text-field-icon__label'];

      if (focused || isFilled) {
        labelClassName.push('_up');
      }

      if (focused) {
        labelClassName.push('_focused');
      }

      var noStyleChangeIcons = ['DownloadRounded']; // icons that shouldn't change style on hover or focus of textfield

      return /*#__PURE__*/React__default.createElement("div", _extends_1({
        className: containerClassName.join(' ')
      }, disableLogging ? {
        'data-dd-privacy': 'hidden',
        'data-dd-action-name': '******'
      } : {}), iconName && !isMultipleIcons && /*#__PURE__*/React__default.createElement("i", {
        className: "text-field-icon__icon"
      }, /*#__PURE__*/React__default.createElement(Icon, _extends_1({
        name: iconName
      }, svgParams))), isMultipleIcons && /*#__PURE__*/React__default.createElement("ul", null, multipleIconsInfo.map(function (icon) {
        var name = icon.iconName;
        return /*#__PURE__*/React__default.createElement("li", {
          key: name
        }, /*#__PURE__*/React__default.createElement("div", {
          onClick: icon === null || icon === void 0 ? void 0 : icon.onClickFunction,
          className: icon.styles
        }, /*#__PURE__*/React__default.createElement("i", {
          className: noStyleChangeIcons.includes(name) ? 'text-field-icon__noStyleChangeIcon' : 'text-field-icon__icon'
        }, icon !== null && icon !== void 0 && icon.toolTipParams ? /*#__PURE__*/React__default.createElement(Tooltip, icon.toolTipParams, /*#__PURE__*/React__default.createElement(Icon, {
          name: name
        })) : /*#__PURE__*/React__default.createElement(Icon, {
          name: name
        }))));
      })), /*#__PURE__*/React__default.createElement("div", {
        className: labelClassName.join(' ')
      }, placeholder), /*#__PURE__*/React__default.createElement("input", _extends_1({
        type: type,
        name: name,
        value: value,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        className: "text-field-icon__field",
        ref: function ref(el) {
          _this2.inputRef = el;
        }
      }, disableLogging ? {
        'data-dd-privacy': 'hidden',
        'data-dd-action-name': '******'
      } : {}, rest)), isSearchIcon && value && /*#__PURE__*/React__default.createElement("button", {
        className: "text-field-icon__reset",
        onClick: this.handleReset
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Close"
      })));
    }
  }]);

  return TextFieldWithIcon;
}(Component);
TextFieldWithIcon.defaultProps = {
  type: 'text',
  onChange: function onChange() {},
  svgParams: {}
};
TextFieldWithIcon.propTypes = {
  iconName: PropTypes__default.string,
  value: PropTypes__default.string.isRequired,
  name: PropTypes__default.string,
  placeholder: PropTypes__default.string,
  type: PropTypes__default.string,
  onChange: PropTypes__default.func,
  svgParams: PropTypes__default.object,
  reset: PropTypes__default.bool,
  focused: PropTypes__default.bool,
  multipleIconsInfo: PropTypes__default.arrayOf(PropTypes__default.shape({
    iconName: PropTypes__default.string.isRequired,
    onClickFunction: PropTypes__default.func,
    toolTipParams: PropTypes__default.object,
    styles: PropTypes__default.string
  })),
  disableLogging: PropTypes__default.bool
};

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Checkbox = /*#__PURE__*/function (_Component) {
  inherits(Checkbox, _Component);

  var _super = _createSuper$k(Checkbox);

  function Checkbox() {
    classCallCheck(this, Checkbox);

    return _super.apply(this, arguments);
  }

  createClass(Checkbox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(['label', 'checked', 'disabled', 'className'], this.props, nextProps);
    }
  }, {
    key: "getCheckboxIconName",
    value: function getCheckboxIconName() {
      var _this$props = this.props,
          checked = _this$props.checked,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;

      if (checked) {
        return 'Checkbox';
      } else if (className.includes('_dirty')) {
        return 'SquareMinus';
      }

      return 'CheckboxBlank';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          label = _this$props2.label,
          checked = _this$props2.checked,
          disabled = _this$props2.disabled,
          _onChange = _this$props2.onChange,
          _this$props2$onClick = _this$props2.onClick,
          onClick = _this$props2$onClick === void 0 ? function () {} : _this$props2$onClick,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "checkbox ".concat(disabled ? 'checkbox_disabled' : '', " ").concat(checked ? 'checkbox_checked' : '', " ").concat(className)
      }, /*#__PURE__*/React__default.createElement("label", {
        className: "checkbox__label",
        htmlFor: name
      }, /*#__PURE__*/React__default.createElement("input", {
        type: "checkbox",
        id: name,
        name: name,
        disabled: disabled,
        checked: checked,
        onChange: function onChange(e) {
          return _onChange(e.target.checked);
        },
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 13) {
            _onChange(!e.target.checked);

            e.stopPropagation();
          }
        },
        className: "checkbox__input"
      }), /*#__PURE__*/React__default.createElement(Icon, {
        name: this.getCheckboxIconName()
      }), label && /*#__PURE__*/React__default.createElement("span", {
        className: "checkbox__title"
      }, label)));
    }
  }]);

  return Checkbox;
}(Component);
Checkbox.defaultProps = {
  onChange: function onChange() {},
  checked: false,
  disabled: false
};
Checkbox.propTypes = {
  name: PropTypes__default.string,
  label: PropTypes__default.string,
  checked: PropTypes__default.bool,
  disabled: PropTypes__default.bool,
  onChange: PropTypes__default.func,
  onClick: PropTypes__default.func,
  className: PropTypes__default.string
};

var css_248z$a = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes Radio-module_hover-ripples__P9-6j {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.Radio-module_radio__3i1Gb {\n  display: flex;\n  cursor: pointer; }\n  .Radio-module_radio__3i1Gb label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin: 0.125rem 0.5rem 0 0.375rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 0.875rem;\n    line-height: 1.125rem; }\n  .Radio-module_radio__3i1Gb input {\n    display: none; }\n  .Radio-module_radio__3i1Gb.Radio-module_checked__3O7vn .svg-icon path {\n    fill: var(--primary2); }\n  .Radio-module_radio__3i1Gb.Radio-module_disabled__18Q5F {\n    cursor: not-allowed;\n    pointer-events: none; }\n    .Radio-module_radio__3i1Gb.Radio-module_disabled__18Q5F .svg-icon path {\n      fill: #787878; }\n";
var styles$9 = {"radio":"Radio-module_radio__3i1Gb","checked":"Radio-module_checked__3O7vn","disabled":"Radio-module_disabled__18Q5F","hover-ripples":"Radio-module_hover-ripples__P9-6j"};
styleInject(css_248z$a);

var Radio = function Radio(props) {
  var className = props.className,
      name = props.name,
      checked = props.checked,
      onChange = props.onChange,
      title = props.title,
      disabled = props.disabled;

  var handleClick = function handleClick() {
    onChange(true);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "radio ".concat(styles$9.radio, " ").concat(className, " ").concat(checked ? styles$9.checked : '', " ").concat(disabled ? styles$9.disabled : ''),
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    name: name,
    style: {
      display: 'none'
    },
    checked: checked,
    onChange: function onChange() {}
  }), /*#__PURE__*/React__default.createElement(Icon, {
    name: checked ? 'RadioChecked' : 'RadioUnchecked'
  }), /*#__PURE__*/React__default.createElement("label", null, title));
};
Radio.defaultProps = {
  className: '',
  disabled: false,
  title: ''
};
Radio.propTypes = {
  className: PropTypes__default.string,
  name: PropTypes__default.string.isRequired,
  checked: PropTypes__default.bool.isRequired,
  onChange: PropTypes__default.func.isRequired,
  title: PropTypes__default.node,
  disabled: PropTypes__default.bool
};

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ButtonsGroup = /*#__PURE__*/function (_Component) {
  inherits(ButtonsGroup, _Component);

  var _super = _createSuper$l(ButtonsGroup);

  function ButtonsGroup() {
    classCallCheck(this, ButtonsGroup);

    return _super.apply(this, arguments);
  }

  createClass(ButtonsGroup, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(['items', 'value', 'className', 'size'], this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          value = _this$props.value,
          onChange = _this$props.onChange,
          className = _this$props.className,
          size = _this$props.size;
      var isCheckboxes = Array.isArray(value);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "btn-group ".concat(size ? "_".concat(size) : '', " ").concat(className)
      }, items.map(function (item, index) {
        var active;

        if (isCheckboxes) {
          active = value.indexOf(item.value) !== -1 ? '_active' : '';
        } else {
          active = item.value === value ? '_active' : '';
        }

        return /*#__PURE__*/React__default.createElement("button", {
          onClick: function onClick() {
            return onChange(item.value);
          },
          key: index,
          className: "btn-group__item ".concat(active)
        }, item.title);
      }));
    }
  }]);

  return ButtonsGroup;
}(Component);
ButtonsGroup.defaultProps = {
  onChange: function onChange() {},
  className: ''
};
ButtonsGroup.propTypes = {
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array]),
  items: PropTypes__default.array.isRequired,
  onChange: PropTypes__default.func,
  className: PropTypes__default.string,
  size: PropTypes__default.string
};

var css_248z$b = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes loadingbar-module_hover-ripples__3MidM {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n@keyframes loadingbar-module_line-bounce__2cmze {\n  0% {\n    left: 0;\n    width: 0; }\n  50% {\n    left: 6.25rem;\n    width: 11.25rem; }\n  100% {\n    left: 19.375rem;\n    width: 0.625rem; } }\n\n.loadingbar-module_loader__1bCA8 {\n  background: #f4f4f4;\n  width: 20rem;\n  height: 0.5rem;\n  border-radius: 0.25rem;\n  position: relative;\n  margin-bottom: 2rem; }\n\n.loadingbar-module_movingLine__1eRrk {\n  background: var(--primary2);\n  border-radius: 0.25rem;\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  width: 5rem;\n  height: 0.5rem;\n  animation: loadingbar-module_line-bounce__2cmze 800ms infinite ease-in; }\n";
var styles$a = {"loader":"loadingbar-module_loader__1bCA8","movingLine":"loadingbar-module_movingLine__1eRrk","line-bounce":"loadingbar-module_line-bounce__2cmze","hover-ripples":"loadingbar-module_hover-ripples__3MidM"};
styleInject(css_248z$b);

var LoadingBar = function LoadingBar() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$a.loader
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$a.movingLine
  }));
};

var css_248z$c = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__2AXyA {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_pill__14tae {\n  border-radius: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  display: inline-flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  white-space: nowrap;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  margin: 0.25rem; }\n  .index-module_pill__14tae.index-module_hasImg__XDK-J {\n    border-radius: 0.75rem 0.25rem 0.25rem 0.75rem;\n    padding: 0.25rem 0.5rem 0.25rem 0;\n    height: 1.5rem; }\n    .index-module_pill__14tae.index-module_hasImg__XDK-J.index-module_hasRemove__3iTa7 {\n      padding: 0 1.875rem 0 0; }\n      .index-module_pill__14tae.index-module_hasImg__XDK-J.index-module_hasRemove__3iTa7.index-module_right__1NvLp {\n        padding: 0.25rem 1.75rem 0.25rem 0.5rem; }\n    .index-module_pill__14tae.index-module_hasImg__XDK-J.index-module_noRemove__36AHt {\n      padding: 0.25rem 0.5rem 0.25rem 0; }\n      .index-module_pill__14tae.index-module_hasImg__XDK-J.index-module_noRemove__36AHt.index-module_right__1NvLp {\n        padding: 0.25rem 0.5rem; }\n    .index-module_pill__14tae.index-module_hasImg__XDK-J.index-module_right__1NvLp {\n      border-radius: 0.25rem; }\n  .index-module_pill__14tae.index-module_hasRemove__3iTa7 {\n    padding: 0.25rem 1.875rem 0.25rem 0.5rem; }\n  .index-module_pill__14tae.index-module_basic__3REc6 {\n    background-color: #f4f4f4; }\n  .index-module_pill__14tae.index-module_success__1S4XW {\n    background-color: #28bc97; }\n  .index-module_pill__14tae.index-module_success1__2PVli {\n    background-color: #ffffff;\n    border: 1px solid #289679; }\n    .index-module_pill__14tae.index-module_success1__2PVli .svg-icon, .index-module_pill__14tae.index-module_success1__2PVli .svg-icon path {\n      fill: #289679; }\n  .index-module_pill__14tae.index-module_warning__zGxlO {\n    background-color: #ffbb43; }\n  .index-module_pill__14tae.index-module_danger__1F8yl {\n    background-color: #ff5859; }\n  .index-module_pill__14tae.index-module_danger1__2ScVQ {\n    background-color: #ffffff;\n    border: 1px solid #f1494a; }\n    .index-module_pill__14tae.index-module_danger1__2ScVQ .svg-icon, .index-module_pill__14tae.index-module_danger1__2ScVQ .svg-icon path {\n      fill: #f1494a; }\n  .index-module_pill__14tae.index-module_link__3C3fQ {\n    background-color: #f4f4f4;\n    color: var(--primary2); }\n    .index-module_pill__14tae.index-module_link__3C3fQ .index-module_pillRemoveIcon__1d6tb,\n    .index-module_pill__14tae.index-module_link__3C3fQ .index-module_iconLeft__2O9r4 {\n      fill: var(--primary2); }\n  .index-module_pill__14tae .index-module_removeIconWrapper__2EHFd {\n    position: absolute;\n    top: 0.25rem;\n    right: 0.5rem; }\n  .index-module_pill__14tae .index-module_pillRemoveIcon__1d6tb {\n    width: 1rem;\n    height: 1rem;\n    margin-left: 0.375rem;\n    fill: #000000;\n    display: flex; }\n    .index-module_pill__14tae .index-module_pillRemoveIcon__1d6tb:hover {\n      cursor: pointer; }\n  .index-module_pill__14tae .index-module_iconLeft__2O9r4 {\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.375rem;\n    fill: #000000; }\n  .index-module_pill__14tae .index-module_iconRight__15TTx {\n    width: 1rem;\n    height: 1rem;\n    margin-left: 0.375rem;\n    fill: #000000; }\n  .index-module_pill__14tae .index-module_imgContainer__omFBC {\n    border-radius: 50%;\n    width: 1.5rem;\n    height: 1.5rem;\n    background-color: transparent;\n    overflow: hidden; }\n    .index-module_pill__14tae .index-module_imgContainerLeft__L4lNV {\n      margin-right: 0.375rem; }\n    .index-module_pill__14tae .index-module_imgContainerRight__3ruS3 {\n      margin-left: 0.375rem; }\n  .index-module_pill__14tae .index-module_img__g3qhp {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; }\n";
var styles$b = {"pill":"index-module_pill__14tae","hasImg":"index-module_hasImg__XDK-J","hasRemove":"index-module_hasRemove__3iTa7","right":"index-module_right__1NvLp","noRemove":"index-module_noRemove__36AHt","basic":"index-module_basic__3REc6","success":"index-module_success__1S4XW","success1":"index-module_success1__2PVli","warning":"index-module_warning__zGxlO","danger":"index-module_danger__1F8yl","danger1":"index-module_danger1__2ScVQ","link":"index-module_link__3C3fQ","pillRemoveIcon":"index-module_pillRemoveIcon__1d6tb","iconLeft":"index-module_iconLeft__2O9r4","removeIconWrapper":"index-module_removeIconWrapper__2EHFd","iconRight":"index-module_iconRight__15TTx","imgContainer":"index-module_imgContainer__omFBC","imgContainerLeft":"index-module_imgContainerLeft__L4lNV","imgContainerRight":"index-module_imgContainerRight__3ruS3","img":"index-module_img__g3qhp","hover-ripples":"index-module_hover-ripples__2AXyA"};
styleInject(css_248z$c);

var Pill = function Pill(props) {
  var label = props.label,
      iconName = props.iconName,
      iconPosition = props.iconPosition,
      variant = props.variant,
      className = props.className,
      removable = props.removable,
      removeClicked = props.removeClicked,
      imgSource = props.imgSource,
      imgAlt = props.imgAlt;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "_pill ".concat(styles$b.pill, " ").concat(iconPosition === 'right' ? styles$b.right : '', " ").concat(!iconName && imgSource ? styles$b.hasImg : '', " ").concat(className, " ").concat(styles$b[variant], " ").concat(removable ? styles$b.hasRemove : styles$b.noRemove)
  }, iconName && iconPosition === 'left' ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconName,
    className: styles$b.iconLeft
  }) : null, !iconName && imgSource && iconPosition === 'left' ? /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$b.imgContainerLeft, " ").concat(styles$b.imgContainer)
  }, /*#__PURE__*/React__default.createElement("img", {
    src: imgSource,
    alt: imgAlt,
    className: styles$b.img
  })) : null, label, removable ? /*#__PURE__*/React__default.createElement("span", {
    className: styles$b.removeIconWrapper,
    onClick: removeClicked
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close",
    className: styles$b.pillRemoveIcon
  })) : null, iconName && iconPosition === 'right' ? /*#__PURE__*/React__default.createElement(Icon, {
    name: iconName,
    className: styles$b.iconRight
  }) : null, !iconName && imgSource && iconPosition === 'right' ? /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$b.imgContainerRight, " ").concat(styles$b.imgContainer)
  }, /*#__PURE__*/React__default.createElement("img", {
    src: imgSource,
    alt: imgAlt,
    className: styles$b.img
  })) : null);
};
Pill.defaultProps = {
  className: '',
  variant: 'basic',
  removable: false,
  removeClicked: function removeClicked() {},
  iconPosition: 'left'
};
Pill.propTypes = {
  label: PropTypes__default.string.isRequired,
  className: PropTypes__default.string,
  iconName: PropTypes__default.string,
  variant: PropTypes__default.oneOf(['basic', 'link', 'success', 'success1', 'warning', 'danger', 'danger1', 'naked']),
  iconPosition: PropTypes__default.oneOf(['left', 'right']),
  removable: PropTypes__default.bool,
  removeClicked: PropTypes__default.func,
  imgSource: PropTypes__default.string,
  imgAlt: PropTypes__default.string
};

var isFunction = function isFunction(element) {
  return typeof element === 'function';
};

var CardHoveredContent = function CardHoveredContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card__overlay"
  }, children);
};
var CardHoveredSubtitle = function CardHoveredSubtitle(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card__subtitle_hovered"
  }, children);
};
var CardSubtitle = function CardSubtitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "card__subtitle"
  }, children);
};
var Card = function Card(props) {
  var title = props.title,
      subtitle = props.subtitle,
      children = props.children,
      shadow = props.shadow;

  var _useState = useState(false),
      _useState2 = slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var onMouseOver = function onMouseOver() {
    setHovered(true);
  };

  var onMouseOut = function onMouseOut() {
    setHovered(false);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "card ".concat(hovered ? 'card_hovered' : '', " _").concat(shadow),
    onMouseEnter: onMouseOver,
    onMouseLeave: onMouseOut
  }, /*#__PURE__*/React__default.createElement("header", {
    className: "card__header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "card__title"
  }, title), subtitle && /*#__PURE__*/React__default.createElement("div", {
    className: "card__title card__title_subtitle"
  }, isFunction(subtitle) ? subtitle({
    hovered: hovered
  }) : subtitle)), /*#__PURE__*/React__default.createElement("main", {
    className: "card__content"
  }, isFunction(children) ? children({
    hovered: hovered
  }) : children));
};
Card.defaultProps = {
  shadow: 'none',
  subtitle: ''
};
Card.propTypes = {
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  subtitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element, PropTypes__default.func]),
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.element), PropTypes__default.element, PropTypes__default.func]),
  shadow: PropTypes__default.oneOf(['depth1', 'depth2', 'depth3', 'depth4', 'depth5', 'none'])
};

var bind = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var css_248z$d = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes Chip-module_hover-ripples__2Wh7z {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.Chip-module_chip__1bL1e {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 .5rem .5rem 0;\n  padding: 0 .5rem 0 1rem;\n  height: 1.5rem;\n  border-radius: .75rem;\n  background: var(--primary2);\n  color: #ffffff;\n  max-width: 100%; }\n  .Chip-module_chip__1bL1e.chip:focus {\n    outline: none;\n    border: 1px solid var(--primary2);\n    background: var(--primary6); }\n  .Chip-module_chip_gray__241V3 {\n    background-color: #cbcbcb;\n    color: #000000; }\n  .Chip-module_chip__1bL1e._outline {\n    padding: 0 .5rem;\n    border: 0.0625rem solid var(--primary2);\n    background: #ffffff;\n    color: var(--primary2); }\n  .Chip-module_chip__1bL1e._exclude, .Chip-module_chip__1bL1e._black, .Chip-module_chip__1bL1e._include {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    padding: 0 .5em;\n    border: 0.0625rem solid;\n    border-color: #666666;\n    background: #ffffff;\n    font-size: 0.75rem;\n    line-height: 1.16667em;\n    text-decoration: none;\n    white-space: nowrap;\n    color: #000000; }\n  .Chip-module_chip__1bL1e._black {\n    border-color: #000000;\n    color: #000000; }\n\n.Chip-module_label__1yRHr {\n  flex: 1 1 auto;\n  color: inherit;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.Chip-module_remove__2iDyl {\n  flex-shrink: 0; }\n  .Chip-module_remove__2iDyl.btn-close {\n    margin-left: 0.625rem;\n    width: 1rem;\n    height: 1rem;\n    border-radius: 50%;\n    background: #ffffff; }\n    .Chip-module_remove__2iDyl.btn-close::before, .Chip-module_remove__2iDyl.btn-close::after {\n      width: 0.4375rem;\n      height: 0.0625rem;\n      background: #818181; }\n\n.Chip-module_chip__1bL1e._exclude .Chip-module_icon__zxoWO, .Chip-module_chip__1bL1e._black .Chip-module_icon__zxoWO, .Chip-module_chip__1bL1e._include .Chip-module_icon__zxoWO {\n  margin-right: 0.6875rem;\n  height: 1rem; }\n  .Chip-module_chip__1bL1e._exclude .Chip-module_icon__zxoWO svg, .Chip-module_chip__1bL1e._black .Chip-module_icon__zxoWO svg, .Chip-module_chip__1bL1e._include .Chip-module_icon__zxoWO svg {\n    width: auto;\n    height: 100%; }\n\n.Chip-module_chip__1bL1e._exclude .Chip-module_remove__2iDyl, .Chip-module_chip__1bL1e._black .Chip-module_remove__2iDyl, .Chip-module_chip__1bL1e._include .Chip-module_remove__2iDyl {\n  margin-left: .5rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  border: 1px solid #666666; }\n  .Chip-module_chip__1bL1e._exclude .Chip-module_remove__2iDyl:before, .Chip-module_chip__1bL1e._exclude .Chip-module_remove__2iDyl:after, .Chip-module_chip__1bL1e._black .Chip-module_remove__2iDyl:before, .Chip-module_chip__1bL1e._black .Chip-module_remove__2iDyl:after, .Chip-module_chip__1bL1e._include .Chip-module_remove__2iDyl:before, .Chip-module_chip__1bL1e._include .Chip-module_remove__2iDyl:after {\n    background: #666666; }\n\n.Chip-module_chip__1bL1e._exclude .Chip-module_icon__zxoWO path,\n.Chip-module_chip__1bL1e._exclude .Chip-module_icon__zxoWO polygon,\n.Chip-module_chip__1bL1e._exclude .Chip-module_icon__zxoWO circle {\n  fill: #9b3434; }\n\n.Chip-module_chip__1bL1e._black .Chip-module_icon__zxoWO path,\n.Chip-module_chip__1bL1e._black .Chip-module_icon__zxoWO polygon,\n.Chip-module_chip__1bL1e._black .Chip-module_icon__zxoWO circle {\n  fill: #000000; }\n\n.Chip-module_chip__1bL1e._black .Chip-module_remove__2iDyl {\n  background: #000000; }\n  .Chip-module_chip__1bL1e._black .Chip-module_remove__2iDyl:before, .Chip-module_chip__1bL1e._black .Chip-module_remove__2iDyl:after {\n    background: #ffffff; }\n\n.Chip-module_chip__1bL1e._include .Chip-module_icon__zxoWO path,\n.Chip-module_chip__1bL1e._include .Chip-module_icon__zxoWO polygon,\n.Chip-module_chip__1bL1e._include .Chip-module_icon__zxoWO circle {\n  fill: #3f9b34; }\n\n.Chip-module_chip__1bL1e._outline .Chip-module_icon__zxoWO {\n  margin-right: .5rem;\n  width: 1rem;\n  height: auto;\n  line-height: 0; }\n  .Chip-module_chip__1bL1e._outline .Chip-module_icon__zxoWO svg {\n    width: 100%;\n    height: auto; }\n\n.Chip-module_chip__1bL1e._outline .Chip-module_remove__2iDyl {\n  margin-left: .5rem;\n  width: .625rem;\n  height: .625rem;\n  background-color: var(--primary2);\n  border: 0; }\n  .Chip-module_chip__1bL1e._outline .Chip-module_remove__2iDyl:before, .Chip-module_chip__1bL1e._outline .Chip-module_remove__2iDyl:after {\n    background-color: #ffffff;\n    width: 0.375rem; }\n";
var styles$c = {"chip":"Chip-module_chip__1bL1e","chip_gray":"Chip-module_chip_gray__241V3","label":"Chip-module_label__1yRHr","remove":"Chip-module_remove__2iDyl","icon":"Chip-module_icon__zxoWO","hover-ripples":"Chip-module_hover-ripples__2Wh7z"};
styleInject(css_248z$d);

/* eslint-disable jsx-a11y/control-has-associated-label */
var cx$1 = bind.bind(styles$c);

var Chip = function Chip(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      item = props.item,
      onRemove = props.onRemove,
      icon = props.icon,
      value = props.value,
      readonly = props.readonly,
      _props$displayTooltip = props.displayTooltip,
      displayTooltip = _props$displayTooltip === void 0 ? false : _props$displayTooltip;
  var chipStyle = cx$1('chip', className.split(' '));
  var iconEl = icon || item.icon;
  var chipElement = /*#__PURE__*/React__default.createElement("div", {
    tabIndex: 0,
    className: 'chip ' + chipStyle,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        onRemove(item);
        e.stopPropagation();
      }
    }
  }, iconEl && /*#__PURE__*/React__default.createElement("i", {
    className: styles$c.icon
  }, iconEl), /*#__PURE__*/React__default.createElement("span", {
    className: styles$c.label
  }, item.label), value ? /*#__PURE__*/React__default.createElement("span", {
    className: "ml-2"
  }, value) : null, !readonly && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    tabIndex: -1,
    className: "btn-close ".concat(styles$c.remove),
    onClick: function onClick() {
      return onRemove(item);
    }
  }));
  return displayTooltip ? /*#__PURE__*/React__default.createElement(Tooltip, {
    label: item.label,
    portal: true
  }, chipElement) : chipElement;
};

Chip.propTypes = {
  className: PropTypes__default.string,
  item: PropTypes__default.shape({
    label: PropTypes__default.string.isRequired,
    reactLabel: PropTypes__default.element,
    icon: PropTypes__default.element,
    isHeader: PropTypes__default.bool,
    value: PropTypes__default.any.isRequired,
    uncountable: PropTypes__default.bool
  }),
  onRemove: PropTypes__default.func,
  icon: PropTypes__default.element,
  value: PropTypes__default.string,
  readonly: PropTypes__default.bool,
  displayTooltip: PropTypes__default.bool
};

function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BODY_CLASS = 'modal__overflow';
var Modal = /*#__PURE__*/function (_Component) {
  inherits(Modal, _Component);

  var _super = _createSuper$m(Modal);

  function Modal() {
    var _this;

    classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.overlayElement = /*#__PURE__*/React__default.createRef();

    _this.handleClickOutside = function (e) {
      if (e.target === _this.overlayElement.current) {
        _this.onClickOutside(e);
      }
    };

    _this.onClickOutside = function (e) {
      _this.props.onClickOutside && _this.props.onClickOutside(e);
    };

    _this.handleKeyEvent = function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        _this.onClickOutside(e);
      }
    };

    return _this;
  }

  createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add(BODY_CLASS);
      document.addEventListener('keydown', this.handleKeyEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove(BODY_CLASS);
      document.removeEventListener('keydown', this.handleKeyEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          children = _this$props.children,
          modalProps = _this$props.modalProps;

      if (!open) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", _extends_1({
        className: "modalV2"
      }, modalProps), /*#__PURE__*/React__default.createElement("div", {
        className: "modalV2__overlay",
        ref: this.overlayElement,
        onClick: this.handleClickOutside
      }, children));
    }
  }]);

  return Modal;
}(Component);
Modal.propTypes = {
  onClickOutside: PropTypes__default.func,
  modalProps: PropTypes__default.object,
  open: PropTypes__default.bool
};

var css_248z$e = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__2WaOD {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_dialog__3rJZZ {\n  min-height: 7.5rem;\n  min-width: 31rem;\n  max-width: 93.75rem;\n  max-height: 62.5rem;\n  border-radius: 0.25rem;\n  position: relative;\n  background: #ffffff;\n  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.04); }\n  .index-module_dialogButtons__3DlKj {\n    display: flex;\n    align-items: center;\n    align-self: flex-end;\n    padding-right: 0.5rem; }\n    .index-module_dialogButtons__3DlKj:not(:first-child) {\n      margin-left: 1rem; }\n    .index-module_dialogButtons__3DlKj > button:not(:last-child) {\n      margin-right: 1rem; }\n  .index-module_dialogHeader__1Lh6q, .index-module_dialogContent__fpYSi {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 1.5rem; }\n  .index-module_dialogHeader__1Lh6q {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    font-size: 1.25rem;\n    line-height: 1.625rem;\n    padding-left: 2rem; }\n    .index-module_dialogHeader__1Lh6q.index-module_withBorder__3paLx {\n      border-bottom: 1px solid rgba(162, 162, 162, 0.5); }\n    .index-module_dialogHeader__1Lh6q .index-module_crossButton__214dK {\n      position: absolute;\n      top: 1.5rem;\n      right: 2rem;\n      height: 1.5rem;\n      cursor: pointer; }\n      .index-module_dialogHeader__1Lh6q .index-module_crossButton__214dK :hover {\n        background-color: #f4f4f4;\n        border-radius: 0.125rem; }\n  .index-module_dialogContent__fpYSi {\n    padding-left: 2rem; }\n  .index-module_dialogHeader__1Lh6q ~ .index-module_dialogContent__fpYSi {\n    margin-top: 4.625rem; }\n  .index-module_dialogFooter__3aonU ~ .index-module_dialogContent__fpYSi {\n    margin-bottom: 4.875rem; }\n  .index-module_dialogFooter__3aonU {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 1.5rem;\n    position: absolute;\n    bottom: 0;\n    width: 100%; }\n    .index-module_dialogFooter__3aonU.index-module_withBorder__3paLx {\n      border-top: 1px solid rgba(162, 162, 162, 0.5); }\n  .index-module_dialog__content-scrollable__1wWgr {\n    max-height: 220px;\n    min-height: 100px;\n    overflow: auto; }\n  .index-module_dialog__3rJZZ ._black {\n    color: #000000; }\n";
var styles$d = {"dialog":"index-module_dialog__3rJZZ","dialogButtons":"index-module_dialogButtons__3DlKj","dialogHeader":"index-module_dialogHeader__1Lh6q","dialogContent":"index-module_dialogContent__fpYSi","withBorder":"index-module_withBorder__3paLx","crossButton":"index-module_crossButton__214dK","dialogFooter":"index-module_dialogFooter__3aonU","dialog__content-scrollable":"index-module_dialog__content-scrollable__1wWgr","hover-ripples":"index-module_hover-ripples__2WaOD"};
styleInject(css_248z$e);

var Dialog = function Dialog(props) {
  var handleEnterKeyEvent = props.handleEnterKeyEvent,
      open = props.open,
      className = props.className,
      children = props.children,
      onClickOutside = props.onClickOutside,
      onCrossButtonClick = props.onCrossButtonClick,
      modalProps = props.modalProps,
      actionButtons = props.actionButtons,
      headerFooterBorders = props.headerFooterBorders,
      dialogTitle = props.dialogTitle,
      crossButton = props.crossButton,
      footerLeft = props.footerLeft,
      waitScreenContent = props.waitScreenContent;
  useEffect(function () {
    var setBodyStyle = function setBodyStyle() {
      return new Promise(function () {
        var observer = new MutationObserver(function () {
          var dialogElement = document.getElementById('dialogV2');

          if (dialogElement) {
            var _document, _document$documentEle, _window;

            var viewportHeight = Math.max(((_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientHeight) || 0, ((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) || 0);
            var dialogHeight = document.getElementById('dialogV2').clientHeight;

            if (dialogHeight <= viewportHeight) {
              document.body.style.overflow = 'hidden';
            }
          } else if (document.getElementsByTagName('body')[0].style.overflow === 'hidden') {
            document.body.style.overflow = 'visible';
          }
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    };

    setBodyStyle();
  }, []);
  var handleKeydown = useCallback(function (e) {
    if (!open || !(e.key === 'Enter')) {
      return;
    }

    handleEnterKeyEvent();
  }, [handleEnterKeyEvent, open]);
  useEffect(function () {
    if (handleEnterKeyEvent) {
      window.addEventListener('keydown', handleKeydown);
    }

    return function () {
      if (handleEnterKeyEvent) {
        window.removeEventListener('keydown', handleKeydown);
      }
    };
  }, [handleKeydown]);
  var borderClass = useMemo(function () {
    return headerFooterBorders ? styles$d.withBorder : '';
  }, [headerFooterBorders]);

  if (!open) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Modal, {
    open: open,
    onClickOutside: onClickOutside,
    modalProps: modalProps
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dialogV2 ".concat(styles$d.dialog, " ").concat(className),
    id: "dialogV2"
  }, dialogTitle || crossButton ? /*#__PURE__*/React__default.createElement("header", {
    className: "".concat(styles$d.dialogHeader, " ").concat(borderClass)
  }, dialogTitle, crossButton ? /*#__PURE__*/React__default.createElement("span", {
    className: styles$d.crossButton,
    onClick: onCrossButtonClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close"
  })) : null) : null, actionButtons.length ? /*#__PURE__*/React__default.createElement("footer", {
    className: "".concat(styles$d.dialogFooter, " ").concat(borderClass)
  }, /*#__PURE__*/React__default.createElement("div", null, footerLeft || null), /*#__PURE__*/React__default.createElement(DialogButtons, {
    buttons: actionButtons
  })) : null, /*#__PURE__*/React__default.createElement("main", {
    className: styles$d.dialogContent
  }, waitScreenContent ? waitScreenContent : children)));
};
var DialogScrollableContent = function DialogScrollableContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "dialog__content-scrollable"
  }, /*#__PURE__*/React__default.createElement("main", {
    className: styles$d.dialogContent
  }, children));
};

var DialogButtons = function DialogButtons(_ref2) {
  var buttons = _ref2.buttons;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.dialogButtons
  }, buttons.map(function (btn, i) {
    return /*#__PURE__*/React__default.createElement(Button, _extends_1({}, btn, {
      title: "",
      key: i,
      onClick: btn.handler,
      className: btn.className || '',
      disabled: btn.disabled,
      variant: btn.variant,
      iconName: btn.iconName || '',
      iconPosition: btn.iconPosition
    }), btn.title);
  }));
};

Dialog.defaultProps = {
  className: '',
  actionButtons: [],
  headerFooterBorders: false,
  dialogTitle: '',
  crossButton: false,
  footerLeft: null,
  waitScreenContent: null
};
Dialog.propTypes = {
  open: PropTypes__default.bool.isRequired,
  handleEnterKeyEvent: PropTypes__default.func,
  onClickOutside: PropTypes__default.func,
  onCrossButtonClick: PropTypes__default.func,
  className: PropTypes__default.string,
  modalProps: PropTypes__default.object,
  actionButtons: PropTypes__default.array,
  headerFooterBorders: PropTypes__default.bool,
  dialogTitle: PropTypes__default.string,
  crossButton: PropTypes__default.bool,
  footerLeft: PropTypes__default.node,
  waitScreenContent: PropTypes__default.node | null
};
DialogButtons.propTypes = {
  buttons: PropTypes__default.array.isRequired
};

function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DefaultLogo = function DefaultLogo() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "nav-bar__circle-icon"
  }, /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null));
};

var DefaultBack = function DefaultBack(_ref) {
  var rest = _extends_1({}, _ref);

  return /*#__PURE__*/React__default.createElement(ButtonCircle, _extends_1({}, rest, {
    outline: true,
    iconName: "ArrowLeft"
  }));
};

var NavigationBar = /*#__PURE__*/function (_Component) {
  inherits(NavigationBar, _Component);

  var _super = _createSuper$n(NavigationBar);

  function NavigationBar(props) {
    var _this;

    classCallCheck(this, NavigationBar);

    _this = _super.call(this, props);
    _this.preventOutsideClick = false;

    _this.handleClickOutsideProfile = function (e) {
      if (_this.profile && !_this.profile.contains(e.target) && _this.state.open && !_this.preventOutsideClick) {
        _this.togglePopup();
      }

      _this.preventOutsideClick = false;
    };

    _this.togglePopup = function () {
      var preventOutside = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var open = _this.state.open;

      _this.setState({
        open: !open
      });

      _this.preventOutsideClick = preventOutside;
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  createClass(NavigationBar, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['backButton', 'className', 'title', 'leftActions', 'rightActions', 'leftLogo', 'profileLogo', 'profileAvatar'], this.props, nextProps) && isEqual(['open'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutsideProfile);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutsideProfile);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          backButton = _this$props.backButton,
          backHandler = _this$props.backHandler,
          title = _this$props.title,
          leftLogo = _this$props.leftLogo,
          profileLogo = _this$props.profileLogo,
          profileAvatar = _this$props.profileAvatar,
          popupContent = _this$props.popupContent,
          children = _this$props.children,
          titleTooltip = _this$props.titleTooltip,
          isElevated = _this$props.isElevated;
      var backComponent = null;

      if (backButton) {
        if ( /*#__PURE__*/React__default.isValidElement(backButton)) {
          backComponent = backButton;
        } else {
          backComponent = /*#__PURE__*/React__default.createElement(DefaultBack, {
            onClick: backHandler
          });
        }
      }

      var open = this.state.open;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "nav-bar ".concat(className, " ").concat(isElevated ? 'nav-bar_elevated' : '')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "nav-bar__container"
      }, backComponent, /*#__PURE__*/React__default.createElement(Tooltip, {
        label: titleTooltip,
        className: "d-flex align-items-center",
        style: {
          userSelect: 'none'
        }
      }, leftLogo, /*#__PURE__*/React__default.createElement("h5", {
        className: "nav-bar__title"
      }, title)), /*#__PURE__*/React__default.createElement("div", {
        className: "nav-bar__content"
      }, children), /*#__PURE__*/React__default.createElement("div", {
        className: "nav-bar__right"
      }, /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this2.profile = el;
        },
        className: "nav-bar__profile ".concat(open ? '_focus' : '')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "nav-bar__profile-container",
        onClick: this.togglePopup
      }, profileLogo, profileAvatar), /*#__PURE__*/React__default.createElement("div", {
        className: "nav-bar__popup ".concat(open ? '_show' : '')
      }, popupContent(open))))));
    }
  }]);

  return NavigationBar;
}(Component);
NavigationBar.defaultProps = {
  backButton: true,
  backHandler: function backHandler() {},
  className: '',
  leftLogo: /*#__PURE__*/React__default.createElement(DefaultLogo, null),
  profileLogo: /*#__PURE__*/React__default.createElement(Logo, {
    animate: false,
    className: "nav-bar__profile-logo"
  }),
  profileAvatar: /*#__PURE__*/React__default.createElement("div", {
    className: "nav-bar__profile-avatar"
  }),
  popupContent: function popupContent() {
    return null;
  },
  titleTooltip: '',
  isElevated: false
};
NavigationBar.propTypes = {
  className: PropTypes__default.string,
  backButton: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.element]),
  backHandler: PropTypes__default.func,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  leftLogo: PropTypes__default.element,
  profileLogo: PropTypes__default.element,
  profileAvatar: PropTypes__default.element,
  popupContent: PropTypes__default.element,
  titleTooltip: PropTypes__default.string,
  isElevated: PropTypes__default.bool
};

function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Pagination = /*#__PURE__*/function (_PureComponent) {
  inherits(Pagination, _PureComponent);

  var _super = _createSuper$o(Pagination);

  function Pagination() {
    var _this;

    classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleOnChange = function (e, pageNumber) {
      e.preventDefault();
      var onChange = _this.props.onChange;
      onChange && onChange(pageNumber);
    };

    _this.handlePrev = function (e) {
      e.preventDefault();
      _this.hasPrev && _this.handleOnChange(e, 1);
    };

    _this.handleNext = function (e) {
      e.preventDefault();
      _this.hasNext && _this.handleOnChange(e, _this.pagesLength);
    };

    return _this;
  }

  createClass(Pagination, [{
    key: "pagesLength",
    get: function get() {
      var _this$props = this.props,
          itemsCountPerPage = _this$props.itemsCountPerPage,
          totalItemsCount = _this$props.totalItemsCount;
      return Math.ceil(totalItemsCount / itemsCountPerPage);
    }
  }, {
    key: "hasPrev",
    get: function get() {
      var activePage = this.props.activePage;
      return activePage > 1;
    }
  }, {
    key: "hasNext",
    get: function get() {
      var activePage = this.props.activePage;
      return activePage < this.pagesLength;
    }
  }, {
    key: "getRange",
    value: function getRange() {
      var _this$props2 = this.props,
          pageRangeDisplayed = _this$props2.pageRangeDisplayed,
          activePage = _this$props2.activePage;
      var pagesLength = this.pagesLength;
      var middlePages = Math.floor(pageRangeDisplayed / 2);
      var startShift = 0;
      var endShift = 0;
      var start;
      var end;

      if (pagesLength <= pageRangeDisplayed) {
        start = 1;
        end = pagesLength;
      } else {
        start = Math.max(activePage - middlePages, 1);

        if (activePage - middlePages < 1) {
          endShift += Math.abs(activePage - middlePages) + 1;
        }

        end = Math.min(activePage + middlePages, pagesLength);

        if (activePage + middlePages > pagesLength) {
          startShift -= Math.abs(activePage + middlePages - pagesLength);
        }
      }

      var pages = [];

      for (var ii = start + startShift; ii <= end + endShift; ii++) {
        pages.push(ii);
      }

      return pages;
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this2 = this;

      var activePage = this.props.activePage;
      var pages = this.getRange();
      return pages.map(function (number) {
        var active = number === activePage;
        return /*#__PURE__*/React__default.createElement("li", {
          key: number,
          className: "pagination__item ".concat(active ? 'pagination__item_active' : '')
        }, active ? /*#__PURE__*/React__default.createElement("span", {
          className: "pagination__link"
        }, number) : /*#__PURE__*/React__default.createElement("a", {
          href: "/",
          onClick: function onClick(e) {
            return _this2.handleOnChange(e, number);
          },
          className: "pagination__link"
        }, number));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "pagination"
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: "pagination__list"
      }, /*#__PURE__*/React__default.createElement("li", {
        className: "pagination__item ".concat(!this.hasPrev ? 'pagination__item_disabled' : '')
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "pagination__link pagination__link_control",
        href: "/",
        onClick: this.handlePrev
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Left"
      }))), this.renderPages(), /*#__PURE__*/React__default.createElement("li", {
        className: "pagination__item ".concat(!this.hasNext ? 'pagination__item_disabled' : '')
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "pagination__link pagination__link_control",
        href: "/",
        onClick: this.handleNext
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Right"
      })))));
    }
  }]);

  return Pagination;
}(PureComponent);
Pagination.defaultProps = {
  itemsCountPerPage: 10,
  activePage: 1,
  pageRangeDisplayed: 5
};
Pagination.propTypes = {
  activePage: PropTypes__default.number.isRequired,
  totalItemsCount: PropTypes__default.number.isRequired,
  itemsCountPerPage: PropTypes__default.number.isRequired,
  onChange: PropTypes__default.func.isRequired,
  pageRangeDisplayed: PropTypes__default.number
};

function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContextMenuComponent = /*#__PURE__*/function (_PureComponent) {
  inherits(ContextMenuComponent, _PureComponent);

  var _super = _createSuper$p(ContextMenuComponent);

  function ContextMenuComponent(props) {
    var _this;

    classCallCheck(this, ContextMenuComponent);

    _this = _super.call(this, props);

    _this.calcPosition = function () {
      var _this$props = _this.props,
          clientX = _this$props.clientX,
          clientY = _this$props.clientY;

      var menuCoord = _this.menu.getBoundingClientRect();

      var clientWidth = window.innerWidth;
      var clientHeight = window.innerHeight;
      var diffX = clientWidth - (menuCoord.width + clientX);
      var diffY = clientHeight - (menuCoord.height + clientY);

      _this.setState({
        position: {
          left: "".concat(diffX < 0 ? clientX + diffX : clientX, "px"),
          top: "".concat(diffY < 0 ? clientY + diffY : clientY, "px")
        }
      });
    };

    _this.state = {
      position: {
        left: 0,
        top: 0
      }
    };
    return _this;
  }

  createClass(ContextMenuComponent, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.onClose();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calcPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clientX !== this.props.clientX || prevProps.clientY !== this.props.clientY) {
        this.calcPosition();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          children = _this$props2.children;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "context-menu ".concat(className),
        ref: function ref(el) {
          return _this2.menu = el;
        },
        style: this.state.position
      }, children);
    }
  }]);

  return ContextMenuComponent;
}(PureComponent);

var ContextMenu = withClickOutside(ContextMenuComponent);
ContextMenuComponent.propTypes = {
  clientX: PropTypes__default.number.isRequired,
  clientY: PropTypes__default.number.isRequired,
  onClose: PropTypes__default.func.isRequired,
  className: PropTypes__default.string
};
ContextMenu.propTypes = {
  clientX: PropTypes__default.number.isRequired,
  clientY: PropTypes__default.number.isRequired,
  onClose: PropTypes__default.func.isRequired,
  className: PropTypes__default.string
};

var ContextMenuList = function ContextMenuList(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React__default.createElement("ul", _extends_1({
    className: "context-menu__list ".concat(className)
  }, rest), children);
};
ContextMenuList.propTypes = {
  className: PropTypes__default.string
};

var ContextMenuListDivider = function ContextMenuListDivider(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rest = objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("li", _extends_1({
    className: "context-menu__list-divider ".concat(className)
  }, rest), children);
};

var ContextMenuListItem = function ContextMenuListItem(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? false : _ref$title,
      rest = objectWithoutProperties(_ref, ["className", "children", "title"]);

  var content;

  if (title) {
    content = /*#__PURE__*/React__default.createElement("div", {
      className: "context-menu__title"
    }, children);
  } else {
    content = children;
  }

  return /*#__PURE__*/React__default.createElement("li", _extends_1({
    className: "context-menu__list-item ".concat(title ? '_title' : '', " ").concat(className)
  }, rest), content);
};
ContextMenuListItem.propTypes = {
  title: PropTypes__default.bool,
  className: PropTypes__default.string
};

function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TableContextMenuComponent = /*#__PURE__*/function (_PureComponent) {
  inherits(TableContextMenuComponent, _PureComponent);

  var _super = _createSuper$q(TableContextMenuComponent);

  function TableContextMenuComponent() {
    var _this;

    classCallCheck(this, TableContextMenuComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleFreezeRows = function (number) {
      var row = _this.props.row;

      _this.props.onFreezeRow(row, number);
    };

    _this.handleFreezeColumns = function (number) {
      var column = _this.props.column;

      _this.props.onFreezeColumn(column, number);
    };

    _this.copySelected = function () {
      var _this$props = _this.props,
          copy = _this$props.copy,
          onClose = _this$props.onClose;
      var input = document.createElement('textarea');
      input.value = copy;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      onClose();
    };

    return _this;
  }

  createClass(TableContextMenuComponent, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          rowNumber = _this$props2.rowNumber,
          colNumber = _this$props2.colNumber,
          _this$props2$unsorted = _this$props2.unsortedDataLength,
          unsortedDataLength = _this$props2$unsorted === void 0 ? 0 : _this$props2$unsorted,
          _this$props2$hasTable = _this$props2.hasTableCheckboxColumn,
          hasTableCheckboxColumn = _this$props2$hasTable === void 0 ? false : _this$props2$hasTable,
          copy = _this$props2.copy;
      var rowNumberDisplay = rowNumber + 1; // starts from 0

      var colNumberDisplay = colNumber + 1; // starts from 0
      // correction of freeze columns real number

      var freezeColumnsCorrection = hasTableCheckboxColumn ? 1 : 0;
      return /*#__PURE__*/React__default.createElement(ContextMenu, {
        clientX: this.props.clientX,
        clientY: this.props.clientY,
        onClose: this.props.onClose
      }, /*#__PURE__*/React__default.createElement(ContextMenuList, null, /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        title: true
      }, "Freeze"), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(0);
        }
      }, "No rows")), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(1 + unsortedDataLength);
        }
      }, "1 Row")), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(2 + unsortedDataLength);
        }
      }, "2 Rows")), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(rowNumberDisplay <= unsortedDataLength ? unsortedDataLength + 1 : rowNumberDisplay);
        }
      }, "Up to Current Row (", rowNumberDisplay - unsortedDataLength > 0 ? rowNumberDisplay - unsortedDataLength : 1, ")")), /*#__PURE__*/React__default.createElement(ContextMenuListDivider, null), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(0);
        }
      }, "No Columns")), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(1 + freezeColumnsCorrection);
        }
      }, "1 Column")), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(2 + freezeColumnsCorrection);
        }
      }, "2 Columns")), colNumberDisplay - freezeColumnsCorrection > 0 && /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(colNumberDisplay);
        }
      }, "Up to Current Column (", colNumberDisplay - freezeColumnsCorrection, ")")), copy && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ContextMenuListDivider, null), /*#__PURE__*/React__default.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "context-menu__button",
        onClick: this.copySelected
      }, "Copy")))));
    }
  }]);

  return TableContextMenuComponent;
}(PureComponent);

var TableContextMenu = withClickOutside(TableContextMenuComponent);
TableContextMenuComponent.propTypes = {
  row: PropTypes__default.object,
  rowNumber: PropTypes__default.number,
  colNumber: PropTypes__default.number,
  clientX: PropTypes__default.number,
  clientY: PropTypes__default.number,
  onClose: PropTypes__default.func,
  onFreezeRow: PropTypes__default.func,
  onFreezeColumn: PropTypes__default.func,
  unsortedDataLength: PropTypes__default.number,
  hasTableCheckboxColumn: PropTypes__default.bool
};

var tablePropTypes = {
  paging: PropTypes__default.shape({
    activePage: PropTypes__default.number.isRequired,
    totalItemsCount: PropTypes__default.number.isRequired,
    itemsCountPerPage: PropTypes__default.oneOf([10, 25, 50, 100]).isRequired,
    pageRangeDisplayed: PropTypes__default.number
  }),
  body: PropTypes__default.arrayOf(PropTypes__default.shape({
    key: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func, PropTypes__default.number]),
    hover: PropTypes__default.func,
    className: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func]),
    classNameHover: PropTypes__default.string
  })),
  header: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.elementType]),
    className: PropTypes__default.string,
    sortingKey: PropTypes__default.string,
    compareFunc: PropTypes__default.func,
    draggableGroup: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number])
  })),
  freeze: PropTypes__default.shape({
    rows: PropTypes__default.number,
    columns: PropTypes__default.number
  }),
  sorting: PropTypes__default.shape({
    field: PropTypes__default.string,
    direction: PropTypes__default.oneOf(['asc', 'desc']),
    compareFunc: PropTypes__default.func
  })
};

function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TablePaging = /*#__PURE__*/function (_Component) {
  inherits(TablePaging, _Component);

  var _super = _createSuper$r(TablePaging);

  function TablePaging() {
    var _this;

    classCallCheck(this, TablePaging);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.perPageValues = [10, 25, 50, 100].map(function (v) {
      return {
        label: v,
        value: v
      };
    });
    _this.perPageMap = {
      10: _this.perPageValues[0],
      25: _this.perPageValues[1],
      50: _this.perPageValues[2],
      100: _this.perPageValues[3]
    };

    _this.handlePaginationChange = function (page) {
      _this.props.onPaginationChanged(page);
    };

    _this.handlePerPageChange = function (data) {
      _this.props.onPerPageChanged(data);
    };

    return _this;
  }

  createClass(TablePaging, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(nextProps.paging === this.props.paging);
    }
  }, {
    key: "render",
    value: function render() {
      var paging = this.props.paging;
      var itemsCountPerPage = paging.itemsCountPerPage,
          totalItemsCount = paging.totalItemsCount;
      var showPagination = itemsCountPerPage < totalItemsCount;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "table__paging"
      }, showPagination && /*#__PURE__*/React__default.createElement(Pagination, _extends_1({}, paging, {
        onChange: this.handlePaginationChange
      })), /*#__PURE__*/React__default.createElement(Select, {
        options: this.perPageValues,
        value: this.perPageMap[paging.itemsCountPerPage],
        onChange: this.handlePerPageChange
      }));
    }
  }]);

  return TablePaging;
}(Component);
TablePaging.propTypes = {
  paging: tablePropTypes.paging,
  onPaginationChanged: PropTypes__default.func.isRequired,
  onPerPageChanged: PropTypes__default.func.isRequired
};

function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableHeader = /*#__PURE__*/function (_Component) {
  inherits(TableHeader, _Component);

  var _super = _createSuper$s(TableHeader);

  function TableHeader() {
    classCallCheck(this, TableHeader);

    return _super.apply(this, arguments);
  }

  createClass(TableHeader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(nextProps.title === this.props.title && nextProps.fixedHeader === this.props.fixedHeader && nextProps.paging === this.props.paging);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          _this$props$fixedHead = _this$props.fixedHeader,
          fixedHeader = _this$props$fixedHead === void 0 ? '' : _this$props$fixedHead,
          innerRef = _this$props.innerRef,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          paging = _this$props.paging,
          onPaginationChanged = _this$props.onPaginationChanged,
          onPerPageChanged = _this$props.onPerPageChanged;
      var classNames = ['table__header', fixedHeader ? 'table__header_fixed' : ''];
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames.join(' ').trim(),
        ref: innerRef,
        style: style
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "table__top"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "table__title title-card"
      }, title), paging && /*#__PURE__*/React__default.createElement(TablePaging, {
        paging: paging,
        onPaginationChanged: onPaginationChanged,
        onPerPageChanged: onPerPageChanged
      })));
    }
  }]);

  return TableHeader;
}(Component);
TableHeader.propTypes = {
  title: PropTypes__default.string,
  fixedHeader: PropTypes__default.bool,
  innerRef: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
    current: PropTypes__default.instanceOf(window.Element)
  })]),
  style: PropTypes__default.object,
  paging: tablePropTypes.paging,
  onPaginationChanged: PropTypes__default.func.isRequired,
  onPerPageChanged: PropTypes__default.func.isRequired
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TdInner = function TdInner(_ref) {
  var children = _ref.children,
      tooltip = _ref.tooltip,
      isUnsorted = _ref.isUnsorted,
      tbodyRowHeight = _ref.tbodyRowHeight;
  var tdContentProps = {
    style: {
      height: "".concat(tbodyRowHeight, "px")
    },
    className: 'td-content'
  };
  return tooltip && !isUnsorted ? /*#__PURE__*/React__default.createElement(Tooltip, _extends_1({}, tdContentProps, {
    label: tooltip
  }), children) : /*#__PURE__*/React__default.createElement("div", tdContentProps, children);
};

var TableCell = /*#__PURE__*/function (_Component) {
  inherits(TableCell, _Component);

  var _super = _createSuper$t(TableCell);

  function TableCell() {
    var _this;

    classCallCheck(this, TableCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isTdClicked: false,
      hasTitle: undefined
    };

    _this.handleTdClick = function () {
      if (_this.props.field.click && !_this.state.isTdClicked) {
        _this.setState({
          isTdClicked: true
        }, function () {
          window.addEventListener('click', _this.handleWindowClick);
          window.addEventListener('keydown', _this.handleKeyDown);
          _this.innerClickElement && _this.innerClickElement.focus();
        });
      }
    };

    _this.handleWindowClick = function (_ref2) {
      var target = _ref2.target;

      if (!(target === _this.td || _this.td.contains(target))) {
        _this.deactivateCell();
      }
    };

    _this.deactivateCell = function () {
      window.removeEventListener('click', _this.handleWindowClick);
      window.removeEventListener('keydown', _this.handleKeyDown);

      _this.setState({
        isTdClicked: false
      });
    };

    _this.handleKeyDown = function (e) {
      if (e.key === 'Escape' || e.key === 'Enter') {
        _this.deactivateCell();
      }
    };

    _this.handleMouseEnter = function () {
      _this.setTitle();
    };

    _this.setTitle = function () {
      if (_this.tdElement && _this.tdElement.offsetWidth < _this.tdElement.scrollWidth) {
        !_this.state.hasTitle && _this.setState({
          hasTitle: true
        });
      } else {
        _this.state.hasTitle && _this.setState({
          hasTitle: false
        });
      }
    };

    return _this;
  }

  createClass(TableCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var isTotalCheckboxEqual = true;

      if (this.props.data.total) {
        isTotalCheckboxEqual = isEqual(['isAllSelected', 'isSomeSelected'], this.props, nextProps);
      }

      return !(isEqual(['field', 'data', 'colIndex', 'onContextMenu', 'rowIndex', 'freezeColumns', 'tdOnMouseOver', 'tdOnMouseLeave', 'isSkeleton', 'tbodyRowHeight'], this.props, nextProps) && isEqual(['isTdClicked', 'hasTitle'], this.state, nextState) && isTotalCheckboxEqual);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          field = _this$props.field,
          data = _this$props.data,
          colIndex = _this$props.colIndex,
          _onContextMenu = _this$props.onContextMenu,
          rowIndex = _this$props.rowIndex,
          freezeColumns = _this$props.freezeColumns,
          tdOnMouseOver = _this$props.tdOnMouseOver,
          tdOnMouseLeave = _this$props.tdOnMouseLeave,
          isSkeleton = _this$props.isSkeleton,
          tbodyRowHeight = _this$props.tbodyRowHeight,
          theadRowHeight = _this$props.theadRowHeight;
      var _this$state = this.state,
          isTdClicked = _this$state.isTdClicked,
          hasTitle = _this$state.hasTitle;
      var classNames = [];

      if (field.className) {
        classNames.push(typeof field.className === 'function' ? field.className(data, field) : field.className);
      }

      if (isTdClicked) {
        classNames.push('_clicked');
      }

      var isUnsorted = data.rowClassName && data.rowClassName.indexOf('tr-unsorted') !== -1;
      var cellHeight = isUnsorted ? theadRowHeight : tbodyRowHeight;
      var childrenProps = {};
      var clickElement;

      if (field.click) {
        clickElement = field.click(data, field);

        if (clickElement && field.isFocusOnClick) {
          var refName = field.clickFocusRefPropName || 'ref';
          childrenProps = defineProperty({}, refName, function (el) {
            _this2.innerClickElement = el;
          });
        }
      }

      var tdContent;

      if (!isSkeleton) {
        tdContent = typeof field.key === 'function' ? field.key(data, field) : data[field.key];
      }

      var tdProps = {
        className: classNames.join(' '),
        style: {
          height: "".concat(cellHeight, "px")
        }
      };

      if (!isSkeleton) {
        tdProps = _objectSpread$7(_objectSpread$7({}, tdProps), {}, {
          ref: function ref(el) {
            _this2.td = el;
          },
          key: colIndex,
          onContextMenu: function onContextMenu(e) {
            _onContextMenu(e, data, rowIndex, colIndex + freezeColumns);
          },
          onMouseOver: function onMouseOver(_ref3) {
            var target = _ref3.target;
            var el = target.closest('td'); // to overcome bug when EditableText Dialog is created through Portal

            if (el) {
              tdOnMouseOver(colIndex + freezeColumns);
            }
          },
          onMouseLeave: function onMouseLeave() {
            return tdOnMouseLeave();
          },
          onClick: this.handleTdClick,
          onMouseEnter: this.handleMouseEnter,
          title: hasTitle ? typeof tdContent === 'string' ? tdContent : undefined : undefined
        });
      }

      var tdContentProps = {
        style: {
          height: "".concat(cellHeight, "px")
        }
      };
      return /*#__PURE__*/React__default.createElement("td", tdProps, !isSkeleton ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, field.hover && /*#__PURE__*/React__default.createElement("div", _extends_1({}, tdContentProps, {
        className: "td-content _hover"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "td-content-inner"
      }, field.hover(data, field))), /*#__PURE__*/React__default.isValidElement(clickElement) && /*#__PURE__*/React__default.createElement("div", _extends_1({}, tdContentProps, {
        className: "td-content _click"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "td-content-inner"
      }, /*#__PURE__*/React__default.cloneElement(clickElement, childrenProps))), /*#__PURE__*/React__default.createElement(TdInner, {
        tooltip: field.tooltip,
        isUnsorted: isUnsorted,
        tbodyRowHeight: cellHeight
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "td-content-inner",
        ref: function ref(el) {
          _this2.tdElement = el;
        }
      }, tdContent))) : /*#__PURE__*/React__default.createElement(TdInner, {
        tbodyRowHeight: cellHeight
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "td-content-inner",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "skeleton-block",
        style: {
          width: '100%',
          height: "".concat(17 / 16, "rem")
        }
      }))));
    }
  }]);

  return TableCell;
}(Component);
TdInner.propTypes = {
  tooltip: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  isUnsorted: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number
};
TableCell.propTypes = {
  rowIndex: PropTypes__default.number,
  data: PropTypes__default.any,
  onContextMenu: PropTypes__default.func,
  colIndex: PropTypes__default.number,
  freezeColumns: PropTypes__default.number,
  tdOnMouseOver: PropTypes__default.func,
  tdOnMouseLeave: PropTypes__default.func,
  field: PropTypes__default.object,
  isSkeleton: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number,
  theadRowHeight: PropTypes__default.number
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$u(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$u(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableRow = /*#__PURE__*/function (_Component) {
  inherits(TableRow, _Component);

  var _super = _createSuper$u(TableRow);

  function TableRow() {
    classCallCheck(this, TableRow);

    return _super.apply(this, arguments);
  }

  createClass(TableRow, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var isEqualRowIndex = true;

      if (this.props.rowIndex === this.props.hoveredRowIndex) {
        if (this.props.rowIndex !== nextProps.hoveredRowIndex) {
          isEqualRowIndex = false;
        }
      } else if (this.props.rowIndex === nextProps.hoveredRowIndex) {
        isEqualRowIndex = false;
      }

      return !(isEqual(['rowIndex', 'freezeColumns', 'onContextMenu', 'rowClickHandler', 'isAllSelected', 'isSomeSelected', 'isSkeleton'], this.props, nextProps) && isEqual$2(nextProps.data, this.props.data) && isEqual$2(nextProps.body, this.props.body) && isEqualRowIndex);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rowIndex = _this$props.rowIndex,
          data = _this$props.data,
          body = _this$props.body,
          _this$props$freezeCol = _this$props.freezeColumns,
          freezeColumns = _this$props$freezeCol === void 0 ? 0 : _this$props$freezeCol,
          onContextMenu = _this$props.onContextMenu,
          rowClickHandler = _this$props.rowClickHandler,
          hoveredRowIndex = _this$props.hoveredRowIndex,
          trOnMouseEnter = _this$props.trOnMouseEnter,
          trOnMouseLeave = _this$props.trOnMouseLeave,
          tdOnMouseOver = _this$props.tdOnMouseOver,
          tdOnMouseLeave = _this$props.tdOnMouseLeave,
          isSkeleton = _this$props.isSkeleton,
          tbodyRowHeight = _this$props.tbodyRowHeight,
          theadRowHeight = _this$props.theadRowHeight,
          isAllSelected = _this$props.isAllSelected,
          isSomeSelected = _this$props.isSomeSelected;
      var trProps;

      if (!isSkeleton) {
        trProps = {
          onClick: function onClick(e) {
            return rowClickHandler(e, data, rowIndex);
          },
          className: "".concat(hoveredRowIndex === rowIndex ? 'tr-hover' : '', " ").concat(data.rowClassName || ''),
          onMouseEnter: trOnMouseEnter,
          onMouseLeave: trOnMouseLeave
        };
      } else {
        trProps = {
          className: "loader"
        };
      }

      return /*#__PURE__*/React__default.createElement("tr", trProps, body.map(function (field, colIndex) {
        var tdProps = {
          field: field,
          data: data,
          tbodyRowHeight: tbodyRowHeight,
          theadRowHeight: theadRowHeight
        };

        if (!isSkeleton) {
          tdProps = _objectSpread$8(_objectSpread$8({}, tdProps), {}, {
            colIndex: colIndex,
            onContextMenu: onContextMenu,
            rowIndex: rowIndex,
            freezeColumns: freezeColumns,
            tdOnMouseOver: tdOnMouseOver,
            tdOnMouseLeave: tdOnMouseLeave,
            isAllSelected: isAllSelected,
            isSomeSelected: isSomeSelected
          });
        } else {
          tdProps = _objectSpread$8(_objectSpread$8({}, tdProps), {}, {
            isSkeleton: true
          });
        }

        return /*#__PURE__*/React__default.createElement(TableCell, _extends_1({}, tdProps, {
          key: colIndex
        }));
      }));
    }
  }]);

  return TableRow;
}(Component);
TableRow.propTypes = {
  body: tablePropTypes.body,
  freeze: tablePropTypes.freeze,
  rowIndex: PropTypes__default.number,
  data: PropTypes__default.any,
  onContextMenu: PropTypes__default.func,
  rowClickHandler: PropTypes__default.func,
  freezeColumns: PropTypes__default.number,
  hoveredRowIndex: PropTypes__default.number,
  trOnMouseEnter: PropTypes__default.func,
  trOnMouseLeave: PropTypes__default.func,
  tdOnMouseOver: PropTypes__default.func,
  tdOnMouseLeave: PropTypes__default.func,
  isSkeleton: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number,
  theadRowHeight: PropTypes__default.number
};

var SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};

function _createSuper$v(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$v(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableHeaderRow = /*#__PURE__*/function (_Component) {
  inherits(TableHeaderRow, _Component);

  var _super = _createSuper$v(TableHeaderRow);

  function TableHeaderRow(props) {
    var _this;

    classCallCheck(this, TableHeaderRow);

    _this = _super.call(this, props);
    _this._startDragIndex = null;
    _this._endDragIndex = null;
    _this._dragItem = null;

    _this.handleDragStart = function (item, index) {
      return function (e) {
        _this._startDragIndex = index;
        _this._dragItem = item;

        _this.setState({
          startDragIndex: index,
          draggableGroup: item.draggableGroup
        });
      };
    };

    _this.handleDragOver = function (item, index) {
      return function (e) {
        if (_this._endDragIndex === index) {
          return;
        }

        if (_this._dragItem && _this._dragItem.draggableGroup) {
          if (_this._startDragIndex !== index && _this._dragItem.draggableGroup === item.draggableGroup) {
            _this._endDragIndex = index;

            _this.setState({
              endDragIndex: index
            });
          }
        } else if (_this._startDragIndex !== index && _this._dragItem && !item.draggableGroup) {
          _this._endDragIndex = index;

          _this.setState({
            endDragIndex: index
          });
        }
      };
    };

    _this.handleDragEnd = function () {
      _this.props.onDragEnd(_this._dragItem, {
        start: _this._startDragIndex,
        end: _this._endDragIndex
      });

      _this._startDragIndex = null;
      _this._endDragIndex = null;
      _this._dragItem = null;

      _this.setState({
        startDragIndex: null,
        endDragIndex: null,
        draggableGroup: null
      });
    };

    _this.state = {
      startDragIndex: null,
      endDragIndex: null
    };
    return _this;
  }

  createClass(TableHeaderRow, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual$2(nextProps.header, this.props.header) && nextProps.sorting === this.props.sorting && nextProps.hoveredColIndex === this.props.hoveredColIndex && isEqual(['startDragIndex', 'endDragIndex'], this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          header = _this$props.header,
          sorting = _this$props.sorting,
          onSortingChanged = _this$props.onSortingChanged,
          draggable = _this$props.draggable,
          hoveredColIndex = _this$props.hoveredColIndex,
          theadRowHeight = _this$props.theadRowHeight,
          handleTheadOnMouseEnterLeave = _this$props.handleTheadOnMouseEnterLeave,
          freezeColumns = _this$props.freezeColumns,
          freezeColumnsRight = _this$props.freezeColumnsRight;
      var _this$state = this.state,
          startDragIndex = _this$state.startDragIndex,
          endDragIndex = _this$state.endDragIndex,
          draggableGroup = _this$state.draggableGroup;

      if (!header || !header.length) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("tr", null, header.map(function (h, i) {
        var className = h.className,
            label = h.label,
            tooltip = h.tooltip;
        var hasSort = sorting && h.sorting !== false && h.sortingKey;
        var sortIcon;
        var attrs = {};

        if (hasSort) {
          attrs.onClick = function () {
            return onSortingChanged(h);
          };

          if (h.sortingKey !== sorting.field) {
            sortIcon = /*#__PURE__*/React__default.createElement(Icon, {
              className: "sort-icon_default",
              name: "UnfoldMore"
            });
          } else if (sorting.direction === SORT_DIRECTION.ASC) {
            sortIcon = /*#__PURE__*/React__default.createElement(Icon, {
              className: "sort-icon_default",
              name: "ArrowUp"
            });
          } else {
            sortIcon = /*#__PURE__*/React__default.createElement(Icon, {
              className: "sort-icon_default",
              name: "ArrowDown"
            });
          }
        }

        var classNames = [className || ''];

        if (hasSort) {
          classNames.push('_sorting');
        }

        if (draggable && h.draggable !== false) {
          attrs.draggable = true;
          attrs.onDragStart = _this2.handleDragStart(h, i);
          attrs.onDragOver = _this2.handleDragOver(h, i);
          attrs.onDragEnd = _this2.handleDragEnd;

          if (endDragIndex === i) {
            classNames.push('_separator');
          }

          if (startDragIndex === i) {
            classNames.push('_hide');
          }

          if (draggableGroup && h.draggableGroup !== draggableGroup || _this2._dragItem && !draggableGroup && h.draggableGroup) {
            classNames.push('_hide');
          }

          classNames.push(startDragIndex < endDragIndex ? '_right' : '_left');
        }

        if (hoveredColIndex === i) {
          classNames.push('_th-hover');
        }

        var sortingClassName = h.sortingKey !== sorting.field ? '' : sorting.direction === SORT_DIRECTION.ASC ? '_up' : '_down';

        if (typeof label === 'function') {
          return /*#__PURE__*/React__default.createElement("td", {
            className: className,
            key: i
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "td-content"
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "td-content-inner",
            ref: function ref(el) {
              _this2.tdElement = el;
            }
          }, label())));
        }

        return /*#__PURE__*/React__default.createElement("td", _extends_1({
          className: classNames.join(' ')
        }, attrs, {
          style: {
            height: "".concat(theadRowHeight, "px")
          },
          key: i,
          onMouseEnter: tooltip ? handleTheadOnMouseEnterLeave({
            i: freezeColumnsRight || i + freezeColumns,
            text: tooltip
          }) : null,
          onMouseLeave: tooltip ? handleTheadOnMouseEnterLeave() : null
        }), /*#__PURE__*/React__default.createElement("div", {
          className: "td-content",
          style: {
            height: "".concat(theadRowHeight, "px")
          }
        }, label, sortIcon && /*#__PURE__*/React__default.createElement("div", {
          className: "td-sorting ".concat(sortingClassName)
        }, sortIcon)));
      }));
    }
  }]);

  return TableHeaderRow;
}(Component);
TableHeaderRow.propTypes = {
  header: tablePropTypes.header,
  freeze: tablePropTypes.freeze,
  sorting: tablePropTypes.sorting,
  onSortingChanged: PropTypes__default.func,
  draggable: PropTypes__default.bool,
  onDragEnd: PropTypes__default.func,
  theadRowHeight: PropTypes__default.number,
  hoveredColIndex: PropTypes__default.number,
  handleTheadOnMouseEnterLeave: PropTypes__default.func,
  freezeColumns: PropTypes__default.number,
  freezeColumnsRight: PropTypes__default.number
};

var css_248z$f = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.tableHeaderTooltip-module_tooltip__1jEpb {\n  pointer-events: none;\n  position: absolute;\n  z-index: 4;\n  transform: translateX(-50%); }\n  .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__bottom__8_32p ::before {\n    content: \"\";\n    position: absolute;\n    width: 8px;\n    height: 8px;\n    top: -1px;\n    left: calc(50% - 8px);\n    background: #ffffff;\n    transform: translate(50%, -50%) rotate(45deg);\n    border-left: 1px solid #f4f4f4;\n    border-top: 1px solid #f4f4f4; }\n  .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__left__1T9wi {\n    transform: translate(-100%, -50%); }\n    .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__left__1T9wi ::before {\n      content: \"\";\n      position: absolute;\n      width: 8px;\n      height: 8px;\n      right: 0;\n      top: 14px;\n      background: #ffffff;\n      transform: translate(50%, -50%) rotate(45deg);\n      border-right: 1px solid #f4f4f4;\n      border-top: 1px solid #f4f4f4; }\n  .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__right__SopMJ {\n    transform: translateY(-50%); }\n    .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__right__SopMJ ::before {\n      content: \"\";\n      position: absolute;\n      width: 8px;\n      height: 8px;\n      left: -8px;\n      top: 14px;\n      background: #ffffff;\n      transform: translate(50%, -50%) rotate(45deg);\n      border-left: 1px solid #f4f4f4;\n      border-bottom: 1px solid #f4f4f4; }\n";
var styles$e = {"tooltip":"tableHeaderTooltip-module_tooltip__1jEpb","_bottom":"tableHeaderTooltip-module__bottom__8_32p","_left":"tableHeaderTooltip-module__left__1T9wi","_right":"tableHeaderTooltip-module__right__SopMJ"};
styleInject(css_248z$f);

function _createSuper$w(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$w(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableHeaderTooltip = /*#__PURE__*/function (_Component) {
  inherits(TableHeaderTooltip, _Component);

  var _super = _createSuper$w(TableHeaderTooltip);

  function TableHeaderTooltip(props) {
    var _this;

    classCallCheck(this, TableHeaderTooltip);

    _this = _super.call(this);

    _this.onFontLoaded = function () {
      var font = new fontfaceobserver_standalone('Avenir Next Regular');
      font.load().then(function () {
        return _this.setLabelMaxWidth();
      }).then(function () {
        return _this.getPosition();
      });
    };

    _this.setLabelMaxWidth = function (isTooltipChanged) {
      if (isTooltipChanged === undefined || isTooltipChanged === true) {
        var contentWidth = Math.ceil(_this.tooltipLabelInner.getBoundingClientRect().width);
        contentWidth = contentWidth <= _this.labelInnerWidth ? contentWidth : _this.labelInnerWidth;

        _this.setState({
          labelInnerMaxWidth: contentWidth,
          position: 'bottom'
        });
      }
    };

    _this.labelInnerWidth = props.labelMaxWidth ? props.labelMaxWidth - 20 : 480; // 2x 10px horizontal paddings

    _this.state = {
      position: 'bottom',
      labelInnerMaxWidth: _this.labelInnerWidth
    };
    return _this;
  }

  createClass(TableHeaderTooltip, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      this.isTooltipChanged = !isEqual$2(nextProps.tooltip, this.props.tooltip);

      if (this.isTooltipChanged) {
        this.isTooltipWidthSet = false;
      } else if (!isEqual$2(nextState.labelInnerMaxWidth, this.state.labelInnerMaxWidth)) {
        this.isTooltipWidthSet = true;
      }

      this.isScrollLeftChanged = !isEqual$2(nextProps.scrollLeft, this.props.scrollLeft);
      return !(isEqual$2(nextProps.tooltip, this.props.tooltip) && isEqual$2(nextProps.cellsWidths, this.props.cellsWidths) && isEqual$2(nextProps.scrollLeft, this.props.scrollLeft) && isEqual$2(nextProps.freezeColumns, this.props.freezeColumns) && isEqual$2(nextState.position, this.state.position) && isEqual$2(nextState.labelInnerMaxWidth, this.state.labelInnerMaxWidth));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onFontLoaded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setLabelMaxWidth(this.isTooltipChanged);

      if (this.isTooltipWidthSet) {
        this.getPosition(this.isScrollLeftChanged);
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition(isScrollLeftChanged) {
      var position = isScrollLeftChanged ? 'bottom' : this.state.position;
      var coord = this.tooltipLabel.getBoundingClientRect();
      var x = coord.x,
          right = coord.right;

      if (x < 0) {
        position = 'right';
      }

      if (right > window.innerWidth) {
        position = 'left';
      }

      if (position !== this.state.position) {
        this.setState({
          position: position
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          tooltip = _this$props.tooltip,
          _this$props$cellsWidt = _this$props.cellsWidths,
          cellsWidths = _this$props$cellsWidt === void 0 ? [] : _this$props$cellsWidt,
          _this$props$scrollLef = _this$props.scrollLeft,
          scrollLeft = _this$props$scrollLef === void 0 ? 0 : _this$props$scrollLef,
          _this$props$freezeCol = _this$props.freezeColumns,
          freezeColumns = _this$props$freezeCol === void 0 ? 0 : _this$props$freezeCol,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;
      var top = this.props.top;
      var _this$state = this.state,
          position = _this$state.position,
          labelInnerMaxWidth = _this$state.labelInnerMaxWidth;
      var left = '';
      var right = 'auto';
      var positionClassName = ''; // sum of cells widths before active one

      var sumOfCellsWidthsBeforeActive = cellsWidths.slice(0, tooltip.i).reduce(function (a, b) {
        return a + b;
      }, 0); // scroll correction, assuming frozen columns

      var scrollCorrection = tooltip.i >= freezeColumns ? scrollLeft : 0;

      switch (position) {
        case 'bottom':
          left = (tooltip.i ? sumOfCellsWidthsBeforeActive : 0) + cellsWidths[tooltip.i] / 2 - // half a width of active cell
          scrollCorrection + 'px';
          positionClassName = styles$e._bottom;
          break;

        case 'left':
          top = top / 2;
          left = sumOfCellsWidthsBeforeActive - scrollCorrection + 'px';
          positionClassName = styles$e._left;
          break;

        case 'right':
          top = top / 2;
          left = (tooltip.i ? sumOfCellsWidthsBeforeActive : 0) + cellsWidths[tooltip.i] - scrollCorrection + 'px';
          positionClassName = styles$e._right;
          break;
      }

      var style = {
        top: "".concat(top, "px"),
        left: left,
        right: right
      };
      return /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this2.tooltipLabel = el;
        },
        className: "".concat(styles$e.tooltip, " td-tooltip ").concat(className, " ").concat(positionClassName, " tooltipV2__label"),
        style: style
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "tooltipV2__label-outer",
        style: {
          width: "".concat(this.labelInnerWidth, "px"),
          maxWidth: "".concat(this.isTooltipChanged ? this.labelInnerWidth : labelInnerMaxWidth, "px")
        }
      }, /*#__PURE__*/React__default.createElement("span", {
        ref: function ref(el) {
          _this2.tooltipLabelInner = el;
        },
        className: "tooltipV2__label-inner"
      }, tooltip.text)));
    }
  }]);

  return TableHeaderTooltip;
}(Component);
TableHeaderTooltip.propTypes = {
  tooltip: PropTypes__default.shape({
    i: PropTypes__default.number,
    text: PropTypes__default.string
  }),
  cellsWidths: PropTypes__default.arrayOf(PropTypes__default.number),
  top: PropTypes__default.number,
  scrollLeft: PropTypes__default.number,
  freezeColumns: PropTypes__default.number,
  className: PropTypes__default.string,
  labelMaxWidth: PropTypes__default.number
};

var getSelectionText = function getSelectionText() {
  if (window.getSelection) {
    try {
      var activeElement = document.activeElement;

      if (activeElement && activeElement.value) {
        // firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=85686
        return activeElement.value.substring(activeElement.selectionStart, activeElement.selectionEnd);
      } else {
        return window.getSelection().toString();
      }
    } catch (e) {}
  } else if (document.selection && document.selection.type !== 'Control') {
    // For IE
    return document.selection.createRange().text;
  }
};
var DEFAULT_CELL_HEIGHT = 40;

var css_248z$g = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes table-module_hover-ripples__UzUbu {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.table-module_container__1ZPhr table {\n  table-layout: fixed;\n  border-collapse: collapse;\n  padding: 0;\n  border: none; }\n\n.table-module_container__1ZPhr thead .td-content {\n  border-bottom: 1px solid rgba(203, 203, 203, 0.5);\n  background: #f4f4f4;\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.875rem; }\n\n.table-module_container__1ZPhr thead td:hover .td-content, .table-module_container__1ZPhr thead td._th-hover .td-content,\n.table-module_container__1ZPhr thead th:hover .td-content,\n.table-module_container__1ZPhr thead th._th-hover .td-content {\n  background: #f2f5ff; }\n\n.table-module_container__1ZPhr thead td:not(._hide):hover .td-content .td-tooltip,\n.table-module_container__1ZPhr thead td:not(._hide):hover .td-content .th-tooltip,\n.table-module_container__1ZPhr thead th:not(._hide):hover .td-content .td-tooltip,\n.table-module_container__1ZPhr thead th:not(._hide):hover .td-content .th-tooltip {\n  display: block; }\n\n.table-module_container__1ZPhr tbody tr:hover .td-content._hover, .table-module_container__1ZPhr tbody tr.tr-hover .td-content._hover {\n  display: flex; }\n  .table-module_container__1ZPhr tbody tr:hover .td-content._hover + .td-content, .table-module_container__1ZPhr tbody tr.tr-hover .td-content._hover + .td-content {\n    display: none; }\n\n.table-module_container__1ZPhr tbody tr:nth-child(even) .td-content .skeleton-block {\n  background-image: linear-gradient(90deg, #dddddd 0px, #e9e8e8 2rem, #dddddd 4rem); }\n\n.table-module_container__1ZPhr tbody tr:first-child .td-content {\n  border-top-width: 0; }\n\n.table-module_container__1ZPhr tbody tr.tr-unsorted .td-content {\n  border-color: rgba(203, 203, 203, 0.5);\n  background: #f4f4f4;\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 0.875rem; }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):last-child .td-content {\n  border-bottom: 1px solid rgba(203, 203, 203, 0.5); }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):hover .td-content, .table-module_container__1ZPhr tbody tr:not(.tr-unsorted).tr-hover .td-content {\n  background-color: #f2f5ff; }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):hover td:first-child .td-content, .table-module_container__1ZPhr tbody tr:not(.tr-unsorted).tr-hover td:first-child .td-content {\n  border-left-color: rgba(203, 203, 203, 0.5); }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):hover td:first-child._checkbox + td .td-content, .table-module_container__1ZPhr tbody tr:not(.tr-unsorted).tr-hover td:first-child._checkbox + td .td-content {\n  border-left-color: rgba(203, 203, 203, 0.5); }\n\n.table-module_container__1ZPhr tbody tr._selected td .td-content, .table-module_container__1ZPhr tbody tr._selected:hover td .td-content, .table-module_container__1ZPhr tbody tr._selected.tr-hover td .td-content {\n  background: #ebeeff !important; }\n\n.table-module_container__1ZPhr tbody tr._selected td._checkbox:first-child + td .td-content, .table-module_container__1ZPhr tbody tr._selected:hover td._checkbox:first-child + td .td-content, .table-module_container__1ZPhr tbody tr._selected.tr-hover td._checkbox:first-child + td .td-content {\n  position: relative; }\n\n.table-module_container__1ZPhr tbody tr._selected:not(:last-child) td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._selected:hover:not(:last-child) td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._selected.tr-hover:not(:last-child) td:not(._checkbox) .td-content {\n  position: relative; }\n\n.table-module_container__1ZPhr tbody tr._excluded td:not(._checkbox) .td-content {\n  background: linear-gradient(to right, rgba(255, 88, 89, 0.1) 0%, rgba(255, 88, 89, 0.1) 100%), linear-gradient(to right, #ffffff 0%, #ffffff 100%) !important; }\n\n.table-module_container__1ZPhr tbody tr._excluded:hover td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._excluded.tr-hover td:not(._checkbox) .td-content {\n  background: linear-gradient(to right, rgba(255, 88, 89, 0.2) 0%, rgba(255, 88, 89, 0.2) 100%), linear-gradient(to right, #ffffff 0%, #ffffff 100%) !important; }\n\n.table-module_container__1ZPhr tbody tr._excluded:hover:not(._selected) td._checkbox:first-child ~ td:not(:nth-child(2)) .td-content, .table-module_container__1ZPhr tbody tr._excluded.tr-hover:not(._selected) td._checkbox:first-child ~ td:not(:nth-child(2)) .td-content {\n  border-left-color: #ffdede !important; }\n\n.table-module_container__1ZPhr td,\n.table-module_container__1ZPhr th {\n  padding: 0;\n  min-width: 100px;\n  width: 300px;\n  max-width: 300px;\n  border: none; }\n  .table-module_container__1ZPhr td:last-child .td-content,\n  .table-module_container__1ZPhr th:last-child .td-content {\n    border-right: 1px solid rgba(203, 203, 203, 0.5); }\n  .table-module_container__1ZPhr td._sorting .td-content,\n  .table-module_container__1ZPhr th._sorting .td-content {\n    cursor: pointer; }\n  .table-module_container__1ZPhr td._checkbox,\n  .table-module_container__1ZPhr th._checkbox {\n    min-width: 44px;\n    width: 44px;\n    max-width: 44px; }\n  .table-module_container__1ZPhr td._clicked .td-content._click,\n  .table-module_container__1ZPhr th._clicked .td-content._click {\n    display: flex; }\n    .table-module_container__1ZPhr td._clicked .td-content._click + .td-content,\n    .table-module_container__1ZPhr th._clicked .td-content._click + .td-content {\n      display: none; }\n\n.table-module_container__1ZPhr .td-content {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  height: 100%;\n  border-top: 1px solid rgba(203, 203, 203, 0.5);\n  border-left: 1px solid rgba(203, 203, 203, 0.5);\n  background: #ffffff;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.875rem;\n  line-height: 1.21429em;\n  color: #2b2b2b;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n  .table-module_container__1ZPhr .td-content._hover {\n    display: none; }\n  .table-module_container__1ZPhr .td-content._click {\n    display: none; }\n    .table-module_container__1ZPhr .td-content._click + .td-content {\n      cursor: pointer; }\n  .table-module_container__1ZPhr .td-content .td-sorting {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: auto;\n    width: 0.5rem;\n    line-height: 0; }\n    .table-module_container__1ZPhr .td-content .td-sorting._up, .table-module_container__1ZPhr .td-content .td-sorting._down {\n      width: 0.75rem; }\n    .table-module_container__1ZPhr .td-content .td-sorting:not(._up):not(._down) {\n      visibility: hidden; }\n    .table-module_container__1ZPhr .td-content .td-sorting .sort-icon_default {\n      flex: 0 0 1rem;\n      margin-left: auto;\n      height: auto;\n      fill: #787878; }\n  .table-module_container__1ZPhr .td-content:hover .td-sorting:not(._up):not(._down) {\n    visibility: visible; }\n\n.table-module_container__1ZPhr .td-content-inner {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.table-module_container__1ZPhr .td-tooltip._css,\n.table-module_container__1ZPhr .th-tooltip._css {\n  display: none; }\n\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg td:last-child .td-content,\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg th:last-child .td-content {\n  border-right: 2px solid #a2a2a2; }\n\n.table-module_container__1ZPhr .table-module_containerRightMost__3FCIF td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerRightMost__3FCIF th:first-child .td-content {\n  border-left: 2px solid #a2a2a2; }\n\n.table-module_container__1ZPhr .table-module_containerRightMost__3FCIF tbody tr:not(.tr-unsorted):hover td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerRightMost__3FCIF tbody tr:not(.tr-unsorted):hover th:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerRightMost__3FCIF tbody tr:not(.tr-unsorted).tr-hover td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerRightMost__3FCIF tbody tr:not(.tr-unsorted).tr-hover th:first-child .td-content {\n  border-left: 2px solid #a2a2a2; }\n\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg + .table-module_containerRight__2tD1U td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg + .table-module_containerRight__2tD1U th:first-child .td-content {\n  border-left-width: 0; }\n\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 tbody tr:not(.tr-unsorted):last-child .td-content {\n  border-bottom: 2px solid #a2a2a2; }\n\n.table-module_containerTable__EaneQ._odd-stripes tbody tr:not(.tr-unsorted):not(.tr-hover):not(:hover) .td-content {\n  background: #ffffff; }\n\n.table-module_containerTable__EaneQ._odd-stripes tbody tr:not(.tr-unsorted):not(.tr-hover):not(:hover):nth-child(odd) .td-content .skeleton-block {\n  background-image: linear-gradient(90deg, #dddddd 0px, #e9e8e8 2rem, #dddddd 4rem); }\n\n.table-module_containerTable__EaneQ {\n  position: relative; }\n  .table-module_containerTableProgress__1ltyG {\n    pointer-events: none;\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    right: 0;\n    transition: background-image 0.25s; }\n\n.table-module_containerUp__2Qe14 {\n  position: -webkit-sticky;\n  /* Safari */\n  position: sticky;\n  z-index: 3;\n  top: 0;\n  display: flex;\n  align-items: flex-start;\n  background: #ffffff; }\n  .table-module_containerUp__2Qe14 .table-module_containerLeft__2m5Kg table {\n    overflow: hidden; }\n\n.table-module_containerDown__3fMpr {\n  position: relative;\n  top: 0;\n  overflow: auto;\n  display: flex;\n  align-items: flex-start; }\n\n.table-module_containerLeft__2m5Kg {\n  flex: 0 1 auto; }\n\n.table-module_containerRight__2tD1U {\n  flex: 0 1 auto;\n  overflow: hidden; }\n  .table-module_containerRightScroller__g3_OG {\n    overflow: auto; }\n\n.table-module_container__1ZPhr .td-content {\n  position: relative; }\n\n.table-module_container__1ZPhr._dnd td._hide .td-content,\n.table-module_container__1ZPhr._dnd th._hide .td-content {\n  opacity: 0.3; }\n\n.table-module_container__1ZPhr._dnd td._separator .td-content:before,\n.table-module_container__1ZPhr._dnd th._separator .td-content:before {\n  content: '';\n  position: absolute;\n  width: 4px;\n  height: 100%;\n  background-color: #798eff; }\n\n.table-module_container__1ZPhr._dnd td._separator._left .td-content:before,\n.table-module_container__1ZPhr._dnd th._separator._left .td-content:before {\n  left: 0; }\n\n.table-module_container__1ZPhr._dnd td._separator._right .td-content:before,\n.table-module_container__1ZPhr._dnd th._separator._right .td-content:before {\n  right: 0; }\n\n.table-module_scroller__HSsUm {\n  position: absolute;\n  z-index: 3;\n  bottom: 0;\n  right: 0;\n  height: 20px;\n  transform: translateY(100%);\n  overflow: auto;\n  opacity: 0.5;\n  transition: opacity 0.25s; }\n  .table-module_scroller__HSsUm:hover {\n    opacity: 1; }\n    .table-module_scroller__HSsUm:hover::-webkit-scrollbar {\n      height: 10px; }\n    .table-module_scroller__HSsUm:hover::-webkit-scrollbar-thumb {\n      height: 10px; }\n  .table-module_scroller__HSsUm._fixed {\n    position: fixed;\n    bottom: 40px;\n    right: auto; }\n  .table-module_scroller__HSsUm::-webkit-scrollbar {\n    -webkit-appearance: none;\n    height: 6px; }\n  .table-module_scroller__HSsUm::-webkit-scrollbar-thumb {\n    height: 6px;\n    border-radius: 5px;\n    background-color: rgba(0, 0, 0, 0.5); }\n  .table-module_scrollerPlaceholder__1PQ0_ {\n    height: 1px; }\n\n.table-module_iframe__2_uWF {\n  display: block;\n  margin: 0;\n  width: 100%;\n  height: 0;\n  border: 0; }\n\n.table-module_tooltipWrapper__2rDL_ {\n  position: -webkit-sticky;\n  /* Safari */\n  position: sticky;\n  z-index: 25; }\n\n.table-module_overflowYHidden__1VvU_ {\n  overflow-y: hidden; }\n";
var styles$f = {"container":"table-module_container__1ZPhr","containerLeft":"table-module_containerLeft__2m5Kg","containerRightMost":"table-module_containerRightMost__3FCIF","containerRight":"table-module_containerRight__2tD1U","containerUp":"table-module_containerUp__2Qe14","containerTable":"table-module_containerTable__EaneQ","containerTableProgress":"table-module_containerTableProgress__1ltyG","containerDown":"table-module_containerDown__3fMpr","containerRightScroller":"table-module_containerRightScroller__g3_OG","scroller":"table-module_scroller__HSsUm","scrollerPlaceholder":"table-module_scrollerPlaceholder__1PQ0_","iframe":"table-module_iframe__2_uWF","tooltipWrapper":"table-module_tooltipWrapper__2rDL_","overflowYHidden":"table-module_overflowYHidden__1VvU_","hover-ripples":"table-module_hover-ripples__UzUbu"};
styleInject(css_248z$g);

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$x(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$x(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Table = /*#__PURE__*/function (_Component) {
  inherits(Table, _Component);

  var _super = _createSuper$x(Table);

  function Table(props) {
    var _this;

    classCallCheck(this, Table);

    _this = _super.call(this, props);

    _this.onFontLoaded = function () {
      var font = new fontfaceobserver_standalone('Avenir Next Regular');
      font.load().then(function () {
        _this.syncWidths();
      });
    };

    _this.tableHeaderElement = /*#__PURE__*/React__default.createRef();

    _this.onTableChanged = function () {
      if (_this.props.onChange) {
        var _this$state = _this.state,
            sorting = _this$state.sorting,
            paging = _this$state.paging;

        _this.props.onChange({
          sorting: sorting,
          paging: paging
        });
      }
    };

    _this.handleContextMenu = function (event, row, rowNumber, colNumber) {
      event.preventDefault();

      _this.setState({
        contextMenu: {
          row: row,
          rowNumber: rowNumber,
          colNumber: colNumber,
          clientX: event.clientX,
          clientY: event.clientY,
          copy: getSelectionText()
        }
      });
    };

    _this.renderBodyRow = function (data, rowIndex, body, freezeColumns) {
      var _this$props = _this.props,
          tbodyRowHeight = _this$props.tbodyRowHeight,
          theadRowHeight = _this$props.theadRowHeight,
          rowKeyExtractor = _this$props.rowKeyExtractor,
          rowClickHandler = _this$props.rowClickHandler;
      var _this$state2 = _this.state,
          hoveredRowIndex = _this$state2.hoveredRowIndex,
          freeze = _this$state2.freeze;
      return /*#__PURE__*/React__default.createElement(TableRow, {
        data: data,
        body: body,
        rowIndex: rowIndex,
        key: rowKeyExtractor(data, rowIndex),
        onContextMenu: _this.handleContextMenu,
        rowClickHandler: rowClickHandler,
        freezeColumns: freezeColumns,
        hoveredRowIndex: hoveredRowIndex,
        trOnMouseEnter: freeze.columns > 0 || freeze.columnsRight ? _this.setHoveredRowIndex(rowIndex) : null,
        trOnMouseLeave: freeze.columns > 0 || freeze.columnsRight ? _this.setHoveredRowIndex(null) : null,
        tdOnMouseOver: _this.setHoveredColIndex,
        tdOnMouseLeave: _this.setHoveredColIndex,
        tbodyRowHeight: tbodyRowHeight,
        theadRowHeight: theadRowHeight,
        isAllSelected: _this.isAllSelected,
        isSomeSelected: _this.isSomeSelected
      });
    };

    _this.setHoveredRowIndex = function (hoveredRowIndex) {
      return function () {
        return _this.setState({
          hoveredRowIndex: hoveredRowIndex
        });
      };
    };

    _this.setHoveredColIndex = function (hoveredColIndex) {
      return _this.setState({
        hoveredColIndex: hoveredColIndex
      });
    };

    _this.handlePerPageChange = function (v) {
      var paging = _this.state.paging;

      _this.setState({
        paging: _objectSpread$9(_objectSpread$9({}, paging), {}, {
          itemsCountPerPage: v.value,
          activePage: 1
        })
      }, function () {
        _this.onTableChanged();
      });
    };

    _this.handlePageChange = function (page) {
      var paging = _this.state.paging;

      _this.setState({
        paging: _objectSpread$9(_objectSpread$9({}, paging), {}, {
          activePage: page
        })
      }, function () {
        _this.onTableChanged();
      });
    };

    _this.handleFreezeRow = function (row, index) {
      var freezeUpdateHandler = _this.props.freezeUpdateHandler;

      _this.setState({
        contextMenu: null,
        freeze: _objectSpread$9(_objectSpread$9({}, _this.state.freeze), {}, {
          rows: index
        })
      }, function () {
        return freezeUpdateHandler && freezeUpdateHandler(_this.state.freeze);
      });
    };

    _this.handleFreezeColumn = function (column, index) {
      var freezeUpdateHandler = _this.props.freezeUpdateHandler;

      _this.setState({
        contextMenu: null,
        freeze: _objectSpread$9(_objectSpread$9({}, _this.state.freeze), {}, {
          columns: index
        })
      }, function () {
        return freezeUpdateHandler && freezeUpdateHandler(_this.state.freeze);
      });
    };

    _this.syncWidths = function () {
      // get lower table full row cells
      var downCells = [].concat(toConsumableArray(_this.tableDowns[0] ? _this.tableDowns[0].querySelectorAll('tbody tr:first-child td') : []), toConsumableArray(_this.tableDowns[1] ? _this.tableDowns[1].querySelectorAll('tbody tr:first-child td') : []), toConsumableArray(_this.tableDowns[2] ? _this.tableDowns[2].querySelectorAll('tbody tr:first-child td') : []));
      var cellsWidths = []; // check if table component has upper table and if yes get all its cells

      var upCells;

      if (_this.tableUps.length) {
        upCells = [].concat(toConsumableArray(_this.tableUps[0] ? _this.tableUps[0].querySelectorAll('thead td') : []), toConsumableArray(_this.tableUps[1] ? _this.tableUps[1].querySelectorAll('thead td') : []), toConsumableArray(_this.tableUps[2] ? _this.tableUps[2].querySelectorAll('thead td') : []));
      }

      [].forEach.call(downCells, function (i, k) {
        if (!i.offsetWidth) return; // @todo does this really needed?

        if (upCells && upCells[k]) {
          upCells[k].style.minWidth = "".concat(i.offsetWidth, "px");
          upCells[k].style.maxWidth = "".concat(i.offsetWidth, "px");
        }

        cellsWidths.push(i.offsetWidth);
      }); // to use widths out of current function

      _this.cellsWidths = cellsWidths;

      if (_this.containerDown && _this.tableDowns[1]) {
        var diff = _this.containerDown.offsetWidth - _this.tableDowns[1].offsetWidth;
        _this.containerDown.style.marginRight = "-".concat(Math.max(0, diff - 1), "px");
      }
    };

    _this.addTableUps = function (el, index) {
      if (!el || _this.tableUps.indexOf(el) !== -1) {
        return;
      }

      _this.tableUps[index] = el;
    };

    _this.addTableDowns = function (el, index) {
      if (!el || _this.tableDowns.indexOf(el) !== -1) {
        return;
      }

      _this.tableDowns[index] = el;
    };

    _this.addSyncedElement = function (el) {
      if (!el || _this.syncedElements.indexOf(el) !== -1) {
        return;
      }

      _this.syncedElements.push(el);
    };

    _this.syncScroll = function (e) {
      // if nothing to sync with or if scroll event fired on element that is not under mouse now
      if (_this.syncedElements.length < 2 || _this.scrollTarget !== e.target) {
        return;
      } // set scroll position for all table parts...


      _this.syncedElements.forEach(function (i) {
        // ...except the part where the event was initiated (since this part has already actual scroll)
        if (i !== e.target) {
          i.scrollLeft = e.target.scrollLeft;
        }
      });

      _this.setState({
        tableHorizontalScroll: e.target.scrollLeft
      }); // setState to update table header tooltip position

    };

    _this.handleTableMouseMoveOrWheelEvent = function (e) {
      _this.setCurrentScrollTarget(e.target);
    };

    _this.setCurrentScrollTarget = function (target) {
      var scrollTarget = _this.syncedElements.find(function (i) {
        return i.contains(target) || i === target;
      });

      if (_this.scrollTarget !== scrollTarget) {
        _this.scrollTarget = scrollTarget;
      }
    };

    _this.setScrollerDimensions = function () {
      if (!_this.scroller) {
        return;
      }

      var fixedXScroller = _this.props.fixedXScroller;
      var fixScrollerAtBottom = _this.state.fixScrollerAtBottom;
      var widthsContainer = _this.tableDowns;
      var scroller = _this.scroller;
      var scrollerPlaceholder = scroller.children[0]; // necessary for scroller position calculating

      var isScrollerAbsolute = !fixedXScroller || fixScrollerAtBottom; // if scroller is absolute or fixed positioned

      var containerBoundingClientRect = _this.table.getBoundingClientRect();

      var fixedLeft = containerBoundingClientRect.left;
      var fixedRight = containerBoundingClientRect.right;
      var tableWidth = containerBoundingClientRect.width; // if table has frozen columns, otherwise table has now 'left down widths'

      var widthFirst = 0;
      var widthRightMost = 0;

      if (widthsContainer[0]) {
        var cellsCols1 = widthsContainer[0].querySelectorAll('tbody tr:first-child td');
        widthFirst = [].reduce.call(cellsCols1, function (acc, current) {
          return acc + current.offsetWidth;
        }, 0);
      }

      var cellsCol2 = widthsContainer[1].querySelectorAll('tbody tr:first-child td');
      var widthLast = [].reduce.call(cellsCol2, function (acc, current) {
        return acc + current.offsetWidth;
      }, 0);

      if (widthsContainer[2]) {
        var cellsCols3 = widthsContainer[2].querySelectorAll('tbody tr:first-child td');
        widthRightMost = [].reduce.call(cellsCols3, function (acc, current) {
          return acc + current.offsetWidth;
        }, 0);
      } // Place x scrollbar right under the table. Otherwise fix it at the bottom of viewport.


      if (isScrollerAbsolute) {
        scroller.style.left = "".concat(widthFirst, "px");
        scroller.style.right = "".concat(widthRightMost, "px");
      } else {
        scroller.style.left = "".concat(fixedLeft + widthFirst, "px");
        scroller.style.right = "".concat(fixedRight + widthRightMost, "px");
        scroller.style.width = "".concat(tableWidth - widthFirst - widthRightMost, "px");
      }

      scrollerPlaceholder.style.width = "".concat(widthLast, "px");
    };

    _this.stickFixedScrollerToTable = function () {
      if (!_this.containerTable) {
        return;
      }

      var containerBoundingClientRect = _this.containerTable.getBoundingClientRect();

      var tableTop = containerBoundingClientRect.top;
      var tableHeight = containerBoundingClientRect.height;
      _this.scrollerBottom = _this.scrollerBottom || parseInt(window.getComputedStyle(_this.scroller).bottom, 10);
      var viewportHeight = window.innerHeight; // if table is scrolled up/down

      var isScrolledUp = viewportHeight - tableTop - tableHeight > _this.scrollerBottom;
      var isScrolledDown = tableTop > viewportHeight;

      if (isScrolledUp || isScrolledDown) {
        !_this.state.fixScrollerAtBottom && _this.setState({
          fixScrollerAtBottom: true
        });
      } else {
        _this.state.fixScrollerAtBottom && _this.setState({
          fixScrollerAtBottom: false
        });
      }
    };

    _this.getTableHeight = function (frozenRowsNumber) {
      var unsortedRowsNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var skeletonsNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var addition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      return "".concat( // each unsorted gets thead height:
      _this.props.theadRowHeight * (1 + unsortedRowsNumber) + // frozenRowsNumber, when not equal to 0, contains unsorted rows number,
      // so here we are removing it, because it was already taken into account above:
      ((frozenRowsNumber ? frozenRowsNumber - unsortedRowsNumber : 0) + skeletonsNumber) * _this.props.tbodyRowHeight + addition, "px");
    };

    _this.getLoader = function (data, body) {
      var _this$props2 = _this.props,
          skeletonRowsNumber = _this$props2.skeletonRowsNumber,
          tbodyRowHeight = _this$props2.tbodyRowHeight,
          theadRowHeight = _this$props2.theadRowHeight;
      return data ? toConsumableArray(new Array(skeletonRowsNumber)).map(function (i, k) {
        return /*#__PURE__*/React__default.createElement(TableRow, {
          isSkeleton: true,
          data: data,
          body: body,
          tbodyRowHeight: tbodyRowHeight,
          theadRowHeight: theadRowHeight,
          key: k
        });
      }) : null;
    };

    _this.handleTheadOnMouseEnterLeave = function (tooltip) {
      return function () {
        return _this.setState({
          tooltip: tooltip
        });
      };
    };

    _this.renderTableHeaderRow = function (header, hoveredColIndex, fixedHeader) {
      var freezeColumns = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var freezeColumnsRight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var _this$props3 = _this.props,
          draggable = _this$props3.draggable,
          onDragEnd = _this$props3.onDragEnd,
          theadRowHeight = _this$props3.theadRowHeight;
      var sorting = _this.state.sorting;
      return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(TableHeaderRow, {
        header: header,
        sorting: sorting,
        onSortingChanged: _this.handleChangeSorting,
        draggable: draggable,
        onDragEnd: onDragEnd,
        hoveredColIndex: hoveredColIndex,
        theadRowHeight: theadRowHeight,
        handleTheadOnMouseEnterLeave: _this.handleTheadOnMouseEnterLeave,
        freezeColumns: freezeColumns,
        freezeColumnsRight: freezeColumnsRight,
        fixedHeader: fixedHeader
      }));
    };

    _this.setScrollProgress = function () {
      // if needed ref does not exist
      if (!_this.containerUp) {
        return;
      }

      var _this$props4 = _this.props,
          offsetTop = _this$props4.offsetTop,
          infiniteScroll = _this$props4.infiniteScroll,
          unsortedData = _this$props4.unsortedData,
          tbodyRowHeight = _this$props4.tbodyRowHeight;
      var totalItemsCount = _this.props.totalItemsCount;
      var freeze = _this.state.freeze;

      var containerUpTop = _this.containerUp.getBoundingClientRect().top;

      var containerDownTop = _this.containerDown.getBoundingClientRect().top; // part of table scrolled by means of window scroll
      // relative to sticky table element


      var scrolledUpPixels = containerUpTop - containerDownTop;
      var innerTableScroll = 0; // exists only with infiniteScroll

      if (infiniteScroll) {
        // infinite content is scrolled inside containerDown
        var infiniteContentTop = _this.containerDownRight.getBoundingClientRect().top;

        innerTableScroll = containerDownTop - infiniteContentTop;
      } // sum of 'window scrolled' and 'infinite scrolled' pixels


      var totalScrolledPixels = scrolledUpPixels + innerTableScroll; // count pixels that cannot be scrolled up (under sticky element),
      // due to not enough space under table

      var pixelsAfterTable = document.body.scrollHeight - (window.pageYOffset + _this.containerDown.getBoundingClientRect().bottom);

      var remainedUnScrolled = window.innerHeight - (offsetTop + _this.containerUp.offsetHeight + pixelsAfterTable);

      if (remainedUnScrolled < 0) {
        remainedUnScrolled = 0;
      }

      totalItemsCount = totalItemsCount || _this.props.data.length;
      var percent = totalScrolledPixels / ((totalItemsCount - (freeze.rows ? freeze.rows - unsortedData.length : 0)) * tbodyRowHeight - remainedUnScrolled) * 100;

      _this.setState({
        tableScrollProgress: percent
      });
    };

    _this.preventOverScroll = function (element) {
      element === null || element === void 0 ? void 0 : element.addEventListener('wheel', function (event) {
        var maxX = (element === null || element === void 0 ? void 0 : element.scrollWidth) - (element === null || element === void 0 ? void 0 : element.clientWidth);
        var position = element === null || element === void 0 ? void 0 : element.scrollLeft;

        if (position + event.deltaX > maxX || position + event.deltaX < 0) {
          event.preventDefault();
        }
      }, false);
    };

    _this.tableUps = [];
    _this.tableDowns = [];
    _this.syncedElements = [];
    _this.state = {
      paging: props.paging || null,
      sorting: props.sorting,
      contextMenu: null,
      fixScrollerAtBottom: true,
      freeze: {
        rows: props.freezeRows,
        columns: props.freezeColumns,
        columnsRight: props.lastColumnFrozen ? props.header.length - 1 : 0
      }
    };

    if (!props.server) {
      _this.state.data = props.data || [];
    }

    _this.handleChangeSorting = _this.handleChangeSorting.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var props = this.props;

      if (props.header.length !== prevProps.header.length) {
        this.setState({
          freeze: _objectSpread$9(_objectSpread$9({}, this.state.freeze), {}, {
            columnsRight: props.lastColumnFrozen ? props.header.length - 1 : 0
          })
        });
      }

      if (!props.server && (prevProps.data.length !== props.data.length || prevProps.data !== props.data)) {
        this.setState({
          data: props.data,
          paging: this.paging
        });
      } else if (props.sorting !== prevProps.sorting) {
        this.setState({
          sorting: props.sorting
        });
      } // update freeze if freezeColumns or freezeRows props have changed


      var isFreezeColsUpdatedThroughProps = this.props.freezeColumns !== prevProps.freezeColumns && this.props.freezeColumns !== this.state.freeze.columns;
      var isFreezeRowsUpdatedThroughProps = this.props.freezeRows !== prevProps.freezeRows && this.props.freezeRows !== this.state.freeze.rows;

      if (isFreezeColsUpdatedThroughProps || isFreezeRowsUpdatedThroughProps) {
        this.setState({
          freeze: {
            columns: isFreezeColsUpdatedThroughProps ? this.props.freezeColumns : this.state.freeze.columns,
            rows: isFreezeRowsUpdatedThroughProps ? this.props.freezeRows : this.state.freeze.rows
          }
        });
      }

      this.syncWidths();

      if (props.infiniteScroll) {
        setTimeout(this.setScrollerDimensions, 300);

        if (this.props.fixedXScroller) {
          this.stickFixedScrollerToTable();
        }
      } // @todo
      // this is a hack to overcome the problem of different scroll
      // horizontal positions of table's parts after its data completely replaced
      // (after switching to another table with another data, but without
      // unmounting current table component


      if (prevProps.data !== props.data && this.syncedElements.length > 1 && this.syncedElements.some(function (el) {
        return el.scrollLeft !== _this2.syncedElements[0].scrollLeft;
      })) {
        this.syncedElements.forEach(function (i) {
          if (i) {
            i.scrollLeft = 0;
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onTableChanged();
      this.syncWidths();
      this.onFontLoaded();

      if (this.props.infiniteScroll) {
        this.setScrollerDimensions();

        if (this.props.fixedXScroller) {
          this.stickFixedScrollerToTable();
          window.addEventListener('scroll', this.stickFixedScrollerToTable);
        }
      }

      window.addEventListener('resize', this.syncWidths);

      if (this.props.windowFreeResizeEvent) {
        this.iframe.contentWindow.addEventListener('resize', this.syncWidths);
      }

      this.setScrollProgress();
      window.addEventListener('scroll', this.setScrollProgress);

      if (this.props.infiniteScroll) {
        this.containerDown.addEventListener('scroll', this.setScrollProgress);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.syncWidths);

      if (this.props.windowFreeResizeEvent) {
        this.iframe.contentWindow.removeEventListener('resize', this.syncWidths);
      }

      if (this.props.infiniteScroll && this.props.fixedXScroller) {
        window.removeEventListener('scroll', this.stickFixedScrollerToTable);
      }

      window.removeEventListener('scroll', this.setScrollProgress);
    }
  }, {
    key: "handleChangeSorting",
    value: function handleChangeSorting(data) {
      var _this3 = this;

      var sorting = this.state.sorting;
      this.syncedElements.forEach(function (i) {
        if (i) {
          i.scrollLeft = 0;
        }
      });
      this.setState({
        sorting: _objectSpread$9(_objectSpread$9({}, sorting), {}, {
          field: data.sortingKey,
          compareFunc: data.compareFunc ? data.compareFunc : null,
          direction: sorting.field === data.sortingKey ? sorting.direction === SORT_DIRECTION.ASC ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC : SORT_DIRECTION.ASC
        }),
        paging: this.paging
      }, function () {
        return _this3.onTableChanged();
      });
    }
  }, {
    key: "paging",
    get: function get() {
      return this.props.paging || this.state.paging;
    }
  }, {
    key: "getData",
    value: function getData() {
      var data = [];
      var sorting = this.state.sorting;
      var paging = this.paging;

      if (this.props.server) {
        return toConsumableArray(this.props.data);
      } else {
        data = this.state.data.slice(); // copy array
      }

      if (sorting) {
        if (sorting.compareFunc) {
          data.sort(sorting.compareFunc.bind(null, sorting.direction));
        } else {
          if (sorting.direction === SORT_DIRECTION.ASC) {
            data.sort(function (a, b) {
              return a[sorting.field] > b[sorting.field] ? 1 : -1;
            });
          } else {
            data.sort(function (a, b) {
              return a[sorting.field] < b[sorting.field] ? 1 : -1;
            });
          }
        }
      }

      if (!paging) {
        return data;
      }

      var activePage = paging.activePage,
          itemsCountPerPage = paging.itemsCountPerPage;
      return data.slice((activePage - 1) * itemsCountPerPage, itemsCountPerPage * activePage);
    }
  }, {
    key: "renderBody",
    value: function renderBody(data, body, freezeColumns) {
      var _this4 = this;

      if (!body || !body.length) {
        return null;
      }

      if (!this.props.infiniteScroll && this.props.loading) {
        return /*#__PURE__*/React__default.createElement("tr", {
          className: "table__loading"
        }, /*#__PURE__*/React__default.createElement("td", null, "Loading..."));
      }

      return data.map(function (i, k) {
        return _this4.renderBodyRow(i, k, body, freezeColumns);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props5 = this.props,
          className = _this$props5.className,
          title = _this$props5.title,
          header = _this$props5.header,
          body = _this$props5.body,
          enableContextMenu = _this$props5.enableContextMenu,
          unsortedData = _this$props5.unsortedData,
          infiniteScroll = _this$props5.infiniteScroll,
          draggable = _this$props5.draggable,
          windowFreeResizeEvent = _this$props5.windowFreeResizeEvent,
          fixedXScroller = _this$props5.fixedXScroller,
          InfiniteScrollComponent = _this$props5.InfiniteScrollComponent,
          skeletonRowsNumber = _this$props5.skeletonRowsNumber,
          theadRowHeight = _this$props5.theadRowHeight,
          tableMaxHeight = _this$props5.tableMaxHeight,
          preventNavigationByScroll = _this$props5.preventNavigationByScroll;
      var offsetTop = this.props.offsetTop;
      var _this$state3 = this.state,
          contextMenu = _this$state3.contextMenu,
          fixScrollerAtBottom = _this$state3.fixScrollerAtBottom,
          hoveredColIndex = _this$state3.hoveredColIndex,
          freeze = _this$state3.freeze,
          tooltip = _this$state3.tooltip,
          tableHorizontalScroll = _this$state3.tableHorizontalScroll,
          tableScrollProgress = _this$state3.tableScrollProgress;
      var freezeRows = freeze.rows;
      var freezeColumns = freeze.columns;
      var freezeColumnsRight = freeze.columnsRight;
      if (!offsetTop && freezeRows > 0) offsetTop = 0;
      var data = this.getData();
      var unsortedDataLength = unsortedData && unsortedData.length || 0;

      if (unsortedDataLength) {
        unsortedData.forEach(function (i) {
          i.rowClassName = 'tr-unsorted';
        });
        data = [].concat(toConsumableArray(unsortedData), toConsumableArray(data));
        freezeRows = freeze.rows || unsortedDataLength;
      }

      var tableHeaderStyle = {};
      var tableContentHeaderStyle = {}; // if offsetTop is number

      var fixedHeader = !!(freezeRows || !isNaN(parseFloat(offsetTop)) && isFinite(offsetTop));

      if (fixedHeader) {
        tableHeaderStyle.top = "".concat(offsetTop, "px");

        if (this.tableHeaderElement.current) {
          tableContentHeaderStyle.top = "".concat(offsetTop + this.tableHeaderElement.current.getBoundingClientRect().height, "px");
        } else {
          tableContentHeaderStyle.top = "".concat(offsetTop, "px");
        }
      }

      var paging = this.paging; // when infinite-scroll table exists - check if it was ended up

      var skeletonsNumber = skeletonRowsNumber;

      if (InfiniteScrollComponent && !InfiniteScrollComponent.hasMore) {
        skeletonsNumber = 0;
      } // check if table has checkbox column @todo take in account case when className is set with function


      var hasTableCheckboxColumn = !!body.filter(function (i) {
        return typeof i.className === 'string' && i.className.indexOf('_checkbox') !== -1;
      }).length; // to update total checkbox when all or something checked/unchecked

      this.isAllSelected = data.length - unsortedDataLength === data.filter(function (i) {
        return i.rowClassName === '_selected';
      }).length;
      this.isSomeSelected = data.filter(function (i) {
        return i.rowClassName === '_selected';
      }).length > 0;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.container, " ").concat(className || '', " ").concat(draggable ? '_dnd' : '', " table"),
        ref: function ref(el) {
          _this5.table = el;
        }
      }, /*#__PURE__*/React__default.createElement(TableHeader, {
        title: title,
        fixedHeader: fixedHeader,
        innerRef: this.tableHeaderElement,
        style: tableHeaderStyle,
        paging: paging,
        onPerPageChanged: this.handlePerPageChange,
        onPaginationChanged: this.handlePageChange
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerTable, " ").concat(unsortedDataLength % 2 === 0 ? '' : '_odd-stripes'),
        ref: function ref(el) {
          _this5.containerTable = el;
        },
        onMouseMove: this.handleTableMouseMoveOrWheelEvent,
        onWheel: this.handleTableMouseMoveOrWheelEvent
      }, tooltip && /*#__PURE__*/React__default.createElement("div", {
        className: styles$f.tooltipWrapper,
        style: _objectSpread$9({}, tableContentHeaderStyle)
      }, /*#__PURE__*/React__default.createElement(TableHeaderTooltip, {
        tooltip: tooltip,
        cellsWidths: this.cellsWidths,
        top: theadRowHeight,
        scrollLeft: tableHorizontalScroll,
        freezeColumns: freezeColumns
      })), fixedHeader && /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this5.containerUp = el;
        },
        className: styles$f.containerUp,
        style: _objectSpread$9({}, tableContentHeaderStyle)
      }, !!freezeColumns && /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerLeft),
        style: {
          height: this.getTableHeight(freeze.rows, unsortedDataLength)
        },
        ref: function ref(el) {
          _this5.addTableUps(el, 0);
        }
      }, /*#__PURE__*/React__default.createElement("table", null, this.renderTableHeaderRow(header.slice(0, freezeColumns), hoveredColIndex < freezeColumns ? hoveredColIndex : undefined, fixedHeader), /*#__PURE__*/React__default.createElement("tbody", null, this.renderBody(data.slice(0, freezeRows), body.slice(0, freezeColumns))))), /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerRight),
        style: {
          height: this.getTableHeight(freeze.rows, unsortedDataLength)
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerRightScroller),
        style: {
          height: this.getTableHeight(freeze.rows, unsortedDataLength, 0, 20)
        },
        ref: function ref(el) {
          _this5.addTableUps(el, 1);

          _this5.addSyncedElement(el);

          if (preventNavigationByScroll) {
            _this5.preventOverScroll(el);
          }
        },
        onScroll: this.syncScroll
      }, /*#__PURE__*/React__default.createElement("table", null, this.renderTableHeaderRow(freezeColumnsRight ? header.slice(freezeColumns, freezeColumnsRight) : header.slice(freezeColumns), hoveredColIndex >= freezeColumns ? hoveredColIndex - freezeColumns : undefined, fixedHeader, freezeColumns), !!freezeRows && /*#__PURE__*/React__default.createElement("tbody", null, this.renderBody(data.slice(0, freezeRows), freezeColumnsRight ? body.slice(freezeColumns, freezeColumnsRight) : body.slice(freezeColumns), freezeColumns))))), !!freezeColumnsRight && /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerRightMost),
        style: {
          height: this.getTableHeight(freeze.rows, unsortedDataLength)
        },
        ref: function ref(el) {
          _this5.addTableUps(el, 2);
        }
      }, /*#__PURE__*/React__default.createElement("table", null, this.renderTableHeaderRow(header.slice(freezeColumnsRight), hoveredColIndex >= freezeColumnsRight ? hoveredColIndex - freezeColumns : undefined, fixedHeader, 0, freezeColumnsRight), /*#__PURE__*/React__default.createElement("tbody", null, this.renderBody(data.slice(0, freezeRows), body.slice(freezeColumnsRight))))), tableScrollProgress !== undefined && /*#__PURE__*/React__default.createElement("div", {
        className: "table-progress-bar ".concat(styles$f.containerTableProgress),
        style: {
          height: '4px',
          top: "".concat(theadRowHeight * (unsortedDataLength ? 2 : 1) - 2, "px"),
          backgroundImage: "linear-gradient(90deg,\n                      #7a93ff ".concat(this.state.tableScrollProgress, "%,\n                      rgb(0, 0, 0, 0.1) ").concat(this.state.tableScrollProgress, "%\n                    )"),
          right: "".concat(window.innerWidth - this.tableDowns[this.tableDowns.length - 1].getBoundingClientRect().right - 16, "px")
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this5.containerDown = el;
        },
        className: "".concat(styles$f.containerDown),
        style: {
          marginTop: fixedHeader ? "-".concat(this.getTableHeight(freeze.rows, unsortedDataLength)) : '',
          maxHeight: infiniteScroll ? tableMaxHeight || '100vh' : tableMaxHeight || '',
          width: this.containerDown && this.containerDown.scrollHeight > this.containerDown.clientHeight ? "calc(100% + ".concat(this.containerDown.offsetWidth - this.containerDown.clientWidth, "px)") : '100%'
        }
      }, !!freezeColumns && /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerLeft),
        ref: function ref(el) {
          _this5.addTableDowns(el, 0);
        }
      }, /*#__PURE__*/React__default.createElement("table", null, this.renderTableHeaderRow(header.slice(0, freezeColumns), !fixedHeader && hoveredColIndex < freezeColumns ? hoveredColIndex : undefined, fixedHeader), !infiniteScroll ? /*#__PURE__*/React__default.createElement("tbody", null, this.renderBody(data, body.slice(0, freezeColumns))) : /*#__PURE__*/React__default.createElement(reactInfiniteScroller, _extends_1({}, InfiniteScrollComponent, {
        element: "tbody",
        getScrollParent: function getScrollParent(el) {
          return el && el.closest(".".concat(styles$f.containerDown));
        },
        loader: this.getLoader(data[0], body.slice(0, freezeColumns))
      }), this.renderBody(data, body.slice(0, freezeColumns))))), /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this5.containerDownRight = el;
        },
        className: "".concat(styles$f.containerRight),
        style: {
          height: infiniteScroll ? this.getTableHeight(data.length, unsortedDataLength, skeletonsNumber) : ''
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.containerRightScroller),
        style: {
          height: infiniteScroll ? this.getTableHeight(data.length, unsortedDataLength, skeletonsNumber, 20) : ''
        },
        ref: function ref(el) {
          _this5.addTableDowns(el, 1);

          _this5.addSyncedElement(el);

          if (preventNavigationByScroll) {
            _this5.preventOverScroll(el);
          }
        },
        onScroll: this.syncScroll
      }, /*#__PURE__*/React__default.createElement("table", null, this.renderTableHeaderRow(freezeColumnsRight ? header.slice(freezeColumns, freezeColumnsRight) : header.slice(freezeColumns), !fixedHeader && hoveredColIndex >= freezeColumns ? hoveredColIndex - freezeColumns : undefined, fixedHeader, freezeColumns), !infiniteScroll ? /*#__PURE__*/React__default.createElement("tbody", null, this.renderBody(data, freezeColumnsRight ? body.slice(freezeColumns, freezeColumnsRight) : body.slice(freezeColumns), freezeColumns)) : /*#__PURE__*/React__default.createElement(reactInfiniteScroller, _extends_1({}, InfiniteScrollComponent, {
        element: "tbody",
        getScrollParent: function getScrollParent(el) {
          return el && el.closest(".".concat(styles$f.containerDown));
        },
        loader: this.getLoader(data[0], freezeColumnsRight ? body.slice(freezeColumns, freezeColumnsRight) : body.slice(freezeColumns))
      }), this.renderBody(data, freezeColumnsRight ? body.slice(freezeColumns, freezeColumnsRight) : body.slice(freezeColumns), freezeColumns))))), !!freezeColumnsRight && /*#__PURE__*/React__default.createElement("div", {
        className: styles$f.containerRightMost,
        ref: function ref(el) {
          _this5.addTableDowns(el, 2);
        }
      }, /*#__PURE__*/React__default.createElement("table", null, this.renderTableHeaderRow(header.slice(freezeColumnsRight), !fixedHeader && hoveredColIndex < freezeColumns ? hoveredColIndex : undefined, fixedHeader), !infiniteScroll ? /*#__PURE__*/React__default.createElement("tbody", null, this.renderBody(data, body.slice(freezeColumnsRight))) : /*#__PURE__*/React__default.createElement(reactInfiniteScroller, _extends_1({}, InfiniteScrollComponent, {
        element: "tbody",
        getScrollParent: function getScrollParent(el) {
          return el && el.closest(".".concat(styles$f.containerDown));
        },
        loader: this.getLoader(data[0], body.slice(freezeColumnsRight))
      }), this.renderBody(data, body.slice(freezeColumnsRight)))))), infiniteScroll && /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.scroller, " ").concat(fixedXScroller && !fixScrollerAtBottom ? '_fixed' : ''),
        ref: function ref(el) {
          _this5.scroller = el;

          _this5.addSyncedElement(el);
        },
        onScroll: this.syncScroll
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$f.scrollerPlaceholder)
      })), windowFreeResizeEvent && /*#__PURE__*/React__default.createElement("iframe", {
        ref: function ref(el) {
          _this5.iframe = el;
        },
        className: styles$f.iframe
      }), contextMenu && enableContextMenu && /*#__PURE__*/React__default.createElement(TableContextMenu, _extends_1({}, contextMenu, {
        onClose: function onClose() {
          return _this5.setState({
            contextMenu: null
          });
        },
        onFreezeRow: this.handleFreezeRow,
        onFreezeColumn: this.handleFreezeColumn,
        unsortedDataLength: unsortedDataLength,
        hasTableCheckboxColumn: hasTableCheckboxColumn
      }))));
    }
  }]);

  return Table;
}(Component);
Table.defaultProps = {
  paging: null,
  header: [],
  body: [],
  server: false,
  loading: false,
  fixedHeader: false,
  sorting: {
    field: null,
    direction: null
  },
  rowClickHandler: function rowClickHandler() {},
  enableContextMenu: true,
  freezeRows: 0,
  freezeColumns: 0,
  lastColumnFrozen: false,
  infiniteScroll: false,
  draggable: false,
  onDragEnd: function onDragEnd() {},
  windowFreeResizeEvent: false,
  fixedXScroller: false,
  skeletonRowsNumber: 5,
  tbodyRowHeight: DEFAULT_CELL_HEIGHT,
  theadRowHeight: DEFAULT_CELL_HEIGHT,
  preventNavigationByScroll: false
};
Table.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.string,
  data: PropTypes__default.array.isRequired,
  rowKeyExtractor: PropTypes__default.func.isRequired,
  server: PropTypes__default.bool,
  loading: PropTypes__default.bool,
  onChange: PropTypes__default.func,
  fixedHeader: PropTypes__default.bool,
  offsetTop: PropTypes__default.number,
  header: tablePropTypes.header,
  sorting: tablePropTypes.sorting,
  body: tablePropTypes.body,
  paging: tablePropTypes.paging,
  rowClickHandler: PropTypes__default.func,
  enableContextMenu: PropTypes__default.bool,
  unsortedData: PropTypes__default.array,
  freezeRows: PropTypes__default.number,
  freezeColumns: PropTypes__default.number,
  lastColumnFrozen: PropTypes__default.bool,
  infiniteScroll: PropTypes__default.bool,
  InfiniteScrollComponent: PropTypes__default.shape({
    loadMore: PropTypes__default.func,
    hasMore: PropTypes__default.bool,
    pageStart: PropTypes__default.number,
    useWindow: PropTypes__default.bool
  }),
  skeletonRowsNumber: PropTypes__default.number,
  draggable: PropTypes__default.bool,
  onDragEnd: PropTypes__default.func,
  freezeUpdateHandler: PropTypes__default.func,
  windowFreeResizeEvent: PropTypes__default.bool,
  fixedXScroller: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number,
  theadRowHeight: PropTypes__default.number,
  totalItemsCount: PropTypes__default.number,
  tableMaxHeight: PropTypes__default.string,
  preventNavigationByScroll: PropTypes__default.bool
};

var defaultSubmit = function defaultSubmit(e) {
  return e.preventDefault();
};

var Form = function Form(_ref) {
  var title = _ref.title,
      className = _ref.className,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? defaultSubmit : _ref$onSubmit,
      children = _ref.children;
  return /*#__PURE__*/React__default.createElement("form", {
    className: "form ".concat(className || ''),
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "title-form form__header"
  }, title), /*#__PURE__*/React__default.createElement("div", {
    className: "form__content"
  }, children));
};

function _createSuper$y(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$y(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Collapse = /*#__PURE__*/function (_PureComponent) {
  inherits(Collapse, _PureComponent);

  var _super = _createSuper$y(Collapse);

  function Collapse(props) {
    var _this;

    classCallCheck(this, Collapse);

    _this = _super.call(this, props);

    _this.handleToggle = function () {
      _this.setState(function (state) {
        return {
          isOpened: !state.isOpened
        };
      });
    };

    _this.state = {
      isOpened: false
    };
    return _this;
  }

  createClass(Collapse, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          title = _this$props.title,
          children = _this$props.children;
      var isOpened = this.state.isOpened;
      var classes = ['collapse', className];

      if (isOpened) {
        classes.push('collapse_opened');
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classes.join(' ')
      }, /*#__PURE__*/React__default.createElement("button", {
        className: "collapse__btn",
        onClick: this.handleToggle
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Right",
        className: "collapse__icon",
        viewBox: "4 4 14 14"
      }), title), /*#__PURE__*/React__default.createElement("div", {
        className: 'collapse__content'
      }, isOpened && children));
    }
  }]);

  return Collapse;
}(PureComponent);
Collapse.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element])
};

function _createSuper$z(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$z(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditableText = /*#__PURE__*/function (_React$PureComponent) {
  inherits(EditableText, _React$PureComponent);

  var _super = _createSuper$z(EditableText);

  function EditableText(props) {
    var _this;

    classCallCheck(this, EditableText);

    _this = _super.call(this, props);

    _this.handleChange = function (value, validationErrors) {
      var type = _this.state.type;

      if (type === 'amount') {
        var i = 0;
        value = value.replace(/[^0-9.]+/g, '').replace(/\./g, function (match) {
          i++;
          return i === 2 ? '' : match;
        });
      } else if (type === 'date') {
        var _i = 0;
        value = value.replace(/[^0-9/]+/g, '').replace(/\//g, function (match) {
          _i++;
          return _i === 3 ? '' : match;
        });
      }

      _this.setState({
        value: _this.props.onChange ? _this.props.onChange(value) : value,
        validationErrors: validationErrors
      });
    };

    _this.handleBlur = function () {
      var _this$state = _this.state,
          defaultValue = _this$state.defaultValue,
          value = _this$state.value,
          validationErrors = _this$state.validationErrors;

      if (value.trim() && defaultValue !== value && !validationErrors) {
        _this.handleShowPopup();
      } else {
        _this.setState({
          value: defaultValue
        });
      }
    };

    _this.handleSubmit = function (e) {
      var _this$state2 = _this.state,
          defaultValue = _this$state2.defaultValue,
          value = _this$state2.value,
          type = _this$state2.type,
          validationErrors = _this$state2.validationErrors;
      var allowedEmptyValue = _this.props.allowedEmptyValue;
      e.preventDefault();

      if (!value.trim() && !allowedEmptyValue || defaultValue === value || validationErrors) {
        return;
      }

      if (type === 'date') {
        var dateRegex = /\d{1,2}\/\d{1,2}\/20\d{2}/g;

        if (value !== defaultValue && dateRegex.test(value) && (_this.props.isValid ? _this.props.isValid(value, defaultValue) : true)) {
          _this.handleShowPopup();
        }
      } else {
        _this.handleShowPopup();
      }
    };

    _this.handleShowPopup = function () {
      var _this$props$Popup = _this.props.Popup,
          remember = _this$props$Popup.remember,
          storageKey = _this$props$Popup.storageKey;

      if (remember && JSON.parse(window.localStorage.getItem(storageKey))) {
        _this.onConfirm();

        return;
      }

      _this.setState({
        showPopup: true
      });
    };

    _this.handleClosePopup = function () {
      _this.setState({
        showPopup: false
      });
    };

    _this.handleCancel = function (e) {
      _this.onCancel(e);
    };

    _this.handleConfirm = function () {
      if (_this.state.remember && _this.props.Popup.storageKey) {
        window.localStorage.setItem(_this.props.Popup.storageKey, JSON.stringify(true));
      }

      _this.onConfirm();
    };

    _this.onCancel = function (e) {
      var defaultValue = _this.state.defaultValue;

      _this.setState({
        value: defaultValue
      }, _this.handleClosePopup);

      _this.props.cancel && _this.props.cancel(_this.state.defaultValue, e);
    };

    _this.onConfirm = function () {
      if (_this.props.confirm) {
        var oldValue = _this.state.value;

        _this.setState({
          value: _this.props.value
        }, function () {
          return _this.props.confirm(oldValue, _this.state.defaultValue);
        });
      }

      _this.handleClosePopup();
    };

    _this.handleChangeRemember = function (value) {
      _this.setState({
        remember: value
      });
    };

    _this.getFooterLeft = function () {
      var _this$props$Popup2 = _this.props.Popup,
          remember = _this$props$Popup2.remember,
          actionsHelp = _this$props$Popup2.actionsHelp;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "d-flex flex-row align-items-center justify-content-between"
      }, remember ? /*#__PURE__*/React__default.createElement(Checkbox, {
        className: "mr-3",
        label: "Don't ask me again",
        checked: _this.state.remember,
        onChange: _this.handleChangeRemember
      }) : null, actionsHelp ? /*#__PURE__*/React__default.createElement("div", {
        className: "d-flex"
      }, actionsHelp) : null);
    };

    _this.renderPopup = function () {
      var _this$props$Popup3 = _this.props.Popup,
          title = _this$props$Popup3.title,
          modalProps = _this$props$Popup3.modalProps;
      var _this$state3 = _this.state,
          defaultValue = _this$state3.defaultValue,
          value = _this$state3.value;
      return /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement(Dialog, {
        open: true,
        onClickOutside: _this.handleCancel,
        modalProps: modalProps,
        dialogTitle: title,
        crossButton: false,
        footerLeft: _this.getFooterLeft(),
        actionButtons: [{
          variant: "secondary",
          title: "Cancel",
          className: "mr-2",
          handler: _this.handleCancel
        }, {
          title: "Apply",
          handler: _this.handleConfirm
        }]
      }, isFunction$1(_this.props.children) ? _this.props.children(defaultValue, value) : _this.props.children), _this.props.Popup.appendTo || document.body);
    };

    _this.state = {
      defaultValue: (props.value || '').toString(),
      value: (props.value || '').toString(),
      showPopup: false,
      remember: false,
      type: props.type || 'text'
    };
    return _this;
  }

  createClass(EditableText, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          defaultValue: this.props.value,
          value: this.props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          propsValue = _this$props.value,
          validationRules = _this$props.validationRules,
          allowedEmptyValue = _this$props.allowedEmptyValue,
          hasBorder = _this$props.hasBorder,
          label = _this$props.label;
      var _this$state4 = this.state,
          value = _this$state4.value,
          showPopup = _this$state4.showPopup,
          validationErrors = _this$state4.validationErrors;
      var iconEl = (value.trim() || allowedEmptyValue) && "".concat(propsValue) !== "".concat(value) && !validationErrors ? /*#__PURE__*/React__default.createElement(Icon, {
        name: "Done"
      }) : null;
      return /*#__PURE__*/React__default.createElement("form", {
        className: "editable-text ".concat(hasBorder ? '_has-border' : '', " ").concat(this.props.className || ''),
        onSubmit: this.handleSubmit,
        ref: function ref() {
          _this2.props.innerRef && _this2.props.innerRef(_this2);
        }
      }, /*#__PURE__*/React__default.createElement(TextField, {
        noBorder: !hasBorder,
        value: value,
        validationRules: validationRules,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        inputRef: function inputRef(el) {
          _this2.props.inputRef && _this2.props.inputRef(el);
        },
        label: label
      }), iconEl, showPopup && this.renderPopup());
    }
  }]);

  return EditableText;
}(React__default.PureComponent);
EditableText.defaultProps = {
  confirm: function confirm() {},
  cancel: function cancel() {},
  Popup: {
    title: '',
    remember: false,
    storageKey: ''
  }
};
EditableText.propTypes = {
  type: PropTypes__default.string,
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  confirm: PropTypes__default.func,
  cancel: PropTypes__default.func,
  Popup: PropTypes__default.shape({
    title: PropTypes__default.oneOfType([PropTypes__default.element, PropTypes__default.elementType]),
    remember: PropTypes__default.bool,
    storageKey: PropTypes__default.string,
    appendTo: PropTypes__default.instanceOf(window.HTMLElement),
    actions: PropTypes__default.func,
    actionsHelp: PropTypes__default.element,
    modalProps: PropTypes__default.object
  }),
  innerRef: PropTypes__default.func,
  onChange: PropTypes__default.func,
  isValid: PropTypes__default.func,
  validationRules: PropTypes__default.array,
  allowedEmptyValue: PropTypes__default.bool,
  hasBorder: PropTypes__default.bool,
  label: PropTypes__default.string
};

function _createSuper$A(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$A(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PADDING_STEP$1 = 20;
var SelectList = /*#__PURE__*/function (_Component) {
  inherits(SelectList, _Component);

  var _super = _createSuper$A(SelectList);

  function SelectList(props) {
    var _this;

    classCallCheck(this, SelectList);

    _this = _super.call(this, props);
    _this._selectList = null;

    _this.handleChangeSearch = function (value) {
      _this.setState({
        search: value
      });
    };

    _this.toggleTumbler = function () {
      _this.props.onTumblerChange();
    };

    _this.handleSelectedOption = function (item) {
      return function (e) {
        var _this$props = _this.props,
            isMulti = _this$props.isMulti,
            withTabs = _this$props.withTabs;
        var _this$state = _this.state,
            stateOfOptions = _this$state.stateOfOptions,
            tabsModeIsInclude = _this$state.tabsModeIsInclude;

        if (withTabs) {
          if (!item.isActive) {
            item = Object.assign(item, tabsModeIsInclude ? {
              included: true
            } : {
              excluded: true
            });
          }
        }

        var newState = updateStateOfOptions(stateOfOptions, item, isMulti);

        _this.setStateOptions(newState, item);
      };
    };

    _this.onSortStart = function () {
      _this.setState({
        isSorting: true
      });
    };

    _this.onSortEnd = function (_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;
      var newValues = moveItem(_this.state.stateOfOptions, oldIndex, newIndex);

      _this.setStateOptions(newValues);

      _this.setState({
        targetDropIndex: null,
        startDragIndex: null,
        isSorting: false
      });
    };

    _this.renderItem = function (item, i) {
      var _this$props2 = _this.props,
          levelPadding = _this$props2.levelPadding,
          withTabs = _this$props2.withTabs;
      var tabsModeIsInclude = _this.state.tabsModeIsInclude;
      var additionalProps = {
        style: {}
      };
      var padd = (item.deep || 0) * (levelPadding || PADDING_STEP$1);

      if (padd !== 0) {
        additionalProps.style.paddingLeft = padd;
      }

      if (!item.isGroupHeader && !item.alwaysEnabled) {
        additionalProps.onClick = _this.handleSelectedOption(item);
      } // to make clickable group header bold the checking is needed:
      // - if option is not a child of other option and have its own children
      // - and also if no reactLabel is used since it has its own markup


      var isClickableGroupHeader = !item.reactLabel && item.deep === 0 && item.options && item.options.length;
      var isActive = item.isActive,
          included = item.included,
          excluded = item.excluded;
      var isDisable = false;

      if (withTabs) {
        isDisable = tabsModeIsInclude ? !!excluded : !!included;
      }

      var className = getItemClasses(item, {
        isActive: isActive,
        isDisable: isDisable
      });

      if (isClickableGroupHeader) {
        className += ' _clickable-header';
      }

      return /*#__PURE__*/React__default.createElement("div", _extends_1({
        key: item.value !== undefined ? item.value : i,
        className: className
      }, additionalProps), /*#__PURE__*/React__default.createElement("div", {
        className: "select__option-label"
      }, item.labelImageSrc && /*#__PURE__*/React__default.createElement("div", {
        className: "select__option-image"
      }, /*#__PURE__*/React__default.createElement(WithErrorPlaceholderImage, {
        src: item.labelImageSrc
      })), item.reactLabel || item.label));
    };

    _this.renderList = function (resultOptions) {
      var res = [];

      var cb = function cb(item) {
        return res.push(item);
      };

      traverseState(resultOptions, cb);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "select__list",
        ref: function ref(el) {
          _this._selectList = el;
        }
      }, res.map(function (item, i) {
        return _this.renderItem(item, i);
      }));
    };

    _this.renderButton = function () {
      var buttonProps = _this.props.buttonProps;

      if (buttonProps) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: "w-100 d-flex justify-content-center"
        }, /*#__PURE__*/React__default.createElement(Button, {
          className: buttonProps.className || 'btn-round _conflower-blue mt-3 mb-3',
          onClick: buttonProps.onClick
        }, !!buttonProps.symbolBeforeLabel && /*#__PURE__*/React__default.createElement("span", {
          className: "btn-round__prefix"
        }, buttonProps.symbolBeforeLabel), buttonProps.label || 'New'));
      }

      return null;
    };

    _this.state = {
      search: '',
      tumblerIsActive: props.tumblerIsActive,
      withGroups: props.options.some(function (item) {
        return item.isGroupHeader;
      }),
      stateOfOptions: makeStateOfOptions(props.options, props.value),
      isSorting: false,
      tabsModeIsInclude: true
    };
    return _this;
  }

  createClass(SelectList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['value', 'options', 'isMulti', 'isSearchable', 'onChange', 'tumbler', 'onTumblerChange', 'labelImageSrc', 'reactLabel', 'className', 'searchLabel', 'searchPlaceholder', 'getSearchInputHandler'], this.props, nextProps) && isEqual(['search', 'stateOfOptions', 'tumblerIsActive', 'targetDropIndex', 'startDragIndex', 'isSorting', 'tabsModeIsInclude'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var getSearchInputHandler = this.props.getSearchInputHandler;

      if (getSearchInputHandler) {
        getSearchInputHandler(this.handleChangeSearch);
      }

      window.addEventListener('click', this.windowClickHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!isEqual(['value', 'options', 'isMulti'], this.props, prevProps) || !isEqual(['isSorting'], this.state, prevState)) {
        this.setState({
          withGroups: this.props.options.some(function (item) {
            return item.isGroupHeader;
          }),
          stateOfOptions: makeStateOfOptions(this.props.options, this.props.value)
        });
      }

      if (prevProps.tumblerIsActive !== this.props.tumblerIsActive) {
        this.setState({
          tumblerIsActive: this.props.tumblerIsActive
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.windowClickHandler);
    }
  }, {
    key: "setStateOptions",
    value: function setStateOptions(state, item, fromDeselectedAll) {
      if (this.props.onChange) {
        var values = [];

        var callback = function callback(item) {
          if (item.isActive) values.push(item);
        };

        traverseState(state, callback);

        if (!this.props.isMulti) {
          values = values.length ? values[0] : null;
        } // add fromDeselectedAll for lazyLoad select


        this.props.onChange(normalizeValue(values), item, fromDeselectedAll);
      }

      this.setState({
        stateOfOptions: state
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          isMulti = _this$props3.isMulti,
          tumbler = _this$props3.tumbler,
          tumblerLabel = _this$props3.tumblerLabel,
          isSearchable = _this$props3.isSearchable,
          changeSearchHandler = _this$props3.changeSearchHandler,
          withTabs = _this$props3.withTabs,
          searchLabel = _this$props3.searchLabel,
          searchPlaceholder = _this$props3.searchPlaceholder,
          getSearchInputHandler = _this$props3.getSearchInputHandler,
          searchByValue = _this$props3.searchByValue;
      var _this$state2 = this.state,
          search = _this$state2.search,
          tumblerIsActive = _this$state2.tumblerIsActive,
          withGroups = _this$state2.withGroups,
          isSorting = _this$state2.isSorting,
          stateOfOptions = _this$state2.stateOfOptions;

      if (!stateOfOptions) {
        return null;
      }

      var resultOptions = stateOfOptions;

      if (isSearchable || getSearchInputHandler) {
        resultOptions = filterItems(stateOfOptions, search, searchByValue);
      }

      if (resultOptions.length === 0 && !isSearchable) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "select _opened js-select ".concat(isSorting ? '_sorting' : '', " ").concat(withGroups ? '_with-groups' : '', " ").concat(className || ''),
        ref: function ref(el) {
          _this2.select = el;
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "select__outer-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "select__wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "select__list-wrapper"
      }, withTabs && isMulti && this.renderTabs(), isSearchable && /*#__PURE__*/React__default.createElement("div", {
        className: "select__list-input-wrapper"
      }, /*#__PURE__*/React__default.createElement(TextField, {
        iconName: "Search" // inputRef={el => { this.searchInput = el; }}
        ,
        label: searchLabel,
        placeholder: searchPlaceholder || 'Search',
        value: changeSearchHandler ? undefined : search,
        onChange: changeSearchHandler || this.handleChangeSearch,
        withBorder: true
      })), this.renderButton(), tumbler && /*#__PURE__*/React__default.createElement(Tumbler, {
        className: "select__tumbler",
        onChange: this.toggleTumbler,
        on: tumblerIsActive,
        title: tumblerLabel || 'Show groups'
      }), this.renderList(resultOptions)))));
    }
  }]);

  return SelectList;
}(Component);
SelectList.propTypes = {
  options: PropTypes__default.array,
  value: PropTypes__default.any,
  onChange: PropTypes__default.func,
  isMulti: PropTypes__default.bool,
  tumblerIsActive: PropTypes__default.bool,
  tumbler: PropTypes__default.bool,
  onTumblerChange: PropTypes__default.func,
  reactLabel: PropTypes__default.elementType,
  labelImageSrc: PropTypes__default.string,
  tumblerLabel: PropTypes__default.string,
  isSearchable: PropTypes__default.bool,
  searchByValue: PropTypes__default.bool,
  className: PropTypes__default.string,
  levelPadding: PropTypes__default.number,
  changeSearchHandler: PropTypes__default.func,
  buttonProps: PropTypes__default.exact({
    label: PropTypes__default.string,
    className: PropTypes__default.string,
    onClick: PropTypes__default.func,
    symbolBeforeLabel: PropTypes__default.string
  }),
  withTabs: PropTypes__default.bool,
  searchLabel: PropTypes__default.string,
  searchPlaceholder: PropTypes__default.string,
  getSearchInputHandler: PropTypes__default.func
};

var css_248z$h = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes block-module_hover-ripples__3skDp {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.block-module_block__3u3oe {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: .5rem 1rem;\n  border-radius: .25rem;\n  background: #f4f4f4; }\n\n.block-module_remove__1zRqd {\n  align-self: flex-end;\n  margin-bottom: 1rem;\n  margin-right: -.25rem; }\n";
var styles$g = {"block":"block-module_block__3u3oe","remove":"block-module_remove__1zRqd","hover-ripples":"block-module_hover-ripples__3skDp"};
styleInject(css_248z$h);

function _createSuper$B(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$B(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var BlockRemove = function BlockRemove(_ref) {
  var _ref$onRemoveClick = _ref.onRemoveClick,
      onRemoveClick = _ref$onRemoveClick === void 0 ? function () {} : _ref$onRemoveClick;
  return /*#__PURE__*/React__default.createElement(ButtonCircle, {
    iconName: "Close",
    className: styles$g.remove,
    onClick: onRemoveClick
  });
};
var Block = function Block(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      children = _ref2.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$g.block, " ").concat(className)
  }, children);
};
var ParamsBlock = /*#__PURE__*/function (_React$Component) {
  inherits(ParamsBlock, _React$Component);

  var _super = _createSuper$B(ParamsBlock);

  function ParamsBlock() {
    var _this;

    classCallCheck(this, ParamsBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isActive: false
    };

    _this.handleOnClick = function () {
      var onClick = _this.props.onClick;
      var isActive = _this.state.isActive;

      _this.setState({
        isActive: !isActive
      });

      if (onClick) {
        onClick();
      }
    };

    return _this;
  }

  createClass(ParamsBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          title = _this$props.title,
          list = _this$props.list;
      var isActive = this.state.isActive;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$g.paramsBlock, " ").concat(isActive ? '_active' : '', " ").concat(className),
        onClick: this.handleOnClick
      }, /*#__PURE__*/React__default.createElement("header", {
        className: styles$g.paramsBlockHeader
      }, /*#__PURE__*/React__default.createElement("h4", {
        className: styles$g.paramsBlockTitle
      }, title)), /*#__PURE__*/React__default.createElement("ul", {
        className: styles$g.paramsBlockList
      }, list.map(function (i) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: styles$g.paramsBlockItem,
          key: i.label,
          style: {
            minWidth: "100 / ".concat(list.length, "%")
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          className: styles$g.paramsBlockLabel
        }, i.label), /*#__PURE__*/React__default.createElement("span", {
          className: styles$g.paramsBlockValue
        }, i.value));
      })));
    }
  }]);

  return ParamsBlock;
}(React__default.Component);
var DateBlock = function DateBlock(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      date = _ref3.date;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$g.dateBlock, " ").concat(className)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: styles$g.dateBlockValue
  }, date));
};
Block.propTypes = {
  className: PropTypes__default.string,
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.element), PropTypes__default.element])
};
BlockRemove.propTypes = {
  onRemoveClick: PropTypes__default.func
};
ParamsBlock.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.string.isRequired,
  list: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.string,
    value: PropTypes__default.string
  })).isRequired,
  onClick: PropTypes__default.func
};
DateBlock.propTypes = {
  className: PropTypes__default.string,
  date: PropTypes__default.string
};

var css_248z$i = ".index-module_grid__3x3Ch {\n  display: grid;\n  width: 100%; }\n";
var styles$h = {"grid":"index-module_grid__3x3Ch"};
styleInject(css_248z$i);

var DisplayItems = function DisplayItems(props) {
  var items = props.items,
      itemClassName = props.itemClassName,
      type = props.type,
      listClassName = props.listClassName,
      gridClassName = props.gridClassName,
      gridColumnCount = props.gridColumnCount;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, type === 'list' ? /*#__PURE__*/React__default.createElement("div", {
    className: listClassName ? listClassName : ''
  }, /*#__PURE__*/React__default.createElement("ul", null, items.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: item.id || idx,
      className: itemClassName ? itemClassName : ''
    }, item.element);
  }))) : /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(gridClassName, " ").concat(styles$h.grid),
    style: {
      gridTemplateColumns: "repeat(".concat(gridColumnCount, ", 1fr)")
    }
  }, items.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.id || idx,
      className: itemClassName
    }, item.element);
  })));
};
DisplayItems.defaultProps = {
  gridClassName: '',
  listClassName: '',
  type: 'list'
};
DisplayItems.propTypes = {
  listClassName: PropTypes__default.string,
  gridClassName: PropTypes__default.object,
  items: PropTypes__default.array.isRequired,
  type: PropTypes__default.oneOf(['grid', 'list'])
};

var css_248z$j = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes actionMenu-module_hover-ripples__1mcLu {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.actionMenu-module_list__13tRc {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 8.25rem;\n  border-radius: 0.125rem;\n  border: 0.0625rem solid var(--primary2);\n  background: #ffffff;\n  box-shadow: 0 0 0.25rem 0 rgba(162, 162, 162, 0.5);\n  overflow: hidden; }\n\n.actionMenu-module_itemBtn__OCUvI {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  display: flex;\n  align-items: center;\n  padding: .5rem 1rem;\n  width: 100%;\n  transition: color .25s;\n  cursor: pointer;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #000000;\n  white-space: nowrap; }\n  .actionMenu-module_itemBtn__OCUvI:focus {\n    outline: 0; }\n  .actionMenu-module_itemBtn__OCUvI:hover {\n    background-color: var(--primary6); }\n\n.actionMenu-module_icon__D-ytm {\n  margin-right: 1rem; }\n  .actionMenu-module_icon__D-ytm svg {\n    width: 0.875rem;\n    height: 0.875rem;\n    display: block;\n    fill: #787878; }\n\n.actionMenu-module_close__2J-tL {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  position: absolute;\n  top: 0.3125rem;\n  right: 0.375rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 50%;\n  cursor: pointer; }\n  .actionMenu-module_close__2J-tL:focus {\n    outline: 0; }\n  .actionMenu-module_close__2J-tL svg {\n    width: auto;\n    height: 1.125rem; }\n  .actionMenu-module_close__2J-tL path {\n    fill: var(--primary2);\n    transition: fill .25s; }\n  .actionMenu-module_close__2J-tL:hover path {\n    fill: var(--primary2); }\n";
var styles$i = {"list":"actionMenu-module_list__13tRc","itemBtn":"actionMenu-module_itemBtn__OCUvI","icon":"actionMenu-module_icon__D-ytm","close":"actionMenu-module_close__2J-tL","hover-ripples":"actionMenu-module_hover-ripples__1mcLu"};
styleInject(css_248z$j);

var ActionMenu = function ActionMenu(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      actions = props.actions,
      close = props.close;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$i.list, " ").concat(className)
  }, actions && !!actions.length && actions.map(function (action) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: action.label,
      className: styles$i.itemBtn,
      onClick: function onClick(e) {
        e.stopPropagation();
        action.onClick();
        if (close) close();
      }
    }, action.label);
  }));
};
ActionMenu.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array,
  close: PropTypes.func
};

function _createSuper$C(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$C(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ActionButton = /*#__PURE__*/function (_React$Component) {
  inherits(ActionButton, _React$Component);

  var _super = _createSuper$C(ActionButton);

  function ActionButton() {
    classCallCheck(this, ActionButton);

    return _super.apply(this, arguments);
  }

  createClass(ActionButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          actions = _this$props.actions,
          _this$props$rightDrop = _this$props.rightDrop,
          rightDrop = _this$props$rightDrop === void 0 ? false : _this$props$rightDrop,
          _this$props$disableAc = _this$props.disableAction,
          disableAction = _this$props$disableAc === void 0 ? false : _this$props$disableAc;
      return /*#__PURE__*/React__default.createElement(Opener, {
        className: "opener__container ".concat(className),
        btnClassName: "".concat(disableAction ? 'opener_disabled' : ''),
        disabled: disableAction,
        btn: /*#__PURE__*/React__default.createElement("button", {
          className: "btn-transparent opener__btn ".concat(disableAction ? 'opener__btn_disabled' : ''),
          disabled: disableAction
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "More"
        })),
        content: /*#__PURE__*/React__default.createElement(ActionMenu, {
          actions: actions
        }),
        contentClassName: "opener__content ".concat(rightDrop ? 'opener__content_right-drop' : '')
      });
    }
  }]);

  return ActionButton;
}(React__default.Component);
ActionButton.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.array,
  rightDrop: PropTypes.bool,
  disableAction: PropTypes.bool
};

var css_248z$k = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__cRW4x {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_block__2WiCD {\n  padding: 1rem;\n  position: relative; }\n  .index-module_block__2WiCD:not(:last-child) {\n    margin-bottom: 1rem; }\n  .index-module_blockHeader__2VP_z {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem; }\n  .index-module_blockRow__12PVT {\n    display: flex;\n    flex-wrap: wrap; }\n    .index-module_blockRow__12PVT:not(:last-child) {\n      margin-bottom: 1rem; }\n    .index-module_blockRow__12PVT .text-field._error .text-field__label {\n      color: #a2a2a2; }\n  .index-module_blockTitle__1kzZL {\n    display: flex;\n    align-items: center;\n    flex-shrink: 1; }\n    .index-module_blockTitleText__3fALn {\n      display: flex;\n      flex-shrink: 0;\n      align-items: center;\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: 700;\n      font-size: 0.875rem;\n      line-height: 1.2;\n      min-width: 6rem;\n      margin-right: 2rem; }\n  .index-module_blockTooltip__29hII {\n    margin-left: 0.5rem;\n    line-height: 0; }\n    .index-module_blockTooltip__29hII .tooltipV2__label {\n      line-height: 1.21429em; }\n  .index-module_blockTitle2__1aDGr {\n    margin: 2rem 0 1rem;\n    font-weight: 400; }\n  .index-module_blockSubtitle__3AbWg {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    margin-top: -1rem;\n    margin-bottom: 1.5rem;\n    color: #a2a2a2;\n    line-height: 1.4; }\n    .index-module_blockSubtitle__3AbWg a {\n      color: #a2a2a2; }\n\n.index-module_goalCol__2dLLy {\n  border-left: 0.0625rem solid rgba(162, 162, 162, 0.5); }\n\n.index-module_p__2uFUj {\n  color: #818181; }\n\n.index-module_locationSelects__1GFRa {\n  display: flex;\n  align-items: center; }\n  .index-module_locationSelects__1GFRa i {\n    margin: 0 0.5rem; }\n  .index-module_locationSelects__1GFRa span {\n    margin-top: 0.25rem; }\n\n.index-module_locationMap__3l7si {\n  height: 12.5rem;\n  border: 0.0625rem solid #a2a2a2; }\n  .index-module_locationMap__3l7si iframe {\n    width: 100%;\n    height: 100%; }\n\n.index-module_deviceType__3f5s4 {\n  padding: 1rem;\n  border: 0.0625rem solid #f4f4f4; }\n  .index-module_deviceTypeRow__1-JeK {\n    display: flex;\n    margin: 0 -0.25rem; }\n  .index-module_deviceTypeItem__3v4F0 {\n    flex: 0 1 20%;\n    min-width: 20%;\n    max-width: 20%;\n    padding: 0 0.25rem; }\n  .index-module_deviceTypeIcon__2rKPG {\n    margin-right: 0.75rem;\n    height: 0.75rem;\n    line-height: 0; }\n    .index-module_deviceTypeIcon__2rKPG svg {\n      height: 100%;\n      width: auto; }\n  .index-module_deviceTypeName__906bQ {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    color: #000000;\n    text-transform: capitalize; }\n\n.index-module_buttons__ZYf1J {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem; }\n  .index-module_buttons__ZYf1J button:not(:last-child) {\n    margin-right: 1rem; }\n\n.index-module_input__3-ECy {\n  flex-grow: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n  .index-module_input__3-ECy.index-module_first__1uHIL {\n    justify-content: flex-start; }\n  .index-module_inputLabel__2tlm8, .index-module_inputLabel__2tlm8.text-label {\n    margin: 0;\n    padding-right: 0.5rem; }\n  .index-module_input__3-ECy.index-module_first__1uHIL .index-module_inputLabel__2tlm8 {\n    flex: 1 1 calc(100% - 28rem / 16);\n    max-width: 13.625rem; }\n  .index-module_inputField__mrlL3 {\n    flex: 1 1 auto; }\n  .index-module_inputNumberInput__lO0hB:not(:first-child) {\n    margin-left: 0; }\n  .index-module_inputSelect__1j1la.select {\n    max-width: 10rem; }\n  .index-module_inputSelect__1j1la.select:not(._opened) {\n    z-index: 0; }\n  .index-module_inputButtons__3hwUE {\n    display: flex;\n    align-items: center; }\n    .index-module_inputButtons__3hwUE > *:not(:last-child) {\n      margin-right: 0.75rem; }\n\n.index-module_inputsListTitles__8SXaS {\n  padding-top: 2.125rem; }\n\n.index-module_inputsListTiles__2EBhc {\n  display: flex;\n  align-items: flex-start;\n  margin-left: -1rem; }\n\n.index-module_inputsListTile__2L40M {\n  padding: 1rem;\n  width: 12.5rem; }\n  .index-module_inputsListTile__2L40M:not(:last-child) {\n    margin-right: 1rem; }\n  .index-module_inputsListTileTitle__2fmHT {\n    height: 1.0625rem; }\n\n.index-module_inputsListRow__MShGg, .index-module_inputsListRow__MShGg.text-label {\n  display: flex;\n  align-items: flex-end;\n  margin: 0;\n  width: 100%;\n  height: 2.75rem; }\n\n.index-module_titles__1G2H0 {\n  align-self: stretch;\n  padding-top: 3.375rem; }\n  .index-module_titlesItem__2jpuW {\n    margin: 0; }\n    .index-module_titlesItem__2jpuW:not(:last-child) {\n      margin-bottom: 2.125rem; }\n\n.index-module_summary__nCqWd {\n  line-height: 1.4;\n  flex-grow: 1; }\n  .index-module_summaryContainer__dSvxT {\n    margin-right: 1rem; }\n  .index-module_summaryLabel__1l3DG {\n    color: #a2a2a2; }\n\n.index-module_arrow__1ZzLU {\n  margin-left: 1rem;\n  flex-shrink: 0;\n  cursor: pointer; }\n  .index-module_arrow__1ZzLU .btn-circle {\n    z-index: 1;\n    background-color: #ffffff; }\n\n.index-module_blockIndex__3Qnvm {\n  margin-right: 1.5rem; }\n\n.index-module_actionsWrapper__3AP-L {\n  display: flex;\n  align-items: center; }\n";
var compStyles = {"block":"index-module_block__2WiCD","blockHeader":"index-module_blockHeader__2VP_z","blockRow":"index-module_blockRow__12PVT","blockTitle":"index-module_blockTitle__1kzZL","blockTitleText":"index-module_blockTitleText__3fALn","blockTooltip":"index-module_blockTooltip__29hII","blockTitle2":"index-module_blockTitle2__1aDGr","blockSubtitle":"index-module_blockSubtitle__3AbWg","goalCol":"index-module_goalCol__2dLLy","p":"index-module_p__2uFUj","locationSelects":"index-module_locationSelects__1GFRa","locationMap":"index-module_locationMap__3l7si","deviceType":"index-module_deviceType__3f5s4","deviceTypeRow":"index-module_deviceTypeRow__1-JeK","deviceTypeItem":"index-module_deviceTypeItem__3v4F0","deviceTypeIcon":"index-module_deviceTypeIcon__2rKPG","deviceTypeName":"index-module_deviceTypeName__906bQ","buttons":"index-module_buttons__ZYf1J","input":"index-module_input__3-ECy","first":"index-module_first__1uHIL","inputLabel":"index-module_inputLabel__2tlm8","inputField":"index-module_inputField__mrlL3","inputNumberInput":"index-module_inputNumberInput__lO0hB","inputSelect":"index-module_inputSelect__1j1la","inputButtons":"index-module_inputButtons__3hwUE","inputsListTitles":"index-module_inputsListTitles__8SXaS","inputsListTiles":"index-module_inputsListTiles__2EBhc","inputsListTile":"index-module_inputsListTile__2L40M","inputsListTileTitle":"index-module_inputsListTileTitle__2fmHT","inputsListRow":"index-module_inputsListRow__MShGg","titles":"index-module_titles__1G2H0","titlesItem":"index-module_titlesItem__2jpuW","summary":"index-module_summary__nCqWd","summaryContainer":"index-module_summaryContainer__dSvxT","summaryLabel":"index-module_summaryLabel__1l3DG","arrow":"index-module_arrow__1ZzLU","blockIndex":"index-module_blockIndex__3Qnvm","actionsWrapper":"index-module_actionsWrapper__3AP-L","hover-ripples":"index-module_hover-ripples__cRW4x"};
styleInject(css_248z$k);

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var CollapsibleBlock = function CollapsibleBlock(props) {
  var children = props.children,
      header = props.header,
      collapsible = props.collapsible,
      _props$isCollapseOpen = props.isCollapseOpen,
      isCollapseOpen = _props$isCollapseOpen === void 0 ? false : _props$isCollapseOpen,
      onToggle = props.onToggle,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      id = props.id,
      customStyle = props.customStyle,
      titleIcons = props.titleIcons,
      _props$shouldUnmount = props.shouldUnmount,
      shouldUnmount = _props$shouldUnmount === void 0 ? false : _props$shouldUnmount,
      _props$persistSummary = props.persistSummary,
      persistSummary = _props$persistSummary === void 0 ? false : _props$persistSummary,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions;

  var _useState = useState(!collapsible),
      _useState2 = slicedToArray(_useState, 2),
      internalIsOpen = _useState2[0],
      setInternalIsOpen = _useState2[1];

  useEffect(function () {
    if (isCollapseOpen !== internalIsOpen) {
      setInternalIsOpen(isCollapseOpen);
    }
  }, [isCollapseOpen]);

  var getSummary = function getSummary() {
    return header && Object.keys(header.summary).map(function (key) {
      return header.summary[key].length ? /*#__PURE__*/React__default.createElement("span", {
        className: styles.summaryContainer,
        key: key
      }, /*#__PURE__*/React__default.createElement("span", {
        className: styles.summaryLabel
      }, key, ": "), header.icon && /*#__PURE__*/React__default.createElement("span", null, header.icon[key]), /*#__PURE__*/React__default.createElement("span", {
        className: styles.summaryValue
      }, header.summary[key])) : null;
    });
  };

  var styles = useMemo(function () {
    if (customStyle) {
      return _objectSpread$a(_objectSpread$a({}, compStyles), customStyle);
    }

    return compStyles;
  }, [customStyle]);
  var handleToggle = useCallback(function () {
    if (collapsible) {
      onToggle === null || onToggle === void 0 ? void 0 : onToggle(!internalIsOpen, id);
      console.log('Setting from toggle as' + !internalIsOpen);
      setInternalIsOpen(!internalIsOpen);
    }
  }, [collapsible, internalIsOpen, onToggle, id]);
  var shouldExpandBlock = useMemo(function () {
    return collapsible ? isBoolean(isCollapseOpen) && isCollapseOpen || !isBoolean(isCollapseOpen) && internalIsOpen : true;
  }, [internalIsOpen, isCollapseOpen, collapsible]);
  var _styles$panelHeaderEx = styles.panelHeaderExpand,
      panelHeaderExpand = _styles$panelHeaderEx === void 0 ? '' : _styles$panelHeaderEx,
      _styles$panelHeaderCo = styles.panelHeaderCollapse,
      panelHeaderCollapse = _styles$panelHeaderCo === void 0 ? '' : _styles$panelHeaderCo;
  return /*#__PURE__*/React__default.createElement("div", {
    id: id,
    className: "block ".concat(styles.block, " ").concat(className)
  }, header && /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles.blockHeader, " ").concat(shouldExpandBlock ? panelHeaderExpand : "".concat(panelHeaderCollapse, " mb-0")),
    onClick: handleToggle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "block-title ".concat(styles.blockTitle)
  }, header.id && /*#__PURE__*/React__default.createElement("div", {
    className: styles.blockIndex
  }, header.id), /*#__PURE__*/React__default.createElement("h4", {
    className: styles.blockTitleText
  }, header.title), header && (!shouldExpandBlock || persistSummary) && header.summary && /*#__PURE__*/React__default.createElement("div", {
    className: styles.summary
  }, getSummary())), titleIcons && shouldExpandBlock && /*#__PURE__*/React__default.createElement("ul", {
    className: styles.titleIconsWrapper
  }, titleIcons.map(function (icon) {
    return /*#__PURE__*/React__default.createElement("li", {
      onClick: function onClick(e) {
        e.stopPropagation();
        icon.onClick();
      },
      key: icon.label
    }, /*#__PURE__*/React__default.createElement(Icon, {
      className: icon.className ? icon.className : '',
      name: icon.iconName
    }));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "actions ".concat(styles.actionsWrapper)
  }, collapsible && /*#__PURE__*/React__default.createElement("div", {
    className: styles.arrow
  }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
    onClick: handleToggle,
    iconName: shouldExpandBlock ? 'Expand' : 'Right'
  })), actions.length > 0 && /*#__PURE__*/React__default.createElement(ActionButton, {
    className: styles.actions,
    actions: actions
  }))), shouldUnmount && shouldExpandBlock && /*#__PURE__*/React__default.createElement("div", null, children), !shouldUnmount && /*#__PURE__*/React__default.createElement("div", {
    hidden: !shouldExpandBlock
  }, children));
};
CollapsibleBlock.propTypes = {
  collapsible: PropTypes__default.bool,
  isCollapseOpen: PropTypes__default.bool,
  onToggle: PropTypes__default.func,
  className: PropTypes__default.string,
  isExtended: PropTypes__default.bool,
  header: PropTypes__default.shape({
    title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]).isRequired,
    summary: PropTypes__default.object,
    id: PropTypes__default.number,
    icon: PropTypes__default.object
  }),
  id: PropTypes__default.string,
  customStyle: PropTypes__default.object,
  shouldUnmount: PropTypes__default.bool,
  persistSummary: PropTypes__default.bool,
  actions: PropTypes__default.array
};

var css_248z$l = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes paramsCard-module_hover-ripples__2YmS_ {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.paramsCard-module_card__149g7 {\n  position: relative; }\n  .paramsCard-module_card__149g7:not(:last-child) {\n    border-bottom: 0.0625rem solid #f4f4f4; }\n\n.paramsCard-module_wrapper__1WX4v {\n  position: relative;\n  padding: .75rem 1.5rem .5rem;\n  transition: background-color .25s; }\n\n.paramsCard-module_card__149g7:not(._blue) .paramsCard-module_wrapper__1WX4v {\n  cursor: pointer; }\n  .paramsCard-module_card__149g7:not(._blue) .paramsCard-module_wrapper__1WX4v:hover {\n    background: #f2f5ff; }\n\n.paramsCard-module_card__149g7._active .paramsCard-module_wrapper__1WX4v {\n  background-color: #dee2ff; }\n\n.paramsCard-module_card__149g7._blue .paramsCard-module_wrapper__1WX4v {\n  background-color: rgba(var(--primary2), 0.125); }\n\n.paramsCard-module_card__149g7._active .paramsCard-module_wrapper__1WX4v:before, .paramsCard-module_card__149g7._blue .paramsCard-module_wrapper__1WX4v:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: .25rem;\n  background-color: var(--primary2); }\n\n.paramsCard-module_card__149g7._sub-content .paramsCard-module_wrapper__1WX4v {\n  display: none; }\n\n.paramsCard-module_header__29XY_ {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: .75rem; }\n\n.paramsCard-module_countsContainer__2ha9_ {\n  display: flex;\n  justify-content: space-between;\n  min-width: 4.5rem;\n  flex-shrink: 0; }\n\n.paramsCard-module_countsItem__10eOr {\n  display: flex;\n  align-items: center;\n  margin: 0 0.5rem; }\n\n.paramsCard-module_countsIcon__1LcPM {\n  font-family: 'Avenir Next Bold', sans-serif;\n  font-weight: normal;\n  font-size: 0.625rem;\n  line-height: 1;\n  height: 0.375rem;\n  width: 0.375rem;\n  border-radius: 50%;\n  margin-right: 0.25rem;\n  display: flex;\n  align-items: center; }\n  .paramsCard-module_countsIconGreen__2Vcop {\n    background-color: #3F9B34; }\n  .paramsCard-module_countsIconRed__hJ3ri {\n    background-color: #FF5859; }\n\n.paramsCard-module_countsText__2QyUI {\n  font-family: 'Avenir Next Bold', sans-serif;\n  font-weight: normal;\n  font-size: 0.625rem;\n  line-height: 0.875rem;\n  color: #666666; }\n\n.paramsCard-module_title__2PKks {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.75rem;\n  line-height: 0.875rem;\n  color: #000000;\n  word-break: break-word; }\n\n.paramsCard-module_card__149g7._blue .paramsCard-module_title__2PKks {\n  font-size: 1.125rem;\n  line-height: 1.22222rem;\n  color: var(--primary2); }\n\n.paramsCard-module_list__36Gh- {\n  display: flex;\n  margin: 0 -.5rem;\n  padding: 0; }\n\n.paramsCard-module_item__iQ0WW {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 0 .5rem;\n  min-width: 0;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem; }\n\n.paramsCard-module_label__1pdM- {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.625rem;\n  line-height: 0.875rem;\n  color: #787878;\n  white-space: nowrap; }\n\n.paramsCard-module_value__1rtmv {\n  font-family: 'Avenir Next Bold', sans-serif;\n  font-weight: normal;\n  overflow: hidden;\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  color: var(--primary1); }\n\n.paramsCard-module_card__149g7._blue .paramsCard-module_value__1rtmv {\n  color: var(--primary2); }\n\n.paramsCard-module_menu__2Q3PX {\n  position: absolute !important;\n  z-index: 1;\n  top: .5rem;\n  right: .625rem; }\n  .paramsCard-module_menu__2Q3PX._opened {\n    z-index: 4; }\n\n.paramsCard-module_card__149g7._sub-content .paramsCard-module_menu__2Q3PX {\n  display: none; }\n\n.paramsCard-module_card__149g7:not(._sub-content) .paramsCard-module_subContent__1iFx9 {\n  display: none; }\n";
var styles$j = {"card":"paramsCard-module_card__149g7","wrapper":"paramsCard-module_wrapper__1WX4v","header":"paramsCard-module_header__29XY_","countsContainer":"paramsCard-module_countsContainer__2ha9_","countsItem":"paramsCard-module_countsItem__10eOr","countsIcon":"paramsCard-module_countsIcon__1LcPM","countsIconGreen":"paramsCard-module_countsIconGreen__2Vcop","countsIconRed":"paramsCard-module_countsIconRed__hJ3ri","countsText":"paramsCard-module_countsText__2QyUI","title":"paramsCard-module_title__2PKks","list":"paramsCard-module_list__36Gh-","item":"paramsCard-module_item__iQ0WW","label":"paramsCard-module_label__1pdM-","value":"paramsCard-module_value__1rtmv","menu":"paramsCard-module_menu__2Q3PX","subContent":"paramsCard-module_subContent__1iFx9","hover-ripples":"paramsCard-module_hover-ripples__2YmS_"};
styleInject(css_248z$l);

var ParamsCard = function ParamsCard(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      title = props.title,
      list = props.list,
      actions = props.actions,
      isActive = props.isActive,
      onClick = props.onClick,
      isBlue = props.isBlue,
      subContent = props.subContent,
      isSubContentOpen = props.isSubContentOpen,
      counts = props.counts,
      titleLeft = props.titleLeft,
      titleRight = props.titleRight,
      onClickIndicators = props.onClickIndicators;

  var handleOnClick = function handleOnClick() {
    if (onClick) {
      onClick();
    }
  };

  var classNames = [styles$j.card];

  if (isActive) {
    classNames.push('_active');
  }

  if (subContent && isSubContentOpen) {
    classNames.push('_sub-content');
  }

  if (isBlue) {
    classNames.push('_blue');
  }

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames.join(' ')
  }, actions && /*#__PURE__*/React__default.createElement(ActionButton, {
    className: styles$j.menu,
    actions: actions
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.wrapper,
    onClick: handleOnClick
  }, /*#__PURE__*/React__default.createElement("header", {
    className: styles$j.header
  }, titleLeft && titleLeft, /*#__PURE__*/React__default.createElement("h4", {
    className: styles$j.title
  }, title), counts && /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.countsContainer,
    onClick: onClickIndicators
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.countsItem
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$j.countsIcon, " ").concat(styles$j.countsIconGreen)
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles$j.countsText
  }, counts.whitelist)), /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.countsItem
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$j.countsIcon, " ").concat(styles$j.countsIconRed)
  }), /*#__PURE__*/React__default.createElement("span", {
    className: styles$j.countsText
  }, counts.blacklist))), titleRight && titleRight), /*#__PURE__*/React__default.createElement("ul", {
    className: styles$j.list
  }, list.map(function (i, k) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: styles$j.item,
      key: typeof i.label === 'string' ? i.label : k,
      style: {
        minWidth: "".concat(100 / list.length, "%")
      }
    }, /*#__PURE__*/React__default.createElement("span", {
      className: styles$j.value
    }, i.value), /*#__PURE__*/React__default.createElement("span", {
      className: styles$j.label
    }, i.label));
  }))), subContent && isSubContentOpen && /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.subContent
  }, subContent));
};
ParamsCard.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  list: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
    value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number, PropTypes__default.element])
  })).isRequired,
  onClick: PropTypes__default.func,
  isActive: PropTypes__default.bool,
  actions: PropTypes__default.array,
  isBlue: PropTypes__default.bool,
  subContent: PropTypes__default.element,
  isSubContentOpen: PropTypes__default.bool,
  counts: PropTypes__default.shape({
    whitelist: number,
    blacklist: number
  }),
  onClickIndicators: PropTypes__default.func
};

var css_248z$m = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes paramsCardsDate-module_hover-ripples__2Zokf {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.paramsCardsDate-module_date__Q-VSi {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 1.5rem;\n  height: 2rem;\n  border-top: 0.0625rem solid #f4f4f4;\n  border-bottom: 0.0625rem solid #f4f4f4;\n  background-color: #f9f9f9; }\n  .paramsCardsDate-module_dateValue__3_SQ2 {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    color: #787878; }\n";
var styles$k = {"date":"paramsCardsDate-module_date__Q-VSi","dateValue":"paramsCardsDate-module_dateValue__3_SQ2","hover-ripples":"paramsCardsDate-module_hover-ripples__2Zokf"};
styleInject(css_248z$m);

var ParamsCardsDate = function ParamsCardsDate(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      date = _ref.date;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$k.date, " ").concat(className)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: styles$k.dateValue
  }, date));
};
ParamsCardsDate.propTypes = {
  className: PropTypes__default.string,
  date: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element])
};

var css_248z$n = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes list-module_hover-ripples___xUJL {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.list-module_btn-transparent__3W6RY {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none; }\n  .list-module_btn-transparent__3W6RY:focus {\n    outline: 0; }\n\n.list-module_container__1eoFb {\n  flex: 1 1 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; }\n\n.list-module_list__26nmP {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain; }\n\n.list-module_search__3mT3d {\n  position: relative; }\n  .list-module_searchWrapper__2BSCK {\n    display: flex;\n    align-items: center;\n    padding: 1rem 1.5rem; }\n\n.list-module_textField__1hRbA {\n  flex: 1 1 auto;\n  min-width: 0; }\n\n.list-module_showSearch__2Cj-w {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  position: absolute;\n  z-index: 4;\n  top: 1rem;\n  left: 1.25rem;\n  width: 1.25rem;\n  transform: translateY(-50%);\n  cursor: pointer; }\n  .list-module_showSearch__2Cj-w:focus {\n    outline: 0; }\n  .list-module_showSearch__2Cj-w svg {\n    width: 100%;\n    height: auto; }\n  .list-module_showSearch__2Cj-w path {\n    fill: #787878; }\n\n.list-module_close__1a9Rw.btn-circle {\n  flex: 0 0 1.25rem;\n  margin-left: 1rem;\n  width: 0.875rem;\n  height: 0.875rem; }\n  .list-module_close__1a9Rw.btn-circle:before, .list-module_close__1a9Rw.btn-circle:after {\n    width: 1.25rem; }\n";
var styles$l = {"btn-transparent":"list-module_btn-transparent__3W6RY","container":"list-module_container__1eoFb","list":"list-module_list__26nmP","search":"list-module_search__3mT3d","searchWrapper":"list-module_searchWrapper__2BSCK","textField":"list-module_textField__1hRbA","showSearch":"list-module_showSearch__2Cj-w","close":"list-module_close__1a9Rw","hover-ripples":"list-module_hover-ripples___xUJL"};
styleInject(css_248z$n);

function _createSuper$D(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$D(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ParamsCardsList = /*#__PURE__*/function (_React$Component) {
  inherits(ParamsCardsList, _React$Component);

  var _super = _createSuper$D(ParamsCardsList);

  function ParamsCardsList() {
    var _this;

    classCallCheck(this, ParamsCardsList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onListScroll = function (_ref) {
      var target = _ref.target;
      var _this$props = _this.props,
          loadData = _this$props.loadData,
          isFetching = _this$props.isFetching;
      var ZOOM_FIX_ADDITIONAL_PX = 20;

      if (isFetching) {
        return;
      }

      if (target.scrollHeight - target.offsetHeight <= target.scrollTop + ZOOM_FIX_ADDITIONAL_PX) {
        loadData();
      }
    };

    _this.getInputRef = function (el) {
      _this.inputRef = el;
    };

    return _this;
  }

  createClass(ParamsCardsList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isSearchOpen = this.props.isSearchOpen;

      if (!prevProps.isSearchOpen && isSearchOpen && this.inputRef) {
        this.inputRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          children = _this$props2.children,
          searchValue = _this$props2.searchValue,
          onSearchChange = _this$props2.onSearchChange,
          toggleSearch = _this$props2.toggleSearch,
          isSearchOpen = _this$props2.isSearchOpen,
          loadData = _this$props2.loadData,
          isFetching = _this$props2.isFetching,
          skeleton = _this$props2.skeleton,
          noSearch = _this$props2.noSearch,
          listRef = _this$props2.listRef;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$l.container, " ").concat(className)
      }, noSearch ? null : /*#__PURE__*/React__default.createElement("div", {
        className: styles$l.search
      }, isSearchOpen ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$l.searchWrapper
      }, /*#__PURE__*/React__default.createElement(TextField, {
        className: styles$l.textField,
        label: "Search",
        iconName: "Search",
        value: searchValue,
        onChange: onSearchChange,
        inputRef: this.getInputRef
      }), /*#__PURE__*/React__default.createElement(ButtonCircle, {
        iconName: "Close",
        className: "".concat(styles$l.close),
        onClick: toggleSearch
      })) : /*#__PURE__*/React__default.createElement("button", {
        className: styles$l.showSearch,
        onClick: toggleSearch
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Search"
      }))), /*#__PURE__*/React__default.createElement("div", {
        ref: listRef,
        className: styles$l.list,
        onScroll: loadData ? this.onListScroll : null
      }, children, isFetching && skeleton));
    }
  }]);

  return ParamsCardsList;
}(React__default.Component);
ParamsCardsList.propTypes = {
  className: PropTypes__default.string,
  searchValue: PropTypes__default.string,
  onSearchChange: PropTypes__default.func,
  toggleSearch: PropTypes__default.func,
  isSearchOpen: PropTypes__default.bool,
  noSearch: PropTypes__default.bool,
  loadData: PropTypes__default.func,
  isFetching: PropTypes__default.bool,
  skeleton: PropTypes__default.element
};

var css_248z$o = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes rightbartabs-module_hover-ripples__gFfMH {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.rightbartabs-module_btn-transparent__1NnR4 {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none; }\n  .rightbartabs-module_btn-transparent__1NnR4:focus {\n    outline: 0; }\n\n.rightbartabs-module_tabs__3TPjq {\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n  width: 100%; }\n\n.rightbartabs-module_tab__2Db3r {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 0 0 20rem;\n  max-width: 20rem;\n  background-color: #ffffff; }\n  .rightbartabs-module_tab__2Db3r:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 0.0625rem;\n    background-color: #f4f4f4; }\n\n.rightbartabs-module_list__oKpKK {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0;\n  padding: .5rem 0;\n  width: 100%;\n  list-style: none; }\n\n.rightbartabs-module_item__227T5 {\n  padding: 0; }\n  .rightbartabs-module_item__227T5:not(:last-child) {\n    margin: 0 0 1rem; }\n";
var styles$m = {"btn-transparent":"rightbartabs-module_btn-transparent__1NnR4","tabs":"rightbartabs-module_tabs__3TPjq","tab":"rightbartabs-module_tab__2Db3r","list":"rightbartabs-module_list__oKpKK","item":"rightbartabs-module_item__227T5","hover-ripples":"rightbartabs-module_hover-ripples__gFfMH"};
styleInject(css_248z$o);

function _createSuper$E(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$E(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var RightbarTab = /*#__PURE__*/function (_React$Component) {
  inherits(RightbarTab, _React$Component);

  var _super = _createSuper$E(RightbarTab);

  function RightbarTab() {
    classCallCheck(this, RightbarTab);

    return _super.apply(this, arguments);
  }

  createClass(RightbarTab, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$m.tab
      }, children);
    }
  }]);

  return RightbarTab;
}(React__default.Component);
var RightbarTabs = /*#__PURE__*/function (_React$Component2) {
  inherits(RightbarTabs, _React$Component2);

  var _super2 = _createSuper$E(RightbarTabs);

  function RightbarTabs() {
    var _this;

    classCallCheck(this, RightbarTabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));

    _this.handleBtnClick = function (index) {
      return function () {
        var activeTabIndex = _this.state.activeTabIndex;
        var newActiveTabIndex = activeTabIndex === index ? null : index;

        _this.setState({
          activeTabIndex: newActiveTabIndex
        });
      };
    };

    _this.getTabs = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          setActiveTab = _this$props.setActiveTab;
      var tabs = [];
      React__default.Children.forEach(children, function (child) {
        tabs.push({
          child: child,
          button: {
            label: child.props.label,
            iconName: child.props.iconName,
            iconClassName: child.props.iconClassName || '',
            iconChildren: child.props.iconChildren,
            onClick: function onClick() {
              return setActiveTab(child.props.label);
            }
          }
        });
      });
      return tabs;
    };

    return _this;
  }

  createClass(RightbarTabs, [{
    key: "render",
    value: function render() {
      var activeLabel = this.props.activeLabel;
      var tabs = this.getTabs();
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$m.tabs
      }, activeLabel !== null && tabs.find(function (tab) {
        return tab.button.label === activeLabel;
      }).child, /*#__PURE__*/React__default.createElement("ul", {
        className: styles$m.list
      }, tabs.map(function (tab, k) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: styles$m.item,
          key: k
        }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
          iconName: tab.button.iconName,
          className: "".concat(tab.button.iconClassName, " ").concat(tab.button.label === activeLabel ? '_selected' : ''),
          onClick: tab.button.onClick
        }, tab.button.iconChildren));
      })));
    }
  }]);

  return RightbarTabs;
}(React__default.Component);
RightbarTabs.propTypes = {
  activeLabel: PropTypes__default.string,
  setActiveTab: PropTypes__default.func
};

var css_248z$p = ".actionSelect-module_container__2RRiI {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  vertical-align: top; }\n\n.actionSelect-module_content__3-e29 {\n  position: absolute;\n  top: 0;\n  left: 0; }\n";
var styles$n = {"container":"actionSelect-module_container__2RRiI","content":"actionSelect-module_content__3-e29"};
styleInject(css_248z$p);

function _createSuper$F(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$F(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ActionSelect = /*#__PURE__*/function (_React$Component) {
  inherits(ActionSelect, _React$Component);

  var _super = _createSuper$F(ActionSelect);

  function ActionSelect() {
    classCallCheck(this, ActionSelect);

    return _super.apply(this, arguments);
  }

  createClass(ActionSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? 'Change' : _this$props$title,
          actions = _this$props.actions;
      return /*#__PURE__*/React__default.createElement(Opener, {
        className: "".concat(styles$n.container, " ").concat(className),
        btn: /*#__PURE__*/React__default.createElement(Button, {
          className: "btn-round _conflower-blue"
        }, /*#__PURE__*/React__default.createElement("span", null, title), /*#__PURE__*/React__default.createElement("span", {
          className: "btn-content__icon"
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "Expand"
        }))),
        content: /*#__PURE__*/React__default.createElement(ActionMenu, {
          actions: actions
        }),
        contentClassName: styles$n.content,
        contentClose: false
      });
    }
  }]);

  return ActionSelect;
}(React__default.Component);
ActionSelect.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  actions: PropTypes.array
};

var css_248z$q = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.imageCard-module_title__vmMzO {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.875rem;\n  line-height: 1.125em; }\n\n@keyframes imageCard-module_hover-ripples__3hkps {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.imageCard-module_container__2hW68 {\n  position: relative;\n  border-radius: .25rem;\n  border: 0.0625rem solid #cbcbcb;\n  box-shadow: 0 0 0.25rem 0 rgba(162, 162, 162, 0.5); }\n  .imageCard-module_container__2hW68._sub-content {\n    background-color: #f4f4f4; }\n\n.imageCard-module_wrapper__1mE5S {\n  cursor: pointer; }\n\n.imageCard-module_image__1MNuZ {\n  width: 100%;\n  height: 13.125rem;\n  line-height: 0;\n  position: relative;\n  border-bottom: 0.0625rem solid #e0e0e0; }\n  .imageCard-module_image__1MNuZ img {\n    object-fit: contain;\n    width: 100%;\n    height: 100%; }\n  .imageCard-module_image__1MNuZ svg {\n    width: 6.5em;\n    height: 6.5em;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n\n.imageCard-module_icon__3ho8J {\n  position: absolute;\n  bottom: 0;\n  transform: translateY(50%);\n  left: 1.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 50%;\n  background: #ffffff;\n  line-height: 0;\n  box-shadow: 0 0 0.5rem 0 rgba(162, 162, 162, 0.5);\n  z-index: 1; }\n  .imageCard-module_icon__3ho8J svg {\n    width: 1.5rem; }\n\n.imageCard-module_content__1SrRP {\n  position: relative;\n  padding: 1rem 1.5rem;\n  border-radius: 0 0 .25rem .25rem;\n  background-color: #ffffff;\n  transition: background-color .25s; }\n  .imageCard-module_content__1SrRP:before {\n    cursor: pointer;\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: .5rem;\n    background-color: transparent;\n    transition: background-color .25s; }\n\n.imageCard-module_container__2hW68._selected .imageCard-module_content__1SrRP {\n  background-color: var(--primary6); }\n  .imageCard-module_container__2hW68._selected .imageCard-module_content__1SrRP:before {\n    background-color: var(--primary2); }\n\n.imageCard-module_header__3Zj1I {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: .75rem;\n  padding-top: 0.5rem;\n  padding-right: 1rem; }\n\n.imageCard-module_title__vmMzO {\n  font-family: 'Avenir Next Bold', sans-serif;\n  font-weight: normal;\n  word-break: break-word; }\n\n.imageCard-module_list__2Dkwv {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.imageCard-module_item__1QPZn {\n  display: flex;\n  align-items: baseline;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #000000; }\n  .imageCard-module_item__1QPZn:not(:last-child) {\n    margin-bottom: .25rem; }\n  .imageCard-module_itemLabel__1VQGl {\n    display: block;\n    margin-right: .25rem;\n    color: #a2a2a2;\n    width: 5.625rem;\n    flex-shrink: 0; }\n  .imageCard-module_itemValue__3dXTv {\n    word-break: break-word; }\n  .imageCard-module_item__1QPZn a {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    color: #000000;\n    text-decoration: underline; }\n\n.imageCard-module_menu__41UxI {\n  position: absolute !important;\n  top: 14rem;\n  right: 1rem; }\n\n.imageCard-module_loading__3oIII {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.5);\n  cursor: default;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .imageCard-module_loadingText__25FpV {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    color: #ffffff; }\n";
var styles$o = {"title":"imageCard-module_title__vmMzO","container":"imageCard-module_container__2hW68","wrapper":"imageCard-module_wrapper__1mE5S","image":"imageCard-module_image__1MNuZ","icon":"imageCard-module_icon__3ho8J","content":"imageCard-module_content__1SrRP","header":"imageCard-module_header__3Zj1I","list":"imageCard-module_list__2Dkwv","item":"imageCard-module_item__1QPZn","itemLabel":"imageCard-module_itemLabel__1VQGl","itemValue":"imageCard-module_itemValue__3dXTv","menu":"imageCard-module_menu__41UxI","loading":"imageCard-module_loading__3oIII","loadingText":"imageCard-module_loadingText__25FpV","hover-ripples":"imageCard-module_hover-ripples__3hkps"};
styleInject(css_248z$q);

var css_248z$r = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes imageCardCompact-module_hover-ripples__tkXIX {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.imageCardCompact-module_container__372Pe {\n  display: flex;\n  padding: .5rem;\n  background-color: #ffffff;\n  cursor: pointer;\n  transition: background-color .25s; }\n  .imageCardCompact-module_container__372Pe:hover {\n    background-color: var(--primary6); }\n  .imageCardCompact-module_container__372Pe._selected {\n    position: relative;\n    background-color: var(--primary6); }\n    .imageCardCompact-module_container__372Pe._selected:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      pointer-events: none;\n      width: .25rem;\n      background-color: var(--primary2); }\n\n.imageCardCompact-module_image__2vvpE {\n  flex: 0 0 5rem;\n  margin-right: 1rem;\n  height: 3rem; }\n  .imageCardCompact-module_image__2vvpE img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain; }\n\n.imageCardCompact-module_cardImage__2i7Rs {\n  width: 100%;\n  height: 100%; }\n\n.imageCardCompact-module_info__1iNO2 {\n  flex: 1 1 auto;\n  display: flex; }\n\n.imageCardCompact-module_item__2cxjc {\n  flex: 0 0 50%;\n  max-width: 50%; }\n  .imageCardCompact-module_item__2cxjc:not(:last-child) {\n    padding-right: .5rem; }\n\n.imageCardCompact-module_label__2NtQd {\n  margin-bottom: .25rem;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #666666; }\n\n.imageCardCompact-module_value__llE32 {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #000000;\n  word-break: break-word; }\n";
var styles$p = {"container":"imageCardCompact-module_container__372Pe","image":"imageCardCompact-module_image__2vvpE","cardImage":"imageCardCompact-module_cardImage__2i7Rs","info":"imageCardCompact-module_info__1iNO2","item":"imageCardCompact-module_item__2cxjc","label":"imageCardCompact-module_label__2NtQd","value":"imageCardCompact-module_value__llE32","hover-ripples":"imageCardCompact-module_hover-ripples__tkXIX"};
styleInject(css_248z$r);

var css_248z$s = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes cardImage-module_hover-ripples__1PgyJ {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.cardImage-module_container__1RBVw {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .cardImage-module_container__1RBVw img {\n    object-fit: contain;\n    width: 100%;\n    height: 100%; }\n\n.cardImage-module_loading__1qe-8 {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); }\n  .cardImage-module_loadingText__3Tjit {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    color: #ffffff; }\n";
var styles$q = {"container":"cardImage-module_container__1RBVw","loading":"cardImage-module_loading__1qe-8","loadingText":"cardImage-module_loadingText__3Tjit","hover-ripples":"cardImage-module_hover-ripples__1PgyJ"};
styleInject(css_248z$s);

function _createSuper$G(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$G(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CardImage = /*#__PURE__*/function (_React$Component) {
  inherits(CardImage, _React$Component);

  var _super = _createSuper$G(CardImage);

  function CardImage() {
    var _this;

    classCallCheck(this, CardImage);

    _this = _super.call(this);

    _this.onLoad = function () {
      return _this.setState({
        isLoading: false
      });
    };

    _this.onError = function () {
      return _this.setState({
        isError: true
      });
    };

    _this.state = {
      isLoading: true,
      isError: false
    };
    return _this;
  }

  createClass(CardImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          src = _this$props.src,
          _this$props$noImageEl = _this$props.noImageElement,
          noImageElement = _this$props$noImageEl === void 0 ? /*#__PURE__*/React__default.createElement(Icon, {
        name: "NoData"
      }) : _this$props$noImageEl,
          _this$props$loadingMe = _this$props.loadingMessage,
          loadingMessage = _this$props$loadingMe === void 0 ? 'Loading...' : _this$props$loadingMe;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          isError = _this$state.isError;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$q.container, " ").concat(className)
      }, src ? /*#__PURE__*/React__default.createElement("img", {
        src: src,
        alt: "",
        onLoad: this.onLoad,
        onError: this.onError
      }) : noImageElement, src && !isError && !!loadingMessage && isLoading ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$q.loading
      }, /*#__PURE__*/React__default.createElement("span", {
        className: styles$q.loadingText
      }, loadingMessage)) : null);
    }
  }]);

  return CardImage;
}(React__default.Component);

var css_248z$t = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.skeleton-module_skeleton__11HVz {\n  display: block;\n  height: 1.75rem;\n  border-radius: 0.3125rem;\n  background-image: linear-gradient(90deg, #f4f4f4 0, #e8e8e8 2rem, #f4f4f4 4rem);\n  background-size: 200%;\n  background-position: 100%;\n  animation: skeleton-module_skeleton__11HVz 1.5s infinite linear; }\n\n@keyframes skeleton-module_skeleton__11HVz {\n  0% {\n    background-position: 100%; }\n  100% {\n    background-position: -100%; } }\n";
var styles$r = {"skeleton":"skeleton-module_skeleton__11HVz"};
styleInject(css_248z$t);

var Skeleton = function Skeleton(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$r.skeleton,
    style: style
  });
};

var ImageCardCompact = function ImageCardCompact(props) {
  var className = props.className,
      title = props.title,
      imageSrc = props.imageSrc,
      noImageElement = props.noImageElement,
      size = props.size,
      duration = props.duration,
      onClick = props.onClick,
      isSkeleton = props.isSkeleton;
  var label = '';
  var value = '';

  if (isSkeleton) {
    title = /*#__PURE__*/React__default.createElement(Skeleton, {
      style: {
        width: '75%',
        height: "".concat(14 / 16, "rem")
      }
    });
    label = /*#__PURE__*/React__default.createElement(Skeleton, {
      style: {
        width: '66%',
        height: "".concat(14 / 16, "rem")
      }
    });
    value = /*#__PURE__*/React__default.createElement(Skeleton, {
      style: {
        width: '75%',
        height: "".concat(14 / 16, "rem")
      }
    });
  } else {
    if (size) {
      label = 'Size';
      value = size;
    } else if (duration) {
      label = 'Duration';
      value = duration;
    }
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$p.container, " ").concat(className),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.image
  }, !isSkeleton ? /*#__PURE__*/React__default.createElement(CardImage, {
    className: styles$p.cardImage,
    src: imageSrc,
    noImageElement: noImageElement
  }) : /*#__PURE__*/React__default.createElement(Skeleton, {
    style: {
      width: '100%',
      height: '100%'
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.info
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.item
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.label
  }, !isSkeleton ? 'Name' : /*#__PURE__*/React__default.createElement(Skeleton, {
    style: {
      width: '66%',
      height: "".concat(14 / 16, "rem")
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.value
  }, title)), !!label && /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.item
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.label
  }, label), /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.value
  }, value))));
};
ImageCardCompact.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  noImageElement: PropTypes.element,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  size: PropTypes.string,
  duration: PropTypes.number,
  onClick: PropTypes.func
};

var css_248z$u = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.ImageCardSubContent-js-module_container__2gbl4 {\n  padding: 1rem;\n  border-radius: 0 0 .25rem .25rem;\n  background: #f4f4f4; }\n";
var styles$s = {"container":"ImageCardSubContent-js-module_container__2gbl4"};
styleInject(css_248z$u);

var ImageCardSubContent = function ImageCardSubContent(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      textFields = props.textFields,
      close = props.close,
      save = props.save,
      disabled = props.disabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$s.container, " ").concat(className)
  }, textFields.map(function (textField) {
    return /*#__PURE__*/React__default.createElement(TextField, {
      key: textField.label,
      className: "mb-3",
      label: textField.label,
      placeholder: textField.placeholder,
      value: textField.value,
      onChange: textField.onChange
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React__default.createElement(Button, {
    onClick: close,
    className: "btn-square _md _cornflower-blue mr-2"
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-square _md _filled _cornflower-blue",
    onClick: save,
    disabled: disabled
  }, "Save Changes")));
};
ImageCardSubContent.propTypes = {
  className: PropTypes.string,
  textFields: PropTypes.array,
  close: PropTypes.func,
  save: PropTypes.func,
  disabled: PropTypes.bool
};

function _createSuper$H(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$H(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$H() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ImageCard = /*#__PURE__*/function (_React$Component) {
  inherits(ImageCard, _React$Component);

  var _super = _createSuper$H(ImageCard);

  function ImageCard() {
    var _this;

    classCallCheck(this, ImageCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onClick = function () {
      var _this$props = _this.props,
          isSubContentOpen = _this$props.isSubContentOpen,
          onClick = _this$props.onClick;

      if (isSubContentOpen) {
        return;
      }

      onClick();
    };

    _this.imageClickHandler = function (e) {
      var _this$props2 = _this.props,
          clickedOnImage = _this$props2.clickedOnImage,
          loadingMessage = _this$props2.loadingMessage;

      if (clickedOnImage && !loadingMessage) {
        e.stopPropagation();
        clickedOnImage();
      }
    };

    _this.getParamValue = function (label) {
      var params = _this.props.params;
      var param = params.find(function (param) {
        return param.label === label;
      });
      return param ? param.value : undefined;
    };

    _this.renderPreview = function () {
      var _this$props3 = _this.props,
          imageSrc = _this$props3.imageSrc,
          _this$props3$noImageE = _this$props3.noImageElement,
          noImageElement = _this$props3$noImageE === void 0 ? null : _this$props3$noImageE,
          loadingMessage = _this$props3.loadingMessage,
          iconName = _this$props3.iconName,
          isOnlyPreview = _this$props3.isOnlyPreview,
          _this$props3$previewC = _this$props3.previewClassName,
          previewClassName = _this$props3$previewC === void 0 ? '' : _this$props3$previewC;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$o.image, " ").concat(previewClassName),
        onClick: _this.imageClickHandler
      }, imageSrc ? /*#__PURE__*/React__default.createElement("img", {
        src: imageSrc,
        alt: ""
      }) : noImageElement, loadingMessage ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$o.loading
      }, /*#__PURE__*/React__default.createElement("span", {
        className: styles$o.loadingText
      }, loadingMessage)) : null, !isOnlyPreview && iconName ? /*#__PURE__*/React__default.createElement("i", {
        className: styles$o.icon
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: iconName
      })) : null);
    };

    return _this;
  }

  createClass(ImageCard, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          className = _this$props4.className,
          title = _this$props4.title,
          imageSrc = _this$props4.imageSrc,
          _this$props4$actions = _this$props4.actions,
          actions = _this$props4$actions === void 0 ? [] : _this$props4$actions,
          _this$props4$params = _this$props4.params,
          params = _this$props4$params === void 0 ? [] : _this$props4$params,
          isSelected = _this$props4.isSelected,
          _this$props4$noImageE = _this$props4.noImageElement,
          noImageElement = _this$props4$noImageE === void 0 ? null : _this$props4$noImageE,
          isSubContentOpen = _this$props4.isSubContentOpen,
          subContentTextFields = _this$props4.subContentTextFields,
          subContent = _this$props4.subContent,
          toggleSubContent = _this$props4.toggleSubContent,
          isCompact = _this$props4.isCompact,
          isSkeleton = _this$props4.isSkeleton,
          isOnlyPreview = _this$props4.isOnlyPreview;
      var classNames = !isCompact ? [styles$o.container] : [];

      if (isSelected) {
        classNames.push('_selected');
      }

      if (isSubContentOpen) {
        classNames.push('_sub-content');
      }

      if (className) {
        classNames.push(className);
      }

      return !isOnlyPreview ? !isCompact ? /*#__PURE__*/React__default.createElement("div", {
        className: classNames.join(' ')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$o.wrapper,
        onClick: this.onClick
      }, this.renderPreview(), !isSubContentOpen ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$o.content
      }, /*#__PURE__*/React__default.createElement("header", {
        className: styles$o.header
      }, /*#__PURE__*/React__default.createElement("h4", {
        className: styles$o.title
      }, title)), /*#__PURE__*/React__default.createElement("ul", {
        className: styles$o.list
      }, params.map(function (param, key) {
        return /*#__PURE__*/React__default.createElement("li", {
          className: styles$o.item,
          key: typeof param.label === 'string' ? param.label : key
        }, /*#__PURE__*/React__default.createElement("span", {
          className: styles$o.itemLabel
        }, param.label), /*#__PURE__*/React__default.createElement("span", {
          className: styles$o.itemValue
        }, param.value));
      }))) : /*#__PURE__*/React__default.createElement("div", {
        className: styles$o.subContent
      }, subContent || /*#__PURE__*/React__default.createElement(ImageCardSubContent, {
        textFields: subContentTextFields,
        close: toggleSubContent
      }))), actions.length && !isSubContentOpen ? /*#__PURE__*/React__default.createElement(ActionButton, {
        className: styles$o.menu,
        actions: actions
      }) : null) : /*#__PURE__*/React__default.createElement(ImageCardCompact, {
        isSkeleton: isSkeleton,
        className: classNames.join(' '),
        title: title,
        imageSrc: imageSrc,
        size: this.getParamValue('Size:'),
        duration: this.getParamValue('Duration:'),
        onClick: this.onClick,
        noImageElement: noImageElement
      }) : this.renderPreview();
    }
  }]);

  return ImageCard;
}(React__default.Component);
ImageCard.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  actions: PropTypes.array,
  params: PropTypes.array,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  noImageElement: PropTypes.element,
  iconName: PropTypes.string,
  clickedOnImage: PropTypes.func,
  loadingMessage: PropTypes.string,
  subContent: PropTypes.element,
  isSubContentOpen: PropTypes.bool,
  subContentTextFields: PropTypes.array,
  toggleSubContent: PropTypes.func,
  isCompact: PropTypes.bool,
  isSkeleton: PropTypes.bool,
  isOnlyPreview: PropTypes.bool,
  previewClassName: PropTypes.string
};

var css_248z$v = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes customerSelect-module_hover-ripples__2xNEC {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.customerSelect-module_btn-transparent__3dn7g {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none; }\n  .customerSelect-module_btn-transparent__3dn7g:focus {\n    outline: 0; }\n\n.customerSelect-module_opener__1d4qG {\n  position: relative;\n  display: inline-block; }\n\n.customerSelect-module_content__12pPg {\n  position: absolute;\n  z-index: 1;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 16.25rem; }\n  .customerSelect-module_content__12pPg.customerSelect-module__selected__2IKhJ {\n    top: 0; }\n\n.customerSelect-module_select__1VdJL.select .select__option:not(:last-child) {\n  border-bottom: 0.0625rem solid #f4f4f4; }\n\n.customerSelect-module_select__1VdJL.select .select__option-label {\n  padding: .25rem .75rem; }\n\n.customerSelect-module_option__2h4R9 {\n  display: flex;\n  align-items: center;\n  width: 100%; }\n  .customerSelect-module_option__2h4R9.customerSelect-module__selected__2IKhJ {\n    padding: 0 .75rem 0 .25rem;\n    width: 100%;\n    max-width: 15rem;\n    height: 2.25rem;\n    border: 0.0625rem solid #cbcbcb;\n    border-radius: .25rem;\n    cursor: pointer; }\n\n.customerSelect-module_icon__3vq1y {\n  flex: 0 0 1.5rem;\n  margin-right: .5rem;\n  padding: 0 .125rem;\n  line-height: 0; }\n  .customerSelect-module_icon__3vq1y svg {\n    width: 100%;\n    height: auto; }\n\n.customerSelect-module_image__29Bc0 {\n  flex: 0 0 1.5rem;\n  margin-right: .75rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  overflow: hidden;\n  line-height: 0; }\n  .customerSelect-module_image__29Bc0:last-child {\n    margin: 0 0 0 .75rem; }\n  .customerSelect-module_image__29Bc0 img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%; }\n\n.customerSelect-module_noImage__2Q5mu {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background-color: #666666;\n  font-size: 1rem;\n  line-height: 1.15;\n  color: #ffffff;\n  text-transform: uppercase; }\n\n.customerSelect-module_info__3FBJ8 {\n  flex: 1 1 auto;\n  min-width: 0; }\n\n.customerSelect-module_info__3FBJ8,\n.customerSelect-module_id__2pHYu,\n.customerSelect-module_balance__2abbD {\n  font-size: .75rem;\n  line-height: 1.16667em;\n  color: #000000; }\n\n.customerSelect-module_label___d4uu,\n.customerSelect-module_idLabel__bueDe,\n.customerSelect-module_balanceLabel__15P59,\n.customerSelect-module_email__1WwoR,\n.customerSelect-module_idValue__2NU1p,\n.customerSelect-module_balanceValue__2_Kug {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal; }\n\n.customerSelect-module_label___d4uu,\n.customerSelect-module_email__1WwoR,\n.customerSelect-module_balanceValue__2_Kug {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.customerSelect-module_id__2pHYu,\n.customerSelect-module_balance__2abbD {\n  flex: 0 0 auto;\n  margin-left: .75rem; }\n";
var styles$t = {"btn-transparent":"customerSelect-module_btn-transparent__3dn7g","opener":"customerSelect-module_opener__1d4qG","content":"customerSelect-module_content__12pPg","_selected":"customerSelect-module__selected__2IKhJ","select":"customerSelect-module_select__1VdJL","option":"customerSelect-module_option__2h4R9","icon":"customerSelect-module_icon__3vq1y","image":"customerSelect-module_image__29Bc0","noImage":"customerSelect-module_noImage__2Q5mu","info":"customerSelect-module_info__3FBJ8","id":"customerSelect-module_id__2pHYu","balance":"customerSelect-module_balance__2abbD","label":"customerSelect-module_label___d4uu","idLabel":"customerSelect-module_idLabel__bueDe","balanceLabel":"customerSelect-module_balanceLabel__15P59","email":"customerSelect-module_email__1WwoR","idValue":"customerSelect-module_idValue__2NU1p","balanceValue":"customerSelect-module_balanceValue__2_Kug","hover-ripples":"customerSelect-module_hover-ripples__2xNEC"};
styleInject(css_248z$v);

function _createSuper$I(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$I(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$I() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Image = /*#__PURE__*/function (_React$Component) {
  inherits(Image, _React$Component);

  var _super = _createSuper$I(Image);

  function Image(props) {
    var _this;

    classCallCheck(this, Image);

    _this = _super.call(this, props);

    _this.onError = function () {
      return _this.setState({
        isError: true
      });
    };

    _this.state = {
      isError: false
    };
    return _this;
  }

  createClass(Image, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          name = _this$props.name;
      var isError = this.state.isError;
      return !isError ? /*#__PURE__*/React__default.createElement("img", {
        src: src,
        alt: "",
        onError: this.onError
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.noImage
      }, name[0]);
    }
  }]);

  return Image;
}(React__default.Component);

var CustomerSelect = /*#__PURE__*/function (_Component) {
  inherits(CustomerSelect, _Component);

  var _super2 = _createSuper$I(CustomerSelect);

  function CustomerSelect() {
    var _this2;

    classCallCheck(this, CustomerSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _this2.getToggleContent = function (func) {
      _this2.toggleOpener = func;
    };

    _this2.closeOpener = function () {
      return _this2.toggleOpener(false);
    };

    _this2.renderOption = function (option) {
      var label = option.label,
          value = option.value,
          email = option.email,
          image = option.image;
      return {
        label: label,
        value: value,
        email: email,
        image: image,
        reactLabel: /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.option
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.image,
          key: "".concat(value, "-image")
        }, /*#__PURE__*/React__default.createElement(Image, {
          src: image,
          name: label
        })), /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.info,
          key: "".concat(value, "-info")
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.label,
          key: "".concat(value, "-name")
        }, label), /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.email,
          key: "".concat(value, "-email")
        }, email)), /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.id,
          key: "".concat(value, "-id")
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.idLabel,
          key: "".concat(value, "-id-title")
        }, "ID"), /*#__PURE__*/React__default.createElement("div", {
          className: styles$t.idValue,
          key: "".concat(value, "-id-value")
        }, value)))
      };
    };

    _this2.transformedOptions = function (options) {
      return options.map(_this2.renderOption);
    };

    _this2.renderBtn = function () {
      var _this2$props = _this2.props,
          value = _this2$props.value,
          balance = _this2$props.balance;
      return !value ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        outline: true,
        iconName: "People",
        className: "_size-24"
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$t.option, " ").concat(styles$t._selected)
      }, /*#__PURE__*/React__default.createElement("i", {
        className: styles$t.icon
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "People"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.info
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.label
      }, value.label), /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.email
      }, value.email)), balance ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.balance
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.balanceLabel
      }, "Balance"), /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.balanceValue
      }, balance)) : null, /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.image
      }, /*#__PURE__*/React__default.createElement(Image, {
        src: value.image,
        name: value.label
      })));
    };

    _this2.renderList = function () {
      var _this2$props2 = _this2.props,
          _this2$props2$classNa = _this2$props2.className,
          className = _this2$props2$classNa === void 0 ? '' : _this2$props2$classNa,
          options = _this2$props2.options,
          value = _this2$props2.value,
          onChange = _this2$props2.onChange,
          selectSpecificProps = _this2$props2.selectSpecificProps,
          isSimpleBtn = _this2$props2.isSimpleBtn;
      var classNames = [styles$t.select];

      if (isSimpleBtn && className) {
        classNames.push(className);
      }

      return /*#__PURE__*/React__default.createElement(Select, _extends_1({
        className: classNames.join(' '),
        isAlwaysOpen: !isSimpleBtn,
        btnOnClick: !isSimpleBtn ? _this2.closeOpener : null,
        options: _this2.transformedOptions(options),
        value: value,
        isSearchable: true,
        isClearable: true,
        onChange: onChange,
        placeholder: "Select Customer"
      }, selectSpecificProps));
    };

    return _this2;
  }

  createClass(CustomerSelect, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          value = _this$props2.value,
          isSimpleBtn = _this$props2.isSimpleBtn;
      return !isSimpleBtn ? /*#__PURE__*/React__default.createElement(Opener, {
        className: "".concat(styles$t.opener, " ").concat(className),
        contentClassName: "".concat(styles$t.content, " ").concat(value ? styles$t._selected : ''),
        getToggleContent: this.getToggleContent,
        btn: this.renderBtn(),
        content: this.renderList()
      }) : this.renderList();
    }
  }]);

  return CustomerSelect;
}(Component);
CustomerSelect.propTypes = {
  className: PropTypes__default.string,
  options: PropTypes__default.array,
  value: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array]),
  onChange: PropTypes__default.func,
  balance: PropTypes__default.string,
  selectSpecificProps: PropTypes__default.object,
  isSimpleBtn: PropTypes__default.bool
};

var css_248z$w = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.progressCircle-module_container__2-wy8 {\n  display: inline-block;\n  vertical-align: top;\n  width: 4rem;\n  height: 4rem;\n  position: relative; }\n\n.progressCircle-module_track__1l8v0 {\n  width: 4rem;\n  height: 4rem;\n  border: 0.25rem solid #dddddd;\n  border-radius: 50%; }\n\n.progressCircle-module_fills__1d1-t {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  will-change: transform;\n  transform: translateZ(0);\n  animation: progressCircle-module_spectrum-fills-rotate__25K9a 1s infinite cubic-bezier(0.25, 0.78, 0.48, 0.89);\n  transform-origin: center; }\n\n@keyframes progressCircle-module_spectrum-fills-rotate__25K9a {\n  0% {\n    transform: rotate(-90deg); }\n  100% {\n    transform: rotate(270deg); } }\n\n.progressCircle-module_mask__26Px8 {\n  width: 50%;\n  height: 100%;\n  transform-origin: 100% center;\n  transform: rotate(180deg);\n  overflow: hidden;\n  position: absolute; }\n\n.progressCircle-module_subMask1__rXA7c {\n  will-change: transform;\n  animation: progressCircle-module_spectrum-fill-mask-1__3-PfY 1s infinite linear;\n  width: 100%;\n  height: 100%;\n  transform-origin: 100% center;\n  overflow: hidden; }\n\n.progressCircle-module_subMask2__36BGd {\n  will-change: transform;\n  animation: progressCircle-module_spectrum-fill-mask-2___l0oY 1s infinite linear;\n  width: 100%;\n  height: 100%;\n  transform-origin: 100% center;\n  overflow: hidden; }\n\n.progressCircle-module_fill__d80pt {\n  width: 4rem;\n  height: 4rem;\n  border: 0.25rem solid var(--primary2);\n  border-radius: 50%; }\n\n@keyframes progressCircle-module_spectrum-fill-mask-1__3-PfY {\n  0% {\n    transform: rotate(90deg); }\n  1.69% {\n    transform: rotate(72.3deg); }\n  3.39% {\n    transform: rotate(55.5deg); }\n  5.08% {\n    transform: rotate(40.3deg); }\n  6.78% {\n    transform: rotate(25deg); }\n  8.47% {\n    transform: rotate(10.6deg); }\n  10.17% {\n    transform: rotate(0deg); }\n  11.86% {\n    transform: rotate(0deg); }\n  13.56% {\n    transform: rotate(0deg); }\n  15.25% {\n    transform: rotate(0deg); }\n  16.95% {\n    transform: rotate(0deg); }\n  18.64% {\n    transform: rotate(0deg); }\n  20.34% {\n    transform: rotate(0deg); }\n  22.03% {\n    transform: rotate(0deg); }\n  23.73% {\n    transform: rotate(0deg); }\n  25.42% {\n    transform: rotate(0deg); }\n  27.12% {\n    transform: rotate(0deg); }\n  28.81% {\n    transform: rotate(0deg); }\n  30.51% {\n    transform: rotate(0deg); }\n  32.2% {\n    transform: rotate(0deg); }\n  33.9% {\n    transform: rotate(0deg); }\n  35.59% {\n    transform: rotate(0deg); }\n  37.29% {\n    transform: rotate(0deg); }\n  38.98% {\n    transform: rotate(0deg); }\n  40.68% {\n    transform: rotate(0deg); }\n  42.37% {\n    transform: rotate(5.3deg); }\n  44.07% {\n    transform: rotate(13.4deg); }\n  45.76% {\n    transform: rotate(20.6deg); }\n  47.46% {\n    transform: rotate(29deg); }\n  49.15% {\n    transform: rotate(36.5deg); }\n  50.85% {\n    transform: rotate(42.6deg); }\n  52.54% {\n    transform: rotate(48.8deg); }\n  54.24% {\n    transform: rotate(54.2deg); }\n  55.93% {\n    transform: rotate(59.4deg); }\n  57.63% {\n    transform: rotate(63.2deg); }\n  59.32% {\n    transform: rotate(67.2deg); }\n  61.02% {\n    transform: rotate(70.8deg); }\n  62.71% {\n    transform: rotate(73.8deg); }\n  64.41% {\n    transform: rotate(76.2deg); }\n  66.1% {\n    transform: rotate(78.7deg); }\n  67.8% {\n    transform: rotate(80.6deg); }\n  69.49% {\n    transform: rotate(82.6deg); }\n  71.19% {\n    transform: rotate(83.7deg); }\n  72.88% {\n    transform: rotate(85deg); }\n  74.58% {\n    transform: rotate(86.3deg); }\n  76.27% {\n    transform: rotate(87deg); }\n  77.97% {\n    transform: rotate(87.7deg); }\n  79.66% {\n    transform: rotate(88.3deg); }\n  81.36% {\n    transform: rotate(88.6deg); }\n  83.05% {\n    transform: rotate(89.2deg); }\n  84.75% {\n    transform: rotate(89.2deg); }\n  86.44% {\n    transform: rotate(89.5deg); }\n  88.14% {\n    transform: rotate(89.9deg); }\n  89.83% {\n    transform: rotate(89.7deg); }\n  91.53% {\n    transform: rotate(90.1deg); }\n  93.22% {\n    transform: rotate(90.2deg); }\n  94.92% {\n    transform: rotate(90.1deg); }\n  96.61% {\n    transform: rotate(90deg); }\n  98.31% {\n    transform: rotate(89.8deg); }\n  100% {\n    transform: rotate(90deg); } }\n\n@keyframes progressCircle-module_spectrum-fill-mask-2___l0oY {\n  0% {\n    transform: rotate(180deg); }\n  1.69% {\n    transform: rotate(180deg); }\n  3.39% {\n    transform: rotate(180deg); }\n  5.08% {\n    transform: rotate(180deg); }\n  6.78% {\n    transform: rotate(180deg); }\n  8.47% {\n    transform: rotate(180deg); }\n  10.17% {\n    transform: rotate(179.2deg); }\n  11.86% {\n    transform: rotate(164deg); }\n  13.56% {\n    transform: rotate(151.8deg); }\n  15.25% {\n    transform: rotate(140.8deg); }\n  16.95% {\n    transform: rotate(130.3deg); }\n  18.64% {\n    transform: rotate(120.4deg); }\n  20.34% {\n    transform: rotate(110.8deg); }\n  22.03% {\n    transform: rotate(101.6deg); }\n  23.73% {\n    transform: rotate(93.5deg); }\n  25.42% {\n    transform: rotate(85.4deg); }\n  27.12% {\n    transform: rotate(78.1deg); }\n  28.81% {\n    transform: rotate(71.2deg); }\n  30.51% {\n    transform: rotate(89.1deg); }\n  32.2% {\n    transform: rotate(105.5deg); }\n  33.9% {\n    transform: rotate(121.3deg); }\n  35.59% {\n    transform: rotate(135.5deg); }\n  37.29% {\n    transform: rotate(148.4deg); }\n  38.98% {\n    transform: rotate(161deg); }\n  40.68% {\n    transform: rotate(173.5deg); }\n  42.37% {\n    transform: rotate(180deg); }\n  44.07% {\n    transform: rotate(180deg); }\n  45.76% {\n    transform: rotate(180deg); }\n  47.46% {\n    transform: rotate(180deg); }\n  49.15% {\n    transform: rotate(180deg); }\n  50.85% {\n    transform: rotate(180deg); }\n  52.54% {\n    transform: rotate(180deg); }\n  54.24% {\n    transform: rotate(180deg); }\n  55.93% {\n    transform: rotate(180deg); }\n  57.63% {\n    transform: rotate(180deg); }\n  59.32% {\n    transform: rotate(180deg); }\n  61.02% {\n    transform: rotate(180deg); }\n  62.71% {\n    transform: rotate(180deg); }\n  64.41% {\n    transform: rotate(180deg); }\n  66.1% {\n    transform: rotate(180deg); }\n  67.8% {\n    transform: rotate(180deg); }\n  69.49% {\n    transform: rotate(180deg); }\n  71.19% {\n    transform: rotate(180deg); }\n  72.88% {\n    transform: rotate(180deg); }\n  74.58% {\n    transform: rotate(180deg); }\n  76.27% {\n    transform: rotate(180deg); }\n  77.97% {\n    transform: rotate(180deg); }\n  79.66% {\n    transform: rotate(180deg); }\n  81.36% {\n    transform: rotate(180deg); }\n  83.05% {\n    transform: rotate(180deg); }\n  84.75% {\n    transform: rotate(180deg); }\n  86.44% {\n    transform: rotate(180deg); }\n  88.14% {\n    transform: rotate(180deg); }\n  89.83% {\n    transform: rotate(180deg); }\n  91.53% {\n    transform: rotate(180deg); }\n  93.22% {\n    transform: rotate(180deg); }\n  94.92% {\n    transform: rotate(180deg); }\n  96.61% {\n    transform: rotate(180deg); }\n  98.31% {\n    transform: rotate(180deg); }\n  100% {\n    transform: rotate(180deg); } }\n";
var styles$u = {"container":"progressCircle-module_container__2-wy8","track":"progressCircle-module_track__1l8v0","fills":"progressCircle-module_fills__1d1-t","spectrum-fills-rotate":"progressCircle-module_spectrum-fills-rotate__25K9a","mask":"progressCircle-module_mask__26Px8","subMask1":"progressCircle-module_subMask1__rXA7c","spectrum-fill-mask-1":"progressCircle-module_spectrum-fill-mask-1__3-PfY","subMask2":"progressCircle-module_subMask2__36BGd","spectrum-fill-mask-2":"progressCircle-module_spectrum-fill-mask-2___l0oY","fill":"progressCircle-module_fill__d80pt"};
styleInject(css_248z$w);

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ProgressCircle = function ProgressCircle(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? 64 : _props$size,
      _props$borderWidth = props.borderWidth,
      borderWidth = _props$borderWidth === void 0 ? 4 : _props$borderWidth;
  var style = {
    width: "".concat(size / 16, "rem"),
    height: "".concat(size / 16, "rem")
  };

  var borderStyle = _objectSpread$b(_objectSpread$b({}, style), {}, {
    borderWidth: "".concat(borderWidth / 16, "rem")
  });

  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$u.container, " ").concat(className),
    style: style
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.track,
    style: borderStyle
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.fills
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$u.mask, " ").concat(styles$u.mask1)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.subMask1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.fill,
    style: borderStyle
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$u.mask, " ").concat(styles$u.mask2)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.subMask2
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.fill,
    style: borderStyle
  })))));
};
ProgressCircle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number
};

var css_248z$x = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.successCircle-module_container__2JZ0w {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 4rem;\n  height: 4rem;\n  border: 0.25rem solid #3F9B34;\n  border-radius: 50%; }\n\n.successCircle-module_translator__1Qxqj {\n  transform: translate(-17.67767%, -35.35534%); }\n\n.successCircle-module_rotator__eyE95 {\n  position: relative;\n  width: 1.5rem;\n  height: 1.5rem;\n  transform: rotate(45deg); }\n\n.successCircle-module_line__7zF2B {\n  position: absolute;\n  border-radius: 0.0625rem;\n  background-color: #3F9B34;\n  animation-duration: .25s;\n  animation-fill-mode: forwards; }\n\n.successCircle-module_line1__1LIkS {\n  bottom: 0;\n  left: 50%;\n  right: 0;\n  height: .125rem;\n  width: 0;\n  animation-name: successCircle-module_line1-animation__2gYXe;\n  animation-timing-function: ease-in;\n  animation-delay: .5s; }\n\n.successCircle-module_line2__11Cgp {\n  bottom: 0;\n  right: 0;\n  width: .125rem;\n  height: 0;\n  animation-name: successCircle-module_line2-animation__2a-vD;\n  animation-timing-function: ease-out;\n  animation-delay: .75s; }\n\n@keyframes successCircle-module_line1-animation__2gYXe {\n  0% {\n    width: 0; }\n  100% {\n    width: 50%; } }\n\n@keyframes successCircle-module_line2-animation__2a-vD {\n  0% {\n    height: 0; }\n  100% {\n    height: 100%; } }\n";
var styles$v = {"container":"successCircle-module_container__2JZ0w","translator":"successCircle-module_translator__1Qxqj","rotator":"successCircle-module_rotator__eyE95","line":"successCircle-module_line__7zF2B","line1":"successCircle-module_line1__1LIkS","line1-animation":"successCircle-module_line1-animation__2gYXe","line2":"successCircle-module_line2__11Cgp","line2-animation":"successCircle-module_line2-animation__2a-vD"};
styleInject(css_248z$x);

var SuccessCircle = function SuccessCircle(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? 64 : _props$size,
      _props$borderWidth = props.borderWidth,
      borderWidth = _props$borderWidth === void 0 ? 4 : _props$borderWidth,
      _props$lineWidth = props.lineWidth,
      lineWidth = _props$lineWidth === void 0 ? 2 : _props$lineWidth;
  var containerStyle = {
    width: "".concat(size / 16, "rem"),
    height: "".concat(size / 16, "rem"),
    borderWidth: "".concat(borderWidth / 16, "rem")
  };
  var rotatorStyle = {
    width: "".concat(size * .375 / 16, "rem"),
    height: "".concat(size * .375 / 16, "rem")
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$v.container, " ").concat(className),
    style: containerStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$v.translator
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$v.rotator,
    style: rotatorStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$v.line, " ").concat(styles$v.line1),
    style: {
      height: "".concat(lineWidth / 16, "rem")
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$v.line, " ").concat(styles$v.line2),
    style: {
      width: "".concat(lineWidth / 16, "rem")
    }
  }))));
};
SuccessCircle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  lineWidth: PropTypes.number
};

var css_248z$y = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.errorCircle-module_container__1ZhjT {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 4rem;\n  height: 4rem;\n  border: 0.25rem solid #FF5859;\n  border-radius: 50%; }\n\n.errorCircle-module_wrapper__2xQew {\n  position: relative;\n  width: 2rem;\n  height: 2rem;\n  transform: rotate(45deg); }\n\n.errorCircle-module_line__3FW3N {\n  position: absolute;\n  border-radius: 0.0625rem;\n  background-color: #FF5859;\n  animation-duration: .25s;\n  animation-fill-mode: forwards; }\n\n.errorCircle-module_line1__-tHb8 {\n  top: 50%;\n  left: 0;\n  height: .125rem;\n  width: 0;\n  transform: translateY(-50%);\n  animation-name: errorCircle-module_line1-animation__3glXU;\n  animation-timing-function: ease-in;\n  animation-delay: .5s; }\n\n.errorCircle-module_line2__3IK6r {\n  top: 0;\n  left: 50%;\n  width: .125rem;\n  height: 0;\n  transform: translateX(-50%);\n  animation-name: errorCircle-module_line2-animation__1ftIT;\n  animation-timing-function: ease-out;\n  animation-delay: .75s; }\n\n@keyframes errorCircle-module_line1-animation__3glXU {\n  0% {\n    width: 0; }\n  100% {\n    width: 100%; } }\n\n@keyframes errorCircle-module_line2-animation__1ftIT {\n  0% {\n    height: 0; }\n  100% {\n    height: 100%; } }\n";
var styles$w = {"container":"errorCircle-module_container__1ZhjT","wrapper":"errorCircle-module_wrapper__2xQew","line":"errorCircle-module_line__3FW3N","line1":"errorCircle-module_line1__-tHb8","line1-animation":"errorCircle-module_line1-animation__3glXU","line2":"errorCircle-module_line2__3IK6r","line2-animation":"errorCircle-module_line2-animation__1ftIT"};
styleInject(css_248z$y);

var ErrorCircle = function ErrorCircle(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$size = props.size,
      size = _props$size === void 0 ? 64 : _props$size,
      _props$borderWidth = props.borderWidth,
      borderWidth = _props$borderWidth === void 0 ? 4 : _props$borderWidth,
      _props$lineWidth = props.lineWidth,
      lineWidth = _props$lineWidth === void 0 ? 2 : _props$lineWidth;
  var containerStyle = {
    width: "".concat(size / 16, "rem"),
    height: "".concat(size / 16, "rem"),
    borderWidth: "".concat(borderWidth / 16, "rem")
  };
  var rotatorStyle = {
    width: "".concat(size * .5 / 16, "rem"),
    height: "".concat(size * .5 / 16, "rem")
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$w.container, " ").concat(className),
    style: containerStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$w.wrapper,
    style: rotatorStyle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$w.line, " ").concat(styles$w.line1),
    style: {
      height: "".concat(lineWidth / 16, "rem")
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$w.line, " ").concat(styles$w.line2),
    style: {
      width: "".concat(lineWidth / 16, "rem")
    }
  })));
};
ErrorCircle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  lineWidth: PropTypes.number
};

function _createSuper$J(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$J(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$J() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var URLTextField = /*#__PURE__*/function (_React$Component) {
  inherits(URLTextField, _React$Component);

  var _super = _createSuper$J(URLTextField);

  function URLTextField() {
    var _this;

    classCallCheck(this, URLTextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onBlur = function (event) {
      var _this$props = _this.props,
          validationRules = _this$props.validationRules,
          value = _this$props.value,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange;

      if (validationRules && validationRules.some(function (rule) {
        return !rule.func(value);
      })) {
        return;
      } else if (value && value.trim() && !/^(?:f|ht)tps?:\/\//.test(value)) {
        onChange("https://".concat(value));
      }

      if (onBlur) {
        onBlur(event);
      }
    };

    return _this;
  }

  createClass(URLTextField, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(TextField, _extends_1({}, this.props, {
        onBlur: this.onBlur
      }));
    }
  }]);

  return URLTextField;
}(React__default.Component);
URLTextField.propTypes = {
  validationRules: PropTypes__default.arrayOf(PropTypes__default.object),
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  value: PropTypes__default.string
};

var css_248z$z = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.FileUploader-module_sample__2DvZy, .FileUploader-module_text__12oLP {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.875rem;\n  line-height: 1.125em; }\n\n@keyframes FileUploader-module_hover-ripples__2yd9Q {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.FileUploader-module_container__1wMjM {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem 1rem;\n  width: 100%;\n  border: 0.0625rem dashed #cbcbcb; }\n  .FileUploader-module_container__1wMjM:hover {\n    border-color: var(--primary2); }\n    .FileUploader-module_container__1wMjM:hover .FileUploader-module_text__12oLP {\n      color: var(--primary2); }\n  .FileUploader-module_container__1wMjM.FileUploader-module_error__1b9X- .FileUploader-module_notice__3tfAK {\n    color: #FF5859; }\n    .FileUploader-module_container__1wMjM.FileUploader-module_error__1b9X- .FileUploader-module_notice__3tfAK ol {\n      padding: 0;\n      list-style-position: inside; }\n\n.FileUploader-module_file__1G3TC {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; }\n\n.FileUploader-module_fileInput__1TvB1 {\n  display: none; }\n\n.FileUploader-module_droppable__pbVBK {\n  border-color: #6075ff; }\n\n.FileUploader-module_browseButton__3rEVi.btn-square svg {\n  width: 1rem;\n  height: auto; }\n\n.FileUploader-module_sample__2DvZy {\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  text-decoration: underline;\n  cursor: pointer;\n  color: #000000;\n  margin-left: 1rem; }\n  .FileUploader-module_sample__2DvZy:focus {\n    outline: 0; }\n  .FileUploader-module_sample__2DvZy.FileUploader-module_Last__3QXw0 {\n    margin: 0; }\n\n.FileUploader-module_text__12oLP {\n  margin-bottom: .375rem;\n  color: #a2a2a2;\n  text-align: center; }\n\n.FileUploader-module_notice__3tfAK {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  margin-top: 1rem;\n  max-width: 100%;\n  font-size: .625rem;\n  line-height: 1.2em;\n  text-align: center;\n  color: #a2a2a2; }\n";
var styles$x = {"sample":"FileUploader-module_sample__2DvZy","text":"FileUploader-module_text__12oLP","container":"FileUploader-module_container__1wMjM","error":"FileUploader-module_error__1b9X-","notice":"FileUploader-module_notice__3tfAK","file":"FileUploader-module_file__1G3TC","fileInput":"FileUploader-module_fileInput__1TvB1","droppable":"FileUploader-module_droppable__pbVBK","browseButton":"FileUploader-module_browseButton__3rEVi","Last":"FileUploader-module_Last__3QXw0","hover-ripples":"FileUploader-module_hover-ripples__2yd9Q"};
styleInject(css_248z$z);

function _createSuper$K(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$K(); return function _createSuperInternal() { var Super = getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$K() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FileUploader = /*#__PURE__*/function (_React$Component) {
  inherits(FileUploader, _React$Component);

  var _super = _createSuper$K(FileUploader);

  function FileUploader(props) {
    var _this;

    classCallCheck(this, FileUploader);

    _this = _super.call(this, props);

    _this.handleDropInput = function (event) {
      var onFileUploaded = _this.props.onFileUploaded;
      event.stopPropagation();
      event.preventDefault();

      if (_this.fileContainerElement.current) {
        _this.fileContainerElement.current.classList.remove(styles$x.droppable);
      }

      if (onFileUploaded) {
        onFileUploaded(event.dataTransfer.files);
      }
    };

    _this.handleBrowseInput = function (event) {
      var onFileUploaded = _this.props.onFileUploaded;

      if (onFileUploaded && event.target.files) {
        onFileUploaded(event.target.files);
      }
    };

    _this.handleDragOver = function (event) {
      event.preventDefault();

      if (_this.fileContainerElement.current) {
        _this.fileContainerElement.current.classList.add(styles$x.droppable);
      }
    };

    _this.handleDragEnd = function (event) {
      event.preventDefault();

      if (_this.fileContainerElement.current) {
        _this.fileContainerElement.current.classList.remove(styles$x.droppable);
      }
    };

    _this.fileContainerElement = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  createClass(FileUploader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          _this$props$getInputR = _this$props.getInputRef,
          getInputRef = _this$props$getInputR === void 0 ? null : _this$props$getInputR,
          browseFileButtonTitle = _this$props.browseFileButtonTitle,
          tooltipParams = _this$props.tooltipParams,
          isMultiple = _this$props.isMultiple,
          isError = _this$props.isError,
          exampleDataURL = _this$props.exampleDataURL,
          accept = _this$props.accept,
          title = _this$props.title,
          notice = _this$props.notice,
          dragDropText = _this$props.dragDropText,
          _this$props$browseBtn = _this$props.browseBtnClassName,
          browseBtnClassName = _this$props$browseBtn === void 0 ? '' : _this$props$browseBtn,
          _this$props$isSampleA = _this$props.isSampleAtBottom,
          isSampleAtBottom = _this$props$isSampleA === void 0 ? false : _this$props$isSampleA;
      var fullClassNames = [styles$x.container];

      if (isError) {
        fullClassNames.push(styles$x.error);
      }

      if (className) {
        fullClassNames.push(className);
      }

      var label = /*#__PURE__*/React__default.createElement("label", {
        className: "btn-square _cornflower-blue ".concat(browseBtnClassName, " ").concat(styles$x.browseButton),
        htmlFor: browseFileButtonTitle
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "btn-content"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "btn-content__icon"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Upload"
      })), /*#__PURE__*/React__default.createElement("span", null, browseFileButtonTitle)));
      return /*#__PURE__*/React__default.createElement("div", {
        className: fullClassNames.join(' '),
        onDrop: this.handleDropInput,
        onDragOver: this.handleDragOver,
        onDragLeave: this.handleDragEnd,
        ref: this.fileContainerElement
      }, title && /*#__PURE__*/React__default.createElement("div", null, title), /*#__PURE__*/React__default.createElement("input", {
        className: styles$x.fileInput,
        type: "file",
        id: browseFileButtonTitle,
        onChange: this.handleBrowseInput,
        value: "",
        multiple: isMultiple,
        accept: accept,
        ref: getInputRef
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "d-flex align-items-center mb-2"
      }, tooltipParams ? /*#__PURE__*/React__default.createElement(Tooltip, {
        label: tooltipParams.label,
        auto: !tooltipParams.position,
        labelMaxWidth: tooltipParams.labelMaxWidth,
        position: tooltipParams.position
      }, label) : label, exampleDataURL && !isSampleAtBottom ? /*#__PURE__*/React__default.createElement("a", {
        href: exampleDataURL,
        download: true,
        className: styles$x.sample
      }, "Sample File") : null), /*#__PURE__*/React__default.createElement("div", {
        className: styles$x.text
      }, dragDropText), /*#__PURE__*/React__default.createElement("div", {
        className: styles$x.notice
      }, notice), exampleDataURL && isSampleAtBottom ? /*#__PURE__*/React__default.createElement("a", {
        href: exampleDataURL,
        download: true,
        className: "".concat(styles$x.sample, " ").concat(styles$x.Last)
      }, "Sample File") : null);
    }
  }]);

  return FileUploader;
}(React__default.Component);
FileUploader.defaultProps = {
  accept: '*',
  browseFileButtonTitle: 'Upload',
  dragDropText: 'Drag and Drop',
  notice: ''
};
FileUploader.propTypes = {
  className: PropTypes__default.string,
  browseFileButtonTitle: PropTypes__default.string,
  onFileUploaded: PropTypes__default.func,
  tooltipParams: PropTypes__default.shape({
    label: PropTypes__default.string,
    labelMaxWidth: PropTypes__default.number,
    position: PropTypes__default.string
  }),
  getInputRef: PropTypes__default.func,
  isMultiple: PropTypes__default.bool,
  isError: PropTypes__default.bool,
  exampleDataURL: PropTypes__default.string,
  accept: PropTypes__default.string,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  notice: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  dragDropText: PropTypes__default.string,
  browseBtnClassName: PropTypes__default.string,
  isSampleAtBottom: PropTypes__default.bool
};

var numberRanges = [{
  divider: 1e12,
  suffix: 'T'
}, {
  divider: 1e9,
  suffix: 'B'
}, {
  divider: 1e6,
  suffix: 'M'
}, {
  divider: 1e3,
  suffix: 'k'
}];
var formatNumberWithSuffix = function formatNumberWithSuffix(number) {
  var alwaysFixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var digits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var parsedNumber = +number;

  if (!alwaysFixed && number < 1000) {
    return parsedNumber;
  }

  for (var i = 0; i < numberRanges.length; i++) {
    if (parsedNumber >= numberRanges[i].divider) {
      return (parsedNumber / numberRanges[i].divider).toFixed(digits).toString() + numberRanges[i].suffix;
    }
  }

  return parsedNumber.toFixed(digits).toString();
};

var NumberFormatter = function NumberFormatter(props) {
  var children = props.children,
      variant = props.variant;

  var formatNumber = function formatNumber(number) {
    var numberToFormat = number.toString().trim();

    if (variant === 'count') {
      return (+numberToFormat).toLocaleString();
    }

    if (variant === 'amount') {
      var CurrencyFormat = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return CurrencyFormat.format(parseInt(numberToFormat, 10));
    }
  };

  return /*#__PURE__*/React__default.createElement("div", null, formatNumber(children));
};
NumberFormatter.defaultProps = {
  variant: 'count'
};
NumberFormatter.propTypes = {
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.element), PropTypes__default.element, PropTypes__default.func]),
  variant: PropTypes__default.oneOf(['count', 'amount'])
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var asyncToGenerator = _asyncToGenerator;

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

var UploadFileButtons = function UploadFileButtons(_ref) {
  var onUpload = _ref.onUpload,
      sampleFileURL = _ref.sampleFileURL,
      sampleFileName = _ref.sampleFileName,
      fileTypes = _ref.fileTypes,
      buttonText = _ref.buttonText,
      className = _ref.className,
      variant = _ref.variant,
      onSampleDownloadSuccess = _ref.onSampleDownloadSuccess,
      onSampleDownloadFailure = _ref.onSampleDownloadFailure;
  var fileInputRef = useRef(null);

  var _useState = useState(''),
      _useState2 = slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleFileInputClick = useCallback(function () {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }, [fileInputRef]);
  var handleFileInputChange = useCallback(function (e) {
    if (e.target.files) {
      onUpload(e.target.files);
      setValue('');
    }
  }, [onUpload]);
  var downloadSample = useCallback( /*#__PURE__*/asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var file, blob, link;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!sampleFileURL) {
              _context.next = 21;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return fetch(sampleFileURL);

          case 4:
            file = _context.sent;
            _context.next = 7;
            return file.blob();

          case 7:
            blob = _context.sent;
            link = window.document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = sampleFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            if (onSampleDownloadSuccess) {
              onSampleDownloadSuccess();
            }

            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            console.log('error :', _context.t0);

            if (onSampleDownloadFailure) {
              onSampleDownloadFailure(_context.t0);
            }

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  })), []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "button-file"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    style: {
      display: 'none'
    },
    ref: fileInputRef,
    accept: fileTypes.map(function (type) {
      return ".".concat(type);
    }).join(', '),
    onChange: handleFileInputChange,
    value: value
  }), /*#__PURE__*/React__default.createElement(Button, {
    className: "mr-3",
    iconName: "Upload",
    variant: variant,
    onClick: handleFileInputClick
  }, buttonText), sampleFileURL && /*#__PURE__*/React__default.createElement(Button, {
    variant: "bold-link",
    onClick: downloadSample
  }, "Sample File")), /*#__PURE__*/React__default.createElement("span", {
    className: "p2"
  }, "Allow Only to Upload ".concat(fileTypes.join('/').toUpperCase(), " files")));
};
UploadFileButtons.defaultProps = {
  onUpload: function onUpload() {},
  fileTypes: '',
  sampleFileURL: '',
  sampleFileName: 'sample-file',
  buttonText: 'Upload File',
  className: '',
  variant: 'tertiary2',
  onSampleDownloadSuccess: function onSampleDownloadSuccess() {},
  onSampleDownloadFailure: function onSampleDownloadFailure() {}
};
UploadFileButtons.propTypes = {
  onUpload: PropTypes__default.func.isRequired,
  fileTypes: PropTypes__default.array.isRequired,
  // ['csv', 'xlsx']
  sampleFileURL: PropTypes__default.string,
  sampleFileName: PropTypes__default.string,
  buttonText: PropTypes__default.string,
  className: PropTypes__default.string,
  variant: PropTypes__default.string,
  onSampleDownloadSuccess: PropTypes__default.func,
  onSampleDownloadFailure: PropTypes__default.func
};

var css_248z$A = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes proportionalSelect-module_hover-ripples__9DsVS {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.proportionalSelect-module_timelineWrapper__1xO2D {\n  --timeline-gap: 2rem;\n  --active-color: #1d58d7;\n  --hover-color: #5173fb;\n  --label-color: #666666;\n  --button-color: #a2a2a2;\n  --line-color: #e7e7e7;\n  --option-color: #787878;\n  --button-size: 1rem;\n  gap: 1rem;\n  display: flex;\n  align-items: stretch;\n  width: fit-content;\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal; }\n\n.proportionalSelect-module_timelineLabel__2FmFb {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  flex: 1 1 0%;\n  justify-content: space-between;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  color: var(--label-color); }\n\n.proportionalSelect-module_timeline__N9I6c {\n  list-style: none;\n  display: flex;\n  position: relative;\n  gap: var(--timeline-gap);\n  padding: 0;\n  margin: 0;\n  width: fit-content; }\n  .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: nowrap; }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 .proportionalSelect-module_timelineBottomLabel__1T5yW,\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 .proportionalSelect-module_timelineTopLabel__3p52_ {\n      color: var(--option-color); }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8:hover {\n      cursor: pointer; }\n      .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8:hover .proportionalSelect-module_timelineTopLabel__3p52_,\n      .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8:hover .proportionalSelect-module_timelineBottomLabel__1T5yW {\n        color: var(--hover-color); }\n      .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8:hover .proportionalSelect-module_timelineItemButton__3iKRv {\n        background: var(--hover-color); }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8.proportionalSelect-module_active__3O2i6 {\n      cursor: pointer; }\n      .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8.proportionalSelect-module_active__3O2i6 .proportionalSelect-module_timelineTopLabel__3p52_,\n      .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8.proportionalSelect-module_active__3O2i6 .proportionalSelect-module_timelineBottomLabel__1T5yW {\n        color: var(--active-color); }\n      .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8.proportionalSelect-module_active__3O2i6 .proportionalSelect-module_timelineItemButton__3iKRv {\n        background: var(--active-color);\n        border: 0.25rem solid white;\n        outline: 0.125rem solid var(--active-color); }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 .proportionalSelect-module_timelineTopLabel__3p52_ {\n      margin-bottom: 0.5rem; }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 .proportionalSelect-module_timelineBottomLabel__1T5yW {\n      margin-top: 0.5rem; }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 .proportionalSelect-module_timelineItemButtonWrapper__3BtOZ {\n      position: relative;\n      line-height: 0;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      z-index: 0; }\n    .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8 .proportionalSelect-module_timelineItemButton__3iKRv {\n      position: relative;\n      height: var(--button-size);\n      width: var(--button-size);\n      border-radius: 50%;\n      padding: 0;\n      margin: 0;\n      background: var(--button-color);\n      border: 0.125rem solid white;\n      z-index: 2; }\n  .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8:not(:first-child) .proportionalSelect-module_timelineItemButtonWrapper__3BtOZ::before {\n    content: '';\n    position: absolute;\n    left: calc(var(--timeline-gap) / -2);\n    height: 0.125rem;\n    top: 50%;\n    width: calc(50% + calc(var(--timeline-gap) / 2));\n    transform: translateY(-50%);\n    background-color: var(--line-color);\n    z-index: 1; }\n  .proportionalSelect-module_timeline__N9I6c .proportionalSelect-module_timelineItem__oMXY8:not(:last-child) .proportionalSelect-module_timelineItemButtonWrapper__3BtOZ::after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    height: 0.125rem;\n    top: 50%;\n    width: calc(50% + calc(var(--timeline-gap) / 2));\n    transform: translateY(-50%);\n    background-color: var(--line-color);\n    z-index: 1; }\n\n.proportionalSelect-module_disabled__2PAE3 {\n  pointer-events: none; }\n";
var styles$y = {"timelineWrapper":"proportionalSelect-module_timelineWrapper__1xO2D","timelineLabel":"proportionalSelect-module_timelineLabel__2FmFb","timeline":"proportionalSelect-module_timeline__N9I6c","timelineItem":"proportionalSelect-module_timelineItem__oMXY8","timelineBottomLabel":"proportionalSelect-module_timelineBottomLabel__1T5yW","timelineTopLabel":"proportionalSelect-module_timelineTopLabel__3p52_","timelineItemButton":"proportionalSelect-module_timelineItemButton__3iKRv","active":"proportionalSelect-module_active__3O2i6","timelineItemButtonWrapper":"proportionalSelect-module_timelineItemButtonWrapper__3BtOZ","disabled":"proportionalSelect-module_disabled__2PAE3","hover-ripples":"proportionalSelect-module_hover-ripples__9DsVS"};
styleInject(css_248z$A);

var ProportionalSelect = function ProportionalSelect(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? function (option, selectedOption) {
    return (option === null || option === void 0 ? void 0 : option.value) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value);
  } : _ref$isActive,
      _ref$getTopLabel = _ref.getTopLabel,
      getTopLabel = _ref$getTopLabel === void 0 ? function (one) {
    return one === null || one === void 0 ? void 0 : one.topLabel;
  } : _ref$getTopLabel,
      _ref$getBottomLabel = _ref.getBottomLabel,
      getBottomLabel = _ref$getBottomLabel === void 0 ? function (one) {
    return one === null || one === void 0 ? void 0 : one.bottomLabel;
  } : _ref$getBottomLabel,
      topLabel = _ref.topLabel,
      bottomLabel = _ref.bottomLabel,
      labelAfter = _ref.labelAfter,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 32 : _ref$gap,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  useEffect(function () {
    if (disabled) {
      var timeline = document.querySelector('.timeline');
      timeline.style.setProperty('--option-color', '#cbcbcb');
      timeline.style.setProperty('--button-color', '#e7e7e7');
      timeline.style.setProperty('--line-color', '#e7e7e7');
      timeline.style.setProperty('--active-color', '#666666');
    }
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "timeline ".concat(styles$y.timelineWrapper),
    style: {
      '--timeline-gap': gap / 16 + 'rem'
    }
  }, !labelAfter && /*#__PURE__*/React__default.createElement(TimelineLabel, {
    labelTop: topLabel,
    labelBottom: bottomLabel
  }), /*#__PURE__*/React__default.createElement("ol", {
    className: styles$y.timeline
  }, options.map(function (one) {
    return /*#__PURE__*/React__default.createElement(TimelineItem, {
      key: one.value,
      labelTop: getTopLabel(one),
      labelBottom: getBottomLabel(one),
      handleClick: function handleClick() {
        return onChange(one);
      },
      isActive: isActive(one, value),
      disabled: disabled
    });
  })), labelAfter && /*#__PURE__*/React__default.createElement(TimelineLabel, {
    labelTop: topLabel,
    labelBottom: bottomLabel
  }));
};

var TimelineItem = function TimelineItem(_ref2) {
  var labelTop = _ref2.labelTop,
      labelBottom = _ref2.labelBottom,
      isActive = _ref2.isActive,
      handleClick = _ref2.handleClick,
      disabled = _ref2.disabled;
  return /*#__PURE__*/React__default.createElement("li", {
    className: "".concat(Boolean(isActive) ? styles$y.timelineItem + ' ' + styles$y.active : styles$y.timelineItem, " ").concat(disabled ? styles$y.disabled : ''),
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineTopLabel
  }, labelTop), /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineItemButtonWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineItemButton
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineBottomLabel
  }, labelBottom));
};

var TimelineLabel = function TimelineLabel(_ref3) {
  var labelTop = _ref3.labelTop,
      labelBottom = _ref3.labelBottom;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineLabel
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineTopLabel
  }, labelTop), /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.timelineBottomLabel
  }, labelBottom));
};

var css_248z$B = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes rangeSlider-module_hover-ripples__2ngG9 {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n:root {\n  --colorStop1: 0;\n  --colorStop2: 0;\n  --toolTipLeft: 0; }\n\n.rangeSlider-module_slider__3ezVh input[type='range'] {\n  -webkit-appearance: none;\n  /* Hides the slider so that custom slider can be made */\n  width: 20rem;\n  /* Specific width is required for Firefox. */\n  background: transparent;\n  /* Otherwise white in Chrome */ }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-webkit-slider-thumb {\n  -webkit-appearance: none; }\n\n.rangeSlider-module_slider__3ezVh input[type='range']:focus {\n  outline: none; }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-ms-track {\n  width: 20rem;\n  cursor: pointer;\n  /* Hides the slider so custom styles can be added */\n  background: transparent;\n  border-color: transparent;\n  color: transparent; }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  border-radius: 50%;\n  box-shadow: 0rem 0rem 0rem 0.5625rem #ffffff, 0rem 0rem 0rem 0.625rem #e7e7e7;\n  width: 0.625rem;\n  height: 0.625rem;\n  background: var(--thumb-background);\n  cursor: pointer;\n  margin-top: -0.0625rem; }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-moz-range-thumb {\n  -moz-appearance: none;\n  border-radius: 50%;\n  box-shadow: 0rem 0rem 0rem 0.5625rem #ffffff, 0rem 0rem 0rem 0.625rem #e7e7e7;\n  width: 0.625rem;\n  height: 0.625rem;\n  background: var(--thumb-background);\n  cursor: pointer; }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-ms-thumb {\n  -ms-appearance: none;\n  border-radius: 50%;\n  box-shadow: 0rem 0rem 0rem 0.5625rem #ffffff, 0rem 0rem 0rem 0.625rem #e7e7e7;\n  width: 0.625rem;\n  height: 0.625rem;\n  background: var(--thumb-background);\n  cursor: pointer; }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-webkit-slider-runnable-track {\n  width: 20rem;\n  height: 0.375rem;\n  cursor: pointer;\n  border-radius: 1.875rem;\n  background-image: linear-gradient(to right, #f4f4f4 0%, #f4f4f4 var(--colorStop1), var(--thumb-background) var(--colorStop1), var(--thumb-background) var(--colorStop2), #f4f4f4 var(--colorStop2), #f4f4f4 100%); }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-moz-range-track {\n  width: 20rem;\n  height: 0.375rem;\n  cursor: pointer;\n  border-radius: 1.875rem;\n  background-image: linear-gradient(to right, #f4f4f4 0%, #f4f4f4 var(--colorStop1), var(--thumb-background) var(--colorStop1), var(--thumb-background) var(--colorStop2), #f4f4f4 var(--colorStop2), #f4f4f4 100%); }\n\n.rangeSlider-module_slider__3ezVh input[type='range']::-ms-track {\n  width: 20rem;\n  height: 0.375rem;\n  cursor: pointer;\n  border-radius: 1.875rem;\n  background-image: linear-gradient(to right, #f4f4f4 0%, #f4f4f4 var(--colorStop1), var(--thumb-background) var(--colorStop1), var(--thumb-background) var(--colorStop2), #f4f4f4 var(--colorStop2), #f4f4f4 100%); }\n\n.rangeSlider-module_slider__3ezVh .rangeSlider-module_box__SuV9C {\n  height: 1.875rem;\n  width: 3.125rem;\n  position: relative;\n  background-color: #ffffff;\n  left: var(--toolTipLeft);\n  border: 0;\n  bottom: -0.75rem;\n  box-shadow: 0 0 0.0625rem 0.0625rem #979797;\n  -moz-box-shadow: 0 0 0.0625rem 0.0625rem #979797;\n  -webkit-box-shadow: 0 0 0.0625rem 0.0625rem #979797;\n  border-radius: 0.25rem;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .rangeSlider-module_slider__3ezVh .rangeSlider-module_box__SuV9C .rangeSlider-module_currentValue__2mjLx {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    font-size: 0.75rem;\n    line-height: 0.875rem;\n    font-weight: 600; }\n\n.rangeSlider-module_slider__3ezVh .rangeSlider-module_boxArrow__-BRBT {\n  width: 0;\n  height: 0;\n  border-left: 0.3125rem solid transparent;\n  border-right: 0.3125rem solid transparent;\n  border-bottom: 0.3125rem solid #979797;\n  position: relative;\n  left: calc(var(--toolTipLeft) + 1.25rem);\n  top: -1.4375rem; }\n\n.rangeSlider-module_slider__3ezVh .rangeSlider-module_boxArrow__-BRBT:after {\n  content: '';\n  width: 0;\n  height: 0;\n  border-left: 0.25rem solid transparent;\n  border-right: 0.25rem solid transparent;\n  border-bottom: 0.25rem solid #ffffff;\n  position: absolute;\n  top: 0.0625rem;\n  left: -0.25rem; }\n\n.rangeSlider-module_slider__3ezVh .rangeSlider-module_percentageIndicatorEnabled__Zg0V7 {\n  margin-top: 0.5625rem;\n  position: absolute;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.75rem;\n  color: #787878; }\n  .rangeSlider-module_slider__3ezVh .rangeSlider-module_percentageIndicatorEnabled__Zg0V7 .rangeSlider-module_percentage__32Xl1 {\n    margin-right: 8.125rem; }\n\n.rangeSlider-module_slider__3ezVh .rangeSlider-module_percentageIndicatorDisabled__39d4R {\n  margin-top: 0.5625rem;\n  position: absolute;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.75rem;\n  color: #cbcbcb; }\n  .rangeSlider-module_slider__3ezVh .rangeSlider-module_percentageIndicatorDisabled__39d4R .rangeSlider-module_percentage__32Xl1 {\n    margin-right: 8.125rem; }\n";
var styles$z = {"slider":"rangeSlider-module_slider__3ezVh","box":"rangeSlider-module_box__SuV9C","currentValue":"rangeSlider-module_currentValue__2mjLx","boxArrow":"rangeSlider-module_boxArrow__-BRBT","percentageIndicatorEnabled":"rangeSlider-module_percentageIndicatorEnabled__Zg0V7","percentage":"rangeSlider-module_percentage__32Xl1","percentageIndicatorDisabled":"rangeSlider-module_percentageIndicatorDisabled__39d4R","hover-ripples":"rangeSlider-module_hover-ripples__2ngG9"};
styleInject(css_248z$B);

var Slider = function Slider(props) {
  var maxAllowedRange = props.maxAllowedRange,
      minAllowedRange = props.minAllowedRange,
      maxRange = props.maxRange,
      minRange = props.minRange,
      initialValue = props.initialValue,
      setSliderValue = props.setSliderValue,
      _props$isSliderDisabl = props.isSliderDisabled,
      isSliderDisabled = _props$isSliderDisabl === void 0 ? false : _props$isSliderDisabl,
      _props$isLabelDisable = props.isLabelDisabled,
      isLabelDisabled = _props$isLabelDisable === void 0 ? false : _props$isLabelDisable,
      _props$showCurrentVal = props.showCurrentValue,
      showCurrentValue = _props$showCurrentVal === void 0 ? true : _props$showCurrentVal;

  var _useState = useState(initialValue !== null && initialValue !== void 0 ? initialValue : 0),
      _useState2 = slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var setValue = function setValue(event) {
    var value = event.target.value;
    var selectedValue = parseInt(value, 10);

    if (maxAllowedRange && minAllowedRange) {
      if (selectedValue <= maxAllowedRange && selectedValue >= minAllowedRange && !isSliderDisabled) {
        setCurrentValue(value);
        setSliderValue(value);
      }
    } else if (!isSliderDisabled) {
      setCurrentValue(value);
      setSliderValue(value);
    }
  };

  var root = document.querySelector(':root');

  if (!isSliderDisabled) {
    var _root$style, _root$style2;

    root === null || root === void 0 ? void 0 : (_root$style = root.style) === null || _root$style === void 0 ? void 0 : _root$style.setProperty('--colorStop1', "".concat(minAllowedRange, "%"));
    root === null || root === void 0 ? void 0 : (_root$style2 = root.style) === null || _root$style2 === void 0 ? void 0 : _root$style2.setProperty('--colorStop2', "".concat(maxAllowedRange, "%"));
  }

  root.style.setProperty('--toolTipLeft', "".concat((320 * (currentValue * 0.01) - 25) / 16, "rem"));
  useEffect(function () {
    var _document$querySelect;

    (_document$querySelect = document.querySelector('#slider')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.style.setProperty('--thumb-background', isSliderDisabled ? '#CBCBCB' : '#1d58d7');
  }, [isSliderDisabled]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$z.slider)
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "slider",
    type: "range",
    min: minRange.toString(),
    max: maxRange.toString(),
    value: currentValue.toString(),
    onChange: function onChange(e) {
      return setValue(e);
    }
  }), !isLabelDisabled ? /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(isSliderDisabled ? styles$z.percentageIndicatorDisabled : styles$z.percentageIndicatorEnabled)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: styles$z.percentage
  }, "0%"), /*#__PURE__*/React__default.createElement("span", {
    className: styles$z.percentage
  }, "50%"), /*#__PURE__*/React__default.createElement("span", null, "100%")) : null, showCurrentValue ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$z.box
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$z.currentValue
  }, currentValue, "%")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$z.boxArrow
  })) : null);
};
Slider.propTypes = {
  maxAllowedRange: PropTypes__default.number,
  minAllowedRange: PropTypes__default.number,
  maxRange: PropTypes__default.number.isRequired,
  minRange: PropTypes__default.number.isRequired,
  initialValue: PropTypes__default.number,
  setSliderValue: PropTypes__default.func.isRequired,
  isSliderDisabled: PropTypes__default.bool
};

var css_248z$C = ".smartText-module_container__J6DMQ {\n  width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n  pointer-events: none; }\n";
var styles$A = {"container":"smartText-module_container__J6DMQ"};
styleInject(css_248z$C);

var SmartText = function SmartText(_ref) {
  var label = _ref.label,
      tooltipParams = _ref.tooltipParams;
  return /*#__PURE__*/React__default.createElement(Tooltip$1, _extends_1({
    label: label
  }, tooltipParams), /*#__PURE__*/React__default.createElement("span", {
    className: styles$A.container
  }, label));
};
SmartText.propTypes = {
  label: PropTypes__default.string,
  tooltipParams: PropTypes__default.object
};

var css_248z$D = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__1nWZj {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_labelOnly__1_pE- {\n  width: 16.25rem;\n  max-width: 16.25rem; }\n\n.styles-module_allowBlockTooltip__2yZfA {\n  display: flex;\n  flex-direction: column;\n  margin: 0.25rem;\n  font-size: 0.875rem; }\n  .styles-module_allowBlockTooltipInfo__1whM3:first-child {\n    margin-bottom: 0.75rem; }\n  .styles-module_allowBlockTooltipSubtitle__2G_2n {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 0.125rem; }\n  .styles-module_allowBlockTooltipText__1vVUA {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal; }\n  .styles-module_allowBlockTooltip__2yZfA .styles-module_bubble__3F3rz {\n    width: 0.5rem;\n    height: 0.5rem;\n    margin-right: 0.25rem;\n    border-radius: 50%;\n    border: 1px solid #e7e7e7; }\n    .styles-module_allowBlockTooltip__2yZfA .styles-module_bubbleBlocked__1bJLe {\n      background: #f1494a; }\n    .styles-module_allowBlockTooltip__2yZfA .styles-module_bubbleAllowed__-8bJM {\n      background: #289679; }\n";
var styles$B = {"labelOnly":"styles-module_labelOnly__1_pE-","allowBlockTooltip":"styles-module_allowBlockTooltip__2yZfA","allowBlockTooltipInfo":"styles-module_allowBlockTooltipInfo__1whM3","allowBlockTooltipSubtitle":"styles-module_allowBlockTooltipSubtitle__2G_2n","allowBlockTooltipText":"styles-module_allowBlockTooltipText__1vVUA","bubble":"styles-module_bubble__3F3rz","bubbleBlocked":"styles-module_bubbleBlocked__1bJLe","bubbleAllowed":"styles-module_bubbleAllowed__-8bJM","hover-ripples":"styles-module_hover-ripples__1nWZj"};
styleInject(css_248z$D);

var AllowlistBlocklistTooltip = function AllowlistBlocklistTooltip(_ref) {
  var dimension = _ref.dimension,
      labelOnly = _ref.labelOnly,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? 'Allowlist/Blocklist' : _ref$content,
      _ref$labelMaxWidth = _ref.labelMaxWidth,
      labelMaxWidth = _ref$labelMaxWidth === void 0 ? 210 : _ref$labelMaxWidth,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps;
  var label = /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$B.allowBlockTooltip, " ").concat(labelOnly ? styles$B.labelOnly : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$B.allowBlockTooltipInfo
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$B.allowBlockTooltipSubtitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$B.bubble, " ").concat(styles$B.bubbleAllowed)
  }), "Allowlist:"), /*#__PURE__*/React__default.createElement("span", {
    className: styles$B.allowBlockTooltipText
  }, "List of ", dimension, " targeted for this campaign")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$B.allowBlockTooltipInfo
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$B.allowBlockTooltipSubtitle
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$B.bubble, " ").concat(styles$B.bubbleBlocked)
  }), "Blocklist:"), /*#__PURE__*/React__default.createElement("span", {
    className: styles$B.allowBlockTooltipText
  }, "List of ", dimension, " blocked for this campaign")));

  if (labelOnly) {
    return label;
  }

  return /*#__PURE__*/React__default.createElement(Tooltip, _extends_1({
    auto: true,
    portal: true,
    labelMaxWidth: labelMaxWidth
  }, tooltipProps, {
    label: label
  }), content);
};
AllowlistBlocklistTooltip.propTypes = {
  dimension: PropTypes__default.string,
  content: PropTypes__default.node,
  labelOnly: PropTypes__default["boolean"],
  labelMaxWidth: PropTypes__default.number,
  tooltipProps: PropTypes__default.object
};

export { ActionButton, ActionMenu, ActionSelect, AllowlistBlocklistTooltip, Block, BlockRemove, Button, ButtonCircle, ButtonLink, ButtonsGroup, Card, CardHoveredContent, CardHoveredSubtitle, CardImage, CardSubtitle, Checkbox, Chip, Collapse, CollapsibleBlock, ContextMenu, ContextMenuList, ContextMenuListDivider, ContextMenuListItem, CopyToClipboardButton, CustomerSelect, DatesPicker, Dialog, DialogScrollableContent, DisplayItems, EditableText, ErrorCircle, FileUploader, Form, Icon, ImageCard, ImageCardSubContent, Layout, LoadingBar, Logo, Modal, NavigationBar, NumberFormatter, Opener, Pagination, ParamsCard, ParamsCardsDate, ParamsCardsList, Pill, ProgressCircle, ProportionalSelect, Radio, RightbarTab, RightbarTabs, Ripple, SORT_DIRECTION, SVG_HOST_URL, Select, SelectList, Sidebar, SidebarHeader, Slider, SmartText, Snackbar, SuccessCircle, Switch, Table, Tabs, TextField, TextFieldWithIcon, TimePicker, Tooltip, Tumbler, URLTextField, UploadFileButtons, applicationsIcons, audienceIcons, campaignsIcons, commonIcons, creativeIcons, creativesIcons, deviceIcons, eventsIcons, filterIcons, formatNumberWithSuffix, iconNameURLMap, osIcons, statusIcons, withClickOutside };
//# sourceMappingURL=index.es.js.map
